{
  "fieldLabels": {
    "supplier": "Dodavatel",
    "customer": "Odběratel",
    "items": "Položky",
    "vatSummary": "Rekapitulace DPH",
    "bankingDetails": "Bankovní údaje",
    "address": "Adresa",
    "documentType": "Typ dokumentu",
    "documentNumber": "Číslo dokladu",
    "issueDate": "Datum vystavení",
    "dueDate": "Datum splatnosti",
    "taxDate": "Datum uskutečnění plnění",
    "currencyCode": "Měna",
    "name": "Název",
    "companyId": "IČO",
    "taxId": "DIČ",
    "vatId": "DIČ pro DPH / VAT ID",
    "email": "E-mail",
    "phone": "Telefon",
    "streetName": "Ulice",
    "buildingNumber": "Číslo popisné",
    "city": "Město",
    "postalCode": "PSČ",
    "countryCode": "Země",
    "description": "Popis",
    "quantity": "Množství",
    "unit": "Jednotka",
    "unitPrice": "Cena za jednotku",
    "totalAmount": "Celková částka",
    "vatRate": "Sazba DPH",
    "totalAmountNoVat": "Celkem bez DPH",
    "totalVatAmount": "DPH celkem",
    "accountingTotalVatAmount": "Účetní DPH celkem",
    "paidAmount": "Uhrazeno",
    "paymentMethod": "Způsob platby",
    "paymentNote": "Poznámka k platbě",
    "orderReference": "Číslo objednávky",
    "receiptDatetime": "Datum a čas účtenky",
    "terminalId": "ID terminálu",
    "cashierId": "ID pokladníka",
    "bankAccount": "Číslo účtu",
    "bankCode": "Kód banky",
    "iban": "IBAN",
    "swift": "SWIFT/BIC",
    "varSymb": "Variabilní symbol",
    "specSymb": "Specifický symbol",
    "netAmount": "Základ daně",
    "vatAmount": "DPH",
    "accountingAmount": "Účetní částka",
    "accountingAmountNoVat": "Účetní částka (bez DPH)",
    "isVatPayer": "Plátce DPH",
    "deliveryAddress": "Doručovací adresa",
    "code": "Kód",
    "discountPercent": "Sleva (%)",
    "isUnitPriceInclVat": "Cena za jednotku vč. DPH"
  },
  "general": {
    "loading": "Načítání...",
    "error": "Chyba",
    "success": "Úspěch",
    "cancel": "Zrušit",
    "save": "Uložit",
    "delete": "Smazat",
    "edit": "Upravit",
    "create": "Vytvořit",
    "view": "Zobrazit",
    "download": "Stáhnout",
    "search": "Hledat",
    "filter": "Filtr",
    "home": "Domů",
    "back": "Zpět"
  },
  "UploadInput": {
    "defaultTitle": "Nahrát soubory",
    "uploading": "Nahrávání...",
    "acceptedTypes": "Povolené typy",
    "maxSize": "Max. velikost",
    "maxFiles": "Max. souborů",
    "errors": {
      "maxFiles": "Maximálně",
      "fileTooBig": "překračuje maximální velikost",
      "invalidType": "není podporovaný typ souboru"
    }
  },
  "error": {
    "boundary": {
      "title": "Něco se pokazilo",
      "message": "Došlo k neočekávané chybě. Zkuste prosím obnovit stránku.",
      "details": "Detaily chyby",
      "reload": "Obnovit Stránku",
      "goHome": "Přejít na Domovskou Stránku"
    },
    "notFound": {
      "title": "Stránka Nenalezena",
      "message": "Stránka, kterou hledáte, neexistuje nebo byla přesunuta.",
      "goHome": "Přejít na Domovskou Stránku",
      "goDashboard": "Přejít na Dashboard"
    }
  },
  "errors": {
    "lineNumber": "Položka {{number}}"
  },
  "enums": {
    "boolean": {
      "true": "Ano",
      "false": "Ne"
    },
    "jobType": {
      "IMPLEMENTATION": "Realizační",
      "OVERHEAD": "Režijní",
      "SUPPORT": "Supportní"
    },
    "glPostingKind": {
      "ANY": "Jakýkoli doklad",
      "ISSUED_INVOICE": "Vydaná faktura",
      "RECEIVED_INVOICE": "Přijatá faktura",
      "CASH_RECEIPT": "Příjmový pokladní doklad",
      "CASH_EXPENSE": "Výdajový pokladní doklad",
      "BANK_RECEIPT": "Bankovní příjem",
      "BANK_EXPENSE": "Bankovní výdej",
      "PAYABLE": "Ostatní závazek",
      "RECEIVABLE": "Ostatní pohledávka",
      "INTERNAL": "Interní doklad"
    },
    "vatCodeDirection": {
      "RECEIVED": "Přijaté doklady",
      "ISSUED": "Vydané doklady"
    },
    "vatPostingDirection": {
      "INCOME": "Příjem",
      "EXPENSE": "Výdej"
    },
    "jobStatus": {
      "PLANNED": "Plánovaná",
      "ACTIVE": "Aktivní",
      "SUSPENDED": "Pozastavená",
      "CLOSED": "Uzavřená"
    },
    "documentAttachmentRole": {
      "SOURCE_DOCUMENT": "Zdrojový dokument",
      "EMAIL_BODY": "Zdrojový email",
      "EMAIL_ATTACHMENT": "Příloha e-mailu",
      "ISDOC": "ISDOC",
      "ATTACHMENT": "Příloha",
      "SYNC_ATTACHMENT": "Soubor z integrace"
    },
    "priority": {
      "all": "Všechny Priority",
      "low": "Nízká",
      "medium": "Střední",
      "high": "Vysoká"
    },
    "documentType": {
      "UNKNOWN": "Neznámý",
      "INVOICE": "Faktura",
      "RECEIPT": "Účtenka",
      "PROFORMA": "Zálohová faktura",
      "ADVANCE": "Daňový doklad k přijaté záloze",
      "CREDIT_NOTE": "Dobropis",
      "DEBIT_NOTE": "Vrubopis",
      "CONTRACT": "Smlouva",
      "OTHER": "Ostatní"
    },
    "processingStatus": {
      "PENDING": "Čeká",
      "PROCESSING": "Zpracovává se",
      "EXTRACTED": "Vytěženo",
      "COMPLETED": "Dokončeno",
      "FAILED": "Selhalo",
      "QUOTA_EXCEEDED": "Překročen limit",
      "UNSUPPORTED_DOCUMENT": "Nepodporovaný typ",
      "PASSWORD_PROTECTED": "Chráněno heslem"
    },
    "validationStatus": {
      "UNPROCESSED": "Nezpracováno",
      "PENDING": "Zpracovává se",
      "SUCCESS": "Validováno",
      "WARNING": "Varování",
      "ERROR": "Chyba validace",
      "WAITING_FOR_CREDITS": "Čeká na kredity"
    },
    "creditOperation": {
      "DOCUMENT_SCAN": "Vytěžení dokladu",
      "DOCUMENT_ISDOC": "Import dokladu ISDOC",
      "VALIDATION": "Kontrola dokladu",
      "APPROVAL": "Schválení",
      "APPROVAL_PREVIEW": "Náhled AI schválení",
      "ATTACHMENT_CLASSIFICATION": "Klasifikace přílohy e-mailu",
      "MATCH_CONFIRMATION": "AI potvrzení párování faktury",
      "MORNING_BRIEFING": "Ranní přehled",
      "CHAT": "Zpráva v AI chatu"
    },
    "invoiceStatus": {
      "all": "Všechny stavy",
      "DRAFT": "Koncept",
      "APPROVED": "Schváleno",
      "REJECTED": "Zamítnuto",
      "SUBMITTED": "Odesláno ke schválení",
      "FOR_APPROVAL": "Ke schválení"
    },
    "approvalStatus": {
      "UNPROCESSED": "Ke zpracování",
      "PENDING": "Ke schválení",
      "FOR_REVIEW": "Ke schválení",
      "APPROVED": "Schváleno",
      "REJECTED": "Zamítnuto"
    },
    "requisitionApprovalStatus": {
      "APPROVED": "Schváleno",
      "FOR_REVIEW": "Ke schválení",
      "REJECTED": "Neschváleno"
    },
    "changeSource": {
      "USER": "Uživatel",
      "EXTRACTION": "Vytěžení",
      "VALIDATION": "Validace",
      "AI_APPROVAL": "AI schvalování",
      "APPROVAL_SKIPPED": "Přeskočené schvalování",
      "AUTOFILL": "Automatické doplnění",
      "SYNC": "Synchronizace",
      "MATCHING": "Párování",
      "AI_MATCHING": "AI párování",
      "COVERAGE": "Pokrytí objednávkami",
      "RENEWAL": "Automatické prodloužení"
    },
    "paymentStatus": {
      "PAID": "Proplaceno",
      "PARTIALLY_PAID": "Částečně proplaceno",
      "UNPAID": "Neproplaceno"
    },
    "invoicePostingStatus": {
      "NOT_POSTED": "Nezaúčtováno",
      "POSTED": "Zaúčtováno",
      "CANCELLED": "Stornováno"
    },
    "invoiceType": {
      "UNKNOWN": "Neznámý",
      "INVOICE": "Faktura",
      "CREDIT_NOTE": "Dobropis",
      "DEBIT_NOTE": "Vrubopis",
      "PROFORMA": "Zálohová faktura",
      "ADVANCE": "Daňový doklad k přijaté záloze",
      "RECEIPT": "Účtenka",
      "OTHER": "Jiný typ dokladu"
    },
    "invoiceDocumentType": {
      "INVOICE": "Faktura",
      "CREDIT_NOTE": "Dobropis",
      "DEBIT_NOTE": "Vrubopis",
      "PROFORMA": "Zálohová faktura"
    },
    "isdocDocumentType": {
      "INVOICE": "Faktura",
      "CREDIT_NOTE": "Dobropis",
      "DEBIT_NOTE": "Vrubopis",
      "PROFORMA": "Zálohová faktura (proforma)",
      "ADVANCE_PAYMENT": "Daňový zálohový list",
      "CREDIT_NOTE_FOR_ADVANCE": "Dobropis k zálohové faktuře",
      "SIMPLIFIED_TAX_DOCUMENT": "Zjednodušený daňový doklad"
    },
    "paymentMethod": {
      "BANK_TRANSFER": "Bankovní převod",
      "CASH": "Hotovost",
      "CARD": "Platební karta",
      "CHECK": "Šek",
      "DIRECT_DEBIT": "Přímé inkaso",
      "CLEARING": "Zápočet",
      "OTHER": "Jiná forma platby"
    },
    "invoicePurpose": {
      "GOODS": "Zboží",
      "SERVICES": "Služby",
      "FREIGHT": "Doprava",
      "SUMMARY": "Souhrnná faktura",
      "PARTIAL": "Dílčí faktura",
      "FINAL": "Konečná faktura",
      "SETTLEMENT": "Zúčtovací faktura",
      "MIXED": "Smíšená (zboží i služby)"
    },
    "vatMode": {
      "STANDARD": "Standardní DPH",
      "REVERSE_CHARGE": "Přenesená daňová povinnost",
      "EXEMPT_DOMESTIC": "Osvobozeno — tuzemsko",
      "EXEMPT_EU_SUPPLY": "Osvobozeno — dodání do EU",
      "EXEMPT_EXPORT": "Osvobozeno — vývoz mimo EU",
      "EXEMPT_OTHER": "Osvobozeno od daně"
    },
    "vatPayerType": {
      "PAYER": "Plátce DPH",
      "NON_PAYER": "Neplátce DPH",
      "IDENTIFIED_PERSON": "Identifikovaná osoba"
    },
    "invoiceDirection": {
      "ISSUED": "Vydaná",
      "RECEIVED": "Přijatá",
      "INTERNAL": "Vnitropodniková"
    },
    "currencyCode": {
      "CZK": "Kč",
      "EUR": "€",
      "USD": "$"
    },
    "userRole": {
      "ADMIN": "Administrátor",
      "SECURITY_ADMIN": "Správce bezpečnosti",
      "ACCOUNTANT": "Účetní",
      "APPROVER": "Schvalovatel",
      "RULES_MANAGER": "Správce pravidel",
      "CODE_LISTS_MANAGER": "Správce číselníků",
      "SYSTEM_BILLING_ADMIN": "Systémový správce fakturace",
      "SYSTEM_SUPPORT_ADMIN": "Systémový správce podpory",
      "MEMBER": "Člen"
    },
    "userRoleDescription": {
      "MEMBER": "Vidí doklady, firmy a číselníky, zakládá faktury, požadavky a objednávky a přijímá zboží. Nic neschvaluje a nemění nastavení.",
      "ADMIN": "Spravuje celý účet: uživatele, nastavení, tarif, číselníky, schvalovatele a integrace.",
      "ACCOUNTANT": "Upravuje, schvaluje, páruje a exportuje faktury, spravuje firmy, přepracovává a maže dokumenty, připravuje platební dávky a zaznamenává platby.",
      "APPROVER": "Schvaluje faktury, požadavky a objednávky. Schvaluje a uvolňuje platební dávky a potvrzuje proplacení plateb.",
      "RULES_MANAGER": "Spravuje pravidla pro kontrolu a schvalování dokladů.",
      "CODE_LISTS_MANAGER": "Spravuje nákladová střediska, zakázky, organizační strukturu a katalog produktů.",
      "SECURITY_ADMIN": "Spravuje uživatele, API klíče, webhooky, integrace a nastavení účtu.",
      "SYSTEM_BILLING_ADMIN": "Spravuje fakturaci napříč účty v administraci platformy.",
      "SYSTEM_SUPPORT_ADMIN": "Podpora platformy: přihlášení za uživatele a katalog pluginů bridge."
    },
    "masterAccountRole": {
      "MASTER_ADMIN": "Správce kanceláře",
      "MASTER_HEAD_ACCOUNTANT": "Hlavní účetní",
      "MASTER_ACCOUNTANT": "Účetní kanceláře"
    },
    "masterAccountRoleDescription": {
      "MASTER_ADMIN": "Spravuje klienty, lidi kanceláře a jejich přiřazení, tarif a údaje kanceláře. U každého klienta je administrátorem.",
      "MASTER_HEAD_ACCOUNTANT": "Pracuje jako účetní u všech klientů kanceláře a rozděluje klienty mezi účetní.",
      "MASTER_ACCOUNTANT": "Vidí board kanceláře. U přiřazených klientů pracuje jako účetní; číselníky klienta nespravuje."
    },
    "accountStatus": {
      "ACTIVE": "Aktivní",
      "DEACTIVATED": "Deaktivován",
      "PENDING": "Pozvánka odeslána"
    },
    "syncDirection": {
      "IN": "Příchozí (externí → Tappeer)",
      "OUT": "Odchozí (Tappeer → externí)"
    },
    "attachmentTransferStatus": {
      "PENDING": "Ve frontě",
      "RUNNING": "Přenáší se",
      "DONE": "Přeneseno",
      "FAILED": "Selhalo",
      "REFUSED": "Odmítnuto"
    },
    "integrationActivityType": {
      "BRIDGE_REGISTERED": "Bridge zaregistrován",
      "BRIDGE_ENROLLMENT_CODE_REGENERATED": "Vydán nový registrační kód",
      "BRIDGE_ENROLLED": "Bridge připojen k účtu",
      "BRIDGE_ENROLLMENT_REJECTED": "Registrace odmítnuta",
      "BRIDGE_AUTH_REJECTED": "Připojení odmítnuto",
      "BRIDGE_CONNECTED": "Bridge se připojil",
      "BRIDGE_DISCONNECTED": "Bridge se odpojil",
      "BRIDGE_WENT_OFFLINE": "Bridge je nedostupný",
      "BRIDGE_CAME_ONLINE": "Bridge je opět dostupný",
      "BRIDGE_REVOKED": "Bridge zneplatněn",
      "BRIDGE_DELETED": "Bridge smazán",
      "MASTER_ACCOUNT_BRIDGE_ACCESS_ENDED": "Přístup k bridgi kanceláře skončil",
      "BRIDGE_TRANSFERRED_TO_MASTER_ACCOUNT": "Bridge převeden na kancelář",
      "BRIDGE_CLOCK_SKEW_WARNING": "Nesprávný čas počítače",
      "BRIDGE_AGENT_ERROR": "Chyba agenta",
      "BRIDGE_PLUGIN_REGISTERED": "Přidán cílový systém",
      "BRIDGE_PLUGIN_REMOVED": "Odebrán cílový systém",
      "BRIDGE_PLUGIN_VERSION_CHANGED": "Cílový systém aktualizován",
      "PLUGIN_INSTANCE_CREATED": "Integrace vytvořena",
      "PLUGIN_INSTANCE_UPDATED": "Integrace upravena",
      "PLUGIN_INSTANCE_DELETED": "Integrace smazána",
      "PLUGIN_INSTANCE_ENABLED": "Integrace zapnuta",
      "PLUGIN_INSTANCE_DISABLED": "Integrace vypnuta",
      "PLUGIN_LINK_UNLINKED": "Vazba zrušena",
      "PLUGIN_LINK_RELINKED": "Vazba převedena na jiný řádek",
      "PLUGIN_LINK_PROMOTED": "Duplicitní záznam firmy se stal primárním",
      "PLUGIN_LINK_PRIMARY_SET": "Duplicitní záznam firmy nastaven jako primární",
      "PLUGIN_LINK_CONFIRMED": "Shoda potvrzena",
      "SYNC_RUN_STARTED": "Synchronizace zahájena",
      "SYNC_RUN_COMPLETED": "Synchronizace dokončena",
      "SYNC_RUN_FAILED": "Synchronizace selhala",
      "SYNC_RECORDS_SKIPPED": "Záznamy přeskočeny",
      "SYNC_RECORDS_DEACTIVATED": "Záznamy chybějící ve zdroji deaktivovány",
      "SYNC_ATTACHMENT_TRANSFER_RETRIED": "Přenos přílohy zopakován",
      "SYNC_ATTACHMENTS_REPUSHED": "Přílohy znovu odeslány",
      "SYNC_OUTBOUND_EVENT_DEAD": "Odchozí změna nebyla doručena",
      "SYNC_OUTBOUND_FULL_FALLBACK": "Hromadné změny odeslány úplnou synchronizací",
      "INTEGRATION_CREATED_FROM_TEMPLATE": "Vytvořeno ze šablony kanceláře",
      "INTEGRATION_TEMPLATE_APPLIED": "Šablona nasazena klientům",
      "SYNC_RECORDS_MISSING": "Záznamy chybí ve zdroji",
      "SYNC_MISSING_HELD": "Vyřazení pozdrženo k potvrzení",
      "SYNC_MISSING_HOLD_DECIDED": "Rozhodnuto o pozdržené dávce",
      "SYNC_MISSING_APPLY_FAILED": "Vyřazení se nepodařilo"
    },
    "integrationActivitySeverity": {
      "INFO": "Informace",
      "WARN": "Varování",
      "ERROR": "Chyba"
    },
    "integrationActivityCategory": {
      "BRIDGE": "Bridge",
      "PLUGIN": "Plugin",
      "SYNC": "Synchronizace"
    },
    "syncRunStatus": {
      "RUNNING": "Probíhá",
      "COMPLETED": "Dokončeno",
      "FAILED": "Selhalo",
      "LOST": "Ztraceno"
    },
    "bridgeRunPriority": {
      "PUSH": "Odeslání změn",
      "BULK": "Synchronizace"
    },
    "entityLinkStatus": {
      "ACTIVE": "Aktivní",
      "PENDING": "Čeká",
      "REJECTED": "Odmítnutá",
      "UNLINKED": "Zrušená"
    },
    "entityLinkMatchedBy": {
      "LINK": "Existující vazba",
      "CODE": "Kód",
      "COMPANY_ID": "IČO",
      "VAT_ID": "DIČ",
      "EMAIL": "E-mail",
      "INVOICE_NUMBER": "Číslo faktury",
      "MARKER": "Značka",
      "CREATED": "Založeno synchronizací",
      "MANUAL": "Ručně"
    },
    "syncMissingReason": {
      "absent": "Úplná synchronizace ho nevrátila",
      "tombstone": "Zdroj ho nahlásil jako smazaný"
    },
    "missingHoldReason": {
      "batch": "Za poslední den chybí 50 a více záznamů.",
      "share": "Za poslední den chybí 10 % a více aktivních záznamů.",
      "small-stream": "Chybí velká část z malého počtu záznamů.",
      "empty-export": "Zdroj nevrátil žádný záznam.",
      "legacy-mark": "Záznamy byly označené jako chybějící ještě před touto verzí Tappeeru."
    },
    "syncMissingAction": {
      "deactivate": "Deaktivováno",
      "delete": "Odstraněno",
      "info": "Jen označeno"
    },
    "deletionMode": {
      "deactivate": "Deaktivovat",
      "delete": "Odstranit",
      "info": "Jen označit"
    },
    "integrationEntityType": {
      "party": "Firmy",
      "partyDescription": "Dodavatelé a odběratelé — firmy, pro které Tappeer vede doklady.",
      "cost-center": "Střediska",
      "cost-centerDescription": "Střediska, ke kterým Tappeer přiřazuje doklady a požadavky.",
      "product": "Produkty",
      "productDescription": "Katalog produktů a služeb synchronizovaný z ERP.",
      "requisition": "Žádanky",
      "requisitionDescription": "Schválené žádanky včetně položek — do ERP se jen odesílají, zpět se nenačítají.",
      "purchase-order": "Objednávky",
      "purchase-orderDescription": "Objednávky odeslané do ERP nebo přijaté z něj, včetně položek.",
      "goods-receipt": "Příjemky",
      "goods-receiptDescription": "Příjemky zboží navázané na objednávky — co a kolik skutečně dorazilo.",
      "invoice": "Faktury",
      "invoiceDescription": "Přijaté a vydané faktury — doklady, které Tappeer schvaluje a platí.",
      "job": "Zakázky",
      "jobDescription": "Zakázky z ERP — druhá nákladová dimenze vedle středisek, ke které Tappeer přiřazuje doklady.",
      "org-unit": "Pozice org. struktury",
      "org-unitDescription": "Pozice org. struktury importované z adresáře (LDAP / Active Directory).",
      "org-unit-member": "Členové pozic org. struktury",
      "org-unit-memberDescription": "Přiřazení uživatelů na pozice org. struktury — kdo je na které pozici.",
      "gl-posting": "Předkontace",
      "gl-postingDescription": "Předkontace z účetního systému — do Tappeeru se jen načítají, zpět se neposílají.",
      "vat-code": "Členění DPH",
      "vat-codeDescription": "Členění DPH z účetního systému — do Tappeeru se jen načítá, zpět se neposílá.",
      "vat-posting": "Zaúčtování DPH",
      "vat-postingDescription": "Zaúčtování DPH z účetního systému — do Tappeeru se jen načítá, zpět se neposílá.",
      "bank-document": "Bankovní, pokladní a interní doklady",
      "bank-documentDescription": "Doklady z účetního systému i s tím, které faktury hradí — do Tappeeru se jen načítají, zpět se neposílají."
    },
    "connectorHealth": {
      "never": "Zatím neběžel",
      "running": "Probíhá",
      "ok": "Poslední běh uspěl",
      "warnings": "Poslední běh měl problémy",
      "failed": "Poslední běh selhal"
    },
    "pluginConfigStatus": {
      "UP_TO_DATE": "Aktuální",
      "OUTDATED": "Zastaralé",
      "NEEDS_REVIEW": "Vyžaduje kontrolu"
    },
    "pluginTransport": {
      "DIRECT": "Přímo",
      "BRIDGED": "Přes bridge"
    },
    "requisitionStatus": {
      "DRAFT": "Rozpracovaná",
      "SUBMITTED": "Odeslaná",
      "FOR_APPROVAL": "Ke schválení",
      "APPROVED": "Schválená",
      "REJECTED": "Neschválená",
      "ORDERED": "Objednaná",
      "CLOSED": "Uzavřená",
      "CANCELLED": "Zrušená"
    },
    "requisitionDisplayStatus": {
      "DRAFT": "Koncept",
      "FOR_APPROVAL": "Ke schválení",
      "TO_ORDER": "K objednání",
      "AWAITING_DELIVERY": "Čeká na dodání",
      "AWAITING_INVOICE": "Čeká na fakturu",
      "AWAITING_DELIVERY_AND_INVOICE": "Čeká na dodání a fakturu",
      "AWAITING_COMPLETION": "Čeká na dokončení",
      "REJECTED": "Zamítnuto",
      "COMPLETED": "Ukončeno",
      "CANCELLED": "Zrušeno"
    },
    "purchaseOrderStatus": {
      "DRAFT": "Rozpracovaná",
      "SUBMITTED": "Odeslaná",
      "FOR_APPROVAL": "Ke schválení",
      "PRE_APPROVED": "Předschválená",
      "APPROVED": "Schválená",
      "DISPATCHED": "Odeslaná dodavateli",
      "REJECTED": "Neschválená",
      "CLOSED": "Uzavřená",
      "CANCELLED": "Zrušená"
    },
    "invoiceDisplayStatus": {
      "FOR_EDIT": "K editaci",
      "FOR_APPROVAL": "Ke schválení",
      "REJECTED": "Zamítnuto",
      "TO_POST": "K zaúčtování",
      "TO_PAY": "K proplacení",
      "TO_POST_AND_PAY": "K zaúčtování a proplacení",
      "COMPLETED": "Ukončeno",
      "CANCELLED": "Zrušeno"
    },
    "purchaseOrderDisplayStatus": {
      "DRAFT": "Koncept",
      "FOR_APPROVAL": "Ke schválení",
      "TO_SEND": "K odeslání",
      "AWAITING_DELIVERY": "Čeká na dodání",
      "AWAITING_INVOICE": "Čeká na fakturu",
      "AWAITING_DELIVERY_AND_INVOICE": "Čeká na dodání a fakturu",
      "AWAITING_COMPLETION": "Čeká na dokončení",
      "REJECTED": "Zamítnuto",
      "COMPLETED": "Ukončeno",
      "CANCELLED": "Zrušeno"
    },
    "deliveryStatus": {
      "NOT_DELIVERED": "Nedodáno",
      "PARTIALLY_DELIVERED": "Částečně dodáno",
      "DELIVERED": "Dodáno"
    },
    "invoicedStatus": {
      "NOT_INVOICED": "Nevyfakturováno",
      "PARTIALLY_INVOICED": "Částečně vyfakturováno",
      "INVOICED": "Vyfakturováno"
    },
    "procurementRelationship": {
      "RAISED_FOR_ME": "Podáno za mě",
      "RAISED_BY_ME": "Zadal jsem",
      "HANDED_TO_ME": "Předáno mně",
      "ASKED_TO_DECIDE": "K rozhodnutí",
      "BUYING_IT": "Nakupuji",
      "RECEIVED_BY_ME": "Přijal jsem"
    },
    "documentHistoryEventType": {
      "CREATED": "Vytvořeno",
      "UPDATED": "Upraveno",
      "STATUS_CHANGED": "Změna stavu",
      "APPROVAL_STATUS_CHANGED": "Změna schválení",
      "ARCHIVED": "Archivováno",
      "UNARCHIVED": "Archivace zrušena",
      "DOCUMENT_LINKED": "Připojen doklad",
      "DOCUMENT_UNLINKED": "Odpojen doklad",
      "ATTACHMENT_ADDED": "Příloha přidána",
      "ATTACHMENT_REMOVED": "Příloha odebrána",
      "TERM_ADDED": "Přidáno období",
      "TERM_CHANGED": "Změna období",
      "TERM_REMOVED": "Odebráno období"
    },
    "goodsReceiptStatus": {
      "DRAFT": "Rozpracovaná",
      "RECEIVED": "Přijato",
      "PARTIALLY_RECEIVED": "Částečně přijato",
      "INSPECTED": "Zkontrolováno",
      "REJECTED": "Odmítnuto",
      "CANCELLED": "Zrušená"
    },
    "incotermsCode": {
      "EXW": "EXW – Ze závodu",
      "FCA": "FCA – Vyplaceně dopravci",
      "CPT": "CPT – Přeprava placena do",
      "CIP": "CIP – Přeprava a pojištění placeny do",
      "DAP": "DAP – S dodáním v místě určení",
      "DPU": "DPU – S dodáním v místě určení vyloženo",
      "DDP": "DDP – S dodáním clo placeno",
      "FAS": "FAS – Vyplaceně k boku lodi",
      "FOB": "FOB – Vyplaceně loď",
      "CFR": "CFR – Náklady a přepravné",
      "CIF": "CIF – Náklady, pojištění a přepravné"
    },
    "productType": {
      "PRODUCT": "Zboží",
      "SERVICE": "Služba"
    },
    "procurementDocumentType": {
      "REQUISITION": "Žádanka",
      "PURCHASE_ORDER": "Objednávka",
      "GOODS_RECEIPT": "Dodací list",
      "INVOICE": "Faktura"
    },
    "contractStatus": {
      "DRAFT": "Koncept",
      "ACTIVE": "Aktivní",
      "TERMINATED": "Vypovězená"
    },
    "contractDisplayStatus": {
      "DRAFT": "Koncept",
      "IN_FORCE": "Platná",
      "TERMINATING": "Ve výpovědi",
      "ENDED": "Skončila",
      "NOT_YET_IN_FORCE": "Zatím neplatí"
    },
    "contractDirection": {
      "SUPPLIER": "Dodavatelská",
      "CUSTOMER": "Odběratelská"
    },
    "contractType": {
      "PURCHASE": "Kupní smlouva",
      "WORK": "Smlouva o dílo",
      "SERVICES": "Smlouva o poskytování služeb",
      "FRAMEWORK": "Rámcová smlouva",
      "LEASE": "Nájemní smlouva",
      "LICENSE": "Licenční smlouva",
      "SERVICE_MAINTENANCE": "Servisní smlouva",
      "COOPERATION": "Smlouva o spolupráci",
      "NDA": "Smlouva o mlčenlivosti (NDA)",
      "EMPLOYMENT": "Pracovní smlouva",
      "OTHER": "Jiná"
    },
    "contractTermOrigin": {
      "INITIAL": "Počáteční",
      "MANUAL": "Prodloužení (ruční)",
      "AUTOMATIC": "Automatické prodloužení"
    },
    "contractTermPeriod": {
      "PAST": "Minulé",
      "CURRENT": "Aktuální",
      "FUTURE": "Budoucí"
    },
    "contractLinkSource": {
      "MANUAL": "Ručně",
      "ORDER": "Z objednávky",
      "SUGGESTED": "Navrženo"
    },
    "contractNotCountedReason": {
      "NOT_YET_COUNTING": "Zatím se nezapočítává",
      "OTHER_CURRENCY": "Jiná měna",
      "OUT_OF_TERM": "Mimo období"
    },
    "matchType": {
      "AUTO": "Automaticky",
      "MANUAL": "Ručně",
      "AI": "Návrh AI"
    },
    "matchPairingRung": {
      "CODE": "kódu položky",
      "EAN": "EAN",
      "DESCRIPTION": "popisu",
      "ELIMINATION": "vyloučení"
    },
    "matchFindingType": {
      "UNRESOLVABLE_REFERENCE": "Objednávku nelze najít",
      "AMBIGUOUS_ORDER": "Nejednoznačná objednávka",
      "SUPPLIER_MISMATCH": "Jiný dodavatel",
      "UNKNOWN_LINE": "Neznámá položka",
      "AMBIGUOUS_PAIRING": "Nejednoznačné spárování",
      "WEAK_PAIRING": "Spárováno podle podobnosti"
    },
    "matchFindingAnswer": {
      "ACCEPTED": "Přijato",
      "REJECTED": "Zamítnuto",
      "PAIRED": "Spárováno",
      "LEAVE_OPEN": "Ponecháno otevřené"
    },
    "matchReviewOutcome": {
      "APPLIED": "Zapsáno",
      "LEFT_OPEN": "Ponecháno k rozhodnutí",
      "BELOW_THRESHOLD": "Nízká jistota",
      "SKIPPED": "Přeskočeno"
    },
    "matchFindingResolution": {
      "OPEN": "Otevřený",
      "ACCEPTED": "Přijato",
      "REJECTED": "Zamítnuto",
      "RESOLVED": "Vyřešeno"
    },
    "matchFindingSubjectType": {
      "INVOICE_LINE": "Položka faktury",
      "MATCH_LINK": "Spárování"
    },
    "approverFallbackStrategy": {
      "MANUAL_APPROVER_SELECTION": "Ruční volba schvalovatele",
      "ANYONE_WITH_PERMISSION": "Kdokoliv s oprávněním ke schválení",
      "ORG_STRUCTURE_THEN_FALLBACK_USER_THEN_ANYONE_WITH_PERMISSION": "Nadřízený žadatele",
      "DOCUMENT_UNIT_MANAGER_THEN_ANYONE_WITH_PERMISSION": "Nadřízený podle pozice org. struktury na dokladu",
      "ORG_UNIT_MANAGER_THEN_ANYONE_WITH_PERMISSION": "Vedoucí zvolené pozice org. struktury",
      "ORG_UNIT_MEMBER_THEN_ANYONE_WITH_PERMISSION": "Kdokoliv ze zvolené pozice org. struktury",
      "ROLE_MEMBER_THEN_ANYONE_WITH_PERMISSION": "Kdokoliv se zvolenou rolí",
      "FALLBACK_USER_THEN_ANYONE_WITH_PERMISSION": "Konkrétní uživatel",
      "SUGGESTED_APPROVER_THEN_ANYONE_WITH_PERMISSION": "Schvalovatel navržený na dokladu"
    },
    "assignableEntityType": {
      "REQUISITION": "Žádanka",
      "PURCHASE_ORDER": "Objednávka",
      "INVOICE": "Faktura"
    },
    "numberSeriesDocumentType": {
      "REQUISITION": "Žádanka",
      "PURCHASE_ORDER": "Objednávka",
      "GOODS_RECEIPT": "Dodací list",
      "CONTRACT": "Smlouva",
      "PAYMENT_RUN": "Platební dávka",
      "EXTRACTED_DOCUMENT": "Vytěžený doklad"
    },
    "masterAccountMemberClassification": {
      "EMPLOYEE": "Zaměstnanec firmy",
      "MASTER_ACCOUNT_MEMBER": "Člen kanceláře"
    },
    "bankAccountVerificationState": {
      "UNVERIFIED": "Neověřený",
      "PENDING": "Čeká na druhý podpis",
      "VERIFIED": "Ověřený",
      "REJECTED": "Zamítnutý",
      "REVOKED": "Zrušený"
    },
    "bankAccountSource": {
      "MANUAL": "Zadaný ručně",
      "ERP": "Z ERP",
      "INVOICE": "Z faktury"
    },
    "bankAccountScheme": {
      "IBAN": "IBAN",
      "CZ": "Český účet",
      "SK": "Slovenský účet",
      "GB_SORT_CODE": "Britský účet (sort code)",
      "US_ABA": "Americký účet (ABA)",
      "OTHER": "Účet v jiné zemi"
    },
    "partyBankAccountEventType": {
      "CREATED": "Účet přidán",
      "FIRST_SIGNED": "První podpis",
      "SYSTEM_CHECKED": "První podpis od systému",
      "VERIFIED": "Druhý podpis, účet ověřen",
      "REJECTED": "Účet zamítnut",
      "REVOKED": "Ověření zrušeno",
      "DEACTIVATED": "Účet deaktivován"
    },
    "bankMovementSource": {
      "STATEMENT": "Bankovní výpis",
      "ERP": "ERP"
    },
    "bankMovementChannel": {
      "BANK": "Banka",
      "CASH": "Pokladna",
      "INTERNAL": "Interní doklad"
    },
    "bankMovementDirection": {
      "INCOMING": "Příchozí",
      "OUTGOING": "Odchozí"
    },
    "bankMovementResolution": {
      "UNMATCHED": "Nespárovaný",
      "PROPOSED": "Navržený",
      "MATCHED": "Spárovaný",
      "NOT_APPLICABLE": "Nepoužije se",
      "DISMISSED": "Vyřazený"
    },
    "bankStatementFormat": {
      "CAMT_053": "CAMT.053",
      "MT940": "MT940",
      "ABO_GPC": "ABO (GPC)"
    },
    "creditorReferenceType": {
      "RF": "Reference RF",
      "CZ_SK_SYMBOLS": "Symboly (VS, KS, SS)",
      "FREE": "Volný text"
    },
    "paymentInstructionStatus": {
      "PLANNED": "Připravená",
      "RELEASED": "Uvolněná",
      "SENT": "V souboru pro banku",
      "CONFIRMED": "Potvrzená",
      "RETURNED": "Vrácená bankou",
      "FAILED": "Neprovedená",
      "CANCELLED": "Zrušená"
    },
    "paymentConfirmationSource": {
      "STATEMENT": "Bankovní výpis",
      "ERP": "ERP",
      "HUMAN": "Ručně"
    },
    "paymentRunStatus": {
      "DRAFT": "Rozpracovaná",
      "PROPOSED": "Ke schválení",
      "APPROVED": "Schválená",
      "RELEASED": "Uvolněná",
      "EXPORTED": "Exportovaná",
      "CONFIRMED": "Potvrzená",
      "CANCELLED": "Zrušená"
    },
    "payableClause": {
      "NOT_APPROVED": "neschválená",
      "RESERVED": "je v uvolněné dávce",
      "NOTHING_OUTSTANDING": "není co doplatit",
      "NO_VERIFIED_ACCOUNT": "dodavatel nemá ověřený účet",
      "AMBIGUOUS_ACCOUNT": "nevíme, na který ověřený účet platit",
      "OVER_BILLED": "objednávka je přefakturovaná",
      "ERP_REPORTS_PAID": "ERP ji hlásí jako proplacenou",
      "ARCHIVED": "archivovaná",
      "CANCELLED": "zrušená"
    },
    "paymentExportFormat": {
      "SEPA_PAIN_001": "SEPA (pain.001)",
      "ABO": "ABO (KPC)"
    },
    "bankStatementImportStatus": {
      "PENDING": "Čeká na načtení",
      "PROCESSING": "Načítá se",
      "DONE": "Načteno",
      "FAILED": "Nenačteno"
    },
    "bankMovementProposalKind": {
      "IDENTITY": "Shoda identifikátoru",
      "REFERENCE": "Shoda symbolu",
      "RESEMBLANCE": "Podobnost",
      "RETURN": "Vratka",
      "MANUAL": "Ruční spárování",
      "SUM": "Součet plateb"
    },
    "bankMovementProposalStatus": {
      "OPEN": "Otevřený",
      "ACCEPTED": "Přijatý",
      "REJECTED": "Zamítnutý",
      "SUPERSEDED": "Nahrazený"
    },
    "bankMovementProposalReason": {
      "AMOUNT_DIFFERS": "Částka se liší od platby.",
      "COUNTERPARTY_DIFFERS": "Peníze šly na jiný účet, než má platba.",
      "COUNTERPARTY_MISSING": "Výpis neuvádí účet protistrany.",
      "REFERENCE_AMBIGUOUS": "Stejný symbol má víc plateb.",
      "PAYMENT_NOT_SENT": "Platba ještě nebyla v souboru pro banku.",
      "PAYMENT_NOT_LIVE": "Platba už neplatí – je zrušená, neprovedená nebo vrácená.",
      "CURRENCY_DIFFERS": "Měna se liší od platby.",
      "UPLOADED_BY_RUN_AUTHOR": "Výpis nahrál někdo, kdo platbu v dávce připravoval, proto ji sami nepárujeme.",
      "DUPLICATE": "Tuhle platbu už potvrdil jiný pohyb, takže tady může jít o dvojí stržení.",
      "PREVIOUSLY_REVOKED": "Tohle spárování už někdo jednou odvolal."
    },
    "paymentDifferenceKind": {
      "FEE": "Bankovní poplatek",
      "FX_DIFFERENCE": "Kurzový rozdíl",
      "PARTIAL": "Částečná platba",
      "RETURNED": "Vráceno bankou"
    }
  },
  "features": {
    "attachments": {
      "title": "Přílohy",
      "empty": "Bez příloh",
      "add": "Přidat přílohu",
      "download": "Stáhnout {{fileName}}",
      "preview": "Zobrazit náhled",
      "previewClose": "Zavřít",
      "previewDownload": "Stáhnout",
      "remove": "Odebrat přílohu",
      "removeTitle": "Odebrat přílohu",
      "removeMessage": "Příloha {{fileName}} bude z dokladu trvale odebrána.",
      "cancel": "Zrušit",
      "confirmUpload": "Nahrát ({{count}})",
      "staged": "Soubory k nahrání ({{count}})",
      "removeStaged": "Odebrat {{fileName}} ze seznamu",
      "addTitle": "Přidat přílohy",
      "addDescription": "Vybrané soubory se připojí k dokladu a zůstanou dostupné ke stažení.",
      "uploadTitle": "Přetáhnout soubory sem",
      "uploadDescription": "Nebo vybrat z počítače",
      "errors": {
        "refused": "Soubor nelze připojit — obsah neodpovídá jeho příponě.",
        "documentLocked": "Doklad již nelze upravovat, přílohy zůstávají beze změny.",
        "tooLarge": "Soubor je příliš velký.",
        "uploadFailed": "Připojení přílohy se nezdařilo.",
        "tooManyFiles_one": "Najednou lze připojit jen {{count}} soubor.",
        "tooManyFiles_few": "Najednou lze připojit nejvýše {{count}} soubory.",
        "tooManyFiles_other": "Najednou lze připojit nejvýše {{count}} souborů.",
        "limitReached": "Doklad již obsahuje maximální počet příloh.",
        "busy": "Soubor teď nelze zpracovat. Zkuste to prosím znovu za chvíli.",
        "tooSlow": "Připojení je pro tento soubor příliš pomalé. Zkuste to prosím znovu na rychlejším připojení.",
        "filesFailed": "Nepodařilo se připojit: {{files}}.",
        "removeFailed": "Odebrání přílohy se nezdařilo."
      }
    },
    "aiChat": {
      "title": "Tappeer AI",
      "connectingMessage": "Přemýšlím…",
      "unread": "Nová zpráva od asistenta",
      "online": "Online",
      "collapsePanel": "Sbalit chat",
      "expandPanel": "Rozbalit chat",
      "openChat": "Otevřít Tappeer AI",
      "launcherHint": "Zeptej se Tappeera na faktury, schvalování nebo výdaje.",
      "inputPlaceholder": "Zeptej se na cokoliv…",
      "typingMessage": "Tappeer píše",
      "userLabel": "Ty",
      "inputActions": {
        "quickActions": "Rychlé akce",
        "help": "Nápověda"
      },
      "quickActions": {
        "title": "Rychlé akce",
        "subtitle": "Vyber si a rovnou odešli. Některé je potřeba doplnit.",
        "needsInput": "doplň",
        "needsInputHint": "Doplň detail a odešli",
        "topics": {
          "daily": "Tvůj den",
          "invoices": "Faktury",
          "reporting": "Reporty",
          "partners": "Partneři"
        },
        "myWork": "Co čeká na moje schválení?",
        "myRequests": "Jak jsou na tom moje žádanky a objednávky?",
        "invoiceLookup": "Najdi faktury od dodavatele",
        "duePayments": "Co máme proplatit tento týden?",
        "overdue": "Které faktury jsou po splatnosti?",
        "spend": "Kolik jsme utratili tento měsíc?",
        "report": "Ukaž mi graf výdajů po dodavatelích za tento rok",
        "matching": "Které faktury mají otevřené nálezy párování?",
        "gettingStarted": "Jak si nastavím Tappeera?",
        "invoiceIssues": "Které faktury mají chyby validace?",
        "purchaseOrders": "Ukaž mi naše otevřené objednávky",
        "partnerVerify": "Zkontroluj IČO a stav DPH tohoto partnera",
        "mailbox": "Jakou máme e‑mailovou adresu pro faktury?",
        "plan": "Jaký máme tarif a kolik zbývá kvóty?",
        "syncStatus": "Synchronizují se naše integrace správně?",
        "notifications": "Co se stalo, když jsem tu nebyl?",
        "partnerLookup": "Ukaž mi detail partnera"
      },
      "help": {
        "title": "Jak používat Tappeer AI",
        "intro": "Tappeer AI je asistent, který vidí tvoje faktury, objednávky a partnery. Ptej se běžnou řeči — česky i anglicky. Odpovídá jen na data tvého účtu a jen na to, k čemu máš oprávnění.",
        "capabilitiesTitle": "S čím pomůže",
        "capabilities": {
          "invoices": "Faktury — najde fakturu, ukáže položky, historii i chyby validace.",
          "approvals": "Schvalování — schválí, zamítne nebo vrátí fakturu (vždy až po tvém potvrzení).",
          "payments": "Platby — co je po splatnosti, co se platí v daném období a jak fakturu proplatit.",
          "spend": "Reporty a grafy — souhrny útrat, průměry a žebříčky dodavatelů za období, vykreslené jako grafy.",
          "matching": "Párování — jak položky faktury sedí na položky objednávky a které nálezy jsou otevřené.",
          "orders": "Objednávky a požadavky — co bylo objednáno, co dorazilo a kde je můj požadavek.",
          "partners": "Partneři — vyhledání, detail, ověření IČO/DIČ a přidání nových partnerů.",
          "account": "Účet — tarif, spotřeba vytěžování, nastavení, uživatelé a e-mail pro faktury.",
          "gettingStarted": "Začátky — provede nastavením účtu a nasměruje tě na správnou stránku.",
          "validation": "Validace — které faktury mají chyby nebo varování a co přesně je špatně.",
          "notifications": "Tvůj den — co čeká na tvé rozhodnutí a co se změnilo, když jsi tu nebyl.",
          "banking": "Bankovní spojení — ověř účet partnera proti veřejnému registru ještě před platbou."
        },
        "tipsTitle": "Tipy pro lepší odpovědi",
        "tips": {
          "beSpecific": "Buď konkrétní — uveď číslo faktury, dodavatele nebo období.",
          "followUp": "Můžeš se doptávat. Asistent si pamatuje předchozí zprávy v konverzaci.",
          "confirm": "Akce, které něco mění, nabídne jako návrh — provedou se až po tvém potvrzení.",
          "reset": "Novou konverzaci začneš tlačítkem pro reset v záhlaví chatu."
        },
        "limitsTitle": "Dobré vědět",
        "limits": {
          "permissions": "Vidí jen data tvého účtu a jen to, na co máš práva.",
          "accuracy": "Umí se splést — u důležitých čísel si výsledek ověř ve faktuře."
        },
        "close": "Zavřít",
        "admin": {
          "title": "Pro administrátory",
          "mailbox": "E‑mail pro faktury — adresa, na kterou dodavatelé posílají faktury.",
          "plan": "Tarif a kvóta — předplatné, limity zpracování a kolik zbývá.",
          "usage": "Spotřeba — kolik dokumentů bylo zpracováno a kým.",
          "settings": "Kontrola nastavení — které části konfigurace chybí nebo selhávají.",
          "sync": "Integrace — stav synchronizace, poslední aktivita a opakování neúspěšných běhů.",
          "users": "Uživatelé — kdo má přístup a pozvání nových lidí do účtu."
        }
      },
      "emptyState": {
        "title": "Pojďme na to",
        "subtitle": "Zeptej se na faktury, schvalování nebo výdaje — nebo si vyber z nápadů níže.",
        "suggestionOverdue": "Které faktury jsou po splatnosti?",
        "suggestionApprovals": "Co čeká na moje schválení?",
        "suggestionMyRequests": "Jak jsou na tom moje žádanky a objednávky?",
        "suggestionSpend": "Shrň výdaje za tento měsíc"
      },
      "openInvoice": "Otevřít fakturu",
      "invoiceCard": {
        "due": "splatnost",
        "errorCount_one": "{{count}} chyba",
        "errorCount_few": "{{count}} chyby",
        "errorCount_other": "{{count}} chyb",
        "warningCount_one": "{{count}} varování",
        "warningCount_few": "{{count}} varování",
        "warningCount_other": "{{count}} varování",
        "overdueDays_one": "{{count}} den po splatnosti",
        "overdueDays_few": "{{count}} dny po splatnosti",
        "overdueDays_other": "{{count}} dnů po splatnosti"
      },
      "invoiceCollection": {
        "title_one": "{{count}} faktura",
        "title_few": "{{count}} faktury",
        "title_other": "{{count}} faktur",
        "showAll_one": "Zobrazit {{count}} fakturu",
        "showAll_few": "Zobrazit {{count}} faktury",
        "showAll_other": "Zobrazit všech {{count}}",
        "partialNotice": "Zobrazeno {{shown}} z {{total}}. Součty pokrývají vše nalezené.",
        "currencyCount_one": "{{count}} faktura v {{currency}}",
        "currencyCount_few": "{{count}} faktury v {{currency}}",
        "currencyCount_other": "{{count}} faktur v {{currency}}",
        "number": "Číslo",
        "supplier": "Dodavatel",
        "amount": "Částka",
        "status": "Stav",
        "dueDate": "Splatnost",
        "issues": "Problémy"
      },
      "issueCollection": {
        "title": "Problémy kontroly",
        "titleFor": "Problémy na {{number}}",
        "showAll_one": "Zobrazit {{count}} problém",
        "showAll_few": "Zobrazit {{count}} problémy",
        "showAll_other": "Zobrazit všech {{count}}",
        "partialNotice": "Ukazuju {{shown}} z {{total}}.",
        "severity": "Závažnost",
        "field": "Pole",
        "problem": "Problém",
        "error": "Chyba",
        "warning": "Varování"
      },
      "resetConfirm": {
        "title": "Začít znovu?",
        "message": "Smažu celou konverzaci a začneme s čistým štítem. Tohle už nevrátím.",
        "confirm": "Smazat konverzaci"
      },
      "settings": {
        "open": "Nastavení chatu",
        "title": "Nastavení chatu",
        "greetingLabel": "Přivítat mě po přihlášení",
        "greetingHint": "Tappeer jednou denně otevře chat a řekne, co vyžaduje tvou pozornost.",
        "saveFailed": "Uložení nevyšlo. Zkus to znovu.",
        "displayMode": {
          "label": "Kde se chat zobrazuje",
          "hint": "Vyber plovoucí bublinu, ukotvený boční sloupec, nebo chat úplně skryj.",
          "bubble": "Bublina",
          "docked": "Boční panel",
          "hidden": "Skrytý"
        }
      },
      "invoiceDetail": {
        "noNumber": "Bez čísla",
        "supplier": "Dodavatel",
        "supplierVatId": "DIČ",
        "customer": "Odběratel",
        "invoiceDate": "Datum vystavení",
        "dueDate": "Datum splatnosti",
        "taxDate": "Datum zdanitelného plnění",
        "documentType": "Typ dokladu",
        "internalNumber": "Interní číslo",
        "description": "Popis",
        "totalNoVat": "Základ daně",
        "totalVat": "DPH",
        "total": "Celkem",
        "paymentStatus": "Stav platby",
        "paidAmount": "Uhrazeno",
        "paidDate": "Datum úhrady",
        "paymentMethod": "Způsob platby",
        "lines": "Položky",
        "history": "Historie změn",
        "expand": "Zobrazit položky a historii",
        "collapse": "Skrýt detail"
      },
      "aggregateSummary": {
        "metric": {
          "total": "Celková částka",
          "average": "Průměrná částka faktury",
          "count": "Počet faktur",
          "min": "Nejnižší faktura",
          "max": "Nejvyšší faktura",
          "median": "Medián částky faktury"
        },
        "groupBy": {
          "supplier": "Dodavatel",
          "month": "Měsíc",
          "quarter": "Čtvrtletí",
          "year": "Rok",
          "week": "Týden",
          "day": "Den",
          "weekday": "Den v týdnu",
          "dayOfMonth": "Den v měsíci",
          "status": "Stav",
          "currency": "Měna",
          "paymentMethod": "Forma úhrady"
        },
        "overall": "Celkem",
        "noData": "Za tohle období jsem žádné faktury nenašel",
        "invoiceCount": "Faktury",
        "truncated": "Zobrazuju jen top výsledky"
      },
      "chartLabels": {
        "text": {
          "unknown": "Neuvedeno",
          "unknownSupplier": "Neznámý dodavatel",
          "unknownPeriod": "Neznámé období",
          "invoices": "Faktury"
        },
        "invoiceStatus": {
          "draft": "Rozpracované",
          "submitted": "Odeslané",
          "forApproval": "Ke schválení",
          "approved": "Schválené",
          "rejected": "Zamítnuté",
          "completed": "Ukončené",
          "archived": "Archivované"
        },
        "weekday": {
          "monday": "Pondělí",
          "tuesday": "Úterý",
          "wednesday": "Středa",
          "thursday": "Čtvrtek",
          "friday": "Pátek",
          "saturday": "Sobota",
          "sunday": "Neděle"
        },
        "paymentMethod": {
          "BANK_TRANSFER": "Bankovní převod",
          "CASH": "Hotovost",
          "CARD": "Platební karta",
          "CHECK": "Šek",
          "DIRECT_DEBIT": "Přímé inkaso",
          "CLEARING": "Zápočet",
          "OTHER": "Jiná forma platby"
        }
      },
      "chartExport": {
        "button": "Exportovat",
        "labelHeader": "Popisek",
        "modal": {
          "title": "Exportovat graf",
          "subtitle": "Vyber formát pro stažení grafu",
          "exporting": "Exportuji…",
          "error": "Export se nepovedl. Zkus to prosím znovu.",
          "cancel": "Zrušit"
        },
        "formats": {
          "pdf": {
            "title": "PDF",
            "description": "Obrázek grafu tak, jak ho vidíš — pro sdílení a tisk"
          },
          "xlsx": {
            "title": "Excel",
            "description": "Podkladová datová tabulka — pro další analýzu"
          }
        }
      },
      "activities": {
        "invoiceSearch": {
          "running": "Hledám faktury…",
          "done": "Hledání faktur dokončeno",
          "failed": "Hledání nevyšlo"
        },
        "invoiceValidationErrors": {
          "running": "Hledám faktury s chybami…",
          "done": "Kontrola chyb dokončena",
          "failed": "Hledání nevyšlo"
        },
        "invoiceAggregate": {
          "running": "Připravuju report…",
          "done": "Report je hotový",
          "failed": "Nevyšlo to"
        },
        "invoicesByStatus": {
          "running": "Počítám faktury podle stavu…",
          "done": "Přehled stavů dokončen",
          "failed": "Nevyšlo to"
        },
        "duePaymentsOutlook": {
          "running": "Připravuju výhled plateb…",
          "done": "Výhled plateb dokončen",
          "failed": "Nevyšlo to"
        },
        "invoiceBlockers": {
          "running": "Koukám, co fakturu blokuje…",
          "done": "Kontrola blokací dokončena",
          "failed": "Nevyšlo to"
        },
        "invoiceDetail": {
          "running": "Otevírám fakturu…",
          "done": "Načtení faktury dokončeno",
          "failed": "Načtení nevyšlo"
        },
        "accountPlan": {
          "running": "Koukám na předplatné…",
          "done": "Kontrola předplatného dokončena",
          "failed": "Nevyšlo to"
        },
        "settingsCheck": {
          "running": "Kontroluju nastavení…",
          "done": "Kontrola nastavení dokončena",
          "failed": "Kontrola nevyšla"
        },
        "extractionUsage": {
          "running": "Koukám na využití vytěžování…",
          "done": "Kontrola vytěžování dokončena",
          "failed": "Nevyšlo to"
        },
        "inviteUser": {
          "running": "Připravuju návrh…",
          "done": "Návrh pozvánky připraven",
          "failed": "Návrh nevyšel"
        },
        "addPartners": {
          "running": "Hledám firmy v registru…",
          "done": "Hledání firem dokončeno",
          "failed": "Hledání nevyšlo"
        },
        "approveInvoice": {
          "running": "Připravuju návrh…",
          "done": "Návrh schválení připraven",
          "failed": "Návrh nevyšel"
        },
        "moveInvoiceStatus": {
          "running": "Připravuju návrh…",
          "done": "Návrh změny stavu připraven",
          "failed": "Návrh nevyšel"
        },
        "revertInvoice": {
          "running": "Připravuju návrh…",
          "done": "Návrh vrácení připraven",
          "failed": "Návrh nevyšel"
        },
        "rejectInvoice": {
          "running": "Připravuju návrh…",
          "done": "Návrh zamítnutí připraven",
          "failed": "Návrh nevyšel"
        },
        "partnerSearch": {
          "running": "Hledám partnery…",
          "done": "Hledání partnerů dokončeno",
          "failed": "Hledání nevyšlo"
        },
        "partnerDetail": {
          "running": "Otevírám partnera…",
          "done": "Načtení partnera dokončeno",
          "failed": "Načtení nevyšlo"
        },
        "partnerVerify": {
          "running": "Ověřuju firmu…",
          "done": "Ověření firmy dokončeno",
          "failed": "Ověření nevyšlo"
        },
        "userDirectory": {
          "running": "Načítám tým…",
          "done": "Načtení týmu dokončeno",
          "failed": "Načtení nevyšlo"
        },
        "mailboxAddress": {
          "running": "Hledám e-mail pro faktury…",
          "done": "Kontrola e-mailu dokončena",
          "failed": "Nevyšlo to"
        },
        "matchFindings": {
          "running": "Načítám nálezy párování…",
          "done": "Načtení nálezů dokončeno",
          "failed": "Načtení nevyšlo"
        },
        "matchSummary": {
          "running": "Kontroluju párování…",
          "done": "Kontrola párování dokončena",
          "failed": "Kontrola nevyšla"
        },
        "answerFinding": {
          "running": "Připravuju návrh…",
          "done": "Návrh odpovědi připraven",
          "failed": "Návrh nevyšel"
        },
        "purchaseOrderSearch": {
          "running": "Hledám objednávky…",
          "done": "Hledání objednávek dokončeno",
          "failed": "Hledání nevyšlo"
        },
        "purchaseOrderDetail": {
          "running": "Otevírám objednávku…",
          "done": "Načtení objednávky dokončeno",
          "failed": "Načtení nevyšlo"
        },
        "requisitionSearch": {
          "running": "Hledám žádanky…",
          "done": "Hledání žádanek dokončeno",
          "failed": "Hledání nevyšlo"
        },
        "requisitionDetail": {
          "running": "Otevírám žádanku…",
          "done": "Načtení žádanky dokončeno",
          "failed": "Načtení nevyšlo"
        },
        "duePayments": {
          "running": "Koukám na splatné platby…",
          "done": "Kontrola splatnosti dokončena",
          "failed": "Nevyšlo to"
        },
        "paymentDetails": {
          "running": "Načítám platební údaje…",
          "done": "Načtení platebních údajů dokončeno",
          "failed": "Načtení nevyšlo"
        },
        "myApprovalQueue": {
          "running": "Koukám, co na tebe čeká…",
          "done": "Fronta ke schválení prověřena",
          "failed": "Nevyšlo to"
        },
        "myNotifications": {
          "running": "Koukám, co právě běží…",
          "done": "Aktivita prověřena",
          "failed": "Nevyšlo to"
        },
        "syncStatus": {
          "running": "Kontroluju synchronizaci…",
          "done": "Kontrola synchronizace dokončena",
          "failed": "Kontrola nevyšla"
        },
        "syncActivity": {
          "running": "Načítám historii synchronizace…",
          "done": "Načtení historie dokončeno",
          "failed": "Načtení nevyšlo"
        },
        "bridgeStatus": {
          "running": "Kontroluji Bridge…",
          "done": "Kontrola Bridge dokončena",
          "failed": "Kontrola nevyšla"
        },
        "openInApp": {
          "running": "Hledám odkaz…",
          "done": "Odkaz připraven",
          "failed": "Nevyšlo to"
        },
        "bankAccountCheck": {
          "running": "Kontroluju bankovní účet…",
          "done": "Kontrola účtu dokončena",
          "failed": "Kontrola nevyšla"
        },
        "partnersVerify": {
          "running": "Ověřuju v rejstříku…",
          "done": "Firmy ověřeny",
          "failed": "Nepovedlo se je ověřit"
        },
        "invoicesBlockers": {
          "running": "Zjišťuju, co je blokuje…",
          "done": "Blokace prověřeny",
          "failed": "Nepovedlo se je prověřit"
        },
        "maintainInvoices": {
          "running": "Připravuju návrh…",
          "done": "Návrh údržby připraven",
          "failed": "Návrh nevyšel"
        },
        "moveInvoicesStatus": {
          "running": "Připravuju návrh…",
          "done": "Návrh změny stavu připraven",
          "failed": "Návrh nevyšel"
        },
        "inviteUsers": {
          "running": "Připravuju návrh…",
          "done": "Návrh pozvánek připraven",
          "failed": "Návrh nevyšel"
        },
        "maintainPartners": {
          "running": "Připravuju návrh…",
          "done": "Návrh úpravy partnerů připraven",
          "failed": "Návrh nevyšel"
        },
        "moveRequisitionsStatus": {
          "running": "Připravuju návrh…",
          "done": "Návrh změny stavu požadavků připraven",
          "failed": "Návrh nevyšel"
        },
        "movePurchaseOrdersStatus": {
          "running": "Připravuju návrh…",
          "done": "Návrh změny stavu objednávek připraven",
          "failed": "Návrh nevyšel"
        },
        "submitRequisitions": {
          "running": "Připravuju návrh…",
          "done": "Návrh odeslání požadavků připraven",
          "failed": "Návrh nevyšel"
        },
        "submitPurchaseOrders": {
          "running": "Připravuju návrh…",
          "done": "Návrh odeslání objednávek připraven",
          "failed": "Návrh nevyšel"
        },
        "retrySyncs": {
          "running": "Připravuju návrh…",
          "done": "Návrh opakování synchronizace připraven",
          "failed": "Návrh nevyšel"
        },
        "cancelRequisitions": {
          "running": "Připravuji zrušení…",
          "done": "Zrušení připraveno",
          "failed": "Zrušení se nepodařilo připravit"
        },
        "completeRequisitions": {
          "running": "Připravuji dokončení…",
          "done": "Dokončení připraveno",
          "failed": "Dokončení se nepodařilo připravit"
        },
        "archiveRequisitions": {
          "running": "Připravuji archivaci…",
          "done": "Archivace připravena",
          "failed": "Archivaci se nepodařilo připravit"
        },
        "unarchiveRequisitions": {
          "running": "Připravuji obnovení z archivu…",
          "done": "Obnovení připraveno",
          "failed": "Obnovení se nepodařilo připravit"
        },
        "returnRequisitionsToDraft": {
          "running": "Připravuji vrácení k úpravám…",
          "done": "Vrácení připraveno",
          "failed": "Vrácení se nepodařilo připravit"
        },
        "acceptRequisitionWarnings": {
          "running": "Připravuji přijetí varování…",
          "done": "Přijetí připraveno",
          "failed": "Přijetí se nepodařilo připravit"
        },
        "deleteRequisitions": {
          "running": "Připravuji smazání…",
          "done": "Smazání připraveno",
          "failed": "Smazání se nepodařilo připravit"
        },
        "draftRequisition": {
          "running": "Připravuji požadavek…",
          "done": "Požadavek připraven",
          "failed": "Požadavek se nepodařilo připravit"
        },
        "requisitionValidation": {
          "running": "Kontroluji požadavek…",
          "done": "Požadavek zkontrolován",
          "failed": "Požadavek se nepodařilo zkontrolovat"
        },
        "requisitionTracking": {
          "running": "Dohledávám požadavek…",
          "done": "Požadavek dohledán",
          "failed": "Požadavek se nepodařilo dohledat"
        },
        "draftPurchaseOrder": {
          "running": "Připravuji objednávku…",
          "done": "Objednávka připravena",
          "failed": "Objednávku se nepodařilo připravit"
        },
        "orderFromRequisition": {
          "running": "Připravuji objednávku z požadavku…",
          "done": "Objednávka připravena",
          "failed": "Objednávku se nepodařilo připravit"
        },
        "purchaseOrderValidation": {
          "running": "Kontroluji objednávku…",
          "done": "Objednávka zkontrolována",
          "failed": "Objednávku se nepodařilo zkontrolovat"
        },
        "purchaseOrderDispatchPreview": {
          "running": "Připravuji e-mail…",
          "done": "E-mail připraven",
          "failed": "E-mail se nepodařilo připravit"
        },
        "dispatchPurchaseOrder": {
          "running": "Připravuji odeslání objednávky…",
          "done": "Odeslání připraveno",
          "failed": "Odeslání se nepodařilo připravit"
        },
        "outstandingOrders": {
          "running": "Hledám otevřené objednávky…",
          "done": "Otevřené objednávky nalezeny",
          "failed": "Otevřené objednávky se nepodařilo načíst"
        },
        "costCenterSearch": {
          "running": "Hledám nákladová střediska…",
          "done": "Hledání středisek dokončeno",
          "failed": "Střediska se nepodařilo vyhledat"
        },
        "jobSearch": {
          "running": "Hledám zakázky…",
          "done": "Hledání zakázek dokončeno",
          "failed": "Zakázky se nepodařilo vyhledat"
        },
        "orgUnitSearch": {
          "running": "Hledám organizační jednotky…",
          "done": "Hledání jednotek dokončeno",
          "failed": "Organizační jednotky se nepodařilo vyhledat"
        },
        "cancelPurchaseOrders": {
          "running": "Připravuji zrušení…",
          "done": "Zrušení připraveno",
          "failed": "Zrušení se nepodařilo připravit"
        },
        "completePurchaseOrders": {
          "running": "Připravuji dokončení…",
          "done": "Dokončení připraveno",
          "failed": "Dokončení se nepodařilo připravit"
        },
        "archivePurchaseOrders": {
          "running": "Připravuji archivaci…",
          "done": "Archivace připravena",
          "failed": "Archivaci se nepodařilo připravit"
        },
        "unarchivePurchaseOrders": {
          "running": "Připravuji obnovení z archivu…",
          "done": "Obnovení připraveno",
          "failed": "Obnovení se nepodařilo připravit"
        },
        "returnPurchaseOrdersToDraft": {
          "running": "Připravuji vrácení k úpravám…",
          "done": "Vrácení připraveno",
          "failed": "Vrácení se nepodařilo připravit"
        },
        "acceptPurchaseOrderWarnings": {
          "running": "Připravuji přijetí varování…",
          "done": "Přijetí připraveno",
          "failed": "Přijetí se nepodařilo připravit"
        },
        "deletePurchaseOrders": {
          "running": "Připravuji smazání…",
          "done": "Smazání připraveno",
          "failed": "Smazání se nepodařilo připravit"
        },
        "goodsReceiptSearch": {
          "running": "Hledám příjemky…",
          "done": "Hledání příjemek dokončeno",
          "failed": "Příjemky se nepodařilo vyhledat"
        },
        "goodsReceiptDetail": {
          "running": "Otevírám příjemku…",
          "done": "Příjemka načtena",
          "failed": "Příjemku se nepodařilo načíst"
        },
        "receiveFromPurchaseOrder": {
          "running": "Připravuji příjemku…",
          "done": "Příjemka připravena k potvrzení",
          "failed": "Příjemku se nepodařilo připravit"
        },
        "draftGoodsReceipt": {
          "running": "Připravuji příjemku…",
          "done": "Příjemka připravena k potvrzení",
          "failed": "Příjemku se nepodařilo připravit"
        },
        "confirmGoodsReceipts": {
          "running": "Připravuji potvrzení…",
          "done": "Potvrzení připraveno",
          "failed": "Potvrzení se nepodařilo připravit"
        },
        "cancelGoodsReceipts": {
          "running": "Připravuji zrušení…",
          "done": "Zrušení připraveno",
          "failed": "Zrušení se nepodařilo připravit"
        },
        "confirmDeliveryWithoutReceipt": {
          "running": "Připravuji potvrzení dodávky…",
          "done": "Potvrzení dodávky připraveno",
          "failed": "Potvrzení dodávky se nepodařilo připravit"
        },
        "archiveGoodsReceipts": {
          "running": "Připravuji archivaci…",
          "done": "Archivace připravena",
          "failed": "Archivaci se nepodařilo připravit"
        },
        "unarchiveGoodsReceipts": {
          "running": "Připravuji obnovení z archivu…",
          "done": "Obnovení připraveno",
          "failed": "Obnovení se nepodařilo připravit"
        },
        "deleteGoodsReceipts": {
          "running": "Připravuji smazání…",
          "done": "Smazání připraveno",
          "failed": "Smazání se nepodařilo připravit"
        },
        "documentSearch": {
          "running": "Hledám dokumenty…",
          "done": "Hledání dokumentů dokončeno",
          "failed": "Dokumenty se nepodařilo vyhledat"
        },
        "reprocessDocuments": {
          "running": "Připravuji vytěžení…",
          "done": "Vytěžení připraveno k potvrzení",
          "failed": "Vytěžení se nepodařilo připravit"
        },
        "deleteDocuments": {
          "running": "Připravuji smazání…",
          "done": "Smazání připraveno",
          "failed": "Smazání se nepodařilo připravit"
        },
        "quarantinedEmails": {
          "running": "Kontroluji karanténu…",
          "done": "Karanténa načtena",
          "failed": "Karanténu se nepodařilo načíst"
        },
        "releaseQuarantinedEmails": {
          "running": "Připravuji uvolnění…",
          "done": "Uvolnění připraveno",
          "failed": "Uvolnění se nepodařilo připravit"
        },
        "discardQuarantinedEmails": {
          "running": "Připravuji zahození…",
          "done": "Zahození připraveno",
          "failed": "Zahození se nepodařilo připravit"
        },
        "trustedSenders": {
          "running": "Načítám důvěryhodné odesílatele…",
          "done": "Důvěryhodní odesílatelé načteni",
          "failed": "Důvěryhodné odesílatele se nepodařilo načíst"
        },
        "trustSenders": {
          "running": "Připravuji důvěryhodné odesílatele…",
          "done": "Odesílatelé připraveni k potvrzení",
          "failed": "Odesílatele se nepodařilo připravit"
        },
        "untrustSenders": {
          "running": "Připravuji odebrání…",
          "done": "Odebrání připraveno",
          "failed": "Odebrání se nepodařilo připravit"
        },
        "manageMailbox": {
          "running": "Připravuji změnu schránky…",
          "done": "Změna schránky připravena",
          "failed": "Změnu schránky se nepodařilo připravit"
        },
        "invoiceRelationships": {
          "running": "Načítám navázané doklady…",
          "done": "Navázané doklady načteny",
          "failed": "Navázané doklady se nepodařilo načíst"
        },
        "linkInvoices": {
          "running": "Připravuji vazbu…",
          "done": "Vazba připravena k potvrzení",
          "failed": "Vazbu se nepodařilo připravit"
        },
        "unlinkInvoices": {
          "running": "Připravuji zrušení vazby…",
          "done": "Zrušení vazby připraveno",
          "failed": "Zrušení vazby se nepodařilo připravit"
        },
        "invoiceAttachments": {
          "running": "Načítám přílohy…",
          "done": "Přílohy načteny",
          "failed": "Přílohy se nepodařilo načíst"
        },
        "removeInvoiceAttachments": {
          "running": "Připravuji odebrání příloh…",
          "done": "Odebrání připraveno",
          "failed": "Odebrání se nepodařilo připravit"
        },
        "exchangeRates": {
          "running": "Hledám kurzy…",
          "done": "Kurzy nalezeny",
          "failed": "Kurzy se nepodařilo načíst"
        },
        "editInvoice": {
          "running": "Připravuji úpravu faktury…",
          "done": "Úprava faktury připravena k potvrzení",
          "failed": "Úpravu faktury se nepodařilo připravit"
        },
        "codeInvoices": {
          "running": "Připravuji zaúčtování na střediska…",
          "done": "Zaúčtování připraveno k potvrzení",
          "failed": "Zaúčtování se nepodařilo připravit"
        },
        "invoiceValidation": {
          "running": "Kontroluji fakturu…",
          "done": "Faktura zkontrolována",
          "failed": "Fakturu se nepodařilo zkontrolovat"
        },
        "acceptInvoiceWarnings": {
          "running": "Připravuji přijetí varování…",
          "done": "Přijetí připraveno",
          "failed": "Přijetí se nepodařilo připravit"
        },
        "approveInvoicesAcceptingWarnings": {
          "running": "Připravuji schválení…",
          "done": "Schválení připraveno k potvrzení",
          "failed": "Schválení se nepodařilo připravit"
        },
        "submitInvoices": {
          "running": "Připravuji předání ke schválení…",
          "done": "Předání připraveno",
          "failed": "Předání se nepodařilo připravit"
        },
        "returnInvoicesToDraft": {
          "running": "Připravuji vrácení k úpravám…",
          "done": "Vrácení připraveno",
          "failed": "Vrácení se nepodařilo připravit"
        },
        "cancelInvoices": {
          "running": "Připravuji zrušení…",
          "done": "Zrušení připraveno",
          "failed": "Zrušení se nepodařilo připravit"
        },
        "deleteInvoices": {
          "running": "Připravuji smazání…",
          "done": "Smazání připraveno",
          "failed": "Smazání se nepodařilo připravit"
        },
        "completeInvoices": {
          "running": "Připravuji dokončení…",
          "done": "Dokončení připraveno",
          "failed": "Dokončení se nepodařilo připravit"
        },
        "invoiceCompletionBlockers": {
          "running": "Zjišťuji, co chybí…",
          "done": "Kontrola dokončení hotová",
          "failed": "Kontrolu dokončení se nepodařilo provést"
        },
        "isdocExport": {
          "running": "Kontroluji export do ISDOC…",
          "done": "Export do ISDOC zkontrolován",
          "failed": "Export do ISDOC se nepodařilo zkontrolovat"
        },
        "matchCandidates": {
          "running": "Hledám řádky objednávek…",
          "done": "Řádky objednávek nalezeny",
          "failed": "Řádky objednávek se nepodařilo načíst"
        },
        "pairInvoiceLines": {
          "running": "Připravuji spárování…",
          "done": "Spárování připraveno k potvrzení",
          "failed": "Spárování se nepodařilo připravit"
        },
        "unmatchInvoiceLines": {
          "running": "Připravuji zrušení spárování…",
          "done": "Zrušení spárování připraveno",
          "failed": "Zrušení spárování se nepodařilo připravit"
        },
        "rejectMatchLinks": {
          "running": "Připravuji odmítnutí návrhů…",
          "done": "Odmítnutí připraveno",
          "failed": "Odmítnutí se nepodařilo připravit"
        },
        "rematchInvoices": {
          "running": "Připravuji nové párování…",
          "done": "Nové párování připraveno",
          "failed": "Nové párování se nepodařilo připravit"
        },
        "approvalStatus": {
          "running": "Zjišťuji stav schvalování…",
          "done": "Stav schvalování načten",
          "failed": "Stav schvalování se nepodařilo načíst"
        },
        "setApprovers": {
          "running": "Připravuji změnu schvalovatelů…",
          "done": "Změna schvalovatelů připravena k potvrzení",
          "failed": "Změnu schvalovatelů se nepodařilo připravit"
        },
        "approverChain": {
          "running": "Načítám pravidla schvalovatelů…",
          "done": "Pravidla schvalovatelů načtena",
          "failed": "Pravidla schvalovatelů se nepodařilo načíst"
        },
        "explainApproval": {
          "running": "Dohledávám rozhodnutí…",
          "done": "Rozhodnutí nalezeno",
          "failed": "Rozhodnutí se nepodařilo načíst"
        },
        "previewApproval": {
          "running": "Zkouším automatické schvalování…",
          "done": "Zkušební běh hotový",
          "failed": "Zkušební běh se nepodařil"
        },
        "pendingApprovals": {
          "running": "Hledám čekající schvalování…",
          "done": "Čekající schvalování nalezena",
          "failed": "Čekající schvalování se nepodařilo načíst"
        },
        "moveInvoicesToExport": {
          "running": "Připravuji přesun k exportu…",
          "done": "Přesun k exportu připraven k potvrzení",
          "failed": "Přesun k exportu se nepodařilo připravit"
        },
        "paymentQr": {
          "running": "Kontroluji QR platbu…",
          "done": "QR platba zkontrolována",
          "failed": "QR platbu se nepodařilo zkontrolovat"
        },
        "inboxNotifications": {
          "running": "Otevírám schránku upozornění…",
          "done": "Upozornění načtena",
          "failed": "Upozornění se nepodařilo načíst"
        },
        "markNotificationsRead": {
          "running": "Připravuji označení jako přečtené…",
          "done": "Připraveno k potvrzení",
          "failed": "Označení se nepodařilo připravit"
        },
        "procurementFlow": {
          "running": "Dohledávám celý nákup…",
          "done": "Nákup dohledán",
          "failed": "Nákup se nepodařilo dohledat"
        },
        "documentThreads": {
          "running": "Hledám dotazy…",
          "done": "Dotazy nalezeny",
          "failed": "Dotazy se nepodařilo načíst"
        },
        "threadMessages": {
          "running": "Otevírám konverzaci…",
          "done": "Konverzace načtena",
          "failed": "Konverzaci se nepodařilo načíst"
        },
        "replyToThread": {
          "running": "Připravuji odpověď…",
          "done": "Odpověď připravena k potvrzení",
          "failed": "Odpověď se nepodařilo připravit"
        },
        "draftCostCenter": {
          "running": "Připravuji nákladové středisko…",
          "done": "Nákladové středisko připraveno",
          "failed": "Nákladové středisko se nepodařilo připravit"
        },
        "deactivateCostCenters": {
          "running": "Kontroluji nákladová střediska…",
          "done": "Nákladová střediska zkontrolována",
          "failed": "Nákladová střediska se nepodařilo zkontrolovat"
        },
        "draftJob": {
          "running": "Připravuji zakázku…",
          "done": "Zakázka připravena",
          "failed": "Zakázku se nepodařilo připravit"
        },
        "activateJobs": {
          "running": "Kontroluji zakázky…",
          "done": "Zakázky zkontrolovány",
          "failed": "Zakázky se nepodařilo zkontrolovat"
        },
        "suspendJobs": {
          "running": "Kontroluji zakázky…",
          "done": "Zakázky zkontrolovány",
          "failed": "Zakázky se nepodařilo zkontrolovat"
        },
        "closeJobs": {
          "running": "Kontroluji zakázky…",
          "done": "Zakázky zkontrolovány",
          "failed": "Zakázky se nepodařilo zkontrolovat"
        },
        "deleteJobs": {
          "running": "Kontroluji zakázky…",
          "done": "Zakázky zkontrolovány",
          "failed": "Zakázky se nepodařilo zkontrolovat"
        },
        "productSearch": {
          "running": "Hledám v katalogu…",
          "done": "Katalog prohledán",
          "failed": "V katalogu se nepodařilo hledat"
        },
        "draftProduct": {
          "running": "Připravuji položku katalogu…",
          "done": "Položka katalogu připravena",
          "failed": "Položku katalogu se nepodařilo připravit"
        },
        "deactivateProducts": {
          "running": "Kontroluji položky katalogu…",
          "done": "Položky katalogu zkontrolovány",
          "failed": "Položky katalogu se nepodařilo zkontrolovat"
        },
        "deleteProducts": {
          "running": "Kontroluji položky katalogu…",
          "done": "Položky katalogu zkontrolovány",
          "failed": "Položky katalogu se nepodařilo zkontrolovat"
        },
        "draftOrgUnit": {
          "running": "Připravuji organizační jednotku…",
          "done": "Organizační jednotka připravena",
          "failed": "Organizační jednotku se nepodařilo připravit"
        },
        "deactivateOrgUnits": {
          "running": "Kontroluji organizační jednotky…",
          "done": "Organizační jednotky zkontrolovány",
          "failed": "Organizační jednotky se nepodařilo zkontrolovat"
        },
        "changeOrgUnitMembers": {
          "running": "Připravuji změnu členů…",
          "done": "Změna členů připravena",
          "failed": "Změnu členů se nepodařilo připravit"
        },
        "setOrgUnitManager": {
          "running": "Připravuji změnu vedoucího…",
          "done": "Změna vedoucího připravena",
          "failed": "Změnu vedoucího se nepodařilo připravit"
        },
        "deletePartners": {
          "running": "Kontroluji partnery…",
          "done": "Partneři zkontrolováni",
          "failed": "Partnery se nepodařilo zkontrolovat"
        },
        "numberSeries": {
          "running": "Načítám číselné řady…",
          "done": "Číselné řady načteny",
          "failed": "Číselné řady se nepodařilo načíst"
        },
        "changeNumberSeries": {
          "running": "Připravuji změnu číslování…",
          "done": "Změna číslování připravena",
          "failed": "Změnu číslování se nepodařilo připravit"
        },
        "approvalPolicy": {
          "running": "Načítám schvalovací pravidla…",
          "done": "Schvalovací pravidla načtena",
          "failed": "Schvalovací pravidla se nepodařilo načíst"
        },
        "changeApprovalPolicy": {
          "running": "Připravuji změnu pravidel…",
          "done": "Změna pravidel připravena",
          "failed": "Změnu pravidel se nepodařilo připravit"
        },
        "resetApprovalPolicy": {
          "running": "Připravuji obnovení pravidel…",
          "done": "Obnovení pravidel připraveno",
          "failed": "Obnovení pravidel se nepodařilo připravit"
        },
        "automationHelp": {
          "running": "Načítám nápovědu k automatizaci…",
          "done": "Nápověda načtena",
          "failed": "Nápovědu se nepodařilo načíst"
        },
        "automationRules": {
          "running": "Načítám pravidla dokončení…",
          "done": "Pravidla dokončení načtena",
          "failed": "Pravidla dokončení se nepodařilo načíst"
        },
        "changeAutomationRules": {
          "running": "Připravuji změnu pravidel dokončení…",
          "done": "Změna pravidel připravena",
          "failed": "Změnu pravidel se nepodařilo připravit"
        },
        "validationPolicy": {
          "running": "Načítám pravidla kontroly…",
          "done": "Pravidla kontroly načtena",
          "failed": "Pravidla kontroly se nepodařilo načíst"
        },
        "changeValidationPolicy": {
          "running": "Připravuji změnu kontroly…",
          "done": "Změna kontroly připravena",
          "failed": "Změnu kontroly se nepodařilo připravit"
        },
        "resetValidationPolicy": {
          "running": "Připravuji obnovení kontroly…",
          "done": "Obnovení kontroly připraveno",
          "failed": "Obnovení kontroly se nepodařilo připravit"
        },
        "previewValidation": {
          "running": "Zkouším kontrolu faktury…",
          "done": "Kontrola vyzkoušena",
          "failed": "Kontrolu se nepodařilo vyzkoušet"
        },
        "invoiceAutomationSwitches": {
          "running": "Načítám automatizaci faktur…",
          "done": "Automatizace faktur načtena",
          "failed": "Automatizaci faktur se nepodařilo načíst"
        },
        "changeInvoiceAutomationSwitches": {
          "running": "Připravuji změnu automatizace…",
          "done": "Změna automatizace připravena",
          "failed": "Změnu automatizace se nepodařilo připravit"
        },
        "documentOutput": {
          "running": "Načítám nastavení dokladu…",
          "done": "Nastavení dokladu načteno",
          "failed": "Nastavení dokladu se nepodařilo načíst"
        },
        "changeDocumentOutput": {
          "running": "Připravuji změnu dokladu…",
          "done": "Změna dokladu připravena",
          "failed": "Změnu dokladu se nepodařilo připravit"
        },
        "deleteEmailTemplates": {
          "running": "Kontroluji e-mailové šablony…",
          "done": "E-mailové šablony zkontrolovány",
          "failed": "E-mailové šablony se nepodařilo zkontrolovat"
        },
        "analysisRuns": {
          "running": "Načítám běhy kontroly…",
          "done": "Běhy kontroly načteny",
          "failed": "Běhy kontroly se nepodařilo načíst"
        },
        "rerunAnalysis": {
          "running": "Kontroluji faktury…",
          "done": "Faktury zkontrolovány",
          "failed": "Faktury se nepodařilo zkontrolovat"
        },
        "procurementOverview": {
          "running": "Načítám přehled nákupu…",
          "done": "Přehled nákupu načten",
          "failed": "Přehled nákupu se nepodařilo načíst"
        },
        "spendByCoding": {
          "running": "Rozpočítávám útratu…",
          "done": "Útrata rozpočítána",
          "failed": "Útratu se nepodařilo rozpočítat"
        },
        "supplierPerformance": {
          "running": "Kontroluji dodávky dodavatelů…",
          "done": "Dodávky dodavatelů zkontrolovány",
          "failed": "Dodávky dodavatelů se nepodařilo zkontrolovat"
        },
        "cycleTime": {
          "running": "Měřím doby nákupu…",
          "done": "Doby nákupu změřeny",
          "failed": "Doby nákupu se nepodařilo změřit"
        },
        "anomalies": {
          "running": "Hledám rizikové faktury…",
          "done": "Rizikové faktury zkontrolovány",
          "failed": "Rizikové faktury se nepodařilo zkontrolovat"
        },
        "pendingMatches": {
          "running": "Načítám nespárované záznamy…",
          "done": "Nespárované záznamy načteny",
          "failed": "Nespárované záznamy se nepodařilo načíst"
        },
        "confirmMatches": {
          "running": "Připravuji spárování…",
          "done": "Spárování připraveno",
          "failed": "Spárování se nepodařilo připravit"
        },
        "rejectMatches": {
          "running": "Kontroluji nespárované záznamy…",
          "done": "Nespárované záznamy zkontrolovány",
          "failed": "Nespárované záznamy se nepodařilo zkontrolovat"
        },
        "resendSyncChanges": {
          "running": "Připravuji opětovné odeslání…",
          "done": "Opětovné odeslání připraveno",
          "failed": "Opětovné odeslání se nepodařilo připravit"
        },
        "retryStuckSyncEvents": {
          "running": "Připravuji opakování…",
          "done": "Opakování připraveno",
          "failed": "Opakování se nepodařilo připravit"
        },
        "repushAttachments": {
          "running": "Připravuji přílohy…",
          "done": "Přílohy připraveny",
          "failed": "Přílohy se nepodařilo připravit"
        },
        "creditBalance": {
          "running": "Načítám AI kredity…",
          "done": "AI kredity načteny",
          "failed": "AI kredity se nepodařilo načíst"
        },
        "creditPacks": {
          "running": "Načítám balíčky kreditů…",
          "done": "Balíčky kreditů načteny",
          "failed": "Balíčky kreditů se nepodařilo načíst"
        },
        "buyCreditPack": {
          "running": "Připravuji platbu…",
          "done": "Platba připravena",
          "failed": "Platbu se nepodařilo připravit"
        },
        "helpSearch": {
          "running": "Hledám v nápovědě…",
          "done": "Nápověda prohledána",
          "failed": "V nápovědě se nepodařilo hledat"
        },
        "undoLast": {
          "running": "Připravuji vrácení…",
          "done": "Vrácení připraveno",
          "failed": "Vrácení se nepodařilo připravit"
        },
        "automationReadiness": {
          "running": "Zjišťuji nastavení automatizace…",
          "done": "Nastavení automatizace zjištěno",
          "failed": "Nastavení automatizace se nepodařilo zjistit"
        },
        "automationDryRun": {
          "running": "Zkouším pravidlo na dokladech…",
          "done": "Pravidlo vyzkoušeno",
          "failed": "Pravidlo se nepodařilo vyzkoušet"
        },
        "integrationPlugins": {
          "running": "Hledám systémy…",
          "done": "Systémy nalezeny",
          "failed": "Hledání se nezdařilo"
        },
        "integrationSetup": {
          "running": "Kontroluji integrace…",
          "done": "Integrace zkontrolovány",
          "failed": "Kontrola se nezdařila"
        },
        "proposeConnectorSetup": {
          "running": "Připravuji návrh…",
          "done": "Návrh integrace je připraven",
          "failed": "Návrh se nezdařil"
        },
        "connectionReadiness": {
          "running": "Kontroluji připojení…",
          "done": "Připojení zkontrolováno",
          "failed": "Kontrola se nezdařila"
        },
        "integrationConnectors": {
          "running": "Hledám synchronizace…",
          "done": "Synchronizace nalezeny",
          "failed": "Hledání se nezdařilo"
        },
        "proposeConnectorEnabled": {
          "running": "Připravuji zapnutí…",
          "done": "Zapnutí čeká na potvrzení",
          "failed": "Návrh se nezdařil"
        },
        "proposeConnectorSchedules": {
          "running": "Připravuji plán…",
          "done": "Změna plánu čeká na potvrzení",
          "failed": "Návrh se nezdařil"
        },
        "proposeConnectorSettings": {
          "running": "Připravuji nastavení…",
          "done": "Změna nastavení čeká na potvrzení",
          "failed": "Návrh se nezdařil"
        },
        "proposeConnectorDelete": {
          "running": "Připravuji smazání…",
          "done": "Smazání čeká na potvrzení",
          "failed": "Návrh se nezdařil"
        },
        "proposeConnectionDelete": {
          "running": "Připravuji smazání…",
          "done": "Smazání čeká na potvrzení",
          "failed": "Návrh se nezdařil"
        }
      },
      "proposals": {
        "invite-user": {
          "title": "Pozvat uživatele",
          "description": "Pošlu pozvánku, aby se mohl přidat k tvé organizaci.",
          "orgUnit": "Pozice v org. struktuře: {{label}}",
          "orgUnitAsHead": "Pozice v org. struktuře: {{label}}, jako vedoucí"
        },
        "approve-invoice": {
          "title": "Schválit fakturu",
          "description": "Potvrď a fakturu schválím."
        },
        "reject-invoice": {
          "title": "Zamítnout fakturu",
          "description": "Potvrď a fakturu zamítnu a vrátím k přezkumu."
        },
        "revert-invoice": {
          "title": "Vrátit fakturu",
          "description": "Potvrď a vrátím fakturu do předchozího stavu."
        },
        "move-invoice-status": {
          "title": "Změnit stav faktury",
          "description": "Potvrď a přesunu fakturu do zvoleného stavu."
        },
        "add-partners": {
          "title": "Přidat partnery",
          "description": "Potvrď a založím tyto firmy jako odběratele i dodavatele.",
          "countDescription_one": "Potvrď a založím {{count}} firmu jako odběratele i dodavatele.",
          "countDescription_few": "Potvrď a založím {{count}} firmy jako odběratele i dodavatele.",
          "countDescription_other": "Potvrď a založím {{count}} firem jako odběratele i dodavatele."
        },
        "confirm": "Potvrdit",
        "cancel": "Zrušit",
        "resolution": {
          "confirmed": "Potvrzeno.",
          "cancelled": "Zrušeno — nic jsem neměnil.",
          "expired": "Platnost karty vypršela. Klidně si řekni znovu."
        },
        "total": "Celkem",
        "toast": {
          "confirmed": "Hotovo — akce proběhla.",
          "failed": "Nepovedlo se to provést. Řekni si znovu a zkusím to zopakovat.",
          "cancelFailed": "Zrušení se nepovedlo."
        },
        "maintain-invoices": {
          "title": "Údržba faktur",
          "description": "Potvrď a spustím to.",
          "revalidate": {
            "title": "Znovu ověřit",
            "countDescription_one": "Potvrď a překontroluju {{count}} fakturu.",
            "countDescription_few": "Potvrď a překontroluju {{count}} faktury.",
            "countDescription_other": "Potvrď a překontroluju {{count}} faktur."
          },
          "archive": {
            "title": "Archivovat faktury",
            "countDescription_one": "Potvrď a archivuju {{count}} fakturu.",
            "countDescription_few": "Potvrď a archivuju {{count}} faktury.",
            "countDescription_other": "Potvrď a archivuju {{count}} faktur."
          },
          "unarchive": {
            "title": "Obnovit faktury",
            "countDescription_one": "Potvrď a vrátím {{count}} fakturu z archivu.",
            "countDescription_few": "Potvrď a vrátím {{count}} faktury z archivu.",
            "countDescription_other": "Potvrď a vrátím {{count}} faktur z archivu."
          }
        },
        "move-invoices-status": {
          "title": "Změnit stav na {{status}}",
          "description": "Potvrď a faktury přesunu.",
          "countDescription_one": "Potvrď a přesunu {{count}} fakturu do stavu {{status}}.",
          "countDescription_few": "Potvrď a přesunu {{count}} faktury do stavu {{status}}.",
          "countDescription_other": "Potvrď a přesunu {{count}} faktur do stavu {{status}}."
        },
        "invite-users": {
          "title": "Pozvat lidi",
          "description": "Potvrď a pozvánky odešlu.",
          "countDescription_one": "Potvrď a pozvu {{count}} uživatele jako člena.",
          "countDescription_few": "Potvrď a pozvu {{count}} lidi jako členy.",
          "countDescription_other": "Potvrď a pozvu {{count}} lidí jako členy.",
          "orgUnit": "Pozice v org. struktuře: {{label}}"
        },
        "maintain-partners": {
          "title": "Upravit partnery",
          "description": "Potvrď a změnu provedu.",
          "archive": {
            "title": "Archivovat partnery",
            "countDescription_one": "Potvrď a archivuju {{count}} partnera.",
            "countDescription_few": "Potvrď a archivuju {{count}} partnery.",
            "countDescription_other": "Potvrď a archivuju {{count}} partnerů."
          },
          "unarchive": {
            "title": "Obnovit partnery",
            "countDescription_one": "Potvrď a obnovím {{count}} partnera.",
            "countDescription_few": "Potvrď a obnovím {{count}} partnery.",
            "countDescription_other": "Potvrď a obnovím {{count}} partnerů."
          },
          "markSupplier": {
            "title": "Označit jako dodavatele",
            "countDescription_one": "Potvrď a označím {{count}} partnera jako dodavatele.",
            "countDescription_few": "Potvrď a označím {{count}} partnery jako dodavatele.",
            "countDescription_other": "Potvrď a označím {{count}} partnerů jako dodavatele."
          },
          "markCustomer": {
            "title": "Označit jako odběratele",
            "countDescription_one": "Potvrď a označím {{count}} partnera jako odběratele.",
            "countDescription_few": "Potvrď a označím {{count}} partnery jako odběratele.",
            "countDescription_other": "Potvrď a označím {{count}} partnerů jako odběratele."
          }
        },
        "move-procurement": {
          "requisitions": {
            "title": "Změnit stav požadavků na {{status}}",
            "description": "Potvrď a požadavky přesunu.",
            "countDescription_one": "Potvrď a přesunu {{count}} požadavek do stavu {{status}}.",
            "countDescription_few": "Potvrď a přesunu {{count}} požadavky do stavu {{status}}.",
            "countDescription_other": "Potvrď a přesunu {{count}} požadavků do stavu {{status}}."
          },
          "purchaseOrders": {
            "title": "Změnit stav objednávek na {{status}}",
            "description": "Potvrď a objednávky přesunu.",
            "countDescription_one": "Potvrď a přesunu {{count}} objednávku do stavu {{status}}.",
            "countDescription_few": "Potvrď a přesunu {{count}} objednávky do stavu {{status}}.",
            "countDescription_other": "Potvrď a přesunu {{count}} objednávek do stavu {{status}}."
          }
        },
        "submit-procurement": {
          "requisitions": {
            "title": "Odeslat požadavky ke schválení",
            "description": "Potvrď a požadavky odešlu ke schválení.",
            "countDescription_one": "Potvrď a odešlu {{count}} požadavek ke schválení.",
            "countDescription_few": "Potvrď a odešlu {{count}} požadavky ke schválení.",
            "countDescription_other": "Potvrď a odešlu {{count}} požadavků ke schválení."
          },
          "purchaseOrders": {
            "title": "Odeslat objednávky ke schválení",
            "description": "Potvrď a objednávky odešlu ke schválení.",
            "countDescription_one": "Potvrď a odešlu {{count}} objednávku ke schválení.",
            "countDescription_few": "Potvrď a odešlu {{count}} objednávky ke schválení.",
            "countDescription_other": "Potvrď a odešlu {{count}} objednávek ke schválení."
          }
        },
        "retry-syncs": {
          "title": "Spustit synchronizaci znovu",
          "description": "Potvrď a spustím novou synchronizaci.",
          "countDescription_one": "Potvrď a spustím novou synchronizaci pro {{count}} konektor.",
          "countDescription_few": "Potvrď a spustím novou synchronizaci pro {{count}} konektory.",
          "countDescription_other": "Potvrď a spustím novou synchronizaci pro {{count}} konektorů."
        },
        "chat": {
          "empty": "(prázdné)",
          "countDescription_one": "Potvrďte a provedu to pro {{count}} záznam.",
          "countDescription_few": "Potvrďte a provedu to pro {{count}} záznamy.",
          "countDescription_other": "Potvrďte a provedu to pro {{count}} záznamů.",
          "note": "Poznámka: {{note}}",
          "titles": {
            "cancel-requisitions": "Zrušit požadavky",
            "complete-requisitions": "Dokončit požadavky",
            "archive-requisitions": "Archivovat požadavky",
            "unarchive-requisitions": "Obnovit požadavky z archivu",
            "return-requisitions-to-draft": "Vrátit požadavky k úpravám",
            "accept-requisition-warnings": "Přijmout varování u požadavků",
            "delete-requisitions": "Smazat rozpracované požadavky",
            "cancel-purchase-orders": "Zrušit objednávky",
            "complete-purchase-orders": "Dokončit objednávky",
            "archive-purchase-orders": "Archivovat objednávky",
            "unarchive-purchase-orders": "Obnovit objednávky z archivu",
            "return-purchase-orders-to-draft": "Vrátit objednávky k úpravám",
            "accept-purchase-order-warnings": "Přijmout varování u objednávek",
            "delete-purchase-orders": "Smazat rozpracované objednávky",
            "draft-requisition": "Uložit požadavek",
            "draft-purchase-order": "Uložit objednávku",
            "order-from-requisition": "Vytvořit objednávku z požadavku",
            "dispatch-purchase-order": "Odeslat objednávku dodavateli",
            "confirm-goods-receipts": "Potvrdit příjemky",
            "cancel-goods-receipts": "Zrušit příjemky",
            "confirm-delivery-without-receipt": "Potvrdit dodání bez dodacího listu",
            "archive-goods-receipts": "Archivovat příjemky",
            "unarchive-goods-receipts": "Obnovit příjemky z archivu",
            "delete-goods-receipts": "Smazat příjemky",
            "receive-from-purchase-order": "Přijmout dodávku k objednávce",
            "draft-goods-receipt": "Příjemka",
            "reprocess-documents": "Znovu vytěžit dokumenty",
            "delete-documents": "Smazat dokumenty",
            "release-quarantined-emails": "Uvolnit e-maily z karantény",
            "discard-quarantined-emails": "Zahodit e-maily z karantény",
            "untrust-senders": "Přestat důvěřovat odesílatelům",
            "trust-senders": "Důvěřovat odesílatelům",
            "manage-mailbox": "Schránka pro faktury",
            "unlink-invoices": "Zrušit vazby faktur",
            "link-invoices": "Propojit faktury",
            "remove-invoice-attachments": "Odebrat přílohy",
            "edit-invoice": "Úprava faktury",
            "code-invoices": "Zaúčtovat faktury na střediska",
            "accept-invoice-warnings": "Přijmout varování faktur",
            "approve-invoices-accepting-warnings": "Schválit faktury",
            "submit-invoices": "Předat faktury ke schválení",
            "return-invoices-to-draft": "Vrátit faktury k úpravám",
            "cancel-invoices": "Zrušit faktury",
            "delete-invoices": "Smazat faktury",
            "complete-invoices": "Dokončit faktury",
            "unmatch-invoice-lines": "Zrušit spárování řádků",
            "reject-match-links": "Odmítnout navržená spárování",
            "rematch-invoices": "Znovu spárovat faktury",
            "pair-invoice-lines": "Spárovat řádky faktury",
            "set-approvers": "Změnit schvalovatele",
            "move-invoices-to-export": "Přesunout faktury k exportu",
            "mark-notifications-read": "Označit upozornění jako přečtená",
            "reply-to-thread": "Odpovědět na dotaz",
            "deactivate-cost-centers": "Deaktivovat nákladová střediska",
            "draft-cost-center": "Nákladové středisko",
            "activate-jobs": "Aktivovat zakázky",
            "suspend-jobs": "Pozastavit zakázky",
            "close-jobs": "Uzavřít zakázky",
            "delete-jobs": "Smazat zakázky",
            "draft-job": "Zakázka",
            "draft-product": "Položka katalogu",
            "deactivate-products": "Deaktivovat položky katalogu",
            "delete-products": "Smazat položky katalogu",
            "draft-org-unit": "Organizační jednotka",
            "deactivate-org-units": "Deaktivovat organizační jednotky",
            "change-org-unit-members": "Členové organizační jednotky",
            "set-org-unit-manager": "Vedoucí organizační jednotky",
            "delete-partners": "Smazat partnery",
            "change-number-series": "Číselná řada",
            "change-approval-policy": "Schvalovací pravidla",
            "reset-approval-policy": "Obnovit schvalovací pravidla",
            "change-automation-rules": "Pravidla dokončení",
            "change-validation-policy": "Pravidla kontroly faktur",
            "reset-validation-policy": "Obnovit pravidla kontroly",
            "change-invoice-automation-switches": "Automatizace faktur",
            "change-document-output": "Nastavení dokladu",
            "delete-email-templates": "Smazat e-mailové šablony",
            "rerun-analysis": "Znovu spustit AI kontrolu",
            "confirm-matches": "Potvrdit spárování",
            "reject-matches": "Zamítnout spárování",
            "resend-sync-changes": "Znovu odeslat změny",
            "retry-stuck-sync-events": "Znovu zařadit uvízlé změny",
            "repush-attachments": "Znovu odeslat přílohy",
            "buy-credit-pack": "Koupit balíček kreditů",
            "setup-connector": "Nastavit integraci",
            "switch-connector": "Zapnout nebo vypnout synchronizaci",
            "change-connector-schedules": "Změnit plán synchronizace",
            "change-connector-settings": "Změnit nastavení synchronizace",
            "delete-connector": "Smazat synchronizaci",
            "delete-connection": "Smazat připojení"
          },
          "targets": {
            "approvalPolicy": {
              "REQUISITION": "Pravidla schvalování žádanek",
              "PURCHASE_ORDER": "Pravidla schvalování objednávek",
              "INVOICE": "Pravidla schvalování faktur"
            },
            "completionRules": {
              "REQUISITION": "Pravidla dokončení žádanek",
              "PURCHASE_ORDER": "Pravidla dokončení objednávek",
              "INVOICE": "Pravidla dokončení faktur"
            },
            "validationPolicy": "Pravidla kontroly faktur",
            "invoiceAutomation": "Automatizace faktur",
            "numberSeries": {
              "REQUISITION": "Číselná řada žádanek {{year}}",
              "PURCHASE_ORDER": "Číselná řada objednávek {{year}}",
              "GOODS_RECEIPT": "Číselná řada příjemek {{year}}",
              "EXTRACTED_DOCUMENT": "Číselná řada dokladů {{year}}"
            },
            "documentOutput": {
              "PURCHASE_ORDER": "PDF objednávky"
            },
            "trustedSenders": "Důvěryhodní odesílatelé",
            "invoiceMailbox": "Schránka na faktury",
            "invoices_one": "{{count}} faktura",
            "invoices_few": "{{count}} faktury",
            "invoices_other": "{{count}} faktur",
            "syncMatches_one": "{{count}} párování synchronizace",
            "syncMatches_few": "{{count}} párování synchronizace",
            "syncMatches_other": "{{count}} párování synchronizace",
            "creditPackCheckout": "Nákup balíčku kreditů",
            "inbox": "Doručené",
            "question": "Dotaz",
            "newRequisition": "Nová žádanka",
            "newPurchaseOrder": "Nová objednávka",
            "newGoodsReceipt": "Nová příjemka",
            "newCostCenter": "Nové nákladové středisko {{code}}",
            "newJob": "Nová zakázka {{code}}",
            "newProduct": "Nový produkt {{code}}",
            "newOrgUnit": "Nová organizační jednotka {{code}}",
            "connectorSetup": "Integrace se systémem {{system}}",
            "connector": "{{name}} ({{system}})",
            "connection": "Připojení {{name}} ({{system}})"
          },
          "fields": {
            "title": "Název",
            "name": "Název",
            "code": "Kód",
            "description": "Popis",
            "note": "Poznámka",
            "notes": "Poznámky",
            "internalNote": "Interní poznámka",
            "justification": "Zdůvodnění",
            "neededBy": "Potřeba do",
            "currencyCode": "Měna",
            "currency": "Měna",
            "supplier": "Dodavatel",
            "supplierName": "Dodavatel",
            "suggestedSupplier": "Navržený dodavatel",
            "expectedDeliveryDate": "Očekávané dodání",
            "paymentTermsDays": "Splatnost (dny)",
            "invoiceNumber": "Číslo faktury",
            "invoiceDate": "Datum vystavení",
            "taxDate": "DUZP",
            "dueDate": "Datum splatnosti",
            "variableSymbol": "Variabilní symbol",
            "orderReference": "Číslo objednávky",
            "userNote": "Poznámka",
            "status": "Stav",
            "dispatched": "Odesláno dodavateli",
            "isActive": "Aktivní",
            "isEnabled": "Zapnuto",
            "lines": "Položky",
            "line": "Položka",
            "carrier": "Dopravce",
            "deliveryNoteNumber": "Číslo dodacího listu",
            "receivedAt": "Přijato",
            "prefix": "Prefix",
            "pattern": "Vzor",
            "padding": "Počet číslic",
            "email": "E-mail",
            "member": "Člen",
            "manager": "Vedoucí",
            "approvers": "Schvalovatelé",
            "prompt": "Pokyny",
            "terms": "Podmínky",
            "footerNote": "Poznámka v patičce",
            "costCenterId": "Nákladové středisko",
            "jobId": "Zakázka",
            "orgUnitId": "Organizační jednotka",
            "costCenter": "Nákladové středisko",
            "job": "Zakázka",
            "orgUnit": "Organizační jednotka",
            "relationType": "Vazba",
            "reply": "Odpověď",
            "unread": "Nepřečtené",
            "trustedSender": "Důvěryhodný odesílatel",
            "mailbox": "Schránka",
            "attachment": "Příloha",
            "attachments": "Přílohy",
            "pack": "Balíček kreditů",
            "unit": "Jednotka",
            "unitPrice": "Jednotková cena",
            "quantity": "Množství",
            "ean": "EAN",
            "vatRate": "Sazba DPH",
            "subject": "Předmět",
            "isSelfApprovalForbidden": "Zákaz schválení sebou",
            "isManualApproverSelectionAllowed": "Ruční výběr schvalovatele",
            "fallbackRole": "Záložní role",
            "fallbackStrategy": "Záložní strategie",
            "approvalMode": "Režim schvalování",
            "system": "Systém",
            "connection": "Připojení",
            "bridge": "Tappeer Bridge",
            "connectorName": "Název synchronizace",
            "entityType": "Synchronizovaná data",
            "syncDirections": "Směr",
            "enabled": "Zapnuto",
            "schedule": "Položka plánu"
          },
          "secretForm": {
            "hint": "Zadejte je sem. Odešlou se jen při potvrzení a v chatu se nikdy neobjeví.",
            "show": "Zobrazit hodnotu",
            "hide": "Skrýt hodnotu"
          },
          "values": {
            "approvalMode": {
              "AI_AND_USER": "AI + uživatel",
              "USER_ONLY": "Schvaluje uživatel",
              "SKIPPED": "Přeskočeno"
            },
            "yes": "Ano",
            "no": "Ne",
            "syncMode": {
              "full": "Všechny záznamy",
              "modified-since": "Záznamy změněné od posledního běhu",
              "read-back": "Načtení toho, co vede cílový systém",
              "event": "Každá změna"
            },
            "schedule": {
              "cron": "{{mode}}, podle plánu {{expr}}",
              "cronInZone": "{{mode}}, podle plánu {{expr}} ({{timezone}})",
              "interval_one": "{{mode}}, každou minutu",
              "interval_few": "{{mode}}, každé {{count}} minuty",
              "interval_other": "{{mode}}, každých {{count}} minut",
              "event": "{{mode}}, hned při změně"
            }
          }
        },
        "rows": {
          "showAll_one": "Zobrazit {{count}} řádek",
          "showAll_few": "Zobrazit všechny {{count}} řádky",
          "showAll_other": "Zobrazit všech {{count}} řádků",
          "showLess": "Zobrazit méně"
        }
      },
      "home": {
        "guideTitle": "Co umí Tappeer AI",
        "fullGuide": "Zobrazit celého průvodce",
        "waitingOnMe": {
          "title": "Čeká na tebe",
          "empty": "Nic na tebe nečeká.",
          "showAll": "Zobrazit vše ({{count}})",
          "error": "Nepodařilo se načíst, co na tebe čeká.",
          "retry": "Zkusit znovu"
        }
      },
      "nudges": {
        "dismiss": "Ne, díky",
        "snooze": "Později",
        "answered": {
          "started": "Jdeme na to — odpověz mi na pár otázek níže.",
          "snoozed": "Zeptám se znovu za pár dní.",
          "dismissed": "Rozumím, tohle už nabízet nebudu."
        },
        "answeredAlert": {
          "started": "Pojďme se na to podívat.",
          "snoozed": "Jestli to do zítřka nebude vyřešené, připomenu se.",
          "dismissed": "Rozumím, ozvu se zase až při novém problému."
        },
        "integration-trouble": {
          "title": "Synchronizace s účetním systémem má problém",
          "description": "Některá data neprocházejí. Zjistím, co se děje, a pomůžu ti to opravit.",
          "start": "Podívat se na to se mnou",
          "startPrompt": "Co nefunguje v synchronizaci a jak to opravím?"
        },
        "approval-automation-setup": {
          "title": "Ať se běžné doklady schvalují samy",
          "description": "Hodně dokladů schvaluješ ručně. V pár otázkách s tebou nastavím, co se smí schválit automaticky a kdo rozhodne o zbytku — a než to uložíme, vyzkoušíme to na tvých skutečných dokladech.",
          "start": "Nastavit se mnou",
          "startPrompt": "Pomoz mi nastavit automatické schvalování."
        },
        "validation-automation-setup": {
          "title": "Přizpůsob AI kontrolu faktur",
          "description": "AI může u přijatých faktur hlídat to, na čem vaší firmě záleží. Pomůžu ti sepsat, co kontrolovat, a nejdřív to vyzkoušíme na pár fakturách.",
          "start": "Nastavit se mnou",
          "startPrompt": "Pomoz mi přizpůsobit AI kontrolu faktur."
        }
      }
    },
    "policies": {
      "tabs": {
        "terms": "Obchodní podmínky",
        "privacy": "Ochrana osobních údajů",
        "subprocessors": "Subdodavatelé"
      }
    },
    "auth": {
      "signIn": {
        "title": "Přihlášení",
        "subtitle": "Přihlaste se ke svému účtu",
        "submit": "Přihlásit se",
        "error": "Neplatný email nebo heslo",
        "forgotPassword": "Zapomenuté heslo?",
        "or": "nebo",
        "microsoft": "Přihlásit se přes Microsoft",
        "google": "Přihlásit se přes Google",
        "noAccount": "Nemáte účet?",
        "signUpLink": "Zaregistrovat se"
      },
      "signUp": {
        "title": "Registrace organizace",
        "subtitle": "Vytvořte si nový účet a začněte",
        "submit": "Vytvořit účet",
        "tosConsentPrefix": "Souhlasím s ",
        "tosConsentLink": "obchodními podmínkami",
        "consentSeparator": " a ",
        "privacyConsentLink": "zásadami ochrany osobních údajů",
        "error": "Nepodařilo se vytvořit účet",
        "emailAlreadyRegistered": "Email je již zaregistrován",
        "passwordMismatch": "Hesla se neshodují",
        "passwordRequirements": "Heslo musí mít alespoň 8 znaků a obsahovat velké písmeno, malé písmeno a číslo",
        "or": "nebo",
        "microsoft": "Registrovat se přes Microsoft",
        "google": "Registrovat se přes Google",
        "haveAccount": "Už máte účet?",
        "signInLink": "Přihlásit se"
      },
      "consentGateModal": {
        "stepIndicator": "{{current}} / {{total}}"
      },
      "policiesConsentModal": {
        "title": "Poslední krok",
        "description": "Váš účet byl vytvořen. Chcete-li pokračovat, přečtěte si a odsouhlaste naše obchodní podmínky a zásady ochrany osobních údajů.",
        "continue": "Pokračovat",
        "logout": "Odhlásit se"
      },
      "accountPendingDeletion": {
        "title": "Tento účet je naplánován ke smazání",
        "description": "Tento účet a všechna jeho data budou trvale smazána {{date}}. Obnovte účet, chcete-li Tappeer dál používat, nebo se odhlaste.",
        "reactivate": "Obnovit účet",
        "switchHint": "Nebo pokračujte v jiné ze svých organizací:",
        "switchTo": "Přepnout na {{name}}",
        "logout": "Odhlásit se",
        "reactivateError": "Účet se nepodařilo obnovit. Zkuste to prosím znovu."
      },
      "crossAccountLink": {
        "title": "Tento záznam je v jiné organizaci",
        "message": "Otevřeli jste odkaz na záznam, který patří organizaci {{name}}. Pro jeho zobrazení se přepněte do této organizace.",
        "confirm": "Přepnout na {{name}}"
      },
      "switchAccount": {
        "title": "Přepnout organizaci?",
        "message": "Nyní pracujete v organizaci {{from}}. Přepnutím přejdete do organizace {{to}} — od té chvíle budou všechny doklady, faktury i nastavení patřit této organizaci.",
        "warning": "Aplikace se znovu načte a otevře úvodní stránku organizace {{to}}. Neuložené změny budou ztraceny.",
        "confirm": "Přepnout na {{to}}",
        "switched": "Nyní pracujete v organizaci {{name}}"
      },
      "accountSelection": {
        "title": "Kam chcete pokračovat?",
        "description": "Jste členem více organizací. Vyberte, ve které chcete pracovat.",
        "masterAccountsGroup": "Účetní kanceláře",
        "organizationsGroup": "Organizace"
      },
      "masterAccountBar": {
        "label": "Lišta kanceláře",
        "masterAccount": "Zpět na board kanceláře {{name}}",
        "switchClient": "Přepnout klienta",
        "moreMatches": "Zobrazeno {{shown}} z {{total}} – upřesněte hledání",
        "backToMasterAccountBoard": "Zpět na board"
      },
      "gdprConsentModal": {
        "title": "Novinky a obchodní sdělení",
        "checkboxPrefix": "Souhlasím se zasíláním novinek a obchodních sdělení o Tappeerovi na svůj e-mail. Souhlas mohu kdykoli odvolat v nastavení účtu nebo odkazem v patičce každého e-mailu. Více v ",
        "checkboxLink": "Zásadách ochrany osobních údajů",
        "checkboxSuffix": ".",
        "accept": "Souhlasím",
        "refuse": "Odmítám"
      },
      "acceptInvitation": {
        "title": "Dokončení registrace",
        "subtitle": "Byli jste pozváni do organizace. Vyplňte prosím své údaje.",
        "submit": "Dokončit registraci",
        "fields": {
          "firstName": "Jméno",
          "lastName": "Příjmení",
          "password": "Heslo",
          "confirmPassword": "Potvrzení hesla"
        },
        "placeholders": {
          "firstName": "Zadejte své jméno",
          "lastName": "Zadejte své příjmení",
          "password": "Zadejte heslo",
          "confirmPassword": "Zadejte heslo znovu"
        },
        "hints": {
          "passwordRequirements": "Minimálně 8 znaků, velké písmeno, malé písmeno a číslo"
        },
        "status": {
          "accepting": "Dokončování..."
        },
        "errors": {
          "firstNameRequired": "Jméno je povinné",
          "lastNameRequired": "Příjmení je povinné",
          "passwordRequired": "Heslo je povinné",
          "passwordTooWeak": "Heslo musí obsahovat velké písmeno, malé písmeno a číslo",
          "passwordMismatch": "Hesla se neshodují",
          "acceptError": "Nepodařilo se dokončit registraci",
          "invalidToken": "Neplatný nebo vypršelý odkaz na pozvánku",
          "alreadyAccepted": "Tato pozvánka již byla použita"
        },
        "alreadyHaveAccount": "Již máte účet?",
        "signInLink": "Přihlásit se"
      },
      "errors": {
        "invalidCredentials": "Neplatný email nebo heslo",
        "emailAlreadyExists": "Tento email je již zaregistrován",
        "emailNotFound": "Účet s tímto emailem nebyl nalezen",
        "invalidEmail": "Neplatný formát emailu",
        "passwordRequired": "Heslo je povinné",
        "passwordTooShort": "Heslo musí mít alespoň 8 znaků",
        "passwordTooWeak": "Heslo musí obsahovat velké písmeno, malé písmeno a číslo",
        "accountNameRequired": "Název organizace je povinný",
        "accountNameTaken": "Tento název organizace je již obsazen",
        "firstNameRequired": "Jméno je povinné",
        "lastNameRequired": "Příjmení je povinné",
        "networkError": "Chyba připojení k serveru. Zkontrolujte své připojení a zkuste to znovu.",
        "unknownError": "Došlo k neočekávané chybě. Zkuste to prosím znovu.",
        "sessionExpired": "Vaše relace vypršela. Přihlaste se prosím znovu.",
        "invalidToken": "Neplatný nebo vypršelý token",
        "verificationFailed": "Ověření se nezdařilo. Zkuste to prosím znovu.",
        "rateLimitExceeded": "Příliš mnoho neúspěšných pokusů o přihlášení. Zkuste to prosím znovu za {{minutes}} minut.",
        "accountDeactivated": "Vaše organizace byla deaktivována. Kontaktujte prosím podporu.",
        "noActiveMembership": "Váš účet nepatří do žádné organizace. Požádejte správce o pozvánku.",
        "captchaFailed": "Nepodařilo se ověřit, že nejste robot. Dokončete prosím ověření a zkuste to znovu.",
        "captchaRequired": "Příliš mnoho neúspěšných pokusů. Potvrďte prosím níže, že nejste robot, a zkuste to znovu.",
        "captchaUnavailable": "Ověření se nepodařilo načíst. Obnovte prosím stránku a zkuste to znovu.",
        "signupRateLimited": "Příliš mnoho pokusů. Zkuste to prosím znovu později.",
        "disposableEmail": "Dočasné emailové adresy nejsou povoleny. Použijte prosím svůj běžný email.",
        "magicLinkSendFailed": "Email se teď nepodařilo odeslat. Zkuste to prosím za chvíli znovu."
      },
      "forgotPassword": {
        "title": "Zapomenuté heslo",
        "description": "Zadejte svůj email a my vám pošleme odkaz pro obnovení hesla.",
        "submit": "Odeslat odkaz",
        "success": "Pokud účet s tímto emailem existuje, byl vám odeslán email s instrukcemi.",
        "error": "Nepodařilo se odeslat email pro obnovení hesla",
        "backToSignIn": "Zpět na přihlášení"
      },
      "verifyEmail": {
        "title": "Ověření emailu",
        "verifying": "Ověřujeme váš email...",
        "noToken": "Nebyl poskytnut ověřovací token",
        "signIn": "Přihlásit se",
        "backToSignIn": "Zpět na přihlášení",
        "success": "Email byl úspěšně ověřen. Nyní se můžete přihlásit ke svému účtu.",
        "alreadyVerified": "Email je již ověřen. Můžete se přihlásit ke svému účtu.",
        "invalidToken": "Neplatný nebo vypršelý ověřovací token",
        "networkError": "Nepodařilo se připojit k serveru. Zkontrolujte prosím své internetové připojení a zkuste to znovu."
      },
      "emailVerificationPending": {
        "title": "Ověřte svůj email",
        "message": "Váš účet byl vytvořen. Zkontrolujte prosím email a klikněte na ověřovací odkaz.",
        "emailSentTo": "Poslali jsme email na",
        "spamTip": "Pokud email nevidíte, podívejte se do spamu nebo složky Promo akce.",
        "expirationInfo": "Ověřovací odkaz platí 24 hodin.",
        "backToSignIn": "Zpět na přihlášení"
      },
      "passwordless": {
        "title": "Pojďme na to!",
        "hint": "Přihlaš se nebo si vytvoř účet — stačí ti jen email.",
        "footer": "Bez karty, bez hesla, bez telefonu. Vyzkoušej si tappeera nezávazně, sám, v klidu.",
        "promoHighlight": "10 dokladů měsíčně zdarma – napořád.",
        "emailLabel": "Váš e-mail",
        "continue": "Pokračovat",
        "consentNotice": "Pokračováním souhlasíš s <tos>obchodními podmínkami</tos> a <privacy>zásadami ochrany osobních údajů</privacy>.",
        "microsoft": "Pokračovat přes Microsoft",
        "google": "Pokračovat přes Google",
        "usePassword": "Přihlásit se heslem",
        "checkEmail": "Zkontrolujte svůj email",
        "checkEmailMessage": "Poslali jsme vám přihlašovací odkaz. Klikněte na odkaz v emailu a pokračujte.",
        "linkExpiry": "Odkaz vyprší za 15 minut.",
        "backToSignIn": "Zpět na přihlášení",
        "verifying": "Přihlašujeme vás...",
        "verifyingMessage": "Počkejte prosím, ověřujeme váš odkaz.",
        "verified": "Jste přihlášeni!",
        "verifiedMessage": "Přesměrováváme vás...",
        "verifyFailed": "Přihlášení se nezdařilo",
        "verifyFailedMessage": "Tento odkaz je neplatný nebo vypršel. Vyžádejte si prosím nový.",
        "noToken": "Nebyl poskytnut ověřovací token.",
        "linkAlreadyUsed": "Tento odkaz již byl použit."
      },
      "magicLinkSent": {
        "title": "Odkaz máš ve schránce",
        "message": "Na email jsem ti poslal odkaz. Klikni na něj a dostaneš se do aplikace. Pokud ho nevidíš, zkontroluj složku spam.",
        "resend": "Poslat znovu",
        "resendTimer": "Poslat znovu ({{seconds}}s)",
        "changeEmail": "Použít jiný email"
      },
      "signOut": {
        "title": "Odhlášení",
        "signingOut": "Odhlašujeme vás...",
        "success": "Byli jste úspěšně odhlášeni",
        "error": "Nepodařilo se odhlásit",
        "signInAgain": "Přihlásit se znovu",
        "backToHome": "Zpět na úvodní stránku"
      },
      "oauth": {
        "processing": "Dokončujeme přihlášení...",
        "error": "Ověření selhalo. Zkuste to prosím znovu.",
        "cancelled": "Přihlášení bylo zrušeno.",
        "emailNotVerified": "Váš poskytovatel identity neověřil e-mailovou adresu tohoto účtu. Přihlaste se jiným způsobem, nebo požádejte IT správce o ověření e-mailové domény.",
        "missingParams": "Neplatné OAuth volání. Chybí povinné parametry.",
        "backToSignIn": "Zpět na přihlášení"
      },
      "fields": {
        "email": "Email",
        "emailPlaceholder": "Zadejte svůj email",
        "password": "Heslo",
        "passwordPlaceholder": "Zadejte heslo",
        "confirmPassword": "Potvrdit heslo",
        "confirmPasswordPlaceholder": "Potvrďte heslo",
        "accountName": "Název organizace",
        "accountNamePlaceholder": "Zadejte název organizace",
        "firstName": "Jméno",
        "firstNamePlaceholder": "Zadejte své jméno",
        "lastName": "Příjmení",
        "lastNamePlaceholder": "Zadejte své příjmení",
        "showPassword": "Zobrazit heslo",
        "hidePassword": "Skrýt heslo"
      }
    },
    "emailUnsubscribe": {
      "confirm": {
        "title": {
          "creditUsage": "Odhlásit upozornění na čerpání kreditů?",
          "creditRenewal": "Odhlásit upozornění na obnovení kreditů?",
          "marketing": "Odhlásit tipy a novinky?"
        },
        "body": "Po odhlášení ti tyhle e-maily přestanou chodit. Zapnout je můžeš kdykoliv v profilu.",
        "action": "Odhlásit"
      },
      "done": {
        "title": "Hotovo",
        "message": {
          "creditUsage": "Upozornění na čerpání kreditů ti už chodit nebudou.",
          "creditRenewal": "Upozornění na obnovení kreditů ti už chodit nebudou.",
          "marketing": "Tipy a novinky ti už chodit nebudou."
        }
      },
      "invalid": {
        "title": "Odkaz nefunguje",
        "message": "Odkaz je neplatný nebo neúplný. E-maily si můžeš nastavit v profilu."
      },
      "failed": "Odhlášení teď nevyšlo. Zkus to za chvíli znovu."
    },
    "dashboard": {
      "title": "Dashboard",
      "subtitle": "Přehled vašich projektů a aktivit",
      "widgets": {
        "totalProjects": "Celkem Projektů",
        "completed": "Dokončeno",
        "pending": "Čekající"
      },
      "table": {
        "headers": {
          "id": "ID",
          "name": "Jméno",
          "status": "Stav",
          "date": "Datum"
        }
      }
    },
    "masterAccountBoardShell": {
      "menu": {
        "clients": "Klienti",
        "queue": "Fronta dokladů",
        "settings": "Nastavení kanceláře",
        "queueWithCount": "Fronta dokladů ({{count}})",
        "queueBadgeOverflow": "99+",
        "queueToDo_one": "{{count}} doklad k vyřízení",
        "queueToDo_few": "{{count}} doklady k vyřízení",
        "queueToDo_many": "{{count}} dokladu k vyřízení",
        "queueToDo_other": "{{count}} dokladů k vyřízení"
      },
      "settingsLayout": {
        "title": "Nastavení kanceláře",
        "groups": {
          "office": "Kancelář",
          "clientIntegrations": "Integrace klientů",
          "subscription": "Předplatné"
        },
        "sections": {
          "office": {
            "label": "Profil kanceláře",
            "description": "Jak se kancelář jmenuje, kde sídlí a jak ji zastihnout.",
            "keywords": "kancelář název ičo dič dph vat adresa sídlo jazyk telefon e-mail ares údaje"
          },
          "people": {
            "label": "Lidé",
            "description": "Kdo v kanceláři pracuje, co smí a které klienty má na starosti.",
            "keywords": "pozvat pozvánka role správce účetní tým přístup oprávnění přiřazení klienti"
          },
          "integrationTemplates": {
            "label": "Šablony integrací",
            "description": "Připravená nastavení konektorů, která použiješ u klientů.",
            "keywords": "šablona konektor integrace kopírovat použít klient nastavení"
          },
          "bridges": {
            "label": "Bridge",
            "description": "Bridge kanceláře, přes které se synchronizují účetní programy klientů.",
            "keywords": "bridge agent instalace účetní program pohoda money synchronizace registrace"
          },
          "billing": {
            "label": "Tarif a fakturace",
            "description": "Tarif kanceláře, platby a faktury od Tappeeru.",
            "keywords": "tarif předplatné plán platba karta faktura stripe kredity balíček"
          },
          "credits": {
            "label": "Výpis kreditů",
            "description": "Odkud se kredity vzaly a za co se čerpaly.",
            "keywords": "kredity výpis pohyby čerpání historie transakce zůstatek"
          },
          "manage": {
            "label": "Správa kanceláře",
            "description": "Zrušení kanceláře i jejího vlastního účetnictví.",
            "keywords": "zrušit smazat ukončit smazání kancelář moje kancelář účetnictví"
          }
        }
      },
      "people": {
        "noAccess": {
          "title": "Lidi kanceláře tu spravovat nemůžete",
          "description": "Lidi kanceláře spravuje správce kanceláře. Přiřazení ke klientům může měnit i hlavní účetní."
        },
        "members": {
          "title": "Lidé kanceláře",
          "name": "Jméno",
          "email": "E-mail",
          "roles": "Role v kanceláři",
          "empty": "Kancelář zatím nemá žádné lidi.",
          "error": "Seznam lidí kanceláře se nepodařilo načíst.",
          "invite": {
            "button": "Pozvat do kanceláře",
            "success": "Pozvánka odešla na {{email}}.",
            "errors": {
              "rolesRequired": "Vyberte alespoň jednu roli v kanceláři.",
              "alreadyMember": "Tento uživatel už v kanceláři je.",
              "alreadyInvited": "Na tento e-mail už pozvánka do kanceláře odešla. Najdete ji v čekajících pozvánkách, kde ji můžete poslat znovu nebo zrušit.",
              "failed": "Pozvánku se nepodařilo odeslat. Zkuste to prosím znovu."
            },
            "emailNotSent": "Pozvánka vytvořena, ale e-mail se nepodařilo odeslat — pošlete ji znovu."
          },
          "actions": {
            "label": "Akce",
            "editRoles": "Změnit role",
            "remove": "Odebrat z kanceláře",
            "removeSelf": "Sami sebe z kanceláře odebrat nemůžete"
          },
          "editRoles": {
            "title": "Role v kanceláři",
            "description": "Vyberte role, které má {{name}} v kanceláři mít.",
            "submit": "Uložit",
            "cancel": "Zrušit",
            "success": "Role byly změněny.",
            "error": "Role se nepodařilo změnit. Zkuste to prosím znovu.",
            "headAccountantRemoved": "Po odebrání role Hlavní účetní ztratí přístup ke všem klientům, dokud ji znovu nepřiřadíte."
          },
          "remove": {
            "title": "Odebrat z kanceláře?",
            "message": "{{name}} přestane být členem kanceláře.",
            "warning": "Přijde o přístup na board i ke všem klientům, ke kterým ho pustila kancelář, a jeho přiřazení ke klientům se zruší.",
            "confirm": "Odebrat",
            "cancel": "Zrušit",
            "success": "{{name}} už v kanceláři není.",
            "error": "Uživatele se nepodařilo z kanceláře odebrat. Zkuste to prosím znovu."
          },
          "errors": {
            "directClientMember": "Tento uživatel je přímo členem některého z klientů kanceláře. Nejdřív ho u klienta odeberte, teprve pak může být v kanceláři.",
            "masterAccountNotActive": "Kancelář není aktivní, proto teď nejde měnit její lidi.",
            "invitationNoLongerValid": "Pozvánka už neplatí, takže ji nejde poslat znovu. Zrušte ji a pozvěte uživatele znovu.",
            "rateLimited": "Kancelář odeslala v krátké době příliš mnoho pozvánek. Zkuste to prosím později.",
            "temporarilyUnavailable": "Služba je teď dočasně nedostupná a nic se nezměnilo. Zkuste to prosím za chvíli."
          },
          "invitations": {
            "title": "Čekající pozvánky",
            "email": "E-mail",
            "roles": "Nabízená role",
            "expiresAt": "Platí do",
            "error": "Čekající pozvánky se nepodařilo načíst.",
            "actions": {
              "label": "Akce",
              "resend": "Poslat znovu",
              "cancel": "Zrušit"
            },
            "resend": {
              "success": "Pozvánka znovu odešla na {{email}}.",
              "error": "Pozvánku se nepodařilo poslat znovu. Zkuste to prosím znovu."
            },
            "cancel": {
              "title": "Zrušit pozvánku?",
              "message": "Pozvánka pro {{email}} přestane platit.",
              "confirm": "Zrušit pozvánku",
              "keep": "Ponechat",
              "success": "Pozvánka pro {{email}} byla zrušena.",
              "error": "Pozvánku se nepodařilo zrušit. Zkuste to prosím znovu."
            }
          }
        },
        "clientAccountants": {
          "title": "Přiřazení účetních ke klientům",
          "description": "Účetní uvidí na boardu jen klienty, ke kterým je přiřazená.",
          "headAccountants": "Hlavní účetní pracují u všech klientů bez přiřazení: {{names}}.",
          "loading": "Načítám přiřazení…",
          "error": "Přiřazení se nepodařilo načíst. Zkuste stránku načíst znovu.",
          "incomplete": "Kancelář má víc klientů, účetních nebo přiřazení, než se tu dá spolehlivě zobrazit.",
          "noClients": "Kancelář zatím nemá žádné klienty.",
          "noAccountants": "Kancelář zatím nemá žádnou účetní. Pozvěte ji do kanceláře s rolí Účetní.",
          "noMatch": "Žádný klient tomu neodpovídá.",
          "search": "Hledat klienta",
          "filter": {
            "label": "Zobrazit",
            "all": "Vše",
            "unassigned": "Bez účetní"
          },
          "bulk": {
            "assign": "Přiřadit účetní ({{count}})",
            "clear": "Zrušit výběr",
            "selected": "Vybráno {{count}}",
            "selectedWithHidden_one": "Vybráno {{selected}} (z toho {{count}} skrytý)",
            "selectedWithHidden_few": "Vybráno {{selected}} (z toho {{count}} skryté)",
            "selectedWithHidden_other": "Vybráno {{selected}} (z toho {{count}} skrytých)",
            "tooMany": "Najednou lze upravit nejvýš {{max}} klientů – vyberte jich méně."
          },
          "table": {
            "selectAll": "Vybrat všechny zobrazené klienty",
            "selectClient": "Vybrat klienta {{client}}",
            "client": "Klient",
            "accountants": "Účetní",
            "actions": "Akce",
            "unassigned": "Bez účetní",
            "inactive": "(neaktivní)",
            "assign": "Přiřadit účetní",
            "edit": "Upravit",
            "assignLabel": "Přiřadit účetní klientovi {{client}}",
            "editLabel": "Upravit účetní klienta {{client}}"
          },
          "modal": {
            "titleSingle": "Účetní – {{client}}",
            "titleBulk_one": "Účetní pro {{count}} klienta",
            "titleBulk_few": "Účetní pro {{count}} klienty",
            "titleBulk_other": "Účetní pro {{count}} klientů",
            "descriptionSingle": "Zaškrtnuté účetní uvidí klienta na boardu.",
            "descriptionBulk": "Zaškrtnutou účetní přiřadíme všem vybraným klientům, odškrtnutou všem odebereme. Částečně zaškrtnutá zůstane, jak je.",
            "accountants": "Účetní kanceláře",
            "inactive": "(neaktivní)",
            "noAccountants": "Kancelář nemá žádnou aktivní účetní.",
            "submit": "Uložit",
            "cancel": "Zrušit",
            "overCap": "Najednou lze změnit nejvýš {{max}} přiřazení – vyberte méně klientů nebo účetních.",
            "success": "Uloženo – přidáno {{assigned}} a odebráno {{revoked}} přiřazení.",
            "error": "Přiřazení se nepodařilo uložit. Zkuste to prosím znovu.",
            "errors": {
              "subscriptionLocked": "Kancelář je zamčená, proto teď účetní přiřadit nejde. Odebrat je můžete.",
              "notAnAccountant": "Některá z vybraných účetních už v kanceláři není aktivní. Seznam jsme načetli znovu.",
              "notAClient": "Některý z vybraných klientů už ke kanceláři nepatří. Seznam jsme načetli znovu.",
              "masterAccountNotActive": "Kancelář není aktivní, proto teď účetní přiřadit nejde."
            }
          }
        }
      },
      "billing": {
        "noAccess": {
          "title": "Tarif kanceláře tu spravovat nemůžete",
          "description": "Tarif a fakturaci kanceláře spravuje správce kanceláře."
        },
        "pool": {
          "title": "Čerpání poolu po klientech",
          "description": "Vytěžení v běžném období ({{period}}).",
          "client": "Klient",
          "extractions": "Vytěžení",
          "total": "Celkem",
          "empty": "Kancelář zatím nemá žádné klienty.",
          "error": "Čerpání poolu se nepodařilo načíst."
        },
        "creditPool": {
          "title": "Čerpání kreditů po klientech",
          "description": "Kredity, které jednotliví klienti vyčerpali v kalendářním měsíci (UTC).",
          "client": "Klient",
          "credits": "Kredity",
          "total": "Celkem",
          "csvTotal": "Kredity celkem",
          "formerClients": "Bývalí a nedostupní klienti",
          "empty": "V tomto měsíci kancelář nečerpala žádné kredity.",
          "error": "Čerpání kreditů se nepodařilo načíst.",
          "export": "Exportovat CSV",
          "toggle": "Rozpis podle operací: {{client}}",
          "incomplete": "Některé klienty se nepodařilo načíst, export proto není k dispozici. Zkuste stránku načíst znovu."
        }
      },
      "settings": {
        "noAccess": {
          "title": "Nastavení kanceláře tu měnit nemůžete",
          "description": "Údaje kanceláře spravuje správce kanceláře."
        },
        "identity": {
          "mirrorNote": "Údaje kanceláře se automaticky propisují do „Moje kancelář“.",
          "name": "Název kanceláře",
          "companyId": "IČO",
          "taxId": "DIČ",
          "vatId": "DIČ pro DPH / VAT ID",
          "isVatPayer": "Plátce DPH",
          "street": "Ulice",
          "buildingNumber": "č.p.",
          "city": "Město",
          "postalCode": "PSČ",
          "country": "Země",
          "phone": "Telefon",
          "email": "E-mail",
          "loading": "Načítám údaje kanceláře…",
          "loadError": "Údaje kanceláře se nepodařilo načíst.",
          "saveSuccess": "Změny byly uloženy",
          "saveError": "Změny se nepodařilo uložit",
          "nameRequired": "Zadejte název kanceláře.",
          "locale": "Jazyk",
          "localeOptions": {
            "CS": "Čeština",
            "EN": "English"
          },
          "registry": {
            "CZ": {
              "label": "Načíst údaje podle IČO nebo DIČ",
              "placeholder": "Zadejte IČO nebo DIČ"
            },
            "SK": {
              "label": "Načíst údaje podle IČO",
              "placeholder": "Zadejte IČO"
            }
          }
        },
        "deletion": {
          "title": "Zrušit účetní kancelář",
          "hint": "Kancelář i „Moje kancelář“ budou po 30denní ochranné lhůtě nenávratně smazány.",
          "button": "Zrušit kancelář",
          "confirmTitle": "Zrušit účetní kancelář?",
          "confirmMessage": "Kancelář se naplánuje ke smazání a spolu s ní i „Moje kancelář“ – vlastní účetnictví kanceláře. Zrušit lze jen kancelář, která:",
          "conditions": {
            "noClients": "nemá žádné další klienty (nejdřív je odpojte nebo převeďte jinam),",
            "ownBooksEmpty": "má prázdnou „Moje kancelář“ – bez dokladů, vlastních uživatelů a otevřených pozvánek."
          },
          "confirmWarning": "Po 30 dnech se kancelář i „Moje kancelář“ nenávratně smažou. Do té doby smazání můžete zrušit. Předplatné kanceláře skončí s koncem zaplaceného období.",
          "confirmButton": "Zrušit kancelář",
          "cancelConfirmButton": "Ponechat kancelář",
          "requestError": "Kancelář se nepodařilo naplánovat ke smazání. Zkuste to prosím znovu později.",
          "pendingTitle": "Kancelář je naplánovaná ke smazání",
          "pendingHint": "Kancelář i „Moje kancelář“ budou trvale smazány {{date}}.",
          "cancelButton": "Zrušit smazání",
          "cancelError": "Smazání kanceláře se nepodařilo zrušit. Zkuste to prosím znovu."
        }
      },
      "manage": {
        "noAccess": {
          "title": "Kancelář tu spravovat nemůžete",
          "description": "Kancelář může zrušit jen správce kanceláře."
        }
      },
      "insideClient": {
        "title": "Pracujete u klienta kanceláře {{name}}",
        "description": "Tato stránka patří boardu kanceláře, takže se na ni z klienta nedostanete přímo. Přepněte se zpět.",
        "action": "Zpět na board"
      },
      "ownOrganization": {
        "title": "Tato stránka patří boardu kanceláře",
        "description": "Právě pracujete v organizaci {{name}}. Board patří účetní kanceláři – přepněte se na něj.",
        "action": "Přejít do kanceláře {{name}}"
      },
      "home": {
        "noAccess": {
          "title": "Na boardu pro vás zatím nic není",
          "description": "Vaše role v kanceláři neotevírají žádnou část boardu. Požádejte správce kanceláře o přístup."
        }
      },
      "errors": {
        "ownBooksCannotLeave": "„Moje kancelář“ zůstává vždy u kanceláře – nejde ji odpojit ani převést jinam.",
        "ownBooksNotEmpty": "„Moje kancelář“ ještě obsahuje doklady nebo vlastní uživatele. Nejdřív je odstraňte, teprve pak lze účetní kancelář zrušit.",
        "ownBooksFollowsMasterAccount": "„Moje kancelář“ se maže a obnovuje jen spolu s kanceláří. Smazání spravujte na boardu kanceláře.",
        "lastMasterAdmin": "Kancelář musí mít alespoň jednoho aktivního správce kanceláře.",
        "masterAccountPendingDeletion": "Kancelář je naplánovaná ke smazání, proto teď nemůže přijímat ani zakládat klienty.",
        "masterAccountHasClients": "Kancelář má ještě klienty. Nejdřív je odpojte nebo převeďte jinam, teprve pak lze kancelář zrušit."
      },
      "pendingDeletion": {
        "title": "Kancelář je naplánovaná ke smazání",
        "description": "Kancelář {{name}} a její „Moje kancelář“ budou trvale smazány {{date}}. Do té doby je dostupné jen zrušení smazání a sekce Tarif a fakturace.",
        "banner": "Kancelář {{name}} je naplánovaná ke smazání {{date}}.",
        "askAdmin": "Smazání může zrušit správce kanceláře.",
        "cancel": "Zrušit smazání kanceláře",
        "billing": "Tarif a fakturace",
        "switchHint": "Nebo pokračujte jinde:",
        "switchTo": "Přepnout na {{name}}",
        "logout": "Odhlásit se",
        "cancelError": "Smazání kanceláře se nepodařilo zrušit. Zkuste to prosím znovu."
      }
    },
    "masterAccountBoard": {
      "title": "Klienti",
      "period": {
        "label": "Období"
      },
      "accountant": {
        "label": "Účetní",
        "all": "Všechny účetní",
        "unassigned": "Bez přiřazené účetní"
      },
      "summary": {
        "waitingForReview": "Čeká na kontrolu",
        "probableError": "Chyby validace",
        "validationWarning": "Varování",
        "waitingForClient": "Čeká na klienta",
        "readyForExport": "Připraveno k exportu",
        "noActivity": "Klienti bez pohybu",
        "extractions": "Vytěžení z poolu",
        "scope": "Součty napříč klienty v tomto pohledu: {{clients}}"
      },
      "status": {
        "REQUIRES_ACTION": "Vyžaduje akci",
        "WAITING_FOR_CLIENT": "Čeká na klienta",
        "NO_ACTIVITY": "Bez pohybu",
        "OK": "V pořádku"
      },
      "counts": {
        "needsHuman": "Zásah uživatele",
        "clientReplied": "Klient odpověděl",
        "waitingForClient": "Čeká na klienta",
        "probableError": "Chyba validace",
        "validationWarning": "Varování",
        "waitingForReview": "Čeká na kontrolu",
        "readyForExport": "Připraveno k exportu"
      },
      "table": {
        "client": "Klient",
        "status": "Stav",
        "waiting": "Co čeká",
        "oldest": "Nejstarší čekající doklad",
        "lastDocument": "Poslední doklad",
        "extractions": "Vytěžení",
        "accountants": "Přiřazené účetní",
        "enter": "Otevřít klienta"
      },
      "row": {
        "unassigned": "Bez přiřazené účetní",
        "noDocuments": "Zatím žádný doklad",
        "noDocumentsHint": "Otevřete nastavení klienta a pošlete mu adresu pro příjem dokladů.",
        "enter": "Otevřít",
        "enterClient": "Otevřít klienta {{name}}",
        "detail": "Detail",
        "detailClient": "Detail klienta {{name}}"
      },
      "empty": {
        "title": "Kancelář zatím nemá klienty",
        "description": "Založte prvního klienta a seznam se naplní jeho doklady.",
        "action": "Založit klienta"
      },
      "filtered": {
        "title": "Filtru neodpovídá žádný klient",
        "action": "Zrušit filtr"
      },
      "error": "Seznam klientů se nepodařilo načíst.",
      "newClient": "Nový klient",
      "ownBooks": {
        "title": "Vaše kancelář",
        "hint": "Vlastní účetnictví kanceláře – nepočítá se do součtů ani filtrů klientů."
      },
      "detail": {
        "title": "Klient",
        "back": "Zpět na klienty",
        "enter": "Vstoupit do klienta",
        "error": "Klienta se nepodařilo načíst.",
        "notFound": {
          "title": "Klient nenalezen",
          "description": "Tento klient v kanceláři není, nebo k němu nemáte přístup."
        },
        "summary": {
          "title": "Přehled za období",
          "nothingWaiting": "Nic nečeká"
        },
        "membership": {
          "title": "Klient kanceláře",
          "joinedAt": "Připojen",
          "origin": "Původ",
          "disconnect": "Odpojit klienta",
          "delete": "Smazat klienta",
          "loading": "Načítání údajů o klientovi…",
          "error": "Údaje o klientovi se nepodařilo načíst.",
          "missing": "Klient už mezi klienty kanceláře není.",
          "noDetach": "Klient nemá žádného vlastního uživatele a kancelář ho nezaložila, proto ho nelze odpojit ani smazat. Obraťte se prosím na podporu.",
          "pendingDeletion": "Klient je naplánován ke smazání."
        },
        "assignments": {
          "title": "Přiřazené účetní",
          "description": "Přiřazená účetní vidí klienta na boardu a může do něj vstoupit.",
          "loading": "Načítání přiřazení…",
          "error": "Přiřazení se nepodařilo načíst. Raději je neukazujeme, než aby byla neúplná.",
          "incomplete": "Kancelář má víc klientů, účetních nebo přiřazení, než se tu dá spolehlivě zobrazit.",
          "noAccountants": "Kancelář zatím nemá žádnou účetní. Pozvěte ji na stránce Lidé.",
          "none": "Klient nemá přiřazenou žádnou účetní, takže ho žádná účetní neuvidí.",
          "readOnly": "Měnit přiřazení můžete jen s oprávněním ke správě uživatelů.",
          "feedback": {
            "assignSuccess": "Účetní byla přiřazena ke klientovi",
            "assignError": "Přiřazení účetní se nezdařilo",
            "revokeSuccess": "Přiřazení bylo odvoláno",
            "revokeError": "Odvolání přiřazení se nezdařilo"
          }
        }
      }
    },
    "masterAccountQueue": {
      "title": "Fronta dokladů",
      "action": {
        "restart": "Od nejstaršího",
        "nextPage": "Další doklady",
        "takeOver": "Převzít",
        "handOver": "Předat…",
        "release": "Uvolnit"
      },
      "table": {
        "document": "Doklad",
        "client": "Klient",
        "state": "Stav",
        "arrived": "Přijato",
        "waiting": "Čeká",
        "handler": "Řešitel",
        "approvedAt": "Schváleno",
        "approvedBy": "Schválení",
        "actions": "Akce",
        "selectAll": "Vybrat všechny doklady na stránce",
        "selectRow": "Vybrat doklad {{document}}"
      },
      "row": {
        "unnamed": "Bez čísla a dodavatele",
        "me": "Já",
        "handledBy": "Řeší {{name}}",
        "unhandled": "Nepřevzato",
        "newForMe": "Nové pro mě",
        "approvedByAi": "Schválila AI",
        "preview": "Náhled dokladu {{document}}",
        "openInClient": "Otevřít v klientovi",
        "openInClientLabel": "Otevřít doklad v klientovi {{client}}",
        "menu": "Další akce s dokladem {{document}}"
      },
      "state": {
        "NEEDS_HUMAN": "Zásah uživatele",
        "CLIENT_REPLIED": "Klient odpověděl",
        "WAITING_FOR_CLIENT": "Čeká na klienta",
        "PROBABLE_ERROR": "Chyba validace",
        "VALIDATION_WARNING": "Varování",
        "WAITING_FOR_REVIEW": "Čeká na kontrolu",
        "READY_FOR_EXPORT": "Připraveno k exportu",
        "NONE": "Bez stavu"
      },
      "empty": {
        "TO_DO": {
          "title": "Nic nečeká",
          "description": "Žádný doklad vašich klientů teď nepotřebuje vaši pozornost."
        },
        "WAITING_FOR_CLIENT": {
          "title": "Na klienty nic nečeká",
          "description": "Žádný doklad teď nečeká na odpověď klienta."
        },
        "DONE": {
          "title": "V tomto měsíci nebylo nic schváleno",
          "description": "Vyberte jiný měsíc nebo upravte filtry."
        }
      },
      "end": {
        "title": "Za tímto místem už fronta nepokračuje",
        "action": "Zpět na nejstarší"
      },
      "error": "Frontu se nepodařilo načíst.",
      "preview": {
        "close": "Zavřít náhled",
        "untitled": "Doklad bez čísla a dodavatele",
        "approvedByAi": "Schválila AI",
        "field": {
          "supplier": "Dodavatel",
          "number": "Číslo dokladu",
          "issueDate": "Datum vystavení",
          "dueDate": "Datum splatnosti",
          "total": "Celkem",
          "variableSymbol": "Variabilní symbol"
        },
        "handler": {
          "mine": "Řešíte vy",
          "other": "Řeší {{name}}",
          "none": "Nepřevzato",
          "otherNotice": "Doklad řeší {{name}} – můžete pokračovat, řešitelem se nestanete."
        },
        "action": {
          "approve": "Schválit",
          "approveWithWarnings": "Schválit s varováním",
          "returnToDraft": "Vrátit do rozpracovaných",
          "askClient": "Dotaz klientovi",
          "editInClient": "Upravit v klientovi"
        },
        "approveWarnings": {
          "title": "Schválit s varováním",
          "message": "Schválením dokladu přijmete tato varování.",
          "cancel": "Zrušit"
        },
        "ask": {
          "title": "Dotaz klientovi",
          "hintNewThread": "Klient dostane k tomuto dokladu dotaz.",
          "hintOpenThread": "K dokladu už je otevřený dotaz – zpráva se k němu připíše a bude čekat na odpověď klienta."
        },
        "toast": {
          "approved": "Doklad je schválený",
          "returned": "Doklad je vrácený do rozpracovaných",
          "messageAdded": "Zpráva je připsaná k otevřenému dotazu"
        },
        "error": {
          "noAccess": "K tomuto klientovi už nemáte přístup.",
          "changed": "Doklad se mezitím změnil. Zobrazujeme jeho aktuální stav.",
          "action": "Akce se nezdařila. Zkuste to prosím znovu.",
          "load": "Doklad se nepodařilo načíst.",
          "loadThreads": "Dotazy k dokladu se nepodařilo načíst."
        }
      },
      "tabs": {
        "TO_DO": "K vyřízení",
        "WAITING_FOR_CLIENT": "Čeká na klienta",
        "DONE": "Hotovo"
      },
      "filters": {
        "handler": {
          "label": "Řešitel",
          "MINE_AND_UNHANDLED": "Moje + nepřevzaté",
          "MINE": "Moje",
          "UNHANDLED": "Nepřevzaté",
          "ALL": "Všichni",
          "person": "{{name}} ({{count}})"
        },
        "client": {
          "label": "Klient",
          "all": "Všichni klienti"
        }
      },
      "bulk": {
        "clear": "Zrušit výběr",
        "oneClientOnly": "Předat lze jen doklady jednoho klienta.",
        "selected_one": "Vybrán {{count}} doklad",
        "selected_few": "Vybrány {{count}} doklady",
        "selected_many": "Vybráno {{count}} dokladu",
        "selected_other": "Vybráno {{count}} dokladů"
      },
      "confirmTakeOver": {
        "title": "Převzít doklady, které řeší někdo jiný?",
        "confirm": "Převzít",
        "cancel": "Zrušit",
        "message_one": "{{count}} z vybraných dokladů už řeší někdo jiný. Po převzetí ho budete řešit vy.",
        "message_few": "{{count}} z vybraných dokladů už řeší někdo jiný. Po převzetí je budete řešit vy.",
        "message_many": "{{count}} z vybraných dokladů už řeší někdo jiný. Po převzetí je budete řešit vy.",
        "message_other": "{{count}} z vybraných dokladů už řeší někdo jiný. Po převzetí je budete řešit vy."
      },
      "handOver": {
        "title": "Předat doklady",
        "label": "Komu",
        "placeholder": "Vyberte, komu doklady předat",
        "loading": "Načítám lidi…",
        "me": "{{name}} (já)",
        "submit": "Předat",
        "cancel": "Zrušit",
        "error": "Seznam lidí se nepodařilo načíst.",
        "empty": "U tohoto klienta nemůže doklady řešit nikdo další.",
        "description_one": "{{count}} doklad klienta {{client}}",
        "description_few": "{{count}} doklady klienta {{client}}",
        "description_many": "{{count}} dokladu klienta {{client}}",
        "description_other": "{{count}} dokladů klienta {{client}}"
      },
      "outcome": {
        "ALREADY_MINE": "{{count}} už řešíte",
        "HANDLED_BY_OTHER": "{{count}} už řeší někdo jiný",
        "HANDLED_BY_OTHER_named": "{{count}} už řeší {{name}}",
        "CONFLICT": "u {{count}} se mezitím změnil řešitel",
        "NOT_ALLOWED": "u {{count}} chybí oprávnění nebo přístup",
        "failedClient": "U klienta {{client}} se změnu nepodařilo uložit.",
        "dismiss": "Zavřít",
        "TAKEN_one": "{{count}} převzat",
        "TAKEN_few": "{{count}} převzaty",
        "TAKEN_many": "{{count}} převzato",
        "TAKEN_other": "{{count}} převzato",
        "HANDED_OVER_one": "{{count}} předán",
        "HANDED_OVER_few": "{{count}} předány",
        "HANDED_OVER_many": "{{count}} předáno",
        "HANDED_OVER_other": "{{count}} předáno",
        "RELEASED_one": "{{count}} uvolněn",
        "RELEASED_few": "{{count}} uvolněny",
        "RELEASED_many": "{{count}} uvolněno",
        "RELEASED_other": "{{count}} uvolněno",
        "NOT_FOUND_one": "{{count}} už neexistuje",
        "NOT_FOUND_few": "{{count}} už neexistují",
        "NOT_FOUND_many": "{{count}} už neexistuje",
        "NOT_FOUND_other": "{{count}} už neexistuje"
      }
    },
    "inbox": {
      "title": "Oznámení",
      "menu": {
        "labelWithUnread": "Oznámení ({{count}})",
        "unread_one": "{{count}} nepřečtené",
        "unread_few": "{{count}} nepřečtená",
        "unread_many": "{{count}} nepřečteného",
        "unread_other": "{{count}} nepřečtených",
        "badgeOverflow": "99+"
      },
      "actions": {
        "markAllRead": "Označit vše jako přečtené",
        "loadMore": "Načíst další"
      },
      "row": {
        "unread": "Nepřečteno"
      },
      "titles": {
        "documentThreadQuestion": {
          "full": "{{actor}} se ptá na doklad {{name}}",
          "withoutActor": "Dotaz k dokladu {{name}}",
          "withoutName": "{{actor}} se ptá na doklad",
          "bare": "Dotaz k dokladu"
        },
        "unknown": "Nové oznámení"
      },
      "empty": {
        "title": "Žádná oznámení",
        "description": "Až se vás někdo zeptá na doklad, najdete dotaz tady."
      },
      "error": "Oznámení se nepodařilo načíst.",
      "feedback": {
        "markAllError": "Oznámení se nepodařilo označit jako přečtená."
      }
    },
    "integrations": {
      "description": "Připojte externí systémy a spravujte konektory pro synchronizaci dat.",
      "empty": "Zatím není nastaven žádný konektor.",
      "loading": "Načítání konektorů...",
      "loadError": "Nepodařilo se načíst konektory",
      "opensInNewTab": "{{label}} (otevře se v nové záložce)",
      "actions": {
        "sync": "Synchronizovat",
        "edit": "Nastavit",
        "delete": "Smazat"
      },
      "modals": {
        "delete": {
          "title": "Smazat konektor",
          "message": "Opravdu chcete smazat konektor „{{name}}“? Tuto akci nelze vrátit zpět.",
          "confirm": "Smazat"
        },
        "register": {
          "title": "Přidat konektor",
          "description": "Vyberte plugin a co má synchronizovat. Konektor se vytvoří vypnutý — nastavíte ho na další obrazovce.",
          "titleForEntity": "Přidat konektor pro {{entity}}",
          "descriptionForEntity": "Vyberte plugin, který synchronizuje {{entity}}. Konektor se vytvoří vypnutý — nastavíte ho na další obrazovce.",
          "submit": "Zaregistrovat a nastavit"
        }
      },
      "fields": {
        "plugin": "Plugin",
        "name": "Název",
        "entityType": "Typ entity",
        "secretSet": "Zabezpečený klíč je nastaven",
        "clearSecret": "Vymazat zabezpečenou hodnotu",
        "discovered": {
          "found": "Nalezeno na bridgi v {{source}}",
          "differs": "Bridge hlásí jinou hodnotu ({{source}})",
          "use": "Použít tuto"
        },
        "syncDirections": "Směr synchronizace",
        "syncDirectionsHint": "Jeden konektor může synchronizovat příchozím směrem, odchozím, nebo oběma.",
        "inbound": {
          "off": "Vypnuto",
          "readBack": "Jen zpětné načtení",
          "full": "Úplná synchronizace"
        },
        "noDirections": "Tento plugin neimplementuje žádný směr synchronizace, nebo se ho nepodařilo načíst — zkontrolujte log API.",
        "default": "Výchozí: {{value}}.",
        "on": "Zapnuto",
        "off": "Vypnuto"
      },
      "placeholders": {
        "name": "např. Synchronizace produkčního ERP",
        "selectPlugin": "Vyberte plugin",
        "selectEntityType": "Vyberte typ entity",
        "selectValue": "Vyberte hodnotu",
        "json": "Zadejte hodnotu ve formátu JSON"
      },
      "success": {
        "created": "Konektor byl vytvořen.",
        "updated": "Konektor byl uložen.",
        "deleted": "Konektor byl smazán.",
        "enabled": "Konektor byl zapnut.",
        "disabled": "Konektor byl vypnut.",
        "syncStarted": "Synchronizace byla spuštěna.",
        "migrated": "Nastavení bylo zmigrováno."
      },
      "errors": {
        "nameRequired": "Název je povinný",
        "entityTypeRequired": "Typ entity je povinný",
        "directionRequired": "Směr synchronizace je povinný",
        "pluginRequired": "Plugin je povinný",
        "configInvalid": "Konfigurace není platná",
        "fieldRequired": "Toto pole je povinné",
        "invalidValue": "Zadejte platnou hodnotu",
        "invalidUrl": "Zadejte platnou URL adresu",
        "invalidJson": "Zadejte platný JSON",
        "invalidNumber": "Zadejte platné číslo",
        "tooShort": "Hodnota je příliš krátká",
        "tooLong": "Hodnota je příliš dlouhá",
        "numberTooSmall": "Hodnota je příliš malá",
        "numberTooLarge": "Hodnota je příliš velká",
        "saveError": "Konektor se nepodařilo uložit",
        "deleteError": "Konektor se nepodařilo smazat",
        "syncError": "Synchronizaci se nepodařilo spustit",
        "migrateError": "Nastavení se nepodařilo zmigrovat",
        "cronInvalid": "Zadejte výraz cron s pěti poli",
        "intervalTooShort": "Nejkratší interval je 1 minuta",
        "timezoneRequired": "Časové pásmo je povinné",
        "modifiedSinceUnavailable": "Jen změny vyžaduje příchozí směr a plugin, který umí vypsat změněné záznamy",
        "readBackNeedsClock": "Zpětné načtení se spouští podle plánu, ne při událostech",
        "readBackWithFullSync": "Úplná příchozí synchronizace tato pole načítá sama; plán zpětného načtení odeberte",
        "readBackUnavailable": "Jen zpětné načtení vyžaduje odchozí směr a plugin, který tuto entitu umí zpětně načíst",
        "connectionRequired": "Vyberte instalaci, ze které konektor čte",
        "entityLinkAuditFailed": "Rozhodnutí se nepodařilo zapsat do protokolu aktivit, nic se nezměnilo. Zkuste to znovu.",
        "linkDecisionForbidden": "Nemáte oprávnění {{permission}}.",
        "invoiceLinkConflict": "Fakturu v jejím současném stavu nelze upravit, nebo se vazba mezitím změnila. Vraťte fakturu k editaci, nebo obnovte stránku a zkuste to znovu.",
        "bridgeManagedByMasterAccount": "Instalace na bridgi kanceláře nastavuje jen vaše účetní kancelář.",
        "bridgeAgendaTaken": "Tuto agendu už používá jiný klient této kanceláře, „{{clientName}}“. Na bridgích kanceláře může jednu agendu používat jen jeden klient.",
        "bridgeAgendaTakenUnnamed": "Tuto agendu už používá jiný klient této kanceláře. Na bridgích kanceláře může jednu agendu používat jen jeden klient.",
        "bridgeAgendaIncomplete": "Z nastavení instalace nelze poznat, kterou agendu otevírá. Vyplňte nastavení, která agendu určují, například IČO. Plugin, který agendu určit neumí, nelze na bridgi kanceláře použít.",
        "missingHoldChanged": "Dávka se mezitím změnila, načtěte ji znovu.",
        "missingHoldConnectorOff": "Konektor je vypnutý. Zapněte ho a dávku potvrďte znovu.",
        "missingHoldNothingToFinish": "Dávka je už celá zpracovaná.",
        "missingHoldFailed": "Rozhodnutí se nepodařilo uložit. Zkuste to znovu."
      },
      "editor": {
        "title": "Konektor",
        "back": "Zpět na integrace",
        "actionsLabel": "Akce konektoru",
        "loadError": "Nepodařilo se načíst konektor",
        "enabledLabel": "Zapnuto",
        "enabledHint": "Vypnutý konektor nikdy nesynchronizuje. Zapnutí vyžaduje kompletní nastavení."
      },
      "bridges": {
        "title": "Bridge",
        "description": "Tappeer Bridge je malý agent na počítači ve vaší síti. Dosáhne na podnikové systémy, na které cloud nedosáhne, a spojení navazuje sám — dovnitř se k němu nikdo nepřipojuje.",
        "empty": "Zatím není zaregistrován žádný bridge.",
        "loading": "Načítání seznamu bridge...",
        "loadError": "Nepodařilo se načíst seznam bridge",
        "unknownHost": "Počítač zatím nenahlášen",
        "lastSeen": "Naposledy {{at}}",
        "neverSeen": "Nikdy nepřipojeno",
        "status": {
          "online": "Online",
          "offline": "Offline",
          "pending": "Čeká na spárování",
          "revoked": "Odvolán"
        },
        "plugins": {
          "none": "Žádné cílové systémy",
          "detail": "Verze {{version}} · {{entities}}"
        },
        "select": {
          "label": "Bridge",
          "placeholder": "Vyberte bridge",
          "online": "{{name}} (online)",
          "offline": "{{name}} (offline)",
          "unavailable": "{{name}} — již není dostupný",
          "unknown": "Neznámý bridge",
          "noPlugin": "{{name}} — nemá plugin pro {{externalApp}}",
          "noneHost": "Žádný z vašich bridgů nemá plugin pro {{externalApp}} a tuto entitu. Nejprve ho na bridge nainstalujte.",
          "none": "Zatím žádný spárovaný bridge. Nejdřív jej zaregistrujte na stránce Bridge."
        },
        "actions": {
          "register": "Zaregistrovat bridge",
          "enrollmentCode": "Párovací kód",
          "revoke": "Odvolat",
          "delete": "Smazat"
        },
        "wizard": {
          "title": "Registrace bridge",
          "back": "Zpět na bridge",
          "intro": "Bridge je malý agent na počítači ve vaší síti. Dosáhne na systémy, na které cloud nemůže, a připojuje se sám ven — dovnitř k němu nic nechodí.",
          "steps": {
            "name": "Pojmenování",
            "install": "Instalace agenta",
            "enroll": "Spárování počítače",
            "done": "Hotovo"
          },
          "name": {
            "intro": "Pojmenujte bridge tak, abyste jej později poznali. Vše ostatní — počítač, operační systém, verzi agenta i cílové systémy, na které dosáhne — nahlásí agent sám po spárování.",
            "submit": "Zaregistrovat a pokračovat",
            "registering": "Registruji…"
          },
          "install": {
            "intro": "Nainstalujte agenta Tappeer Bridge na počítač s Windows, který dosáhne na váš podnikový systém — instalátorem pro jeho architekturu. Bridge je k dispozici pouze pro Windows.",
            "platforms": {
              "windows": {
                "title": "Spusťte instalátor pro Windows (.msi)",
                "body": "Spusťte instalátor, a až se zeptá na párovací kód, zadejte kód zobrazený v tomto kroku. Instalátor nainstaluje agenta jako službu Windows, spustí jej a spáruje; práva správce jsou potřeba při instalaci a ještě jednou, pokud po dokončení spárování ověříte nebo zopakujete v konzoli.",
                "installer": {
                  "archLabel": "Architektura",
                  "arch": {
                    "amd64": "x64",
                    "arm64": "ARM64"
                  },
                  "summary": "Verze {{version}} · {{size}}",
                  "download": "Stáhnout instalátor",
                  "sha256Label": "Kontrolní součet SHA-256",
                  "copySha256": "Kopírovat kontrolní součet",
                  "codeLabel": "Párovací kód",
                  "copyCode": "Kopírovat párovací kód",
                  "commandLabel": "Nebo instalace bez obsluhy (PowerShell jako správce)",
                  "copyCommand": "Kopírovat příkaz",
                  "hint": "Spusťte jej ve složce, kam jste instalátor stáhli. Má-li služba běžet pod doménovým účtem služby, připojte SERVICEACCOUNT=… SERVICEPASSWORD=….",
                  "gatewayHint": "Brána tohoto prostředí je {{endpoint}}; příkaz výše ji obsahuje.",
                  "expiresIn": "Párovací kód vyprší za {{remaining}}",
                  "expired": "Platnost párovacího kódu vypršela. Vystavte nový, abyste mohli agenta nainstalovat a spárovat.",
                  "reissue": "Vystavit nový kód",
                  "unavailable": "Instalátor pro tuto architekturu zatím není ke stažení.",
                  "loadFailed": "Instalátor se nepodařilo načíst. Zkuste to později."
                }
              }
            },
            "afterwards": "Zadali jste párovací kód v instalátoru, nebo jste instalovali příkazem bez obsluhy? Pak spárování už proběhlo — pokračujte a stránka si všimne, až se agent ozve. Instalovali jste bez párovacího kódu? Agent běží, ale zatím nikomu nepatří; v dalším kroku jej párovacím kódem spárujete s tímto účtem.",
            "continue": "Agent je nainstalovaný",
            "back": "Zpět"
          },
          "enroll": {
            "intro": "Spusťte na počítači, kam jste nainstalovali agenta. Kód se tím spotřebuje a počítač se spáruje s bridge „{{name}}“.",
            "codeLabel": "Jednorázový kód",
            "waiting": "Čekáme, až se agent ozve — stránka si toho všimne sama.",
            "reissue": "Vystavit nový kód",
            "back": "Zpět"
          },
          "done": {
            "title": "Bridge „{{name}}“ je spárovaný a online.",
            "plugins": "Cílové systémy, které hlásí",
            "noPlugins": "Zatím žádné. Cílový systém se tu objeví, jakmile je na počítači nainstalovaný jeho plugin.",
            "next": "Dál: na stránce bridge přidejte instalaci, na kterou dosáhne — agendu, účetní jednotku — a pak na ni namiřte konektor.",
            "openBridge": "Otevřít bridge",
            "finish": "Zpět na bridge",
            "nextOffice": "Dál: v účtu každého klienta přidejte na tento bridge instalaci — agendu klienta — a pak na ni namiřte konektor klienta."
          },
          "diagram": {
            "alt": "Tappeer v cloudu, jeden bezpečný tunel a bridge ve vaší síti, který dosáhne na podnikový systém.",
            "yourNetwork": "Vaše síť",
            "cloud": "běží v cloudu",
            "tunnel": "Bezpečný tunel",
            "dialsOut": "otevírá jej bridge, jen ven",
            "bridge": "Bridge",
            "agent": "malý agent na jednom PC",
            "caption": "Bridge se sám připojí k Tappeeru a drží otevřený jeden šifrovaný tunel. Záznamy jím putují oběma směry; zvenčí se do vaší sítě nikdy nic nepřipojuje a žádný port se neotevírá.",
            "tappeerZone": "Server Tappeer",
            "internet": "Internet",
            "bothWays": "záznamy putují oběma směry",
            "localLink": "bridge na ně dosáhne lokálně",
            "moreSystems": "další systémy…"
          }
        },
        "modals": {
          "register": {
            "title": "Registrace bridge",
            "description": "Pojmenujte jej tak, abyste jej poznali. Vše ostatní — počítač, operační systém, verzi i cílové systémy — nahlásí agent sám při spárování.",
            "nameLabel": "Název",
            "nameHint": "Například: Účetní PC nebo Server ve skladu",
            "nameRequired": "Název je povinný",
            "submit": "Zaregistrovat",
            "cancel": "Zrušit"
          },
          "code": {
            "title": "Párovací kód pro {{name}}",
            "shownOnce": "Tento kód se zobrazí jen jednou a později jej nelze zjistit. Pokud jej ztratíte, vystavte v řádku bridge nový.",
            "installTitle": "Spusťte na počítači, kde je bridge nainstalován",
            "copyCode": "Kopírovat kód",
            "copyCommand": "Kopírovat příkaz",
            "copied": "Zkopírováno do schránky.",
            "expiresIn": "Vyprší za {{remaining}}",
            "expired": "Platnost kódu vypršela. Vystavte v řádku bridge nový."
          },
          "revoke": {
            "title": "Odvolat tento bridge?",
            "message": "Přihlašovací údaj bridge „{{name}}“ okamžitě přestane platit a jeho spojení se ukončí.",
            "warning": "Odvolaný bridge už nelze obnovit. Agenta bude nutné spárovat znovu proti nové registraci.",
            "confirm": "Odvolat",
            "officeWarning": "Odvolaný bridge už nelze obnovit a synchronizace klientů, jejichž instalace na něm běží, se zastaví. Agenta bude nutné spárovat znovu proti nové registraci."
          },
          "delete": {
            "title": "Smazat tento bridge?",
            "message": "Bridge „{{name}}“ bude odstraněn i s historií připojení.",
            "confirm": "Smazat",
            "installations": "Spolu s ním se odstraní jeho instalace i uložené přihlašovací údaje.",
            "connectors_one": "Spolu s ním se odstraní jeho instalace i přihlašovací údaje. Konektor, který přes něj běží — {{names}} — se vypne a zůstane bez instalace; namiřte jej na jiný bridge, aby běžel znovu.",
            "connectors_few": "Spolu s ním se odstraní jeho instalace i přihlašovací údaje. {{count}} konektory, které přes něj běží — {{names}} — se vypnou a zůstanou bez instalace; namiřte je na jiný bridge, aby běžely znovu.",
            "connectors_other": "Spolu s ním se odstraní jeho instalace i přihlašovací údaje. {{count}} konektorů, které přes něj běží — {{names}} — se vypne a zůstane bez instalace; namiřte je na jiný bridge, aby běžely znovu.",
            "office": "Bridge, který ještě používá instalace některého klienta, smazat nelze. Nejdřív tyto instalace odstraňte."
          }
        },
        "toasts": {
          "revoked": "Bridge „{{name}}“ byl odvolán.",
          "deleted": "Bridge „{{name}}“ byl smazán."
        },
        "errors": {
          "registerFailed": "Bridge se nepodařilo zaregistrovat",
          "codeFailed": "Párovací kód se nepodařilo vystavit",
          "revokeFailed": "Bridge se nepodařilo odvolat",
          "deleteFailed": "Bridge se nepodařilo smazat",
          "inUse": "Bridge „{{name}}“ ještě používají instalace klientů: {{clients}}. Než ho smažete, odstraňte je.",
          "inUseUnlisted": "Bridge „{{name}}“ ještě používají instalace klientů. Než ho smažete, odstraňte je.",
          "otherAccount": "jiný účet"
        },
        "statusPage": {
          "title": "Bridge",
          "back": "Zpět na bridge",
          "loadError": "Tento bridge se nepodařilo načíst.",
          "tabs": {
            "overview": "Přehled",
            "sessions": "Historie připojení",
            "activity": "Aktivita"
          },
          "hostname": "Název počítače",
          "platform": "Platforma",
          "agentVersion": "Verze agenta",
          "lastSeen": "Naposledy viděn",
          "enrolledAt": "Registrován",
          "plugins": "Cílové systémy",
          "sessions": {
            "title": "Historie připojení",
            "hint": "Opakovaná krátká spojení končící vypršením limitu ukazují na síť; jedno dlouhé spojení ukončené vypnutím je nasazení.",
            "connectedAt": "Připojeno",
            "disconnectedAt": "Odpojeno",
            "reason": "Důvod",
            "gateway": "Brána",
            "open": "Stále připojeno"
          },
          "actionsLabel": "Akce s bridgem"
        },
        "health": {
          "online": {
            "title": "Online",
            "heard": "Komunikuje s Tappeerem — naposledy se ozval {{when}}.",
            "hint": "Právě teď komunikuje s Tappeerem."
          },
          "offline": {
            "title": "Offline",
            "since": "Spárovaný, ale neozval se od {{when}}. Počítač může být vypnutý, nebo se agent zastavil.",
            "hint": "Spárovaný, ale nepřipojený."
          },
          "pending": {
            "title": "Čeká na spárování",
            "hint": "Zaregistrovaný, ale žádný agent se s ním zatím nespároval. Vystavte párovací kód a spusťte jej na počítači."
          },
          "revoked": {
            "title": "Odvolaný",
            "hint": "Jeho přihlašovací údaj už neplatí. Pro nové spárování počítače zaregistrujte nový bridge."
          },
          "reason": "poslední spojení skončilo: {{reason}}",
          "lastSeenAt": "Naposledy viděn {{at}}",
          "agent": "Agent",
          "host": "Počítač",
          "plugins": "Cílové systémy",
          "noPlugins": "Zatím žádné nahlášeny"
        },
        "card": {
          "connectors_one": "Běží přes něj {{count}} konektor",
          "connectors_few": "Běží přes něj {{count}} konektory",
          "connectors_other": "Běží přes něj {{count}} konektorů",
          "noConnectors": "Zatím přes něj neběží žádný konektor"
        },
        "office": {
          "description": "Všechny bridge vaší účetní kanceláře. Běží na nich instalace vašich klientů a nastavují je jen lidé z kanceláře.",
          "clients": {
            "title": "Instalace klientů",
            "hint": "Každá agenda na bridgích kanceláře slouží jen jednomu klientovi.",
            "empty": "Na tomto bridgi zatím nemá instalaci žádný klient.",
            "client": "Klient",
            "plugin": "Plugin",
            "installation": "Instalace",
            "agenda": "Agenda",
            "otherAccount": "Jiný účet",
            "agendaUnknown": "Neurčena",
            "duplicate": "Stejná agenda dvakrát",
            "duplicateHint": "Stejnou agendu otevírá na tomto bridgi i jiná instalace tohoto klienta."
          }
        },
        "handOver": {
          "action": "Předat kanceláři",
          "title": "Předat bridge kanceláři?",
          "message": "Bridge „{{name}}“ bude patřit vaší účetní kanceláři „{{office}}“ a zůstane spárovaný, takže počítač není nutné párovat znovu. Spravovat ho pak budou lidé z kanceláře v sekci „Bridge kanceláře“; instalace účtu Moje kancelář na něm zůstanou a dál se synchronizují.",
          "warning": "Předání je jednosměrné: bridge pak patří kanceláři a zpět ho přesunout nelze.",
          "confirm": "Předat",
          "success": "Bridge „{{name}}“ teď patří kanceláři. Spravujete ho v sekci „Bridge kanceláře“.",
          "errors": {
            "notAllowed": "Tento bridge teď nelze předat kanceláři.",
            "unavailable": "Bridge kanceláře zatím vaše účetní kancelář k dispozici nemá.",
            "failed": "Bridge se nepodařilo předat kanceláři"
          }
        },
        "queue": {
          "title": "Fronta běhů",
          "hint": "Bridge provádí vždy jen jeden běh, ostatní čekají ve frontě. Odeslání změn má přednost před synchronizací.",
          "empty": "Na bridgi teď nic neběží ani nečeká.",
          "unavailable": "Frontu se teď nepodařilo načíst.",
          "running": "Běží",
          "ownRun": "Váš běh",
          "othersRunning": "Běží běh jiného účtu",
          "othersWaiting_one": "+ {{count}} běh jiného účtu čeká",
          "othersWaiting_few": "+ {{count}} běhy jiných účtů čekají",
          "othersWaiting_other": "+ {{count}} běhů jiných účtů čeká",
          "columns": {
            "position": "Pořadí",
            "run": "Běh",
            "client": "Klient",
            "priority": "Druh",
            "waiting": "Čeká"
          }
        }
      },
      "activity": {
        "title": "Aktivita",
        "viewDetails": "Zobrazit detail",
        "detailsLabel": "Detaily",
        "errorLabel": "Chyba",
        "detailsTruncated": "Data byla větší než limit a byla zkrácena.",
        "correlationId": "Korelační ID",
        "loadError": "Aktivitu se nepodařilo načíst.",
        "retry": "Zkusit znovu",
        "loadMore": "Načíst další",
        "severity": {
          "INFO": "Informace",
          "WARN": "Varování",
          "ERROR": "Chyba"
        },
        "filters": {
          "all": "Vše",
          "problems": "Chyby a varování"
        },
        "empty": {
          "noActivity": "Zatím se nic nestalo.",
          "noProblems": "Žádné chyby ani varování — vše proběhlo v pořádku."
        }
      },
      "syncRuns": {
        "title": "Průběhy synchronizace",
        "hint": "Rozbalte průběh a uvidíte aktivitu, která v něm proběhla.",
        "empty": "Tento konektor zatím neběžel.",
        "loadMore": "Načíst další",
        "counts": "{{created}} vytvořeno · {{updated}} upraveno · {{skipped}} přeskočeno",
        "errorCount": "{{count}} selhalo",
        "aliasedCount_one": "{{count}} zápis do duplicity",
        "aliasedCount_few": "{{count}} zápisy do duplicit",
        "aliasedCount_other": "{{count}} zápisů do duplicit",
        "columns": {
          "startedAt": "Začátek",
          "entity": "Entita",
          "status": "Stav",
          "records": "Záznamy",
          "duration": "Trvání",
          "activity": "Aktivita",
          "connector": "Konektor"
        },
        "modes": {
          "full": "Úplná synchronizace",
          "modifiedSince": "Jen změny",
          "records": "Vybrané záznamy",
          "readBack": "Zpětné načtení"
        },
        "emptyHint": "Zapněte konektor a stiskněte Synchronizovat — jeho první běh se objeví zde.",
        "attachmentErrorCount": "{{count}} příloh nepřeneseno",
        "fieldWarningCount_one": "{{count}} pole nezapsáno",
        "fieldWarningCount_few": "{{count}} pole nezapsána",
        "fieldWarningCount_other": "{{count}} polí nezapsáno",
        "recordErrors": {
          "title_one": "{{count}} záznam se nesynchronizoval",
          "title_few": "{{count}} záznamy se nesynchronizovaly",
          "title_other": "{{count}} záznamů se nesynchronizovalo",
          "hint": "Tyto záznamy byly vynechány; běh pokračoval s ostatními.",
          "columns": {
            "businessKey": "Business klíč",
            "reason": "Důvod"
          },
          "capped": "Zobrazeno {{shown}} z {{count}}.",
          "codes": {
            "code-too-long": "Kód v tomto záznamu je delší, než cílový systém dovoluje. Zkraťte ho v Tappeeru, nebo upravte pravidlo transformace, a spusťte synchronizaci znovu."
          },
          "codeTooLong_one": "Kód v poli „{{field}}“ má {{length}} znak; cílový systém jich dovoluje nejvýš {{maxLength}}. Zkraťte ho v Tappeeru, nebo upravte pravidlo transformace, a spusťte synchronizaci znovu.",
          "codeTooLong_few": "Kód v poli „{{field}}“ má {{length}} znaky; cílový systém jich dovoluje nejvýš {{maxLength}}. Zkraťte ho v Tappeeru, nebo upravte pravidlo transformace, a spusťte synchronizaci znovu.",
          "codeTooLong_other": "Kód v poli „{{field}}“ má {{length}} znaků; cílový systém jich dovoluje nejvýš {{maxLength}}. Zkraťte ho v Tappeeru, nebo upravte pravidlo transformace, a spusťte synchronizaci znovu."
        },
        "fieldWarnings": {
          "title_one": "{{count}} pole nebylo zapsáno",
          "title_few": "{{count}} pole nebyla zapsána",
          "title_other": "{{count}} polí nebylo zapsáno",
          "hint": "Tato pole zůstala tak, jak byla; zbytek každého záznamu se synchronizoval.",
          "columns": {
            "businessKey": "Business klíč",
            "field": "Pole",
            "reason": "Důvod"
          },
          "capped": "Zobrazeno {{shown}} z {{count}}.",
          "codes": {
            "text-too-long": "Text byl příliš dlouhý na to, aby ho pravidlo zpracovalo. Zkraťte ho, nebo změňte pravidlo.",
            "lines-not-replaced": "Cílový systém odmítl nahradit položky dokladu (v ABRA Flexi například u dokladu spárovaného s úhradou), proto se zapsala jen hlavička dokladu a položky zůstaly beze změny.",
            "code-not-mapped": "Kód z cílového systému neodpovídá žádné hodnotě v nastavení konektoru nebo připojení, nebo odpovídá více hodnotám. Pole zůstalo beze změny; upravte tam mapování kódů.",
            "reference-not-linked": "Doklad hradí fakturu, kterou konektor faktur na stejném připojení zatím nepropojil. Doklad se uložil bez ní; doplní se při další synchronizaci, až bude faktura propojená.",
            "amount-zero": "Doklad má nulovou částku, takže nejde o žádný pohyb peněz. Do Tappeeru se nenačetl.",
            "value-not-read": "Hodnotu z cílového systému se nepodařilo jednoznačně přečíst, proto se vynechala."
          },
          "unknownCode": "Nezapsáno z důvodu, pro který tato verze Tappeeru nemá text ({{code}})."
        },
        "bridgeWait": {
          "label": "Čeká na bridge",
          "hint": "Bridge provádí vždy jen jeden běh. Tento běh začne, až na něj přijde řada.",
          "for": "už {{duration}}",
          "ahead_one": "při zařazení před ním {{count}} běh",
          "ahead_few": "při zařazení před ním {{count}} běhy",
          "ahead_other": "při zařazení před ním {{count}} běhů"
        }
      },
      "readiness": {
        "title": "Připravenost k synchronizaci",
        "hint": "Ověří, zda může proběhnout synchronizace přes tuto instalaci. Nic se přitom nesynchronizuje.",
        "run": "Ověřit připravenost",
        "runAgain": "Ověřit znovu",
        "running": "Ověřuje se…",
        "saveFirst": "Nejdříve uložte změny — ověřuje se uložené nastavení.",
        "notSaved": "Připravenost lze ověřit až po uložení instalace.",
        "targetStep": "Probíhá kontrola cílového systému…",
        "detail": "Podrobnosti:",
        "targetVersion": "Verze cílového systému:",
        "stalled": "Ověření trvá déle, než se čekalo. Zkuste ho ověřit znovu.",
        "expired": "Výsledek posledního ověření už není k dispozici. Ověřte připravenost znovu.",
        "retry": "Poté ověřte připravenost znovu.",
        "status": {
          "passed": "V pořádku",
          "failed": "Nezdařilo se",
          "skipped": "Přeskočeno",
          "running": "Probíhá"
        },
        "checks": {
          "BRIDGE_ONLINE": "Připojení bridge",
          "PLUGIN_VERSION": "Verze pluginu na bridgi",
          "CONFIG": "Nastavení",
          "EXECUTABLE": "Spuštění cílového systému",
          "LOGIN": "Přihlášení",
          "AGENDA": "Agenda",
          "DEFINITIONS": "Definice exportu a importu",
          "EXPORT": "Zkušební export",
          "CARD_IMPORT_KEY": "Klíč importu kmenových karet"
        },
        "verdict": {
          "ready": "Připraveno k synchronizaci",
          "notReady": "Není připraveno k synchronizaci",
          "reachable": "Cílový systém odpověděl",
          "notReachable": "Cílový systém neodpověděl",
          "incomplete": "Ověření se nepodařilo dokončit",
          "notSupported": "Tento konektor nelze ověřit"
        },
        "errors": {
          "notFound": "Tato instalace už neexistuje. Načtěte stránku znovu.",
          "forbidden": "Nemáte oprávnění spravovat integrace.",
          "rateLimited": "Příliš mnoho ověření za krátkou dobu. Zkuste to později.",
          "rateLimitedIn_one": "Příliš mnoho ověření za krátkou dobu. Zkuste to znovu za {{count}} minutu.",
          "rateLimitedIn_few": "Příliš mnoho ověření za krátkou dobu. Zkuste to znovu za {{count}} minuty.",
          "rateLimitedIn_other": "Příliš mnoho ověření za krátkou dobu. Zkuste to znovu za {{count}} minut.",
          "unavailable": "Ověření teď nelze spustit. Zkuste to za chvíli.",
          "conflict": "Právě se spouští jiné ověření této instalace. Zkuste to za chvíli.",
          "failed": "Ověření se nepodařilo spustit. Zkuste to znovu."
        }
      },
      "failures": {
        "openSettings": "Otevřít nastavení",
        "help": {
          "sharedIco": "Jak Money S3 vybírá agendu"
        },
        "openGuide": "Více v nápovědě",
        "dialogTitle": "Blokující okno:",
        "quoteOpen": "„",
        "quoteClose": "“",
        "rawMessage": "Původní hlášení:",
        "retrySync": "Poté spusťte synchronizaci znovu.",
        "otherInstance": {
          "sameSession": "Cílový systém běží i ve stejné uživatelské relaci jako bridge.",
          "otherSession": "Cílový systém běží na počítači s bridgem i v relaci jiného uživatele."
        },
        "codes": {
          "CONFIG_INVALID": {
            "title": "Některé nastavení konektoru není platné",
            "remedy": "Opravte nastavení. {{retry}}"
          },
          "MONEYS3_AGENDA_NOT_FOUND": {
            "title": "Money S3 nemá agendu s nastaveným IČO",
            "remedy": "Zkontrolujte IČO v nastavení. {{retry}}"
          },
          "MONEYS3_AGENDA_AMBIGUOUS": {
            "title": "Money S3 našlo více odpovídajících agend",
            "remedy": "Zkontrolujte složku agendy v nastavení tak, aby odpovídala právě jedna agenda. {{retry}}"
          },
          "MONEYS3_WRONG_AGENDA": {
            "title": "Agenda v Money S3 má jiné IČO, než je nastaveno",
            "remedy": "Zkontrolujte IČO a agendu v nastavení. {{retry}}"
          },
          "MONEYS3_NO_OUTPUT": {
            "title": "Money S3 skončilo, aniž vrátilo data",
            "remedy": "Zkontrolujte nastavení připojení k Money S3. {{retry}} Pokud chyba trvá, kontaktujte podporu."
          },
          "MONEYS3_EXIT_NONZERO": {
            "title": "Money S3 skončilo s chybou",
            "remedy": "Chvíli počkejte. {{retry}} Pokud chyba trvá, kontaktujte podporu."
          },
          "MONEYS3_PROCESS_TIMEOUT": {
            "title": "Money S3 nedoběhlo v časovém limitu",
            "remedy": "Pokud se to opakuje, zvyšte v nastavení časový limit (pole „Timeout (ms)“); lze jej zvýšit nejvýše asi o 15 sekund nad výchozí hodnotu. {{retry}}"
          },
          "MONEYS3_ALREADY_RUNNING": {
            "title": "Money S3 je otevřené na počítači s bridgem",
            "remedy": "Zavřete Money S3 na počítači s bridgem. {{retry}}"
          },
          "MONEYS3_LOGIN_REQUIRED": {
            "title": "Přihlášení do Money S3 se nezdařilo",
            "remedy": "Heslo do Money S3 chybí nebo není správné. Zkontrolujte heslo v nastavení připojení. {{retry}}"
          },
          "MONEYS3_DIALOG_BLOCKED": {
            "title": "Okno Money S3 čeká na odpověď",
            "remedy": "Na počítači s bridgem otevřete Money S3, okno vyřiďte a Money S3 zavřete. {{retry}}"
          },
          "MONEYS3_PROCESS_HUNG": {
            "title": "Money S3 přestalo reagovat",
            "remedy": "Pokud se to opakuje, ověřte na počítači s bridgem, že se Money S3 spustí a na nic nečeká. {{retry}}"
          },
          "MONEYS3_PROCESS_SLOW": {
            "title": "Money S3 ještě pracovalo, když vypršel časový limit",
            "remedy": "Pokud se to opakuje, zvyšte v nastavení časový limit (pole „Timeout (ms)“); lze jej zvýšit nejvýše asi o 15 sekund nad výchozí hodnotu. {{retry}}"
          },
          "MONEYS3_TRANSFER_CONFIG_UNWRITABLE": {
            "title": "Konfiguraci XML přenosů Money S3 se nepodařilo upravit",
            "remedy": "Na počítači s bridgem ověřte, že soubory ve složce XMLDE\\Config\\Command v datech Money S3 nejsou jen pro čtení a bridge do nich smí zapisovat. Nebo v nastavení připojení vypněte „Spravovat konfiguraci XML přenosů“. {{retry}}"
          },
          "MONEYS3_TRANSFER_CONFIG_MISSING": {
            "title": "Konfigurace XML přenosů Money S3 nebyla nalezena",
            "remedy": "Na počítači s bridgem ověřte, že složka s daty Money S3 obsahuje složku XMLDE se standardní konfigurací, nebo v nastavení připojení vypněte „Spravovat konfiguraci XML přenosů“. {{retry}}"
          },
          "MONEYS3_DATA_FOLDER_UNCONFIRMED": {
            "title": "Složku s daty Money S3 se nepodařilo ověřit",
            "remedy": "Na počítači s bridgem ověřte, že vedle MonS3.exe je soubor MonS3.ini, který uvádí složku s daty (DATAROOT) a který mohou měnit jen správci, nebo v nastavení připojení vypněte „Spravovat konfiguraci XML přenosů“. Je-li složka s daty nebo některá složka nad ní spojení adresářů (junction) či symbolický odkaz, nahraďte ji skutečnou složkou: do té doby se žádná firma nezapíše. {{retry}}"
          },
          "BRIDGE_NOT_CONNECTED": {
            "title": "Bridge není připojen",
            "remedy": "Ověřte, že je počítač s bridgem zapnutý a připojený k internetu. {{retry}}"
          },
          "BRIDGE_BUSY": {
            "title": "Bridge je zaneprázdněný",
            "remedy": "Chvíli počkejte. {{retry}}"
          },
          "BRIDGE_NOT_AVAILABLE": {
            "title": "Tento účet nemůže bridge používat",
            "remedy": "Připojte konektor k instalaci na bridgi, který tento účet smí používat, nebo požádejte účetní kancelář, aby tomuto účtu přidělila agendu. {{retry}}"
          },
          "BRIDGE_REVOKED": {
            "title": "Bridge byl zneplatněn nebo smazán, zatímco na něj synchronizace čekala",
            "remedy": "Připojte konektor k instalaci na jiném bridgi. {{retry}}"
          }
        },
        "classes": {
          "transient": {
            "title": "Synchronizace selhala z dočasného důvodu",
            "remedy": "Chvíli počkejte. {{retry}} Pokud chyba trvá, kontaktujte podporu."
          },
          "config": {
            "title": "Nastavení je potřeba opravit",
            "remedy": "Zkontrolujte nastavení. {{retry}}"
          },
          "auth": {
            "title": "Přihlášení do cílového systému se nezdařilo",
            "remedy": "Zkontrolujte přihlašovací údaje v nastavení. {{retry}}"
          },
          "timeout": {
            "title": "Cílový systém nedoběhl včas",
            "remedy": "Chvíli počkejte. {{retry}} Pokud se to opakuje, kontaktujte podporu."
          },
          "data": {
            "title": "Data se nepodařilo zpracovat",
            "remedy": "Podívejte se na původní hlášení a opravte data, která uvádí. {{retry}}"
          }
        }
      },
      "attachments": {
        "title": "Přílohy",
        "intro": "Přílohy záznamu mohou putovat spolu s ním. {{externalApp}} musí daný směr nabízet; dokud to zde nezapnete, přenášejí se jen data záznamu.",
        "summary": {
          "off": "Přílohy se nepřenášejí ani jedním směrem",
          "in": "Přílohy se stahují z druhého systému",
          "out": "Přílohy se odesílají do druhého systému",
          "both": "Přílohy se přenášejí oběma směry"
        },
        "directions": {
          "in": {
            "label": "Stahovat přílohy z {{externalApp}}",
            "hint": "Příloha externího záznamu se uloží k záznamu v Tappeeru. Nikdy se z ní nestane sken faktury a nečte ji vytěžování."
          },
          "out": {
            "label": "Odesílat přílohy do {{externalApp}}",
            "hint": "Přílohy záznamu v Tappeeru se druhému systému nabídnou poté, co se zapíšou jeho data. Soubor, který už má, se neposílá znovu."
          }
        },
        "capability": {
          "noRead": "Konektor {{externalApp}} neumí číst přílohy entity {{entity}}, tento směr proto nelze zapnout. Je potřeba verze pluginu, která to nabízí.",
          "noWrite": "Konektor {{externalApp}} neumí zapisovat přílohy entity {{entity}}, tento směr proto nelze zapnout. Je potřeba verze pluginu, která to nabízí.",
          "notReported": "Bridge zatím nehlásí, že jeho plugin {{externalApp}} přílohy přenáší. Záznamy se synchronizují dál; přílohy se rozjedou, jakmile to ohlásí."
        },
        "roles": {
          "label": "Přílohy, které se odesílají",
          "hint": "Druhému systému se nabídnou jen přílohy se zaškrtnutou rolí. Příchozí přílohy se podle role nefiltrují."
        },
        "transfers": {
          "title": "Přílohy",
          "hint": "Všechny přílohy, které tento konektor zařadil do fronty, přenesl nebo odmítl. Odmítnutá příloha nikdy nebyla způsobilá a neopakuje se; neúspěšnou zkusí další běhy znovu.",
          "empty": "Pro tento konektor zatím není naplánovaná žádná příloha.",
          "emptyHint": "Zapněte přílohy v Nastavení — od dalšího běhu se objeví zde.",
          "loadError": "Přílohy se nepodařilo načíst.",
          "loadMore": "Načíst další",
          "totalCount": "{{count}} příloh",
          "columns": {
            "file": "Soubor",
            "direction": "Směr",
            "status": "Stav",
            "size": "Velikost",
            "attempts": "Pokusů",
            "reason": "Důvod",
            "actions": "Akce"
          },
          "retry": "Zkusit znovu",
          "retried": "Příloha je znovu ve frontě.",
          "repush": "Odeslat záznam znovu",
          "repushed": "Znovu zařazeno: {{planned}} příloh, {{refused}} odmítnuto.",
          "actionError": "Akce neproběhla. Zkuste to znovu.",
          "repushModal": {
            "title": "Odeslat přílohy tohoto záznamu znovu?",
            "message": "Tappeer zapomene, které přílohy už tento konektor za daný záznam odeslal, a naplánuje je všechny znovu.",
            "warning": "Použijte, když druhý systém o soubor přišel. Druhému systému může přijít kopie souboru, který už měl.",
            "confirm": "Odeslat znovu",
            "cancel": "Zrušit"
          },
          "reasons": {
            "attachment_too_large": "Přesahuje povolenou velikost",
            "attachment_type_not_allowed": "Nepovolený typ souboru",
            "attachment_role_excluded": "Tato role se ven neodesílá",
            "attachment_name_invalid": "Neplatný název souboru",
            "attachment_hash_mismatch": "Přenesená data neodpovídají souboru",
            "attachment_rejected": "Kontrola po přenosu soubor odmítla",
            "attachment_not_found": "Druhý systém soubor už nemá",
            "attachment_transfer_failed": "Přenos selhal"
          }
        },
        "runErrors": {
          "title": "Přílohy, které se nepodařilo přenést ({{count}})",
          "capped": "a další ({{count}})"
        }
      },
      "deletion": {
        "title": "Smazané záznamy",
        "summary": {
          "deactivate": "Záznam smazaný ve zdroji Tappeer deaktivuje",
          "delete": "Záznam smazaný ve zdroji Tappeer odstraní",
          "info": "Záznam smazaný ve zdroji Tappeer jen označí",
          "notReading": "Konektor ze zdroje nečte, smazané záznamy nehlídá"
        },
        "intro": "Co má Tappeer udělat, když {{externalApp}} záznam smaže nebo ho přestane posílat.",
        "label": "Když záznam ve zdroji zmizí",
        "defaultOption": "{{mode}} (výchozí)",
        "hints": {
          "deactivate": "Záznam zmizí z nabídek. Doklady, které ho používají, zůstanou beze změny.",
          "delete": "Záznam se odstraní. Když ho něco používá, Tappeer ho jen označí.",
          "info": "Záznam zůstane, jak je. Uvidíte u něj jen štítek „Smazáno ve zdroji ({{externalApp}})“."
        },
        "scopeNote": "Když konektoru ve zdrojovém systému zúžíte rozsah, třeba filtrem nebo jinou účetní jednotkou, budou záznamy mimo nový rozsah vypadat jako smazané. Když jich zmizí hodně najednou, Tappeer je pozdrží v dávce, kterou v monitoru potvrdíte, nebo zahodíte. Když jen pár, naloží s nimi podle zvoleného režimu.",
        "notReading": "Smazané záznamy hlídá jen konektor s příchozím směrem. Tento ho zapnutý nemá.",
        "unsupported": "Režim „{{mode}}“ tato entita nepodporuje. Vyberte jiný.",
        "unsupportedShort": "Nepodporovaný režim"
      },
      "behaviour": {
        "echoSuppression": {
          "title": "Potlačení ozvěny",
          "description": "Přeskočí záznam, který se z druhého systému vrátí beze změny, aby jedna úprava neskákala mezi systémy donekonečna. Pole neslučuje.",
          "offWarning": "Vypnuto: každý záznam se zapíše při každém běhu, změněný či ne. Oba systémy si budou navzájem stále přeukládat záznamy.",
          "pointer": "Který systém smí zapisovat které pole se nastavuje v Transformace → Pole.",
          "goToFieldMap": "Otevřít sekci Pole"
        }
      },
      "mapping": {
        "noMetadata": "Plugin nepopisuje entitu {{entityType}}, mapovací pravidla zde nelze upravit.",
        "key": {
          "title": "Business klíč",
          "hint": "Podle čeho se řádek v Tappeeru a záznam druhého systému poznají jako tentýž.",
          "mode": {
            "default": "Výchozí z modelu",
            "fields": "Pole",
            "expression": "Výraz"
          },
          "modelDefault": "Klíčem je pole modelu: {{fields}}",
          "fields": "Pole klíče",
          "preview": {
            "button": "Zkontrolovat kolize",
            "error": "Náhled se nepodařilo spočítat.",
            "sampled": "{{count}} řádků vyhodnoceno",
            "unkeyed": "{{count}} řádků bez klíče",
            "collisions": "{{count}} klíčů sdílí více řádků — pravidlo neurčuje řádek jednoznačně.",
            "noCollisions": "Každý řádek s klíčem má svůj vlastní.",
            "truncated": "Náhled skončil na limitu řádků; větší účet může skrývat další kolize.",
            "columns": {
              "key": "Klíč",
              "count": "Řádků"
            }
          },
          "changeWarning": "Když změníte způsob sestavení klíče, záznamy, které se dřív párovaly, se párovat přestanou — místo aktualizací vzniknou duplicity. Před uložením si nechte zobrazit kolize."
        },
        "filters": {
          "title": "Filtry",
          "hint": "Synchronizují se jen řádky splňující podmínku.",
          "out": "Filtrovat odchozí řádky",
          "in": "Filtrovat příchozí záznamy",
          "serverSide": "na straně serveru",
          "inMemory": "v paměti",
          "noDirections": "Nejdřív vyberte směr synchronizace v Nastavení — filtr patří ke směru.",
          "serverSideHint": "Tappeer vybírá rovnou jen odpovídající řádky, takže na množství dat nezáleží.",
          "inMemoryHint": "Všechny řádky se načtou a filtrují až potom, což je nad velkými daty pomalé. Na straně serveru běží jen prosté „je“ nad filtrovatelným polem.",
          "inMemoryHintIn": "Každý záznam, který systém {{externalApp}} pošle, se načte a filtruje až v Tappeeru. Příchozí filtr na straně serveru neběží nikdy.",
          "pluginDefault": "Výchozí z pluginu"
        },
        "derived": {
          "title": "Odvozená pole",
          "hint": "Spočítat pole ze záznamu před jeho zápisem.",
          "toCanonical": "Příchozí — do polí Tappeeru",
          "toExternal": "Odchozí — do druhého systému",
          "target": "Cíl",
          "targetPlaceholder": "Název pole (může být virtuální)",
          "add": "Přidat pole",
          "remove": "Odebrat pole",
          "toCanonicalHint": "Použije se na každý příchozí záznam před zápisem do Tappeeru.",
          "toExternalHint": "Použije se na každý odchozí záznam před odesláním do druhého systému; cílem může být pole, které má jen druhý systém.",
          "chaining": "Pravidla běží shora dolů a pozdější pravidlo může použít, co zapsalo dřívější.",
          "pickTarget": "Před uložením zvolte, kam se má výsledek zapsat."
        },
        "defaults": {
          "title": "Výchozí hodnoty",
          "hint": "Hodnota pole Tappeeru, které příchozí záznam nechá prázdné.",
          "add": "Přidat výchozí hodnotu",
          "remove": "Odebrat výchozí hodnotu",
          "toCanonical": "Příchozí — do polí Tappeeru",
          "toExternal": "Odchozí — do druhého systému",
          "toCanonicalHint": "Použije se, když příchozí záznam nechá pole Tappeeru prázdné.",
          "toExternalHint": "Použije se, když odchozí záznam nechá pole prázdné; cílem může být pole, které má jen druhý systém.",
          "noDirections": "Nejdřív vyberte směr synchronizace v Nastavení — výchozí hodnota patří ke směru."
        },
        "marker": {
          "label": "Zapisovat id Tappeeru",
          "hint": "Plugin zapíše id Tappeeru do svého značkovacího pole, takže záznam pozná i po změně klíče."
        },
        "valueKind": {
          "label": "Typ hodnoty",
          "unset": "Nenastaveno",
          "string": "Text",
          "number": "Číslo",
          "boolean": "Ano/Ne",
          "null": "Prázdné",
          "json": "JSON"
        },
        "expression": {
          "customPath": "Jiná cesta…",
          "add": "Přidat",
          "remove": "Odebrat",
          "ops": {
            "field": "Pole",
            "const": "Konstanta",
            "meta": "Údaj o záznamu",
            "concat": "Spojení",
            "template": "Šablona",
            "coalesce": "První neprázdné",
            "lookup": "Převodní tabulka",
            "case": "Podmínky",
            "arith": "Aritmetika",
            "string": "Textová funkce",
            "splitStreet": "Rozdělit ulici",
            "joinStreet": "Spojit ulici",
            "eq": "Rovná se",
            "ne": "Nerovná se",
            "gt": "Větší než",
            "gte": "Větší nebo rovno",
            "lt": "Menší než",
            "lte": "Menší nebo rovno",
            "in": "Je v seznamu",
            "contains": "Obsahuje",
            "startsWith": "Začíná na",
            "endsWith": "Končí na",
            "isNull": "Je prázdné",
            "notNull": "Není prázdné",
            "and": "Všechny z",
            "or": "Některá z",
            "not": "Není",
            "resolve": "Vyhledat v cílovém systému",
            "fn": "Funkce pluginu",
            "ref": "Odkaz na Tappeer"
          },
          "slots": {
            "op": "Operace",
            "path": "Cesta k poli",
            "key": "Klíč",
            "fn": "Funkce",
            "left": "Levá strana",
            "right": "Pravá strana",
            "value": "Hodnota",
            "list": "Seznam",
            "item": "Položka",
            "input": "Vstup",
            "arg": "Argument",
            "args": "Argument",
            "parts": "Část",
            "when": "Větev",
            "if": "Když",
            "then": "Pak",
            "else": "Jinak",
            "separator": "Oddělovač",
            "scale": "Desetinná místa",
            "table": "Tabulka",
            "default": "Výchozí",
            "source": "Číselník",
            "sourcePath": "Pole číselníku",
            "wholeRecord": "Celý záznam",
            "entityType": "Entita",
            "by": "Hledat podle",
            "want": "Vrátit",
            "part": "Část ulice",
            "streetName": "Název ulice",
            "buildingNumber": "Číslo popisné"
          },
          "meta": {
            "externalId": "Externí id",
            "externalKey": "Externí klíč",
            "insioId": "Id Tappeeru",
            "runStartedAt": "Začátek běhu",
            "direction": "Směr"
          },
          "arith": {
            "round": "Zaokrouhlit"
          },
          "string": {
            "trim": "Oříznout mezery",
            "upper": "Velká písmena",
            "lower": "Malá písmena",
            "stripPrefix": "Odebrat předponu",
            "addPrefix": "Přidat předponu",
            "slice": "Výřez"
          },
          "streetPart": {
            "streetName": "Název ulice",
            "buildingNumber": "Číslo popisné"
          },
          "lookupKind": {
            "list": "číselník",
            "record": "záznam"
          },
          "ref": {
            "by": {
              "businessKey": "Business klíč",
              "externalId": "Externí id"
            },
            "want": {
              "externalId": "Externí id",
              "businessKey": "Business klíč",
              "insioId": "Id Tappeeru"
            }
          },
          "virtualOption": "{{name}} (virtuální)",
          "syncOnly": "jen pro synchronizaci",
          "syncOnlyOption": "{{name}} (jen pro synchronizaci)",
          "unsupported": "Toto pravidlo používá operaci, která už není podporována. Nahraďte ho, nebo odeberte."
        },
        "target": {
          "title": "Mapování cílového systému",
          "hint": "Jak se vlastní záznam {{externalApp}} převádí na pole Tappeeru a zpět. Vyhodnocuje plugin {{externalApp}} na bridgi.",
          "hintDirect": "Jak se vlastní záznam {{externalApp}} převádí na pole Tappeeru a zpět. Vyhodnocuje konektor {{externalApp}} v Tappeeru.",
          "runsOn": "Vyhodnocuje plugin {{externalApp}} na vašem bridgi nad vlastním záznamem {{externalApp}}. Surová data nikdy neopustí vaši síť.",
          "runsOnDirect": "Vyhodnocuje konektor {{externalApp}} v Tappeeru při čtení záznamů z aplikace {{externalApp}} a jejich zápisu do ní.",
          "model": "{{fields}} polí · {{sources}} číselníků · {{functions}} funkcí",
          "in": "Příchozí — pole {{externalApp}} → pole Tappeeru",
          "inHint": "Každé pravidlo čte záznam {{externalApp}} a zapíše jedno pole Tappeeru. Název začínající $ je pomocné pole jen pro pravidla níže.",
          "out": "Odchozí — pole Tappeeru → pole {{externalApp}}",
          "outHint": "Každé pravidlo čte záznam Tappeeru včetně odchozích odvozených polí a zapíše jedno pole {{externalApp}}.",
          "targetField": "Pole {{externalApp}}",
          "canonicalField": "Pole Tappeeru",
          "add": "Přidat mapování",
          "remove": "Odebrat mapování",
          "reset": "Vrátit výchozí pravidla pluginu",
          "status": {
            "default": "Výchozí z pluginu",
            "changed": "Upraveno",
            "added": "Přidáno"
          },
          "removedDefaults_one": "Odebráno {{count}} výchozí pravidlo pluginu: {{targets}}",
          "removedDefaults_few": "Odebrána {{count}} výchozí pravidla pluginu: {{targets}}",
          "removedDefaults_other": "Odebráno {{count}} výchozích pravidel pluginu: {{targets}}",
          "noDirections": "Nejdřív vyberte směr synchronizace v Nastavení — mapování cíle patří ke směru.",
          "issues": {
            "unknownTargetPath": "{{path}} není pole modelu {{externalApp}}, který plugin deklaruje.",
            "unknownLookupSource": "Číselník {{source}} plugin nedeklaruje.",
            "unknownTargetFunction": "Funkci {{name}} plugin nedeklaruje.",
            "resolveWithoutDefault": "Vyhledávání nemá výchozí hodnotu, neznámý klíč tedy dá prázdnou hodnotu.",
            "unknownCanonicalTarget": "{{field}} není pole Tappeeru této entity."
          },
          "noChaining": "Každé pravidlo čte záznam ze systému {{externalApp}} tak, jak přišel — žádné pravidlo nevidí výstup jiného, takže na jejich pořadí nezáleží."
        },
        "simple": {
          "advancedRule": "Pokročilé pravidlo",
          "switchToSimple": "Jednoduchý pohled",
          "switchToAdvanced": "Pokročilý pohled",
          "remove": "Odebrat",
          "addOption": "Přidat pole",
          "addPart": "Přidat část",
          "addRow": "Přidat řádek",
          "addCase": "Přidat případ",
          "addOtherwise": "Přidat náhradní hodnotu",
          "addCondition": "Přidat podmínku",
          "fallbackHint": "Použije se pro hodnotu, kterou tabulka neuvádí. Bez ní zůstane pole u neznámé hodnoty prázdné.",
          "otherwiseHint": "Použije se, když neodpovídá žádný případ. Bez ní zůstane pole prázdné.",
          "conditionsHint": "Musí platit všechny podmínky. Prosté „je“ nad filtrovatelným polem zvládne externí systém sám.",
          "operand": {
            "kind": "Druh",
            "field": "Pole",
            "value": "Hodnota",
            "meta": "Údaj o záznamu"
          },
          "meta": {
            "externalId": "Externí id",
            "externalKey": "Externí klíč",
            "insioId": "Id v Tappeeru",
            "runStartedAt": "Čas spuštění synchronizace",
            "direction": "Směr synchronizace"
          },
          "operator": {
            "eq": "je",
            "ne": "není",
            "gt": "je větší než",
            "gte": "je alespoň",
            "lt": "je menší než",
            "lte": "je nejvýše"
          },
          "slots": {
            "shape": "Toto pravidlo",
            "from": "Vzít z",
            "options": "Zkusit v pořadí",
            "checks": "Zkusit v pořadí",
            "otherwise": "Jinak",
            "table": "Převody",
            "tableKey": "Externí hodnota",
            "fallback": "Cokoli jiného",
            "function": "Funkce",
            "on": "Podívat se na",
            "cases": "Případy",
            "caseWhen": "když",
            "caseThen": "použít",
            "parts": "Části",
            "separator": "Oddělovač",
            "operator": "Porovnání",
            "against": "Porovnat s",
            "conditions": "Podmínky"
          },
          "chooseValue": "Vyberte hodnotu"
        },
        "recipes": {
          "insert": "Vložit recept",
          "hint": "Recept přidá hotové pravidlo nebo podmínku filtru, které před uložením upravíte. Přidá se k tomu, co už máte; nic se nenahradí.",
          "items": {
            "copyField": {
              "title": "Zkopírovat pole",
              "description": "Vezme hodnotu přímo z jednoho pole. Pole vyberte v části „Vzít z“ a zvolte, kam se má zapsat."
            },
            "firstFilled": {
              "title": "První vyplněné z několika polí",
              "description": "Pro hodnotu, která je někdy v jednom poli a někdy v jiném. Pole uveďte v části „Zkusit v pořadí“; použije se první, které není prázdné, a jsou-li prázdná všechna, zůstane cílové pole prázdné."
            },
            "fixedValue": {
              "title": "Vždy stejná hodnota",
              "description": "Zapíše hodnotu, kterou zadáte, a přepíše cokoli, co přišlo. Má-li hodnota jen doplnit pole, které záznam nechává prázdné, přidejte ji raději v části „Výchozí hodnoty“."
            },
            "translateValues": {
              "title": "Převést hodnoty převodní tabulkou",
              "description": "Pro dva systémy, které tutéž věc zapisují různě. Vyberte pole, přidejte řádek pro každou hodnotu a vyplňte „Cokoli jiného“ — zůstane-li prázdné, hodnota, která v tabulce není, nechá pole prázdné."
            },
            "flagFromCode": {
              "title": "Ano/ne podle kódu",
              "description": "Pro pole ano/ne, které druhý systém vede jen jako kód. Výsledek je ano, když pole nemá hodnotu, kterou zadáte; pro opačný význam přepněte porovnání na „je“."
            },
            "chooseByField": {
              "title": "Vybrat podle pole",
              "description": "Hodnota závisí na tom, co říká jiné pole. Přidejte případ pro každou hodnotu a ponechte „Jinak“, aby něco dostal i záznam, kterému neodpovídá žádný případ."
            },
            "joinFields": {
              "title": "Spojit několik polí",
              "description": "Spojí několik polí do jednoho, s oddělovačem mezi nimi (předvyplněna mezera)."
            },
            "pluginFunction": {
              "title": "Převést funkcí pluginu",
              "description": "Pro převod, který se pravidlem zapsat nedá, například název země na její kód. Vyberte některou z funkcí, které plugin nabízí, a pole, které funkce čte."
            },
            "filterEquals": {
              "title": "Jen záznamy s danou hodnotou",
              "description": "Synchronizují se jen záznamy, u kterých má pole hodnotu, kterou zadáte. Prosté „je“ nad filtrovatelným polem je jediná podmínka, kterou zvládne druhý systém sám."
            },
            "filterExclude": {
              "title": "Vynechat záznamy s danou hodnotou",
              "description": "Synchronizují se všechny záznamy kromě těch, u kterých má pole hodnotu, kterou zadáte. Filtruje se v paměti."
            },
            "filterFrom": {
              "title": "Jen záznamy od určité hodnoty",
              "description": "Synchronizují se jen záznamy, u kterých je pole alespoň tak velké jako hodnota, kterou zadáte — datum nebo číslo. Filtruje se v paměti, což je nad dlouhou historií pomalé."
            },
            "filterAllOf": {
              "title": "Několik podmínek najednou",
              "description": "Jeden řádek na podmínku; záznam se synchronizuje, jen když platí všechny. Na straně serveru filtr běží, jen dokud je každá z nich prosté „je“ nad filtrovatelným polem."
            }
          }
        },
        "traps": {
          "readsEarlierRule": "Toto pravidlo čte pole {{field}}, které zapisuje pravidlo výše — vidí už novou hodnotu.",
          "readsLaterRule": "Toto pravidlo čte pole {{field}}, které zapisuje pravidlo níže — vidí ještě původní hodnotu.",
          "targetHeldBack": "Pole {{field}} podle nastavení v sekci Pole dovnitř nepřechází — výsledek pravidla se do Tappeeru nezapíše.",
          "targetNotSynced": "Pole {{field}} se podle nastavení v sekci Pole nesynchronizuje — výsledek pravidla se nezapíše a změna jen v tomto poli se nesleduje.",
          "filterNotFlow": "Záznam vyřazený filtrem se do synchronizace vůbec nedostane, takže Tappeer nepozná, zda byl smazán, změněn, nebo jen odfiltrován. Nemá-li přecházet jen některé pole, nastavte místo filtru jeho tok v sekci Pole."
        },
        "unavailable": {
          "line": "V tomto kroku není k dispozici: {{operations}} — {{reason}}",
          "refNeedsTappeer": "Čte vazby Tappeeru, které krok vyhodnocovaný v systému {{externalApp}} nevidí. Použijte krok počítaný v Tappeeru.",
          "resolveNeedsTarget": "Běží uvnitř systému {{externalApp}}. Použijte krok, který ze systému {{externalApp}} čte nebo do něj odesílá.",
          "fnNeedsTarget": "Běží uvnitř systému {{externalApp}}. Použijte krok, který ze systému {{externalApp}} čte nebo do něj odesílá.",
          "noTargetModel": "Tento konektor předává pole Tappeeru přímo; nemá v čem vyhledávat ani co volat.",
          "noLookupSources": "Plugin pro {{externalApp}} neuvádí žádné číselníky.",
          "noFunctions": "Plugin pro {{externalApp}} neuvádí žádné funkce."
        },
        "transformPreview": {
          "direction": "Směr",
          "noDirections": "Nejdřív vyberte směr synchronizace v Nastavení — náhled běží v jednom směru.",
          "source": {
            "label": "Ukázkový záznam",
            "accountRecord": "Použít záznam tohoto účtu",
            "pasted": "Vložit JSON"
          },
          "sampleKind": {
            "label": "Vložený záznam je",
            "canonical": "Záznam Tappeeru",
            "target": "Záznam {{externalApp}}"
          },
          "sample": {
            "label": "Záznam jako JSON",
            "hint": "Jeden objekt JSON, nejvýše {{limit}} KiB. Odešle se jen pro tento náhled a nikam se neukládá.",
            "errors": {
              "empty": "Nejdřív vložte záznam.",
              "invalidJson": "Tohle není platný JSON.",
              "notObject": "Ukázka musí být jeden objekt JSON, ne seznam ani jednotlivá hodnota.",
              "tooLarge": "Ukázka je větší než {{limit}} KiB. Vložte menší záznam."
            }
          },
          "run": "Zobrazit náhled",
          "hint": "Použije pravidla transformace tak, jak je tu máte, včetně neuložených změn. Tok polí a směry synchronizace se berou z uloženého nastavení — chcete-li vidět jejich změnu, nejdřív je uložte. Nic se neuloží a žádná synchronizace se nespustí.",
          "waiting": {
            "title": "Náhled se vyhodnocuje… {{seconds}} s",
            "hint": "Kvůli náhledu se možná bude muset spustit aplikace {{externalApp}}. Může to trvat až dvě minuty."
          },
          "cancel": "Zrušit",
          "error": "Náhled se nepodařilo spočítat.",
          "stale": "Pravidla se od tohoto náhledu změnila. Spusťte ho znovu, abyste viděli, co dělají teď.",
          "result": {
            "source": {
              "accountRecord": "Náhled nad záznamem tohoto účtu.",
              "pasted": "Náhled nad vloženým záznamem."
            },
            "direction": "Spočítáno pro směr: {{direction}}"
          },
          "none": {
            "title": "Tento účet zatím nemá žádný záznam pro náhled.",
            "hint": "Vložte místo toho záznam jako JSON."
          },
          "notices": {
            "approximate": {
              "title": "Vstup je jen přibližný.",
              "body": "Záznam {{externalApp}} se nepodařilo načíst, proto ho zastupuje záznam Tappeeru. Skutečná synchronizace může dát jiný výsledek."
            },
            "bridgeInbound": "Záznam {{externalApp}} zůstává na vašem bridgi. Tady se zobrazují jen výsledky pravidel.",
            "excluded": "Záznam neprojde filtrem — synchronizace by ho nezapsala.",
            "noBusinessKey": "Záznam nemá business klíč, synchronizace by ho proto přeskočila.",
            "targetProblem": "Systém {{externalApp}} nevrátil žádný záznam — synchronizace by ho nezapsala a nahlásila by problém uvedený níže."
          },
          "keys": {
            "business": "Business klíč",
            "external": "Externí klíč"
          },
          "input": "Vstupní záznam",
          "output": "Výsledek",
          "noOutput": "Žádný záznam nevznikne — synchronizace by nic nezapsala.",
          "stageOutput": "Záznam po tomto kroku",
          "withheld": {
            "title": "Ponecháno beze změny:",
            "reason": "Hodnota byla příliš dlouhá na to, aby ji pravidlo zpracovalo, proto tato pole zůstávají tak, jak byla."
          },
          "masked": "Skryto",
          "stages": {
            "targetIn": "Záznam {{externalApp}} → pole Tappeeru",
            "cloudIn": "Příchozí pravidla v Tappeeru",
            "cloudOut": "Odchozí pravidla v Tappeeru",
            "targetOut": "Pole Tappeeru → záznam {{externalApp}}"
          },
          "evaluator": {
            "cloud": "Vyhodnotil Tappeer",
            "bridge": "Vyhodnotil bridge",
            "connector": "Vyhodnotil konektor"
          },
          "skipped": {
            "noTargetSample": "Nevyhodnoceno: tato pravidla čtou záznam {{externalApp}}, ale ukázka je záznam Tappeeru.",
            "noTargetModel": "Nevyhodnoceno: pro {{externalApp}} není deklarován žádný model, takže tu žádná pravidla nejsou.",
            "noRules": "Nevyhodnoceno: v tomto směru není žádné pravidlo."
          },
          "fallback": {
            "title": "Vyhodnotil Tappeer, ne tam, kde tato pravidla vyhodnocuje synchronizace.",
            "bridgeNotConnected": "Bridge není připojený.",
            "bridgeBusy": "Bridge právě vyřizuje jiný požadavek. Zkuste to za chvíli znovu.",
            "notSupported": "Tato verze pluginu nebo konektoru pro {{externalApp}} náhled pravidel zatím neumí.",
            "timeout": "Systém {{externalApp}} neodpověděl včas.",
            "targetError": "Systém {{externalApp}} pravidla nedokázal vyhodnotit.",
            "noLinkedRecord": "Ukázkový záznam není spárovaný se záznamem {{externalApp}}, takže nebylo co načíst."
          },
          "problem": "Synchronizace by k záznamu nahlásila:",
          "notes": "Poznámky vyhodnocení",
          "slots": {
            "defaultsToCanonical": "Výchozí hodnota, příchozí",
            "fieldsToCanonical": "Odvozené pole, příchozí",
            "defaultsToExternal": "Výchozí hodnota, odchozí",
            "fieldsToExternal": "Odvozené pole, odchozí",
            "targetIn": "Mapování cílového systému, příchozí",
            "targetOut": "Mapování cílového systému, odchozí",
            "keyOnCreate": "Klíč nového záznamu"
          },
          "field": {
            "rule": "Pravidlo {{number}}",
            "edited": "Právě upravujete",
            "before": "Před",
            "after": "Po",
            "changed": "Změněno",
            "unchanged": "Beze změny",
            "diagnostics": "Diagnostika"
          },
          "rule": {
            "title": "V posledním náhledu"
          },
          "maskedHint": "Hodnoty, které vypadají jako tajné údaje, se v náhledu nezobrazují.",
          "unsavedSettings": "Směry synchronizace nebo tok polí mají neuložené změny. Náhled použije uložené nastavení.",
          "status": {
            "started": "Náhled se vyhodnocuje.",
            "finished": "Náhled je hotový.",
            "failed": "Náhled se nepodařilo spočítat."
          }
        }
      },
      "linkDecisionPermissions": {
        "invoice": "upravovat faktury",
        "party": "spravovat firmy",
        "cost-center": "spravovat nákladová střediska",
        "job": "spravovat zakázky",
        "org-unit": "spravovat pozice org. struktury",
        "org-unit-member": "spravovat pozice org. struktury a jejich členy",
        "product": "spravovat produkty",
        "gl-posting": "spravovat účetní číselníky",
        "vat-code": "spravovat účetní číselníky",
        "vat-posting": "spravovat účetní číselníky",
        "bank-document": "párovat platby"
      },
      "pendingMatches": {
        "title": "Čekající shody",
        "hint": "Příchozí záznamy, které mohou být více řádky Tappeeru. Vyberte řádek, nebo shodu odmítněte.",
        "empty": "Nic nečeká na rozhodnutí.",
        "loadError": "Čekající shody se nepodařilo načíst.",
        "loadMore": "Načíst další",
        "totalCount": "{{count}} čeká",
        "externalId": "Externí id",
        "candidates": "Řádek Tappeeru",
        "chooseCandidate": "Vyberte řádek…",
        "openRow": "Otevřít řádek",
        "openList": "Otevřít seznam",
        "rowMissing": "Řádek už v Tappeeru není.",
        "confirm": "Potvrdit",
        "reject": "Odmítnout",
        "confirmListed": "Potvrdit zobrazené",
        "rejectAll": "Odmítnout vše",
        "confirmed": "Záznam byl spárován.",
        "rejected": "Shoda byla odmítnuta.",
        "bulkConfirmed_one": "Spárován {{count}} záznam.",
        "bulkConfirmed_few": "Spárovány {{count}} záznamy.",
        "bulkConfirmed_other": "Spárováno {{count}} záznamů.",
        "bulkRejected_one": "Odmítnuta {{count}} shoda.",
        "bulkRejected_few": "Odmítnuty {{count}} shody.",
        "bulkRejected_other": "Odmítnuto {{count}} shod.",
        "bulkPartial": "Spárováno: {{resolved}}. Nepodařilo se: {{failed}}.",
        "bulkPartialInvoice": "Spárováno: {{resolved}}. Nepodařilo se: {{failed}}. Nejčastěji proto, že faktury v jejich současném stavu nelze upravit; vraťte je k editaci, případně obnovte stránku, a shody potvrďte znovu.",
        "permissionRequired": "K potvrzení shody potřebujete oprávnění {{permission}}.",
        "nothingToConfirm": "Žádná ze zobrazených shod nemá vybraný řádek.",
        "error": "Rozhodnutí se nepodařilo uložit.",
        "rejectModal": {
          "title": "Odmítnout shodu",
          "message": "Záznam nebude spárován s žádným z navržených řádků. Příští synchronizace ho vezme jako nový.",
          "confirm": "Odmítnout",
          "cancel": "Zrušit"
        },
        "confirmListedModal": {
          "title": "Potvrdit zobrazené shody",
          "message_one": "Potvrdí se {{count}} zobrazená shoda, celkem jich čeká {{total}}. Záznam se spáruje s řádkem vybraným v jeho nabídce; kde jste nevybrali jiný, je to první návrh.",
          "message_few": "Potvrdí se {{count}} zobrazené shody, celkem jich čeká {{total}}. Každý záznam se spáruje s řádkem vybraným v jeho nabídce; kde jste nevybrali jiný, je to první návrh.",
          "message_other": "Potvrdí se {{count}} zobrazených shod, celkem jich čeká {{total}}. Každý záznam se spáruje s řádkem vybraným v jeho nabídce; kde jste nevybrali jiný, je to první návrh.",
          "warning": "Data příchozích záznamů se zapíšou do vybraných řádků. Špatně vybraný řádek tím přepíšete a vrátit to zpět nelze.",
          "confirm": "Potvrdit zobrazené",
          "cancel": "Zrušit"
        },
        "rejectAllModal": {
          "title": "Odmítnout všechny shody",
          "message_one": "Odmítne se {{count}} čekající shoda tohoto konektoru, i kdyby nebyla zobrazená.",
          "message_few": "Odmítnou se {{count}} čekající shody tohoto konektoru, i ty, které nejsou zobrazené.",
          "message_other": "Odmítne se všech {{count}} čekajících shod tohoto konektoru, i ty, které nejsou zobrazené.",
          "warning": "Žádný záznam se nespáruje. Příští synchronizace je vezme jako nové a může založit duplicity.",
          "confirm": "Odmítnout vše",
          "cancel": "Zrušit"
        }
      },
      "entityLinks": {
        "title": "Vazby",
        "hint": "Všechna spárování záznamu cílového systému s řádkem Tappeeru, která tento konektor vytvořil, včetně uzavřených. Aktivní vazbu lze zrušit, nebo ji převést na jiný řádek.",
        "search": "Hledat podle business klíče, externího klíče nebo id",
        "status": "Stav",
        "allStatuses": "Všechny stavy",
        "empty": "Žádná vazba neodpovídá.",
        "loadError": "Vazby se nepodařilo načíst.",
        "loadMore": "Načíst další",
        "totalCount_one": "{{count}} vazba",
        "totalCount_few": "{{count}} vazby",
        "totalCount_other": "{{count}} vazeb",
        "columns": {
          "businessKey": "Business klíč",
          "record": "Řádek Tappeeru",
          "external": "Externí záznam",
          "status": "Stav",
          "matched": "Spárováno",
          "lastSynced": "Poslední synchronizace"
        },
        "rowMissing": "Řádek už v Tappeeru není.",
        "missingSince": "Ve zdroji chybí od {{date}}",
        "unlink": "Zrušit vazbu",
        "relink": "Změnit řádek",
        "unlinked": "Vazba byla zrušena.",
        "relinked": "Záznam byl spárován s vybraným řádkem.",
        "permissionRequired": "Ke změně řádku potřebujete oprávnění {{permission}}.",
        "error": "Něco se nepovedlo. Zkuste to prosím znovu.",
        "unlinkModal": {
          "title": "Zrušit vazbu",
          "message": "Vazba mezi business klíčem {{businessKey}} a externím id {{externalId}} bude uzavřena. V seznamu zůstane jako historie.",
          "warning": "Příští synchronizace záznam znovu spáruje podle business klíče a alternativních klíčů. Když se nic neshoduje, vezme ho jako nový a může ho znovu založit jako duplicitu; když se shoduje více řádků, počká jako čekající shoda.",
          "confirm": "Zrušit vazbu",
          "cancel": "Zpět"
        },
        "relinkModal": {
          "title": "Změnit řádek",
          "keyLabel": "Business klíč řádku",
          "lookup": "Vyhledat",
          "noRows": "Žádný jiný řádek Tappeeru tento klíč nemá.",
          "pickRow": "Vyberte řádek…",
          "message": "Externí id {{externalId}}, nyní spárované přes business klíč {{businessKey}}, se místo toho spáruje s řádkem, který vyberete.",
          "warning": "Příští příchozí synchronizace zapíše cílový záznam do vybraného řádku; příští odchozí synchronizace odešle vybraný řádek do cílového záznamu. Předchozí spárování zůstane jako historie.",
          "confirm": "Změnit řádek",
          "cancel": "Zrušit"
        }
      },
      "targetDuplicates": {
        "title": "Duplicity v cílovém systému",
        "hint": "Řádky Tappeeru, které cílový systém vede vícekrát, například firma založená dvakrát se stejným IČO. Synchronizace zapisuje změny z Tappeeru jen do primárního záznamu. Duplicity vyčistěte v cílovém systému; do té doby můžete vybrat, který záznam je primární.",
        "totalCount_one": "{{count}} řádek s duplicitami",
        "totalCount_few": "{{count}} řádky s duplicitami",
        "totalCount_other": "{{count}} řádků s duplicitami",
        "loadError": "Duplicity v cílovém systému se nepodařilo načíst.",
        "loadMore": "Načíst další",
        "rowMissing": "Řádek už v Tappeeru není.",
        "lastMatchedAt": "Naposledy spárováno {{date}}",
        "matchedBy": "Shodný klíč:",
        "matchKey": "{{kind}} {{value}}",
        "primary": "Primární",
        "alias": "Duplicita",
        "externalKey": "Externí klíč: {{key}}",
        "pairedBy": "Spárováno podle: {{matchedBy}}",
        "matched": "Spárováno podle: {{matchedBy}} · {{date}}",
        "missingSince": "Ve zdroji chybí od {{date}}",
        "missingInTarget": "Záznam v cílovém systému chybí",
        "permissionRequired": "K nastavení primárního záznamu potřebujete oprávnění {{permission}}.",
        "setPrimary": "Nastavit jako primární",
        "primarySet": "Záznam {{externalId}} je nyní primární.",
        "setPrimaryModal": {
          "title": "Nastavit jako primární",
          "message": "Externí záznam {{externalId}} se stane primárním záznamem řádku {{row}}; záznam {{primaryExternalId}} zůstane spárovaný jako duplicita.",
          "warning": "Od příští synchronizace se změny z Tappeeru zapisují do {{externalId}} místo do {{primaryExternalId}}. Změna se zapíše do událostí konektoru.",
          "confirm": "Nastavit jako primární",
          "cancel": "Zrušit"
        },
        "errors": {
          "notFound": "Tento záznam už neexistuje. Duplicity byly znovu načteny.",
          "refused": "Tento záznam teď nelze nastavit jako primární. Duplicity byly znovu načteny.",
          "conflict": "Duplicity se mezitím změnily. Byly znovu načteny; zkuste to prosím znovu.",
          "generic": "Něco se nepovedlo. Zkuste to prosím znovu."
        }
      },
      "missingRecords": {
        "hold": {
          "sectionTitle": "Pozdržené dávky",
          "title": "Dávka chybějících záznamů",
          "status": {
            "pending": "Čeká na rozhodnutí",
            "running": {
              "deactivate": "Deaktivuje se",
              "delete": "Odstraňuje se",
              "info": "Označuje se"
            }
          },
          "intro": "Při synchronizaci chybělo ve zdrojovém systému najednou víc záznamů než obvykle, a tak je Tappeer pozdržel. Zatím se s nimi nic nestalo. Pokud jsou ve zdroji opravdu smazané, potvrďte to. Pokud chybí omylem, třeba po změně filtru, dávku zahoďte.",
          "facts": {
            "missing": "Chybělo",
            "missingValue": "{{missing}} z {{total}}",
            "held": "V dávce teď",
            "acted": {
              "deactivate": "Deaktivováno",
              "delete": "Zpracováno",
              "info": "Označeno"
            },
            "heldMode": "Režim při pozdržení",
            "mode": "Režim",
            "raised": "Pozdrženo",
            "confirmed": "Potvrzeno"
          },
          "modeChanged": "Když se dávka pozdržela, platil režim „{{held}}“. Potvrzení použije současné nastavení konektoru: „{{current}}“.",
          "connectorOff": {
            "pending": "Konektor je vypnutý. Dávku potvrdíte, až ho zapnete; zahodit ji můžete i teď.",
            "running": {
              "deactivate": "Konektor je vypnutý. Deaktivace se dokončí, až ho zapnete.",
              "delete": "Konektor je vypnutý. Odstraňování se dokončí, až ho zapnete.",
              "info": "Konektor je vypnutý. Označování se dokončí, až ho zapnete."
            }
          },
          "discard": "Zahodit dávku",
          "running": {
            "deactivate": "Deaktivace probíhá… Hotovo {{acted}} z {{total}}.",
            "delete": "Odstraňování probíhá… Hotovo {{acted}} z {{total}}.",
            "info": "Označování probíhá… Hotovo {{acted}} z {{total}}."
          },
          "reload": "Načíst znovu",
          "finish": "Dokončit",
          "discarded": "Dávka je zahozená. Záznamy, které ve zdroji pořád chybí, posoudí příští synchronizace znovu.",
          "confirmed": "Hotovo. Tappeer dávku zpracovává.",
          "finishing": "Hotovo. Tappeer dávku dokončuje.",
          "loadError": "Pozdržené dávky se nepodařilo načíst."
        },
        "confirm": {
          "deactivate": "Deaktivovat záznamy",
          "delete": "Odstranit záznamy",
          "info": "Označit záznamy"
        },
        "confirmModal": {
          "title": "Potvrdit pozdrženou dávku",
          "message": {
            "deactivate_one": "Tappeer deaktivuje {{count}} záznam, který ve zdrojovém systému chybí. Zmizí z nabídek; doklady, které ho používají, zůstanou beze změny.",
            "deactivate_few": "Tappeer deaktivuje {{count}} záznamy, které ve zdrojovém systému chybí. Zmizí z nabídek; doklady, které je používají, zůstanou beze změny.",
            "deactivate_other": "Tappeer deaktivuje {{count}} záznamů, které ve zdrojovém systému chybí. Zmizí z nabídek; doklady, které je používají, zůstanou beze změny.",
            "delete_one": "Tappeer odstraní {{count}} záznam, který ve zdrojovém systému chybí. Když ho něco používá, jen ho označí.",
            "delete_few": "Tappeer odstraní {{count}} záznamy, které ve zdrojovém systému chybí. Záznam, který něco používá, jen označí.",
            "delete_other": "Tappeer odstraní {{count}} záznamů, které ve zdrojovém systému chybí. Záznam, který něco používá, jen označí.",
            "info_one": "Tappeer {{count}} záznam jen označí jako smazaný ve zdroji. V Tappeeru se nic nezmění.",
            "info_few": "Tappeer {{count}} záznamy jen označí jako smazané ve zdroji. V Tappeeru se nic nezmění.",
            "info_other": "Tappeer {{count}} záznamů jen označí jako smazané ve zdroji. V Tappeeru se nic nezmění."
          },
          "comesBack": "Když se záznam ve zdroji znovu objeví, Tappeer ho při další synchronizaci vrátí.",
          "cancel": "Zrušit"
        },
        "list": {
          "title": "Chybí ve zdroji",
          "hint": "Záznamy, které zdrojový systém přestal posílat nebo nahlásil jako smazané, od nejnovějšího.",
          "totalCount_one": "{{count}} záznam",
          "totalCount_few": "{{count}} záznamy",
          "totalCount_other": "{{count}} záznamů",
          "columns": {
            "record": "Záznam",
            "reason": "Proč chybí",
            "state": "Co se stalo",
            "since": "Zjištěno"
          },
          "held": "V pozdržené dávce",
          "waiting": "Čeká na zpracování",
          "externalKey": "Externí klíč: {{key}}",
          "empty": "Ve zdroji nic nechybí.",
          "emptyHint": "Když zdrojový systém přestane posílat některý záznam, uvidíte ho tady.",
          "loadError": "Chybějící záznamy se nepodařilo načíst.",
          "loadMore": "Načíst další"
        }
      },
      "connector": {
        "tabs": {
          "settings": "Nastavení",
          "transform": "Transformace",
          "links": "Vazby",
          "monitor": "Monitor"
        },
        "selectTab": "Sekce",
        "saveBar": {
          "label": "Neuložené změny",
          "unsavedIn": "Neuložené změny v: {{tabs}}",
          "discard": "Zahodit",
          "save": "Uložit změny",
          "saving": "Ukládám…",
          "fixErrors": "Před uložením konektoru je potřeba opravit některé hodnoty.",
          "dirtyDot": "Neuložené změny"
        },
        "unsaved": {
          "title": "Neuložené změny",
          "message": "Konektor má neuložené změny. Přidání instalace otevře jinou stránku — změny nejdřív uložte, nebo zahoďte.",
          "messageNoInstallation": "Konektor má neuložené změny, ale dokud nečte žádnou instalaci, nejde uložit. Změny zahoďte, nebo zůstaňte na stránce.",
          "cancel": "Zůstat",
          "discard": "Zahodit změny",
          "save": "Uložit a pokračovat",
          "saving": "Ukládám…"
        },
        "status": {
          "enabled": "Zapnuto",
          "draft": "Koncept",
          "pluginUnavailable": "Plugin není dostupný",
          "needsReview": "Vyžaduje kontrolu",
          "outdated": "Zastaralé nastavení"
        },
        "directions": {
          "in": "Příchozí: záznamy změněné v {{externalApp}} se zapisují do Tappeeru.",
          "readBack": "Jen zpětné načtení: podle plánu Tappeer znovu načte stav záznamů, které odeslal do {{externalApp}}, například stav zaúčtování. Nic jiného nevytváří ani nemění.",
          "out": "Odchozí: záznamy změněné v Tappeeru se zapisují do {{externalApp}}.",
          "inLabel": "příchozí, {{externalApp}} → Tappeer",
          "outLabel": "odchozí, Tappeer → {{externalApp}}"
        },
        "setup": {
          "status": {
            "title": "Stav",
            "intro": "Konektor synchronizuje, jen když je zapnutý. Vše ostatní lze připravit předem.",
            "pluginUnavailable": "Plugin, který tento konektor používá, není na platformě nainstalovaný, takže konektor nelze zapnout."
          },
          "problems_one": "{{count}} k opravě",
          "problems_few": "{{count}} k opravě",
          "problems_other": "{{count}} k opravě",
          "scheduleCount_one": "{{count}} plán",
          "scheduleCount_few": "{{count}} plány",
          "scheduleCount_other": "{{count}} plánů",
          "basics": {
            "title": "Základní údaje",
            "intro": "Co tento konektor synchronizuje a kterým směrem."
          },
          "schedule": {
            "title": "Plán synchronizace",
            "intro": "Kdy se konektor spouští sám. Ruční synchronizace funguje bez ohledu na plán.",
            "empty": {
              "title": "Zatím žádný plán",
              "description": "Dokud nepřidáte plán, nic neběží periodicky. Ruční synchronizace funguje i tak."
            },
            "add": "Přidat plán",
            "remove": "Odebrat",
            "readBackLast": "Jen zpětné načtení potřebuje alespoň jeden plán zpětného načtení. Pokud ho chcete zastavit, nastavte příchozí směr na Vypnuto.",
            "mode": {
              "label": "Co synchronizovat",
              "full": "Úplná synchronizace",
              "modifiedSince": "Jen změny (od posledního běhu)",
              "readBack": "Zpětné načtení",
              "hint": {
                "noInbound": "Jen změny lze zvolit pouze u příchozího konektoru.",
                "unsupported": "{{externalApp}} neumí vypsat záznamy změněné od zadaného času, k dispozici je jen úplná synchronizace."
              }
            },
            "cadence": {
              "label": "Jak často",
              "every1m": "Každou minutu",
              "every15m": "Každých 15 minut",
              "every30m": "Každých 30 minut",
              "hourly": "Každou hodinu",
              "every6h": "Každých 6 hodin",
              "daily": "Denně v zadaný čas",
              "weekly": "Týdně v zadaný den",
              "custom": "Vlastní (cron)"
            },
            "time": "Čas",
            "weekday": "Den",
            "cron": "Výraz cron",
            "cronHint": "Pět polí: minuta hodina den měsíc den v týdnu, např. 0 2 * * *",
            "timezone": "Časové pásmo",
            "outboundEvents": {
              "label": "Okamžitě odesílat změny z Tappeeru do systému {{externalApp}}",
              "hint": "Když je zapnuto, záznam změněný v Tappeeru se krátce po uložení zapíše do systému {{externalApp}}. Když je vypnuto, změny se do systému {{externalApp}} dostanou jen naplánovanou úplnou synchronizací nebo ruční synchronizací."
            },
            "status": {
              "nextRun": "Další běh {{when}} ({{at}})",
              "lastRun": "Poslední běh {{when}}",
              "notScheduled": "Zatím nenaplánováno — aktivuje se uložením.",
              "disabled": "Nenaplánováno — nejprve konektor zapněte."
            }
          }
        },
        "advanced": {
          "connection": {
            "title": "Nastavení připojení",
            "required": "Povinné hodnoty jako první",
            "intro": "Jak se Tappeer dostane k {{externalApp}}: adresy, přihlašovací údaje a vlastní volby pluginu.",
            "sharedIntro": "Jen nastavení, která se liší podle entity. Vše, co sdílí celá instalace — adresa, firma, přihlašovací údaje — se nastavuje jednou na samotné instalaci.",
            "empty": "Tento plugin žádné nastavení připojení nepotřebuje.",
            "readsConnection": "Čte sdílenou instalaci.",
            "readsConnectionOnBridge": "Čte sdílenou instalaci na bridgi {{bridge}}.",
            "editOnConnection": "Upravit její sdílená nastavení"
          },
          "discovered": {
            "title": "Nalezeno na bridgi",
            "intro": "Hodnoty, které plugin {{externalApp}} na bridgi našel na svém počítači. Použití vyplní jen pole, která jsou zatím prázdná.",
            "applyAll": "Použít všechny návrhy",
            "nothing": "Bridge zatím pro {{externalApp}} žádné hodnoty nenahlásil.",
            "hiddenBy": "Teď se nezobrazuje – závisí na nastavení „{{setting}}“.",
            "choice": {
              "label": "{{name}} (nalezeno: {{total}})",
              "hint": "Vyberte jednu z možností; vyplní najednou všechna nastavení, která k ní patří.",
              "placeholder": "Vyberte",
              "source": "Nalezeno v {{source}}",
              "use": "Použít vybranou možnost",
              "conflicts": "Tato pole už obsahují jinou hodnotu. Nahradit je?",
              "replace": "Nahradit",
              "keep": "Ponechat stávající hodnoty",
              "names": {
                "accountingUnit": "Účetní jednotka"
              }
            },
            "columns": {
              "key": "Nastavení",
              "value": "Hodnota",
              "source": "Nalezeno v"
            }
          },
          "engine": {
            "title": "Engine",
            "intro": "Jak synchronizační engine zachází se záznamy, které se vrací z druhého systému."
          }
        },
        "transform": {
          "transfer": {
            "label": "Kopírování, export a import pravidel",
            "copy": {
              "button": "Zkopírovat pravidla z jiného konektoru",
              "title": "Zkopírovat pravidla z jiného konektoru",
              "description": "Převezme pravidla a tok polí jiného konektoru systému {{externalApp}} pro stejnou entitu. Nastavení připojení se nekopíruje.",
              "source": "Konektor",
              "placeholder": "Vyberte konektor",
              "usesDefaults": "{{name}} — používá výchozí pravidla pluginu",
              "none": "Žádný jiný konektor tento plugin pro tuto entitu nepoužívá.",
              "loadError": "Konektory se nepodařilo načíst."
            },
            "export": {
              "button": "Exportovat pravidla",
              "hint": "Exportovaný soubor neobsahuje hesla ani nastavení připojení, obsahuje ale vaše převodní tabulky, konstanty a výchozí hodnoty.",
              "dirty": "Nejdřív změny uložte, nebo zahoďte — export obsahuje uložená pravidla. Soubor neobsahuje hesla ani nastavení připojení, obsahuje ale vaše převodní tabulky, konstanty a výchozí hodnoty."
            },
            "import": {
              "button": "Importovat pravidla",
              "title": "Importovat pravidla",
              "description": "Načte pravidla a tok polí ze souboru exportovaného z konektoru systému {{externalApp}} pro stejnou entitu.",
              "file": {
                "title": "Vyberte soubor .json",
                "description": "nebo ho sem přetáhněte",
                "selected": "Soubor:",
                "remove": "Odebrat soubor",
                "unreadable": "Soubor se nepodařilo přečíst."
              },
              "paste": {
                "label": "Nebo vložte exportovaný text"
              },
              "problems": {
                "empty": "Není co importovat.",
                "invalidJson": "Toto není platný JSON.",
                "notObject": "Toto není exportovaný soubor pravidel: očekával se objekt.",
                "tooLarge": "Pravidla překračují limit {{limit}} KiB.",
                "tooDeep": "Pravidla jsou příliš hluboko vnořená.",
                "wrongKind": "Toto není exportovaný soubor pravidel.",
                "wrongFormatVersion": "Soubor je exportován ve formátu, který tato verze Tappeeru neumí přečíst.",
                "differentPlugin": "Tato pravidla byla exportována z konektoru jiného systému, ne systému {{externalApp}}.",
                "differentEntity": "Tato pravidla byla exportována z konektoru pro jinou entitu."
              },
              "warnings": {
                "pluginVersion": "Soubor byl exportován z verze pluginu {{exported}}; tento konektor běží na verzi {{current}}. Pravidla byla zkontrolována proti verzi tohoto konektoru.",
                "pluginVersionUnknown": "Soubor neuvádí, z jaké verze pluginu byl exportován; tento konektor běží na verzi {{current}}. Pravidla byla zkontrolována proti verzi tohoto konektoru."
              }
            },
            "check": "Zkontrolovat a pokračovat",
            "cancel": "Zrušit",
            "refused": "Tato pravidla na tomto konektoru použít nelze. Nic se nezměnilo.",
            "failed": "Pravidla se nepodařilo zkontrolovat. Nic se nezměnilo.",
            "confirm": {
              "title": "Nahradit pravidla a tok polí?",
              "message": {
                "connector": "Pravidla a tok polí, které teď máte v editoru, budou nahrazeny těmi z konektoru {{name}}. Nic se neuloží, dokud konektor neuložíte.",
                "file": "Pravidla a tok polí, které teď máte v editoru, budou nahrazeny těmi ze souboru {{name}}. Nic se neuloží, dokud konektor neuložíte.",
                "pasted": "Pravidla a tok polí, které teď máte v editoru, budou nahrazeny těmi z vloženého textu. Nic se neuloží, dokud konektor neuložíte."
              },
              "warnings": "Než je nahradíte, je dobré vědět:",
              "rekeyed": "Vazby konektoru se při uložení převedou na nový klíč.",
              "replace": "Nahradit"
            },
            "replaced": {
              "connector": "Pravidla a tok polí byly nahrazeny těmi z konektoru {{name}}.",
              "file": "Pravidla a tok polí byly nahrazeny těmi ze souboru {{name}}.",
              "pasted": "Pravidla a tok polí byly nahrazeny těmi z vloženého textu."
            },
            "undo": "Vrátit zpět"
          },
          "fieldMap": {
            "title": "Pole",
            "intro": "Každé pole entity: kterým směrem přechází a co se s ním cestou děje. Otevřete pole a upravte jeho kroky. Tok může zápis pole jen omezit, nikdy rozšířit."
          },
          "key": {
            "title": "Business klíč",
            "intro": "Podle čeho se řádek v Tappeeru a záznam v {{externalApp}} poznají jako tentýž."
          },
          "filters": {
            "title": "Filtry",
            "intro": "Synchronizují se jen řádky splňující podmínku."
          },
          "defaults": {
            "title": "Výchozí hodnoty",
            "intro": "Hodnoty použité pro pole, které záznam nechá prázdné."
          },
          "marker": {
            "title": "Značka",
            "intro": "Zda plugin zapisuje id Tappeeru do svého záznamu, aby ho poznal i po změně klíče."
          },
          "preview": {
            "title": "Náhled",
            "intro": "Podívejte se, co pravidla transformace udělají s jedním záznamem, krok za krokem, ještě než je uložíte."
          }
        },
        "monitor": {
          "activityTitle": "Události konektoru",
          "activityIntro": "Změny nastavení a další události konektoru, od nejnovějšího — průběhy synchronizace jsou na vedlejší záložce."
        },
        "pipeline": {
          "label": "Pipeline"
        },
        "migration": {
          "banner": {
            "outdatedTitle": "Nastavení tohoto konektoru pochází ze schématu pluginu v{{from}}; plugin je nyní ve verzi v{{to}}.",
            "outdatedBody": "Migrace přenese uložené hodnoty do nového schématu. Pokud chcete, nejdřív si v Nastavení prohlédněte, co se změní.",
            "needsReviewTitle": "Nastavení bylo zmigrováno na schéma pluginu v{{to}}, ale před spuštěním konektoru potřebuje kontrolu.",
            "migrate": "Migrovat nyní",
            "saveFirst": "Nejdřív uložte své změny",
            "review": "Zkontrolovat v Nastavení",
            "fix": "Opravit v Nastavení"
          },
          "version": {
            "title": "Verze nastavení",
            "intro": "Schéma nastavení pluginu má verze. Konektor uložený proti starší verzi se migruje; co migrace nevyřešila, je uvedeno zde.",
            "connectorVersion": "Verze schématu konektoru",
            "pluginVersion": "Verze schématu pluginu",
            "status": "Stav",
            "upToDate": "Tento konektor je na aktuálním schématu pluginu.",
            "reviewHint": "Uložení platného nastavení stav „Vyžaduje kontrolu“ zruší.",
            "diff": {
              "title": "Co se změnilo mezi v{{from}} a v{{to}}",
              "added": "Přidané klíče",
              "removed": "Odebrané klíče",
              "changed": "Změněné klíče",
              "required": "povinné",
              "secret": "tajné",
              "none": "Žádné rozdíly na úrovni klíčů."
            },
            "report": {
              "previewTitle": "Co by migrace provedla",
              "storedTitle": "Poslední migrace: v{{from}} → v{{to}}, {{at}}",
              "droppedKeys": "Zahozené klíče",
              "renamedSecrets": "Přejmenovaná tajemství",
              "clearedSecrets": "Vymazaná tajemství",
              "issues": "Problémy",
              "nothing": "Není co hlásit — každá hodnota se přenese tak, jak je."
            },
            "missingRequired": "Povinná nastavení bez hodnoty",
            "missingRequiredHint": "Vyplňte je výše v Nastavení připojení; bez nich konektor nelze zapnout."
          }
        }
      },
      "fieldMap": {
        "columns": {
          "field": "Pole",
          "role": "Role",
          "flow": "Tok",
          "story": "Co se děje"
        },
        "summary": {
          "fields": "{{count}} polí",
          "allBothWays": "všechna pole oběma směry",
          "oneWay": "{{count}} jedním směrem",
          "none": "{{count}} nesynchronizováno",
          "warnings": "{{count}} upozornění",
          "errors": "{{count}} chyb"
        },
        "search": "Hledat pole",
        "show": {
          "label": "Zobrazit",
          "all": "Všechna pole",
          "configured": "S nastaveným tokem",
          "keys": "Klíčová pole",
          "rules": "S pravidly",
          "warnings": "S upozorněním"
        },
        "flow": {
          "label": "Tok pole {{field}}",
          "choice": {
            "both": "Oběma směry",
            "in": "Jen do Tappeeru",
            "out": "Jen do {{externalApp}}",
            "none": "Nesynchronizuje se"
          },
          "locked": {
            "keyField": "Klíčové pole přechází vždy — podle něj se záznam pozná.",
            "virtual": "Toto pole existuje jen v {{externalApp}}; na straně Tappeeru není co zadržet.",
            "syncOnly": "Toto pole slouží jen pravidlům při synchronizaci a nikam se neukládá, takže nemá tok, který by šlo nastavit."
          },
          "outWrites": "Tappeer zapisuje {{field}} do {{externalApp}}.",
          "outHeld": "Hodnota {{field}} z Tappeeru se do {{externalApp}} neposílá.",
          "inWrites": "{{externalApp}} zapisuje {{field}} do Tappeeru.",
          "inHeld": "Hodnota {{field}} z {{externalApp}} se do Tappeeru nezapisuje."
        },
        "roles": {
          "businessKey": "Business klíč",
          "keyRuleInput": "Vstup klíče",
          "alternateKey": "Náhradní klíč",
          "hashed": "Hashované",
          "filterable": "Filtrovatelné"
        },
        "roleHints": {
          "businessKey": "Identifikuje záznam na obou stranách. Přechází vždy, ať je tok jakýkoli.",
          "keyRuleInput": "Čte ho pravidlo business klíče. Přechází vždy, ať je tok jakýkoli.",
          "alternateKey": "Slouží k nalezení protějšku při prvním kontaktu, když business klíč nic nenajde.",
          "hashed": "Součást detekce změn: změna tohoto pole znamená změněný záznam.",
          "filterable": "Podle tohoto pole umí Tappeer při odesílání vybírat řádky sám, takže prostý filtr „je“ nad ním je rychlý."
        },
        "type": {
          "nullable": "nepovinné",
          "unknownRow": "Není pole této entity",
          "virtualRow": "Jen v {{externalApp}}",
          "syncOnlyRow": "Jen pro pravidla, neukládá se",
          "unsupportedRule": "Nepodporované pravidlo"
        },
        "warnings": {
          "keyFlowsIn": "{{field}} je vstupem business klíče a zapisuje ho jen {{externalApp}} — přejmenování tam záznam překlíčuje.",
          "toExternalWithoutInverse": "Odchozí pravidlo přepisuje hashované pole {{field}}, které zároveň teče dovnitř, bez příchozího pravidla. Každý oběh by vypadal jako změna.",
          "unknownFlowKey": "{{field}} má nastavený tok, ale entita žádné takové pole nemá. Nastavte ho zpět na Oběma směry."
        },
        "notes": {
          "noDirections": "Zatím není nastaven žádný směr synchronizace. Vyberte jej v Nastavení — do té doby nic neteče."
        },
        "legend": "⇄ oběma směry · ← do Tappeeru · → do {{externalApp}} · ∅ nesynchronizuje se a nepočítá se do detekce změn · podbarvený řádek = engine to odmítne (červená) nebo stojí za pozornost (oranžová)",
        "empty": {
          "noMetadata": "Plugin tuto entitu nepopisuje",
          "noMetadataHint": "Bez seznamu polí není co mapovat. Vyberte v Nastavení jinou entitu, nebo aktualizujte plugin.",
          "noMatch": "Žádné pole neodpovídá",
          "noMatchHint": "Zkuste jiné hledání, nebo zobrazte všechna pole.",
          "clearFilters": "Zrušit filtry"
        },
        "shapes": {
          "copy": {
            "field": "Zkopírovat {{field}}",
            "value": "Vždy {{value}}",
            "meta": "Použít {{name}}"
          },
          "firstNonEmpty": "První vyplněné z {{options}}",
          "lookupTable": "Přeložit {{field}} převodní tabulkou",
          "lookupTableWithFallback": "Přeložit {{field}} převodní tabulkou, jinak {{fallback}}",
          "pluginFunction": "Použít {{name}} na {{field}}",
          "choice": "Rozhodnout podle {{field}}",
          "choiceWithOtherwise": "Rozhodnout podle {{field}}, jinak {{otherwise}}",
          "join": "Spojit {{parts}}",
          "test": "Platí, když {{left}} {{operator}} {{right}}",
          "advanced": "Pokročilé pravidlo",
          "meta": {
            "externalId": "externí id",
            "externalKey": "externí klíč",
            "insioId": "id v Tappeeru",
            "runStartedAt": "čas spuštění synchronizace",
            "direction": "směr synchronizace"
          },
          "value": {
            "empty": "prázdné",
            "yes": "ano",
            "no": "ne"
          },
          "whenSet": "První nastavené z {{options}}, jinak {{otherwise}}",
          "shapeKind": {
            "copy": "Zkopírovat pole nebo hodnotu",
            "choice": "Rozhodnout podle pole",
            "firstNonEmpty": "První vyplněné z několika polí",
            "whenSet": "První nastavené z několika polí",
            "lookupTable": "Přeložit převodní tabulkou",
            "test": "Porovnání ano/ne",
            "join": "Spojit několik hodnot",
            "pluginFunction": "Funkce pluginu",
            "allOf": "Podmínky, které musí platit všechny"
          },
          "allOf": "Vše z: {{tests}}"
        },
        "story": {
          "none": "—",
          "unplaced": "Pravidla bez cíle",
          "toggle": "Kroky: {{field}}",
          "direction": {
            "in": "Do Tappeeru",
            "out": "Do systému {{externalApp}}"
          },
          "edge": {
            "asSent": "tak, jak přijde ze systému {{externalApp}}",
            "notFilled": "ze systému {{externalApp}} se neplní",
            "sentAsIs": "odesílá se beze změny",
            "notSent": "do systému {{externalApp}} se neposílá"
          },
          "reads": {
            "targetRecord": "Čte: záznam ze systému {{externalApp}} tak, jak přišel",
            "canonicalAfterAbove": "Čte: záznam v Tappeeru po provedení kroků výše",
            "canonicalAfterEarlier": "Čte: záznam v Tappeeru po provedení dřívějších kroků",
            "outgoingAfterAbove": "Čte: odchozí záznam po krocích výše"
          },
          "layer": {
            "suffix": "· {{layer}}",
            "cloud": "v Tappeeru",
            "bridge": "provádí plugin pro {{externalApp}} na vašem bridgi",
            "connector": "provádí konektor {{externalApp}}"
          },
          "status": {
            "default": "Výchozí pravidlo pluginu",
            "changed": "Vlastní",
            "added": "Přidáno",
            "removed": "Vypnuto",
            "own": "Váš krok"
          },
          "default": "když je prázdné: {{value}}",
          "subField": "{{target}}: {{summary}}",
          "openStep": {
            "in": "Otevřít příchozí krok ({{field}}): {{summary}}",
            "out": "Otevřít odchozí krok ({{field}}): {{summary}}"
          },
          "openFeed": "Otevřít pravidlo pro {{target}}, které čte pole {{field}}",
          "alsoFeeds": "také plní → {{target}}",
          "alsoDecides": "také rozhoduje o → {{target}}",
          "many": {
            "label": "{{summary}}. Zobrazit kroky: {{field}}.",
            "targetIn_one": "{{count}} pole načtené ze systému {{externalApp}}",
            "targetIn_few": "{{count}} pole načtená ze systému {{externalApp}}",
            "targetIn_other": "{{count}} polí načtených ze systému {{externalApp}}",
            "targetOut_one": "{{count}} pole odesílané do systému {{externalApp}}",
            "targetOut_few": "{{count}} pole odesílaná do systému {{externalApp}}",
            "targetOut_other": "{{count}} polí odesílaných do systému {{externalApp}}",
            "cloud_one": "{{count}} krok v Tappeeru",
            "cloud_few": "{{count}} kroky v Tappeeru",
            "cloud_other": "{{count}} kroků v Tappeeru",
            "alsoFeeds_one": "Na tomto poli závisí také {{count}} pravidlo",
            "alsoFeeds_few": "Na tomto poli závisí také {{count}} pravidla",
            "alsoFeeds_other": "Na tomto poli závisí také {{count}} pravidel",
            "turnedOff_one": "{{count}} výchozí pravidlo pluginu je vypnuté",
            "turnedOff_few": "{{count}} výchozí pravidla pluginu jsou vypnutá",
            "turnedOff_other": "{{count}} výchozích pravidel pluginu je vypnutých"
          },
          "notRun": {
            "in_one": "Tento konektor do Tappeeru nesynchronizuje. {{count}} pravidlo zůstává uložené a nespouští se.",
            "in_few": "Tento konektor do Tappeeru nesynchronizuje. {{count}} pravidla zůstávají uložená a nespouštějí se.",
            "in_other": "Tento konektor do Tappeeru nesynchronizuje. {{count}} pravidel zůstává uložených a nespouští se.",
            "out_one": "Tento konektor do systému {{externalApp}} nesynchronizuje. {{count}} pravidlo zůstává uložené a nespouští se.",
            "out_few": "Tento konektor do systému {{externalApp}} nesynchronizuje. {{count}} pravidla zůstávají uložená a nespouštějí se.",
            "out_other": "Tento konektor do systému {{externalApp}} nesynchronizuje. {{count}} pravidel zůstává uložených a nespouští se."
          },
          "actions": {
            "edit": "Upravit",
            "editFor": "Upravit krok {{target}} ({{field}})",
            "turnOff": "Vypnout",
            "turnOffFor": "Vypnout krok {{target}} ({{field}})",
            "useDefault": "Použít výchozí",
            "useDefaultFor": "Použít výchozí pravidlo pluginu pro {{target}} ({{field}})",
            "remove": "Odebrat",
            "removeFor": "Odebrat krok {{target}} ({{field}})",
            "editDefault": "Upravit ve Výchozích hodnotách",
            "editDefaultFor": "Upravit výchozí hodnotu pole {{field}} ve Výchozích hodnotách",
            "openRule": "Otevřít pravidlo"
          },
          "editor": {
            "label": "Kroky: {{field}}",
            "sideIn": "Kroky do Tappeeru: {{field}}",
            "sideOut": "Kroky do systému {{externalApp}}: {{field}}",
            "step": "{{ordinal}}. {{title}}",
            "kind": {
              "targetIn": "Načíst ze systému {{externalApp}}",
              "targetOut": "Odeslat do systému {{externalApp}}",
              "derivedIn": "Spočítat v Tappeeru",
              "derivedOut": "Upravit před odesláním",
              "default": "Výchozí hodnota pro prázdné pole"
            },
            "destinationFor": "Cíl kroku pole {{field}}",
            "noSteps": "Žádné kroky.",
            "directionOffIn": "Tento konektor do Tappeeru nesynchronizuje. Zde uložená pravidla se nespouštějí.",
            "directionOffOut": "Tento konektor do systému {{externalApp}} nesynchronizuje. Zde uložená pravidla se nespouštějí.",
            "recipeInserted": "Vloženo pro pole {{field}}. Před uložením doplňte prázdné hodnoty — uložený beze změny by tento krok zapsal prázdnou hodnotu.",
            "destination": "Zapisuje do",
            "destinationPlaceholder": "Název pole (může existovat jen v systému {{externalApp}})",
            "destinationTaken": "{{name}} — už se zapisuje",
            "takenIn": "Zašedlé pole už ze systému {{externalApp}} načítá jiný krok — upravte ten.",
            "takenOut": "Do zašedlého pole systému {{externalApp}} už odesílá jiný krok — upravte ten.",
            "issues": {
              "unknownTargetPath": "{{path}} není pole systému {{externalApp}}, které plugin zná."
            },
            "followsPlugin": "Poté ostatní pravidla pro {{externalApp}} v tomto směru přestanou sledovat aktualizace pluginu."
          },
          "ownList": {
            "in": "Pravidla, která čtou ze systému {{externalApp}}, jsou teď váš vlastní seznam ({{kept}} z {{total}} beze změny). Protože bylo některé výchozí pravidlo pluginu upraveno, vypnuto nebo bylo přidáno nové, žádné z nich už nesleduje aktualizace pluginu — ani ta, kterých jste se nedotkli.",
            "out": "Pravidla, která odesílají do systému {{externalApp}}, jsou teď váš vlastní seznam ({{kept}} z {{total}} beze změny). Protože bylo některé výchozí pravidlo pluginu upraveno, vypnuto nebo bylo přidáno nové, žádné z nich už nesleduje aktualizace pluginu — ani ta, kterých jste se nedotkli.",
            "resetIn": "Použít výchozí pravidla pluginu pro všechna příchozí pravidla",
            "resetOut": "Použít výchozí pravidla pluginu pro všechna odchozí pravidla",
            "confirm_one": "Tím zahodíte {{count}} svou změnu v tomto směru, včetně pravidel, která jste přidali.",
            "confirm_few": "Tím zahodíte {{count}} své změny v tomto směru, včetně pravidel, která jste přidali.",
            "confirm_other": "Tím zahodíte {{count}} svých změn v tomto směru, včetně pravidel, která jste přidali.",
            "confirmYes": "Zahodit a použít výchozí pravidla pluginu",
            "confirmNo": "Ponechat můj seznam"
          },
          "add": {
            "trigger": "Přidat krok",
            "triggerFor": "Přidat krok: {{field}}",
            "entryFor": "{{entry}} ({{field}})",
            "targetIn": "Načíst z polí systému {{externalApp}}",
            "derivedIn": "Spočítat z polí Tappeeru",
            "derivedOut": "Upravit hodnotu před odesláním",
            "targetOut": "Odeslat do pole systému {{externalApp}}",
            "reason": {
              "alreadyReadFromTarget": "Toto pole už ze systému {{externalApp}} načítá jeden krok — upravte ten.",
              "directionOffIn": "Tento konektor do Tappeeru nesynchronizuje.",
              "directionOffOut": "Tento konektor do systému {{externalApp}} nesynchronizuje.",
              "noTargetModel": "Tento konektor předává pole Tappeeru přímo; záznam systému {{externalApp}} zde není k dispozici ke čtení ani k zápisu."
            },
            "recipeHint": "Recept přidá hotový krok pro {{field}}. Před uložením doplňte jeho prázdné hodnoty.",
            "recipeHintTargetOut": "Recept, který odesílá do systému {{externalApp}}, zatím nemá cíl; přidá se mezi „Pravidla bez cíle“.",
            "withoutField": "Přidat krok bez pole"
          },
          "unused": {
            "summary_one": "Nepoužito: {{unused}} z {{count}} pole systému {{externalApp}}",
            "summary_few": "Nepoužito: {{unused}} z {{count}} polí systému {{externalApp}}",
            "summary_other": "Nepoužito: {{unused}} z {{count}} polí systému {{externalApp}}",
            "show": "Zobrazit",
            "hide": "Skrýt",
            "toggle": "Nepoužitá pole systému {{externalApp}}"
          },
          "held": {
            "in": "Tyto kroky se dál provádějí; výsledek se do Tappeeru neuloží.",
            "out": "Hodnota z Tappeeru se neodesílá. Výchozí hodnota nebo krok „Upravit hodnotu před odesláním“ u tohoto pole dál odesílá to, co vytvoří; kroky „Odeslat do pole systému {{externalApp}}“ čtou toto pole jako prázdné.",
            "unwatched": "Změna jen v tomto poli se nesleduje."
          }
        }
      },
      "glossary": {
        "entity": {
          "title": "Entita Tappeeru",
          "text": "Čím záznamy v Tappeeru jsou — firmy, střediska, faktury. Jeden pruh na entitu; každý konektor v něm synchronizuje právě ji."
        },
        "connection": {
          "title": "Připojení",
          "text": "Jak Tappeer dosáhne na externí systém: přímo přes internet, nebo bezpečným tunelem k bridge ve vaší síti."
        },
        "connector": {
          "title": "Konektor",
          "text": "Jedna synchronizace jedné entity s jedním externím systémem: její směr, plán a pravidla, která cestou upravují každý záznam."
        },
        "externalSystem": {
          "title": "Externí systém",
          "text": "Druhý systém, odkud záznamy přicházejí nebo kam jdou — účetní program, ERP — se kterým mluví jeho plugin."
        },
        "businessKey": {
          "title": "Business klíč",
          "text": "Hodnota, která říká „tento řádek Tappeeru a tamten externí záznam jsou totéž“ — IČO, kód. Obě strany se na ní musí shodnout."
        },
        "hashedField": {
          "title": "Hashované pole",
          "text": "Pole zahrnuté do detekce změn. Když se změní, záznam se počítá jako změněný a zapíše se; ostatní pole se ignorují."
        },
        "echoSuppression": {
          "title": "Potlačení ozvěny",
          "text": "Když Tappeer zapíše záznam ven, v dalším běhu se tentýž záznam vrátí zpět. Potlačení ozvěny ho pozná jako nezměněný a přeskočí."
        },
        "transform": {
          "title": "Transformace",
          "text": "Pravidla použitá na záznam cestou: business klíč, filtry, kroky polí a výchozí hodnoty."
        },
        "bridge": {
          "title": "Bridge",
          "text": "Malý agent Tappeeru na počítači ve vaší síti. Dosáhne na systémy, kam Tappeer nedosáhne, a vždy jen volá ven."
        },
        "direct": {
          "title": "Přímé připojení",
          "text": "Konektor mluví s druhým systémem přes internet, bez bridge mezi nimi."
        },
        "fieldFlow": {
          "title": "Tok",
          "text": "Kterým směrem pole přechází mezi Tappeerem a druhým systémem: oběma směry, jedním, nebo vůbec. Klíčová pole přecházejí vždy."
        },
        "keyRule": {
          "title": "Pravidlo klíče",
          "text": "Jak se business klíč počítá — seznam polí, nebo výraz. Jeho změna překlíčuje všechny spárované záznamy."
        },
        "alternateKey": {
          "title": "Náhradní klíč",
          "text": "Druhý způsob, jak při prvním kontaktu najít protějšek, když business klíč nic nenajde."
        }
      },
      "overview": {
        "intro": "Každý pruh je jedna entita Tappeeru a konektory, které ji synchronizují: kam data dorazí, jak se k externímu systému připojujeme, který konektor je přenáší a odkud přicházejí. Rozbalením karty zobrazíte podrobnosti.",
        "lanes": {
          "entity": "Entita Tappeeru",
          "connection": "Připojení",
          "connector": "Konektor",
          "system": "Externí systém",
          "entityHint": "Kde záznamy žijí v Tappeeru",
          "connectionHint": "Jak se k systému připojujeme",
          "connectorHint": "Co záznamy přenáší a upravuje",
          "systemHint": "Odkud přicházejí, nebo kam jdou"
        },
        "card": {
          "expand": "Zobrazit podrobnosti",
          "collapse": "Skrýt podrobnosti"
        },
        "addConnector": "Přidat konektor",
        "addSystem": "Přidat systém",
        "actionsLabel": "Akce integrací",
        "openHelpGuide": "Nápověda",
        "connectorCount_one": "{{count}} konektor",
        "connectorCount_few": "{{count}} konektory",
        "connectorCount_other": "{{count}} konektorů",
        "noConnector": "Zatím žádný konektor",
        "addForEntity": "Přidat konektor pro {{entity}}",
        "stages": {
          "system": {
            "plugin": "Plugin v{{version}}"
          },
          "transport": {
            "cloud": "Cloud",
            "direct": "Přímé připojení",
            "tunnel": "Bezpečný tunel",
            "openBridge": "Otevřít bridge {{name}}",
            "directHint": "Tappeer se k {{externalApp}} připojuje přes internet.",
            "missing": "Není vybrán bridge",
            "missingHint": "Před zapnutím konektoru vyberte instalaci v Nastavení.",
            "missingOpen": "Otevřít konektor {{name}}",
            "connectionMissing": "Není vybrána instalace",
            "connectionMissingHint": "Před zapnutím konektoru vyberte v Nastavení instalaci, ze které čte.",
            "openConnection": "Otevřít instalaci {{name}}",
            "unknownHost": "Počítač zatím nenahlášen",
            "agentVersion": "Agent v{{version}}",
            "pluginVersion": "Plugin {{externalApp}} v{{version}}",
            "pluginMissing": "Plugin {{externalApp}} na tomto bridge není nainstalován",
            "lastSeen": "Naposledy viděn {{when}}",
            "officeBridge": "Bridge kanceláře",
            "queue": {
              "title": "Fronta na bridgi",
              "running": "Běží: {{run}}",
              "waiting": "{{position}}. v pořadí: {{run}}, čeká {{duration}}"
            }
          },
          "connector": {
            "open": "Otevřít konektor {{name}}",
            "rules": {
              "open": "Otevřít pravidla konektoru {{name}}",
              "pluginDefault": "výchozí pravidla pluginu",
              "custom": "upraveno",
              "keyDefault": "Výchozí klíč",
              "keyFields": "Klíč z polí",
              "keyExpression": "Klíč výrazem",
              "filters_one": "{{count}} filtr",
              "filters_few": "{{count}} filtry",
              "filters_other": "{{count}} filtrů",
              "derived_one": "{{count}} odvozené pole",
              "derived_few": "{{count}} odvozená pole",
              "derived_other": "{{count}} odvozených polí",
              "defaults_one": "{{count}} výchozí hodnota",
              "defaults_few": "{{count}} výchozí hodnoty",
              "defaults_other": "{{count}} výchozích hodnot"
            },
            "disabledHint": "Vypnuto — nic se nesynchronizuje, dokud konektor nezapnete."
          }
        },
        "health": {
          "when": "{{when}}",
          "failedCount_one": "{{count}} záznam selhal",
          "failedCount_few": "{{count}} záznamy selhaly",
          "failedCount_other": "{{count}} záznamů selhalo"
        },
        "flow": {
          "summary": "Tok: {{oneWay}} jedním směrem · {{none}} nesynchronizováno",
          "default": "Tok: všechna pole oběma směry"
        },
        "empty": {
          "title": "Žádné synchronizační pluginy",
          "description": "Platforma nemá pro tento účet nainstalovaný žádný synchronizační plugin, takže zatím není co připojit."
        },
        "direction": {
          "in": "Příchozí: {{externalApp}} → Tappeer",
          "out": "Odchozí: Tappeer → {{externalApp}}",
          "both": "Oba směry: {{externalApp}} ⇄ Tappeer",
          "none": "Směr není nastaven",
          "legend": "Šipky",
          "legendIn": "příchozí",
          "legendOut": "odchozí",
          "legendBoth": "oba směry"
        }
      },
      "monitor": {
        "filters": {
          "connector": "Konektor",
          "status": "Výsledek",
          "entity": "Entita",
          "allConnectors": "Všechny konektory",
          "allStatuses": "Všechny výsledky",
          "allEntities": "Všechny entity"
        }
      },
      "connections": {
        "title": "Instalace",
        "intro": "Instalace, ze kterých čtou vaše konektory. Každý konektor, který z některé čte, sdílí tato nastavení, takže adresu nebo heslo zadáte jen jednou.",
        "none": "Zatím není nastavena žádná instalace.",
        "noPlugins": "Zatím žádný konektor nepotřebuje sdílená nastavení.",
        "edit": "Upravit",
        "delete": "Odebrat",
        "migrate": "Migrovat",
        "usedBy_one": "Čte z ní {{count}} konektor",
        "usedBy_few": "Čtou z ní {{count}} konektory",
        "usedBy_other": "Čte z ní {{count}} konektorů",
        "unused": "Zatím z ní nečte žádný konektor",
        "outdated": "Nastavení jsou pozadu za aktuální verzí pluginu",
        "needsReview": "Nastavení po poslední migraci vyžadují kontrolu",
        "deleteModal": {
          "title": "Odebrat {{name}}?",
          "description": "Uložené přihlašovací údaje se smažou spolu s ní. Konektory, které z ní čtou, je nutné nejdřív přesměrovat.",
          "confirm": "Odebrat"
        },
        "toast": {
          "saved": "Instalace uložena",
          "deleted": "Instalace odebrána",
          "migrated": "Nastavení migrována"
        },
        "errors": {
          "nameRequired": "Název je povinný",
          "saveFailed": "Instalaci se nepodařilo uložit",
          "bridgeRequired": "Bridge je povinný",
          "loadFailed": "Instalace se nepodařilo načíst"
        },
        "addFor": "Přidat instalaci {{externalApp}}",
        "groups": {
          "required": "Povinné",
          "requiredHint": "Bez těchto hodnot nic nefunguje.",
          "optional": "Volitelné",
          "optionalHint": "Stojí za pohled; plugin se obejde i bez nich.",
          "advanced": "Rozšířené",
          "advancedHint": "Limity a časové prodlevy, které plugin zvolil dobře už sám. Měňte je jen z důvodu.",
          "toFix_one": "{{count}} k opravě",
          "toFix_few": "{{count}} k opravě",
          "toFix_other": "{{count}} k opravě"
        },
        "configGroups": {
          "installation": "Instalace",
          "login": "Přihlášení",
          "company": "Účetní jednotka",
          "database": "Databáze",
          "locale": "Regionální nastavení",
          "documentTypes": "Typy dokladů",
          "payment": "Formy úhrady",
          "vatCodes": "Kódy DPH",
          "advanced": "Rozšířené"
        },
        "introBridge": "Instalace, na které tento bridge dosáhne. Každý konektor, který z některé čte, sdílí tato nastavení, takže cestu nebo heslo zadáte jen jednou.",
        "noneBridge": "Na tomto bridgi zatím není nastavena žádná instalace.",
        "noPluginsBridge": "Tento bridge nemá načtený plugin, který by potřeboval nastavení.",
        "direct": "Dosažitelné přímo",
        "openBridge": "Otevřít bridge {{name}}",
        "needsBridge": "Potřebuje aktivní bridge s nainstalovaným pluginem {{externalApp}}.",
        "select": {
          "label": "Instalace",
          "placeholder": "Vyberte instalaci",
          "hint": "Instalace, ze které konektor čte. Adresa, firma a přihlašovací údaje se nastavují na ní.",
          "online": "{{name}} na {{bridge}} (online)",
          "offline": "{{name}} na {{bridge}} (offline)",
          "unavailable": "Již není dostupné",
          "none": "Pro tento konektor zatím není nastavena žádná instalace.",
          "noneLink": "Přidejte ji na stránce Instalace.",
          "create": "Nová instalace",
          "setupWizard": "Nebo otevřete průvodce nastavením {{system}}.",
          "taken": "{{name}} — už ji používá konektor „{{connector}}“",
          "takenError": "Už ji používá konektor „{{connector}}“.",
          "takenErrorUnnamed": "Už ji používá jiný konektor pro tuto entitu.",
          "allTaken": "Každá instalace už má konektor pro tuto entitu:",
          "allTakenLink": "Další instalaci přidejte na stránce Instalace."
        },
        "editor": {
          "title": "Instalace",
          "createTitle": "Přidat instalaci {{externalApp}}",
          "editTitle": "Upravit {{name}}",
          "back": "Zpět",
          "loadError": "Instalaci se nepodařilo načíst",
          "fixErrors": "Před uložením instalace je potřeba opravit některé hodnoty.",
          "form": {
            "description": "Co bridge potřebuje, aby dosáhl na tuto instalaci {{externalApp}}. Každý konektor, který z ní čte, sdílí tato nastavení.",
            "descriptionDirect": "Co Tappeer potřebuje, aby přes internet dosáhl na tuto instalaci {{externalApp}}. Každý konektor, který z ní čte, sdílí tato nastavení.",
            "nameLabel": "Název",
            "namePlaceholder": "např. agenda nebo firma, kterou otevírá",
            "nameHint": "Podle čeho ji poznáte, až ji budete vybírat u konektoru.",
            "bridgeLabel": "Bridge",
            "bridgeHint": "Bridge, který na tuto instalaci dosáhne. Později ho už nelze změnit.",
            "bridgeLockedHint": "Nastaven při přidání instalace; změnit ho už nelze.",
            "bridgePlaceholder": "Vyberte bridge",
            "empty": "Tento plugin nepotřebuje sdílená nastavení.",
            "officeBridgeOption": "{{name}} (bridge kanceláře)"
          },
          "saveBar": {
            "label": "Neuložené změny",
            "unsaved": "Instalace má neuložené změny",
            "discard": "Zahodit",
            "save": "Uložit změny",
            "saving": "Ukládám…"
          },
          "inlineSave": {
            "save": "Uložit a pokračovat",
            "saving": "Ukládám…"
          },
          "leave": {
            "title": "Neuložené změny",
            "message": "Instalace má neuložené změny. Pokud odejdete, budou ztraceny.",
            "confirm": "Odejít bez uložení"
          },
          "discovery": {
            "reload": "Načíst znovu",
            "reloading": "Načítám…",
            "reloaded": "Hodnoty byly načteny.",
            "directTitle": "Nalezeno v systému {{externalApp}}",
            "directIntro": "Hodnoty, které {{externalApp}} nabízí pro zadanou adresu a přihlášení. Načítají se jen na vyžádání.",
            "nothingFound": "Pro zadané hodnoty se nic nenašlo.",
            "snapshot": "Bridge používá starší verzi agenta, která neumí načíst hodnoty znovu. Toto jsou hodnoty, které nahlásil při svém spuštění.",
            "storedSecretNotUsed": "Se změněným nastavením se uložené přihlašovací údaje nepoužijí. Pro načtení je zadejte znovu.",
            "removedSecretStillUsed": "Uložená hodnota označená k odstranění se při načtení ještě použije, dokud instalaci neuložíte.",
            "errors": {
              "failed": "Živé ověření se nezdařilo. Zkontrolujte adresu a přihlašovací údaje.",
              "busy": "Právě probíhá jiné načítání. Zkuste to za chvíli.",
              "rateLimited": "Příliš mnoho načtení za krátkou dobu. Zkuste to později.",
              "rateLimitedIn_one": "Příliš mnoho načtení za krátkou dobu. Zkuste to znovu za {{count}} minutu.",
              "rateLimitedIn_few": "Příliš mnoho načtení za krátkou dobu. Zkuste to znovu za {{count}} minuty.",
              "rateLimitedIn_other": "Příliš mnoho načtení za krátkou dobu. Zkuste to znovu za {{count}} minut.",
              "invalid": "Zadané hodnoty nejsou platné. Opravte je a zkuste to znovu.",
              "generic": "Hodnoty se nepodařilo načíst. Zkuste to znovu.",
              "managedByMasterAccount": "Hodnoty z bridgu kanceláře načítá jen vaše účetní kancelář."
            }
          },
          "mapper": {
            "columns": {
              "tappeer": "V Tappeeru",
              "code": "Kód v systému {{externalApp}}",
              "default": "Výchozí"
            },
            "useDefault": "Použít výchozí",
            "notSet": "Nenastaveno",
            "default": {
              "automatic": "Automaticky: {{value}}",
              "none": "—"
            },
            "status": {
              "none": "Kódy ze systému {{externalApp}} zatím nejsou načtené. Načtěte je, nebo je zadejte ručně.",
              "failed": "Kódy ze systému {{externalApp}} se nepodařilo načíst. Zadejte je ručně, nebo to zkuste znovu.",
              "stale": "Údaje pro připojení se od načtení kódů změnily. Načtěte je znovu.",
              "snapshot": "Kódy nejsou načtené živě ze systému {{externalApp}}. Jsou to ty, které bridge nahlásil při svém spuštění.",
              "empty": "Ze systému {{externalApp}} nepřišly žádné kódy. Zkontrolujte údaje pro připojení, třeba vybranou firmu, a načtěte je znovu.",
              "noneManual": "Kódy ze systému {{externalApp}} nejsou načtené. Zadejte je ručně.",
              "failedManual": "Kódy ze systému {{externalApp}} se nepodařilo načíst. Zadejte je ručně.",
              "staleManual": "Údaje pro připojení se od načtení kódů změnily. Nabízené kódy nemusí platit.",
              "emptyManual": "Ze systému {{externalApp}} nepřišly žádné kódy. Zadejte je ručně.",
              "pickBridge": "Kódy ze systému {{externalApp}} se načítají přes bridge. Nejdřív ho vyberte."
            },
            "load": "Načíst kódy ze systému {{externalApp}}",
            "loading": "Načítám…",
            "row": {
              "none": "Seznam zatím není načtený.",
              "failed": "Seznam se nepodařilo načíst.",
              "noList": "Pro tento řádek {{externalApp}} žádné kódy nenabízí.",
              "unavailable": "Seznam pro tento řádek se nenačetl. Zadejte kód.",
              "missing": "V systému {{externalApp}} kód {{code}} není. Vyberte jiný.",
              "type": "Zadat kód ručně",
              "pick": "Vybrat ze seznamu",
              "required": "Povinné."
            }
          },
          "help": {
            "sharedIco": {
              "title": "Více agend se stejným IČO",
              "why": "Money S3 vybírá agendu podle IČO. Když stejné IČO najde u více agend, skončí a nic nepřenese – například u demo agend, které mají všechny stejné IČO.",
              "whatToSet": "Vyplňte „Přípona složky agendy“: část názvu datové složky agendy za „Agenda.“ (u složky „Agenda.spa“ je to „spa“). Agenda se pak vybere podle složky, ne podle IČO. „IČO agendy“ nechte vyplněné – každý export se s ním dál porovnává. Má-li agenda více účetních roků, vyplňte i „Účetní rok“; prázdný znamená rok, který Money S3 použilo naposledy.",
              "agendaCode": "„Kód agendy“ agendu nevybírá. Je to další pojistka: je-li vyplněn a otevřená agenda má jiný kód, přenos se odmítne.",
              "pickFromList": "Nejsnazší je vybrat agendu ze seznamu „Účetní jednotka“ v části „Nalezeno na bridgi“ — výběr tato nastavení vyplní. Seznam ukazuje jen složku a rok, protože název a IČO agendy se z disku nečtou; IČO pak zadejte ručně."
            }
          },
          "readOnly": {
            "title": "Instalaci spravuje vaše účetní kancelář",
            "body": "Běží na bridgi kanceláře, a tak její nastavení může měnit jen kancelář. Vaše konektory z ní číst mohou."
          },
          "agendaDuplicate": {
            "title": "Stejnou agendu otevírá i jiná instalace",
            "body": "Jiná instalace tohoto účtu na stejném bridgi otevírá stejnou agendu (například stejné IČO), takže by obě zapisovaly do jedné agendy a mohly by vznikat duplicitní nebo kolidující záznamy. Pokud to není záměr, upravte u jedné z nich nastavení agendy, nebo ji smažte.",
            "bodyReadOnly": "Jiná instalace tohoto účtu na stejném bridgi otevírá stejnou agendu (například stejné IČO), takže by obě zapisovaly do jedné agendy a mohly by vznikat duplicitní nebo kolidující záznamy. Pokud to není záměr, požádejte účetní kancelář, aby jednu z nich upravila."
          },
          "bridgeUnavailable": {
            "title": "Bridge už není k dispozici",
            "body": "Tento účet už bridge této instalace nemůže používat. Instalaci můžete smazat v seznamu cílových systémů, nebo se obraťte na účetní kancelář."
          }
        },
        "view": "Zobrazit",
        "officeBridge": "Bridge kanceláře",
        "officeBridgeManaged": "Instalace na bridgi kanceláře nastavuje vaše účetní kancelář.",
        "bridgeUnavailable": "Bridge není k dispozici",
        "setupWizard": "Otevřít průvodce nastavením"
      },
      "welcome": {
        "title": "Propojte Tappeer s účetnictvím",
        "incomplete": {
          "title": "Část údajů se nepodařilo načíst",
          "description": "Pokud máte nastavení rozpracované, tlačítko „Pokračovat v nastavení“ se teď nemusí zobrazit. Zkuste stránku za chvíli načíst znovu."
        },
        "intro": "Tappeer drží firmy ve shodě s vaším účetním systémem a faktury do něj pošle sám. Pak si načte, jestli jsou zaúčtované a proplacené.",
        "continue": {
          "title": "Nastavení máte rozpracované",
          "description": "Navážeme tam, kde jste skončili.",
          "action": "Pokračovat v nastavení"
        },
        "systems": {
          "title": "Vyberte účetní systém",
          "setUp": "Nastavit"
        },
        "manual": {
          "description": "Používáte jiný systém? Konektor můžete přidat i ručně.",
          "action": "Přidat konektor ručně"
        }
      },
      "systems": {
        "moneyS3": {
          "name": "Money S3",
          "description": "Účetní systém Money S3 od společnosti Solitea. Připojuje se přes Tappeer Bridge na počítači, kde běží Money S3.",
          "requirements": "Počítač s Windows, kde běží Money S3, a nainstalovaný Tappeer Bridge (u síťové instalace na serveru s daty Money S3, nebo na terminálovém serveru), případně bridge vaší účetní kanceláře.",
          "syncs": "Firmy oběma směry, faktury do Money S3.",
          "readBack": "Stav zaúčtování, úhrada a číslo dokladu."
        },
        "abraFlexi": {
          "name": "ABRA Flexi",
          "description": "Cloudový účetní systém ABRA Flexi. Připojuje se přímo přes jeho API.",
          "requirements": "Adresa serveru ABRA Flexi, databáze firmy a uživatel s přístupem k API.",
          "syncs": "Firmy oběma směry, faktury do ABRA Flexi.",
          "readBack": "Stav zaúčtování, úhrada a interní číslo dokladu."
        }
      },
      "setup": {
        "title": "Nastavení integrace",
        "back": "Zpět na integrace",
        "intro": "Připojte Tappeer k účetnímu systému. Firmy půjdou oběma směry, faktury do účetnictví a jejich stav zpět.",
        "loadError": "Průvodce se nepodařilo načíst. Načtěte stránku znovu.",
        "continue": "Pokračovat",
        "steps": {
          "system": "Systém",
          "bridge": "Bridge",
          "connection": "Instalace",
          "readiness": "Připravenost",
          "codelists": "Číselníky",
          "entities": "Firmy a faktury",
          "firstSync": "První synchronizace"
        },
        "system": {
          "intro": "Vyberte účetní systém, který chcete připojit.",
          "none": "Pro tento účet není k dispozici žádný podporovaný účetní systém.",
          "notAvailable": "Systém „{{plugin}}“ není k dispozici. Vyberte některý ze systémů níže."
        },
        "systemCard": {
          "requirements": "Co potřebujete",
          "syncs": "Co se synchronizuje",
          "readBack": "Co se načítá zpět",
          "choose": "Vybrat",
          "chosen": "Vybráno"
        },
        "bridge": {
          "intro": "Tappeer se k {{system}} dostane přes Tappeer Bridge – malého agenta na počítači ve vaší síti, který na {{system}} dosáhne.",
          "usableTitle": "Bridge, které můžete použít",
          "use": "Použít tento bridge",
          "chosen": "Vybráno",
          "office": "Účetní kancelář",
          "installationsTitle": "Existující instalace",
          "installationsHint": "Instalaci {{system}} už máte a má svůj bridge. Pokračujte s ní.",
          "useInstallation": "Pokračovat s touto instalací",
          "register": "Zaregistrovat nový bridge",
          "registerTitle": "Nový bridge",
          "cancelRegister": "Zrušit",
          "paired": "Bridge „{{name}}“ je spárovaný.",
          "blockers": {
            "noBridge": {
              "title": "Zatím nemáte žádný bridge",
              "body": "Zaregistrujte bridge a nainstalujte ho na počítač, kde běží {{system}}."
            },
            "pending": {
              "title": "Bridge „{{name}}“ čeká na spárování",
              "body": "Vystavte nový párovací kód a dokončete instalaci agenta.",
              "bodyOffice": "Spárování musí dokončit vaše účetní kancelář.",
              "action": "Spárovat bridge"
            },
            "offline": {
              "title": "Bridge „{{name}}“ je offline",
              "body": "Ověřte, že je počítač s bridgem zapnutý a připojený k internetu. Stránka se obnovuje sama.",
              "help": "Jak bridge znovu připojit"
            },
            "pluginNotReported": {
              "title": "Bridge „{{name}}“ nehlásí {{system}}",
              "body": "Bridge musí hlásit {{system}} s firmami a fakturami. Ověřte, že na počítači s bridgem běží {{system}} a že má agent aktuální verzi."
            },
            "officeInstallation": {
              "title": "Instalaci zakládá vaše účetní kancelář",
              "body": "Bridge vaší účetní kanceláře ({{names}}) se používá přes instalaci, kterou kancelář pro váš účet založí. Požádejte kancelář o její založení, nebo si zaregistrujte vlastní bridge."
            }
          }
        },
        "connection": {
          "intro": "Instalace určuje, se kterou agendou nebo databází {{system}} Tappeer pracuje. Čtou z ní všechny konektory tohoto nastavení.",
          "pickHint": "Máte více instalací {{system}}. Vyberte tu, kterou chcete nastavit.",
          "pick": "Vybrat",
          "current": "Vybráno",
          "notFound": {
            "title": "Instalace nebyla nalezena",
            "body": "Mohla být smazána. Vyberte jinou.",
            "action": "Vybrat jinou instalaci"
          },
          "bridgeGone": {
            "title": "Instalace přišla o svůj bridge",
            "body": "{{names}} používá bridge, který už není k dispozici. Založte místo ní novou instalaci."
          }
        },
        "readiness": {
          "intro": "Před první synchronizací Tappeer ověří, že přes tuto instalaci může synchronizace proběhnout.",
          "provenByRun": "Konektor této instalace už jednou úspěšně synchronizoval.",
          "continueAnyway": "Přesto pokračovat",
          "confirm": {
            "title": "Pokračovat bez úspěšného ověření?",
            "message": "Ověření připravenosti neprošlo. Dokud se problém neodstraní, může první synchronizace selhat.",
            "confirm": "Přesto pokračovat",
            "cancel": "Zpět k ověření"
          },
          "continueBlocked": "Pokračovat můžete, až ověření připravenosti projde."
        },
        "codelists": {
          "intro": "Ke každé hodnotě Tappeeru vyberte kód ze systému {{system}}. Prázdný řádek použije výchozí hodnotu.",
          "backToReadiness": "Zpět na připravenost"
        },
        "entities": {
          "intro": "Na instalaci „{{connection}}“ budou dva konektory: jeden pro firmy, druhý pro faktury. Nové se založí vypnuté, zapne je až první synchronizace.",
          "party": "Firmy",
          "invoice": "Faktury",
          "names": {
            "party": "{{system}} – Firmy",
            "invoice": "{{system}} – Faktury"
          },
          "badges": {
            "new": "Nový",
            "existing": "Existující",
            "created": "Založený"
          },
          "reused": "Použije se konektor „{{name}}“, který už na této instalaci máte.",
          "createdAs": "Založen jako „{{name}}“.",
          "openConnector": "Otevřít konektor",
          "plan": {
            "inFull": "Z {{system}} do Tappeeru.",
            "readBack": "Z {{system}} se zpět načítá stav faktur.",
            "noReadBack": "{{system}} stav faktur zpět neposílá, faktury jen odcházejí.",
            "outOnChange": "Z Tappeeru do {{system}}, hned po každé změně.",
            "outScheduled": "Z Tappeeru do {{system}}, podle plánu.",
            "schedule": "{{mode}} {{cadence}}.",
            "modes": {
              "full": "Úplná synchronizace",
              "modifiedSince": "Jen změny",
              "readBack": "Zpětné načtení"
            },
            "cadence": {
              "daily": "každý den v {{time}} ({{timezone}})",
              "hourly": "každou hodinu",
              "every6h": "každých 6 hodin",
              "other": "podle vlastního plánu"
            }
          },
          "create": "Založit konektory",
          "createFailed": "Konektor se nepodařilo založit",
          "duplicates": {
            "party": "Na této instalaci je víc konektorů pro firmy",
            "invoice": "Na této instalaci je víc konektorů pro faktury",
            "body": "Průvodce neví, který z nich použít. Nechte jen jeden a ostatní smažte."
          },
          "needsMigration": {
            "title": "Konektor „{{name}}“ potřebuje aktualizovat nastavení",
            "body": "Dokud nastavení neaktualizujete, žádná synchronizace nepoběží.",
            "action": "Otevřít nastavení konektoru"
          },
          "notOutbound": {
            "title": "Konektor „{{name}}“ do {{system}} nic neposílá",
            "body": "První synchronizace potřebuje, aby konektor posílal z Tappeeru do {{system}}.",
            "action": "Zapnout odesílání",
            "confirm": {
              "title": "Zapnout odesílání?",
              "message": "Konektor „{{name}}“ začne posílat změny z Tappeeru do {{system}}. Co z {{system}} načítá, zůstane beze změny.",
              "confirm": "Zapnout odesílání",
              "cancel": "Zrušit"
            },
            "failed": "Odesílání se nepodařilo zapnout"
          }
        },
        "firstSync": {
          "intro": "Tappeer teď poprvé synchronizuje: nejdřív firmy, potom faktury. Může to chvíli trvat. Stránku můžete zavřít a vrátit se později.",
          "enableNote": "Před spuštěním průvodce konektory zapne.",
          "rows": {
            "partyIn": "Firmy z {{system}} do Tappeeru",
            "partyOut": "Firmy z Tappeeru do {{system}}",
            "partyReadBack": "Firmy zpět z {{system}}",
            "invoiceIn": "Faktury z {{system}} do Tappeeru",
            "invoiceOut": "Faktury z Tappeeru do {{system}}",
            "invoiceReadBack": "Stav faktur zpět z {{system}}"
          },
          "pending": "Čeká",
          "waitingForReadBack": "Čeká na zpětné načtení",
          "readBackInMonitor": "Výsledek zpětného načtení uvidíte v monitoru.",
          "openMonitor": "Monitor",
          "pendingMatches_one": "{{count}} firma čeká na spárování",
          "pendingMatches_few": "{{count}} firmy čekají na spárování",
          "pendingMatches_other": "{{count}} firem čeká na spárování",
          "runFailed": "Průběh skončil chybou.",
          "nothingSent": {
            "approved": "Zatím neodešla žádná faktura. To je v pořádku: {{system}} dostává jen schválené faktury.",
            "all": "Zatím neodešla žádná faktura. Tento účet ještě žádnou nemá."
          },
          "expectations": {
            "approved": "Do {{system}} odejdou jen schválené faktury. Když zatím žádná schválená není, neodejde nic a i to je v pořádku.",
            "all": "Do {{system}} odejdou všechny faktury tohoto účtu.",
            "invoices": "Zobrazit faktury",
            "readBack": "První zpětné načtení hned po odeslání obvykle nic nezmění. Stav faktur přinese až pravidelné načítání."
          },
          "start": "Spustit první synchronizaci",
          "resume": "Pokračovat v synchronizaci",
          "running": "Synchronizace běží. Průběh se tu ukazuje sám.",
          "waitingForRuns": "Synchronizace je spuštěná, čeká se na její další průběh.",
          "openAccountMonitor": "Otevřít monitor",
          "syncing": "Synchronizuje se…",
          "retry": "Zkusit znovu",
          "failed": {
            "party": "Synchronizace firem skončila chybou",
            "invoice": "Synchronizace faktur skončila chybou"
          },
          "refused": {
            "party": "Synchronizaci firem se nepodařilo spustit",
            "invoice": "Synchronizaci faktur se nepodařilo spustit"
          },
          "enableFailed": "Konektor „{{name}}“ se nepodařilo zapnout",
          "openSettings": "Otevřít nastavení konektoru",
          "done": {
            "title": "Hotovo. První synchronizace proběhla.",
            "body": "Firmy i faktury se od teď synchronizují samy podle plánu.",
            "transform": "Pravidla",
            "finish": "Hotovo"
          },
          "noAnswer": "Na spuštění nepřišla odpověď a žádný průběh se neobjevil."
        }
      }
    },
    "documents": {
      "title": "Vytěžování",
      "subtitle": "Správa a organizace vašich dokumentů",
      "searchPlaceholder": "Hledat dodavatele, číslo dokladu…",
      "empty": "Žádné dokumenty k zobrazení",
      "card": {
        "created": "Vytvořeno",
        "extractionQuality": "Kvalita vytěžení",
        "viewDocument": "Zobrazit dokument {{filename}}",
        "unknownType": "Neznámý typ dokumentu",
        "uploadedBy": "Nahrál",
        "completedNew": "Dokončeno · nové",
        "processingProgress": "Louskám… {{progress}} %",
        "takingLonger": "Trvá déle než obvykle"
      },
      "overLimit": {
        "badge": "Nad rámec tarifu, doúčtuje se"
      },
      "banner": {
        "processing": "Probíhá vytěžování...",
        "fileCount_one": "{{count}} soubor",
        "fileCount_few": "{{count}} soubory",
        "fileCount_other": "{{count}} souborů"
      },
      "error": {
        "loadFailed": "Chyba při načítání dokumentů"
      },
      "filters": {
        "allDocuments": "Všechny dokumenty",
        "pendingReview": "Ke kontrole",
        "sectionAllDocuments": "Všechny dokumenty",
        "sectionPendingReview": "Dokumenty ke kontrole",
        "all": "Vše"
      },
      "view": {
        "card": "Karty",
        "table": "Tabulka"
      },
      "sort": {
        "date": "Datum",
        "filename": "Název souboru",
        "type": "Typ",
        "status": "Stav"
      },
      "table": {
        "filename": "Název souboru",
        "type": "Typ",
        "status": "Stav",
        "size": "Velikost",
        "created": "Vytvořeno",
        "headers": {
          "id": "ID",
          "name": "Jméno",
          "type": "Typ",
          "size": "Velikost",
          "uploadedBy": "Nahrál",
          "date": "Datum",
          "actions": "Akce"
        }
      },
      "widgets": {
        "totalDocuments": "Celkem Dokumentů",
        "pdfs": "PDF soubory",
        "spreadsheets": "Tabulky",
        "documents": "Dokumenty"
      },
      "actions": {
        "uploadDocument": "Nahrát Dokument"
      },
      "upload": {
        "button": "Nahrát dokument",
        "title": "Nahrát Dokument",
        "selectFile": "Vybrat Soubor",
        "selectedFile": "Vybraný soubor",
        "dragDrop": "Přetáhněte soubor sem",
        "clickToSelect": "nebo klikněte pro výběr",
        "takePhoto": "Vyfotit",
        "takeAnotherPhoto": "Vyfotit další",
        "chooseFromGallery": "Vybrat z galerie",
        "chooseFile": "Vybrat soubor",
        "tooManyFiles_one": "Najednou lze vybrat jen {{count}} soubor",
        "tooManyFiles_few": "Najednou lze vybrat nejvýše {{count}} soubory",
        "tooManyFiles_other": "Najednou lze vybrat nejvýše {{count}} souborů",
        "documentType": "Typ Dokumentu",
        "autoDetect": "Automatická detekce",
        "autoDetectHint": "Systém automaticky detekuje typ dokumentu",
        "cancel": "Zrušit",
        "clearFiles": "Vymazat soubory",
        "upload": "Nahrát",
        "uploading": "Nahrávám...",
        "converting": "Převádím...",
        "success": "Dokument byl úspěšně nahrán",
        "duplicate": "Tento dokument již existuje.",
        "duplicateReason": "Duplicitní dokument – stejný soubor byl již nahrán {{date}}",
        "duplicatesSkippedHint": "Duplicitní soubory budou přeskočeny a nebudou nahrány znovu.",
        "allDuplicates": "Všechny vybrané soubory již byly nahrány dříve. Nahrávání nebude spuštěno.",
        "processingFailed": "Dokument byl nahrán, ale nepodařilo se ho zpracovat.",
        "conversionFailed": "Dokument se nepodařilo převést do čitelné podoby.",
        "conversionUnavailable": "Služba pro převod je nedostupná — soubor byl uložen, zkuste to prosím později.",
        "busy": "Právě se nahrává příliš mnoho souborů. Zkuste to prosím znovu za chvíli.",
        "tooSlow": "Připojení je pro tento soubor příliš pomalé. Zkuste to prosím znovu na rychlejším připojení.",
        "error": "Nepodařilo se nahrát dokument",
        "fileTooLarge": "Soubor překračuje limit 100 MB",
        "invalidFileType": "Nepodporovaný typ souboru. Povoleno: PDF, PNG, JPEG, WebP, HEIC, HEIF, ISDOC (i jako XML), DOC, DOCX",
        "isdocInvalid": "Soubor není platný ISDOC doklad.",
        "limitReached": "Byl dosažen měsíční limit extrakce dokumentů. Pro pokračování upgradujte svůj plán.",
        "selectFiles": "Vybrat soubory",
        "filesToUpload": "Soubory k nahrání ({{count}})",
        "removeFile": "Odebrat",
        "uploadAll": "Nahrát vše ({{count}})",
        "dropFilesHere": "Přetáhněte soubory kamkoliv pro nahrání",
        "dropToAdd": "Pusťte pro přidání souborů",
        "pasteHint": "Soubory lze také vložit (Ctrl+V / ⌘V)"
      },
      "emailSetup": {
        "button": "Nastavit email",
        "modal": {
          "title": "Importujte dokumenty emailem",
          "formTitle": "Nastavení emailové schránky",
          "description": "Získejte vlastní emailovou adresu, na kterou stačí přeposlat faktury a účtenky. Dokumenty se automaticky nahrají a zpracují — bez ručního nahrávání.",
          "benefits": {
            "forward": "Přeposílejte faktury přímo z vaší emailové schránky",
            "auto": "Dokumenty se nahrají a zpracují automaticky",
            "share": "Adresu můžete sdílet s dodavateli i kolegy"
          },
          "locationHint": "Nastavení emailu kdykoliv najdete v Nastavení systému → Emailová schránka.",
          "setupCta": "Nastavit email",
          "later": "Nastavím později",
          "successTitle": "Schránka je připravená",
          "createdLabel": "Vaše adresa pro import dokladů",
          "copy": "Kopírovat",
          "usageHint": "Přeposílejte faktury a účtenky na tuto adresu — automaticky se nahrají a zpracují.",
          "editHint": "Schránku můžete kdykoliv upravit v",
          "editLink": "Nastavení systému → Emailová schránka",
          "done": "Hotovo"
        }
      },
      "detail": {
        "loading": "Načítání dokumentu...",
        "retry": "Zkusit znovu",
        "notFound": {
          "title": "Dokument nenalezen",
          "message": "Dokument, který hledáte, neexistuje nebo byl smazán."
        },
        "error": {
          "title": "Nepodařilo se načíst dokument"
        },
        "actions": {
          "back": "Zpět na seznam",
          "download": "Stáhnout",
          "reprocess": "Zpracovat znovu",
          "reprocessing": "Zpracovává se...",
          "convertToDocument": "Převést na doklad",
          "delete": "Smazat",
          "approveAll": "Schválit vše",
          "moreActions": "Další akce",
          "comingSoon": "Již brzy",
          "openInvoice": "Otevřít fakturu"
        },
        "unknownDocument": "Neznámý dokument",
        "reprocessError": "Nepodařilo se spustit zpracování znovu. Zkuste to prosím později.",
        "reprocessModal": {
          "title": "Zpracovat dokument znovu",
          "description": "Znovu spustit AI extrakci tohoto dokumentu.",
          "documentTypeRequired": "Prosím vyberte typ dokumentu",
          "userPromptLabel": "Dodatečné instrukce",
          "userPromptPlaceholder": "Volitelné: Přidejte instrukce pro AI extrakci (např. 'Zaměř se na dodací adresu', 'Toto je česká faktura')...",
          "cancel": "Zrušit",
          "confirm": "Zpracovat znovu"
        },
        "deleteModal": {
          "title": "Smazat dokument",
          "description": "Opravdu chcete trvale smazat tento dokument? Tuto akci nelze vrátit zpět.",
          "cancel": "Zrušit",
          "confirm": "Smazat",
          "deleting": "Mazání...",
          "errorTitle": "Dokument nelze smazat",
          "errorMessage": "Při mazání dokumentu došlo k chybě. Zkuste to prosím znovu.",
          "forbiddenTitle": "Přístup zamítnut",
          "forbiddenMessage": "Nemáte oprávnění k smazání tohoto dokumentu. Obraťte se prosím na správce."
        },
        "backToList": "Zpět na seznam",
        "fields": {
          "filename": "Název souboru",
          "documentType": "Typ dokumentu",
          "status": "Stav",
          "createdAt": "Vytvořeno",
          "placeholder": "Bez hodnoty",
          "confidence": "Spolehlivost"
        },
        "itemsTable": {
          "noItems": "Žádné položky",
          "headers": {
            "item": "Položka",
            "quantity": "Množství",
            "unitPrice": "Jedn. cena",
            "total": "Celkem",
            "vatRate": "DPH %"
          }
        },
        "preview": {
          "controls": {
            "prevPage": "Předchozí stránka",
            "nextPage": "Další stránka",
            "pageCount": "Stránka {{current}} z {{total}}",
            "zoomIn": "Přiblížit",
            "zoomOut": "Oddálit",
            "resetZoom": "Obnovit přiblížení"
          },
          "error": {
            "loadFailed": "Nepodařilo se načíst náhled dokumentu"
          },
          "notPreviewable": "Tento typ souboru nelze zobrazit v náhledu.",
          "download": "Stáhnout soubor",
          "passwordProtected": "Dokument je chráněn heslem"
        },
        "statusPanel": {
          "processing": {
            "title": "Čmuchám data z vašeho dokladu!",
            "description": "Chvíli to potrvá, ale vyhrabu z toho vše podstatné."
          },
          "extracted": {
            "title": "Vytěžování hotovo!",
            "description": "Zpracovávám výsledky a zakládám doklad. Ještě chviličku..."
          },
          "invoiceFailed": {
            "title": "Vytěžení proběhlo, doklad se ale nezaložil",
            "description": "Data mám přečtená, ale založení dokladu se nepovedlo. Použijte tlačítko \"Zpracovat znovu\" výše a zkusím to znovu."
          },
          "failed": {
            "title": "Jejda, to se mi nepovedlo!",
            "description": "Při vytěžování dokumentu nastala chyba. Použijte tlačítko \"Zpracovat znovu\" výše a já se pokusím lépe."
          },
          "quotaExceeded": {
            "title": "Dosáhli jste svého limitu",
            "description": "Byl dosažen měsíční limit extrakce dokumentů. Pro pokračování upgradujte svůj plán."
          },
          "unsupportedDocument": {
            "title": "Tento dokument neumím zpracovat",
            "description": "Dokument jsem nerozpoznal jako podporovaný účetní doklad. Jestli jsem se zmýlil, zkusme to klidně znova!"
          },
          "passwordProtected": {
            "title": "Tento dokument je zamčený",
            "description": "PDF je chráněné heslem. Zadejte ho níže a já dokument odemknu a vytěžím."
          }
        },
        "unlock": {
          "passwordLabel": "Heslo dokumentu",
          "passwordPlaceholder": "Zadejte heslo dokumentu",
          "submit": "Odemknout a vytěžit",
          "errorInvalidPassword": "Zadané heslo není správné. Zkuste to prosím znovu.",
          "errorAsyncFailed": "Odemčení se nezdařilo. Zkontrolujte heslo a zkuste to znovu.",
          "errorGeneric": "Odemčení se nepovedlo. Zkuste to prosím znovu."
        },
        "extractedData": {
          "overallConfidence": "Celková Spolehlivost",
          "noData": "Nejsou k dispozici žádná extrahovaná data",
          "sections": {
            "documentDetails": "Detaily Dokumentu",
            "supplierInformation": "Informace o Dodavateli",
            "customerInformation": "Informace o Zákazníkovi",
            "invoiceDetails": "Detaily Faktury",
            "paymentInformation": "Platební Informace",
            "receiptDetails": "Detaily Účtenky",
            "items": "Položky",
            "totals": "Celkem"
          },
          "fields": {
            "name": "Název",
            "companyId": "IČO",
            "taxId": "DIČ",
            "vatId": "DIČ pro DPH / VAT ID",
            "address": "Adresa",
            "email": "Email",
            "phone": "Telefon",
            "invoiceNumber": "Číslo Faktury",
            "invoiceDate": "Datum Faktury",
            "dueDate": "Datum Splatnosti",
            "deliveryDate": "Datum Dodání",
            "paymentTerms": "Platební Podmínky",
            "orderReference": "Číslo Objednávky",
            "bankAccount": "Číslo Účtu",
            "bankCode": "Kód Banky",
            "bankName": "Název Banky",
            "iban": "IBAN",
            "swift": "SWIFT/BIC",
            "variableSymbol": "Variabilní Symbol",
            "constantSymbol": "Konstantní Symbol",
            "specificSymbol": "Specifický Symbol",
            "receiptNumber": "Číslo Účtenky",
            "datetime": "Datum a Čas",
            "paymentMethod": "Způsob Platby",
            "lineItems": "Řádkové Položky",
            "currency": "Měna",
            "subtotal": "Mezisoučet",
            "vatAmount": "Částka DPH",
            "vatRate": "Sazba DPH",
            "total": "Celkem",
            "amountDue": "K úhradě",
            "amountPaid": "Proplaceno",
            "documentNumber": "Číslo dokladu",
            "issueDate": "Datum vystavení",
            "taxDate": "Datum uskutečnění plnění",
            "receiptDatetime": "Datum a čas účtenky",
            "relatedDocumentNumber": "Číslo souvisejícího dokladu",
            "correctionReason": "Důvod opravy",
            "netAmount": "Základ daně",
            "totalAmountNoVat": "Celkem bez DPH",
            "totalVatAmount": "DPH celkem",
            "totalAmountInclVat": "Celková částka (s DPH)",
            "paidAmount": "Uhrazeno",
            "paymentNote": "Poznámka k platbě",
            "terminalId": "ID terminálu",
            "cashierId": "ID pokladníka",
            "eetFik": "EET FIK",
            "eetBkp": "EET BKP",
            "eetPkp": "EET PKP"
          }
        },
        "processingLogs": {
          "title": "Detaily Zpracování",
          "processingDuration": "Doba Zpracování",
          "tokenUsage": "Využití Tokenů",
          "inputTokens": "Vstupní Tokeny",
          "outputTokens": "Výstupní Tokeny",
          "totalTokens": "Celkem Tokenů"
        }
      },
      "emptySearch": "Nic nenalezeno pro „{{query}}“",
      "groups": {
        "attention": "Vyžaduje pozornost",
        "locked": "Vyžaduje heslo",
        "processing": "Zpracovává se",
        "completed": "Zpracováno",
        "sortedNewest": "Seřazeno od nejnovějšího"
      }
    },
    "documentThreads": {
      "title": "Dotazy",
      "openTag": "Otevřený dotaz",
      "resolve": "Vyřešit",
      "overviewLink": "Všechny otevřené dotazy",
      "turn": {
        "masterAccount": {
          "NONE": "Vyřešeno",
          "AWAITING_CLIENT": "Čeká na klienta",
          "CLIENT_REPLIED": "Klient odpověděl"
        },
        "client": {
          "NONE": "Vyřešeno",
          "AWAITING_CLIENT": "Čeká na vaši odpověď",
          "CLIENT_REPLIED": "Odpověď odeslána"
        }
      },
      "subject": {
        "loading": "Načítám doklad…",
        "unavailable": "Doklad není dostupný"
      },
      "message": {
        "formerMember": "Bývalý uživatel",
        "side": {
          "DIRECT": "Klient",
          "MASTER_ACCOUNT": "Účetní kancelář"
        },
        "note": "Poznámka"
      },
      "messages": {
        "loadEarlier": "Zobrazit starší zprávy"
      },
      "composer": {
        "openLabel": "Dotaz na klienta",
        "replyLabel": "Zpráva",
        "openPlaceholder": "Na co se chcete klienta k dokladu zeptat?",
        "masterAccountPlaceholder": "Napište klientovi…",
        "replyPlaceholder": "Napište odpověď…",
        "submitOpen": "Odeslat dotaz",
        "submitReply": "Odpovědět",
        "submitQuestion": "Odeslat klientovi",
        "submitNote": "Odeslat poznámku",
        "tooLong": "Zpráva je příliš dlouhá, nejvýš {{max}} znaků.",
        "removeFile": "Odebrat {{fileName}}",
        "attach": "Přiložit doklad",
        "uploadTitle": "Přiložit doklad",
        "uploadDescription": "Přetáhněte soubor sem nebo klikněte a vyberte ho",
        "requiresClientAction": "Čekat na odpověď klienta",
        "requiresClientActionOn": "Dotaz přejde na klienta k odpovědi.",
        "requiresClientActionOff": "Klient zprávu uvidí, ale odpověď se od něj nečeká."
      },
      "noClientUser": {
        "title": "Dotaz potřebuje adresáta",
        "description": "Klient zatím nemá v Tappeeru žádného uživatele, který by dotaz přečetl. Pozvěte uživatele klienta – dotaz půjde odeslat, jakmile pozvánku přijme.",
        "askAdmin": "Uživatele klienta může pozvat správce klienta nebo správce účetní kanceláře.",
        "retry": "Zkusit znovu",
        "invite": "Pozvat uživatele klienta",
        "invited": "Pozvánka odeslána. Dotaz půjde odeslat, jakmile ji uživatel přijme."
      },
      "new": {
        "hint": "K dokladu zatím není žádný dotaz. Klient ho uvidí přímo u dokladu.",
        "hintAgain": "Předchozí dotazy jsou vyřešené. Můžete se klienta zeptat znovu."
      },
      "empty": {
        "title": "Žádné dotazy",
        "description": "K tomuto dokladu zatím účetní kancelář nemá žádný dotaz."
      },
      "history": {
        "title": "Vyřešené dotazy",
        "resolved": "Vyřešeno {{date}}",
        "resolvedBy": "Vyřešeno {{date}} · {{name}}",
        "loadMore": "Zobrazit starší dotazy"
      },
      "errors": {
        "alreadyOpen": "K dokladu už je otevřený dotaz – zobrazujeme ho.",
        "resolved": "Dotaz byl mezitím vyřešen.",
        "generic": "Akce se nezdařila. Zkuste to prosím znovu.",
        "loadThreads": "Dotazy se nepodařilo načíst.",
        "loadMessages": "Zprávy se nepodařilo načíst.",
        "loadOverview": "Otevřené dotazy se nepodařilo načíst.",
        "sameDocument": "Tento soubor je doklad, ke kterému se dotaz vztahuje. Přiložte prosím jiný doklad."
      },
      "toast": {
        "opened": "Dotaz odeslán klientovi",
        "resolved": "Dotaz vyřešen"
      },
      "overview": {
        "title": "Otevřené dotazy",
        "button": "Otevřené dotazy ({{total}})",
        "count": "Otevřených dotazů: {{total}}",
        "loadMore": "Načíst další",
        "empty": {
          "title": "Žádné otevřené dotazy",
          "descriptionMasterAccount": "Dotaz klientovi položíte v detailu dokladu.",
          "descriptionClient": "Až se vás účetní kancelář na něco zeptá, najdete to tady."
        },
        "table": {
          "document": "Doklad",
          "turn": "Stav",
          "lastActivity": "Poslední aktivita",
          "asked": "Datum dotazu"
        }
      }
    },
    "invoices": {
      "matching": {
        "findings": {
          "accept": "Přijmout",
          "reject": "Zamítnout",
          "notePlaceholder": "Důvod (nepovinné)",
          "answerSaved": "Odpověď byla uložena.",
          "settledByPairing": "Tento nález nelze přijmout ani zamítnout — vyřeší ho až ruční spárování položky."
        },
        "findingExplanation": {
          "UNRESOLVABLE_REFERENCE": "Objednávku, kterou faktura uvádí, se nepodařilo najít.",
          "AMBIGUOUS_ORDER": "Údajům na faktuře odpovídá více objednávek, takže dokud nebude vybrána jedna, nelze nic spárovat.",
          "SUPPLIER_MISMATCH": "Objednávka patří jinému dodavateli, než který poslal tuto fakturu.",
          "UNKNOWN_LINE": "Na objednávce se nepodařilo najít odpovídající položku.",
          "AMBIGUOUS_PAIRING": "Položka faktury odpovídá stejně dobře více objednaným položkám.",
          "WEAK_PAIRING": "Položka byla spárována jen podle podobnosti (popisu nebo vyloučením), ne podle kódu ani EAN."
        },
        "answerEffect": {
          "UNRESOLVABLE_REFERENCE": {
            "accept": "Přijetím potvrdíte, že objednávku uvedenou na faktuře nelze najít; jakmile v hlavičce faktury nezůstane nic dalšího otevřeného, potvrdí se spárování všech položek, které nic dalšího nedrží."
          },
          "AMBIGUOUS_ORDER": {
            "accept": "Přijetím se žádná objednávka nevybere; jakmile v hlavičce faktury nezůstane nic dalšího otevřeného, potvrdí se spárování všech položek, které nic dalšího nedrží."
          },
          "SUPPLIER_MISMATCH": {
            "accept": "Přijetím potvrdíte, že jiný dodavatel na objednávce je v pořádku; jakmile v hlavičce faktury nezůstane nic dalšího otevřeného, potvrdí se spárování všech položek, které nic dalšího nedrží."
          },
          "UNKNOWN_LINE": {
            "reject": "Zamítnutím potvrdíte, že na objednávce není s čím položku spárovat; automatické párování ani AI ji už nespárují a spárovat ji půjde jen ručně."
          },
          "WEAK_PAIRING": {
            "accept": "Přijetím potvrdíte spárování, pokud položku nedrží nic dalšího.",
            "reject": "Zamítnutím se automatické spárování odstraní a položka počká na ruční spárování."
          }
        },
        "links": {
          "title": "Spárování",
          "orderedLine": "Objednaná položka",
          "pairedBy": "Jak spárováno",
          "state": "Stav",
          "actions": "Akce",
          "receivedLine": "Přijatá položka bez objednávky",
          "byRung": "podle {{rung}}",
          "confirmed": "Potvrzeno",
          "unconfirmed": "Nepotvrzeno",
          "order": "Objednávka {{number}}",
          "confirmedAutomatically": "Potvrzeno automaticky",
          "confirmedBy": "Potvrdil/a {{name}}"
        },
        "pairing": {
          "unpair": "Odpárovat",
          "pairLine": "Spárovat položku ručně",
          "pair": "Spárovat",
          "pairSuccess": "Položka byla spárována.",
          "orderGroup": "Objednávka {{number}}",
          "otherOrders": "Další objednávky dodavatele",
          "supplierOrders": "Objednávky dodavatele",
          "noOtherOrders": "Dodavatel nemá žádnou další objednávku, se kterou by šlo párovat.",
          "noCandidates": "Dodavatel této faktury nemá žádnou objednávku, se kterou by šlo párovat.",
          "loadMore": "Načíst další",
          "lineNumber": "Č.",
          "description": "Popis",
          "code": "Kód",
          "ordered": "Objednáno",
          "invoiced": "Fakturováno",
          "unitPrice": "Cena za jednotku",
          "proposed": "Návrh",
          "selectLine": "Vybrat položku {{number}} objednávky {{order}}",
          "overInvoiced": "Spárováním této položky se překročí objednané množství.",
          "nothingOnOrderSuccess": "Uloženo: položka nemá na objednávce protějšek."
        },
        "errors": {
          "resolveFailed": "Odpověď se nepodařilo uložit.",
          "pairingFailed": "Párování položky se nepodařilo uložit."
        },
        "lineStatus": {
          "clean": "Vyřešeno — nic otevřeného",
          "attention": "Spárování čeká na odpověď",
          "problem": "Položka není spárována s objednanou položkou",
          "held": "Vynecháno z automatického párování — čeká na ruční spárování",
          "openLabel": "{{status}} — otevřít párování položky"
        },
        "latest": {
          "pairedByHand": "Spárováno ručně",
          "paired": "Spárováno",
          "automatically": "Automaticky",
          "held": {
            "UNKNOWN_LINE": "Na objednávce není co párovat",
            "WEAK_PAIRING": "Navržené spárování zamítnuto"
          },
          "heldExplanation": "Automatické párování ani AI položku znovu nespárují; spárovat ji půjde jen ručně."
        },
        "edit": {
          "confirm": "Potvrdit",
          "cancel": "Zrušit",
          "nothingOnOrder": "Položka nemá na objednávce protějšek; automatické párování ji vynechá.",
          "pairsWith": "Položka se spáruje s položkou {{number}} objednávky {{order}}."
        },
        "lineModal": {
          "title": "Položka {{number}}",
          "close": "Zavřít",
          "unconfirmedNote": "Toto spárování zatím není potvrzené. Dokud je u položky nebo v hlavičce faktury otevřený nález, nic ho nepotvrdí.",
          "notPaired": "Položka zatím není spárována s žádnou objednanou položkou."
        },
        "actions": {
          "confirmed": "Párování potvrzeno"
        }
      },
      "list": {
        "title": "Doklady",
        "error": "Nepodařilo se načíst faktury",
        "retry": "Zkusit znovu",
        "empty": "Žádné faktury k zobrazení",
        "searchPlaceholder": "Hledat faktury...",
        "tabs": {
          "all": "Vše",
          "FOR_EDIT": "K editaci",
          "FOR_APPROVAL": "Ke schválení",
          "FOR_EXPORT": "K zaúčtování",
          "FOR_PAYMENT": "K proplacení",
          "REJECTED": "Zamítnuto",
          "CANCELLED": "Zrušeno",
          "COMPLETED": "Ukončeno",
          "ARCHIVED": "Archivováno"
        },
        "view": {
          "card": "Karty",
          "table": "Tabulka"
        },
        "headers": {
          "invoiceNumber": "Číslo faktury",
          "internalNumber": "Interní číslo",
          "supplier": "Dodavatel",
          "documentType": "Typ dokumentu",
          "totalAmount": "Částka s DPH",
          "invoiceDate": "Vystaveno",
          "dueDate": "Splatnost",
          "actions": "Akce"
        },
        "sort": {
          "created": "Vytvořeno",
          "date": "Datum vystavení",
          "amount": "Částka (vč. DPH)",
          "vendor": "Dodavatel",
          "number": "Číslo"
        },
        "batchExport": {
          "button": "Exportovat",
          "selectHint": "Vyberte doklady k exportu",
          "selectedCount_one": "Vybrán {{count}} doklad",
          "selectedCount_few": "Vybrány {{count}} doklady",
          "selectedCount_other": "Vybráno {{count}} dokladů",
          "selectionCapped_one": "Vybráno prvních {{limit}} z {{count}} dokladu",
          "selectionCapped_few": "Vybráno prvních {{limit}} z {{count}} dokladů",
          "selectionCapped_other": "Vybráno prvních {{limit}} z {{count}} dokladů",
          "selectAll": "Vybrat vše",
          "deselectAll": "Odznačit vše",
          "exportAs": "Exportovat jako",
          "exporting": "Exportuji…",
          "cancel": "Zrušit",
          "error": {
            "partialValidation_one": "{{count}} doklad nelze exportovat — zbytek byl stažen",
            "partialValidation_few": "{{count}} doklady nelze exportovat — zbytek byl stažen",
            "partialValidation_other": "{{count}} dokladů nelze exportovat — zbytek byl stažen",
            "allSkipped": "Žádný doklad nelze stáhnout — všechny doklady selhaly při validaci.",
            "failed": "Export selhal. Zkuste to prosím znovu.",
            "selectAllFailed": "Nepodařilo se vybrat všechny doklady. Zkuste to prosím znovu.",
            "noData": "Server nevrátil žádná data.",
            "notExportable": "Některé doklady už nelze exportovat. Obnovte stránku a zkuste to znovu.",
            "sessionExpired": "Vaše relace vypršela. Přihlaste se prosím znovu.",
            "invoiceLabel": "Doklad {{number}}",
            "invoiceUnknown": "Neznámý doklad",
            "pdfUnreadable": "PDF soubory vybraných dokladů nelze přečíst (mohou být zašifrované nebo poškozené). Exportujte je jako ISDOC XML."
          },
          "selectedCount": "Vybráno {{count}}",
          "issue": {
            "pdfMissing": "Doklad nemá připojený PDF soubor, proto ho nelze exportovat do PDF.",
            "notValidated": "Doklad neprošel validací ani nemá přijatá varování, proto ho nelze exportovat."
          }
        },
        "batchAction": {
          "progress": "Zpracováno {{processed}} z {{total}}",
          "error": {
            "interrupted_one": "Hotovo {{done}} z {{count}} dokladu, zbytek se nepodařilo zpracovat. Zkuste to prosím znovu.",
            "interrupted_few": "Hotovo {{done}} z {{count}} dokladů, zbytek se nepodařilo zpracovat. Zkuste to prosím znovu.",
            "interrupted_other": "Hotovo {{done}} z {{count}} dokladů, zbytek se nepodařilo zpracovat. Zkuste to prosím znovu."
          }
        },
        "batchArchive": {
          "button": "Přesunout do archivu",
          "archiving": "Přesouvám do archivu…",
          "confirmTitle": "Přesunout doklady do archivu",
          "confirmMessage_one": "Opravdu chcete přesunout {{count}} doklad do archivu?",
          "confirmMessage_few": "Opravdu chcete přesunout {{count}} doklady do archivu?",
          "confirmMessage_other": "Opravdu chcete přesunout {{count}} dokladů do archivu?",
          "confirmButton": "Přesunout do archivu",
          "cancel": "Zrušit",
          "successMessage_one": "{{count}} doklad byl přesunut do archivu.",
          "successMessage_few": "{{count}} doklady byly přesunuty do archivu.",
          "successMessage_other": "{{count}} dokladů bylo přesunuto do archivu.",
          "error": {
            "failed": "Přesun do archivu se nepodařil. Zkuste to prosím znovu.",
            "partialValidation_one": "{{count}} doklad nelze přesunout do archivu.",
            "partialValidation_few": "{{count}} doklady nelze přesunout do archivu.",
            "partialValidation_other": "{{count}} dokladů nelze přesunout do archivu.",
            "allSkipped": "Žádný doklad nebyl přesunut do archivu.",
            "invoiceLabel": "Doklad {{number}}",
            "invoiceUnknown": "Neznámý doklad"
          }
        },
        "batchMoveToExport": {
          "button": "Přesunout k exportu",
          "moving": "Přesouvám…",
          "confirmTitle": "Přesun k exportu",
          "confirmMessage_one": "Opravdu chcete přesunout {{count}} doklad do stavu K zaúčtování? Doklady s chybami validace budou přeskočeny.",
          "confirmMessage_few": "Opravdu chcete přesunout {{count}} doklady do stavu K zaúčtování? Doklady s chybami validace budou přeskočeny.",
          "confirmMessage_other": "Opravdu chcete přesunout {{count}} dokladů do stavu K zaúčtování? Doklady s chybami validace budou přeskočeny.",
          "confirmButton": "Přesunout",
          "cancel": "Zrušit",
          "successMessage_one": "{{count}} doklad byl přesunut k exportu.",
          "successMessage_few": "{{count}} doklady byly přesunuty k exportu.",
          "successMessage_other": "{{count}} dokladů bylo přesunuto k exportu.",
          "error": {
            "failed": "Přesun selhal. Zkuste to prosím znovu.",
            "partialValidation_one": "{{count}} doklad byl přeskočen kvůli chybám validace.",
            "partialValidation_few": "{{count}} doklady byly přeskočeny kvůli chybám validace.",
            "partialValidation_other": "{{count}} dokladů bylo přeskočeno kvůli chybám validace.",
            "allSkipped": "Žádný doklad nebyl přesunut — všechny doklady mají chyby validace.",
            "invoiceLabel": "Doklad {{number}}",
            "invoiceUnknown": "Neznámý doklad"
          }
        }
      },
      "card": {
        "invoiceNumber": "Číslo faktury",
        "internalNumber": "Interní číslo",
        "download": "Stáhnout",
        "downloadAria": "Stáhnout fakturu",
        "unknown": "Neznámý",
        "supplier": "Dodavatel",
        "totalAmount": "Částka s DPH",
        "invoiceDate": "Vystaveno",
        "dueDate": "Splatnost"
      },
      "detail": {
        "loading": "Načítání faktury...",
        "retry": "Zkusit znovu",
        "invoiceLines": "Položky faktury",
        "matching": "Párování s objednávkou",
        "contract": "Smlouva",
        "AI_ANALYSIS": "AI validace",
        "supplierInfo": "Údaje dodavatele",
        "customerInfo": "Údaje odběratele",
        "addressInfo": "Adresní údaje",
        "dataFields": "Datová pole",
        "invoiceTotals": "Souhrn",
        "vatSummary": "Rekapitulace DPH",
        "bankingDetails": "Bankovní údaje",
        "duplicateInvoiceNumber": "Duplicitní číslo faktury",
        "duplicateVariableSymbol": "Duplicitní variabilní symbol",
        "error": {
          "title": "Nepodařilo se načíst fakturu"
        },
        "notFound": {
          "title": "Faktura nenalezena",
          "message": "Faktura, kterou hledáte, neexistuje nebo byla smazána."
        },
        "actions": {
          "delete": "Smazat",
          "back": "Zpět na přehled",
          "changeStatus": "Změnit stav",
          "qrPayment": "QR platba",
          "export": "Export",
          "moreActions": "Další akce",
          "editBankingDetails": "Upravit bankovní spojení",
          "editVatSummary": "Upravit rekapitulaci DPH",
          "editVatTotals": "Upravit celkové částky",
          "editLines": "Upravit položky faktury",
          "editScan": "Upravit dle skenu",
          "editForm": "Upravit ve formuláři",
          "acceptWarnings": "Změnit stav",
          "complete": "Dokončit editaci",
          "submitForApproval": "Ke schválení",
          "submitForApprovalSuccess": "Faktura byla předána ke schválení.",
          "submitForApprovalError": "Fakturu se nepodařilo předat ke schválení.",
          "submitForApprovalNotValidated": "Fakturu nelze předat ke schválení, dokud neprojde validací.",
          "submitForApprovalBlockedByErrors": "Doklad obsahuje validační chyby. Předání ke schválení je možné až po jejich odstranění.",
          "submitForApprovalBlockedByValidation": "Probíhá kontrola dokladu. Předání ke schválení bude možné po jejím dokončení.",
          "archive": "Přesunout do archivu",
          "unarchive": "Obnovit z archivu",
          "completeInvoice": "Ukončit",
          "cancel": "Zrušit fakturu",
          "cancelSuccess": "Faktura byla zrušena.",
          "cancelError": "Fakturu se nepodařilo zrušit.",
          "returnToEditing": "Vrátit k editaci",
          "selectForExport": "Vybrat pro export",
          "select": "Vybrat doklad",
          "archiveHint": "Skryje doklad z běžných přehledů. Zůstane jen pro čtení a kdykoli ho obnovíte.",
          "completeInvoiceHint": "Označí doklad jako vyřízený. Zůstane v přehledech, dokud se nepřesune do archivu."
        },
        "header": {
          "invoice": "FAKTURA",
          "invoiceNumber": "Číslo dokladu",
          "internalNumber": "Interní číslo",
          "invoiceType": "Typ",
          "vatMode": "Režim DPH",
          "vatExemptionNote": "Doložka k režimu DPH",
          "orderReference": "Číslo objednávky",
          "orderReferencePlaceholder": "Zadejte nebo vyhledejte objednávku",
          "orderReferenceCustom": "Použít zadané číslo",
          "orderReferenceClear": "Bez čísla objednávky",
          "contract": "Smlouva",
          "isVatDocument": "Daňový doklad",
          "originalDocumentReference": "Původní doklad",
          "userNote": "Poznámka",
          "currency": "Měna",
          "changeCurrency": "Změnit měnu"
        },
        "accountingCodes": {
          "glPosting": "Předkontace",
          "vatCode": "Členění DPH",
          "connectorDefault": "Výchozí z nastavení konektoru",
          "lineDefault": "Podle hlavičky, jinak výchozí z konektoru",
          "lineCaption": "Členění DPH: {{code}}",
          "lineCaptionNotInCodeList": "Členění DPH: {{code}}, kód není v číselníku",
          "notInCodeList": "Kód není v číselníku"
        },
        "lineCoding": {
          "costCenterCaption": "Středisko: {{value}}",
          "jobCaption": "Zakázka: {{value}}"
        },
        "changeCurrency": {
          "select": {
            "title": "Změna měny faktury",
            "description": "Vyberte novou měnu pro tuto fakturu. Před uložením budete vyzváni k potvrzení změny.",
            "label": "Měna",
            "continueLabel": "Pokračovat",
            "cancelLabel": "Zrušit"
          },
          "confirm": {
            "title": "Potvrdit změnu měny",
            "message": "Změnit měnu faktury z {{from}} na {{to}}?",
            "warning": "Všechny částky na faktuře si zachovají svou číselnou hodnotu — nedojde k jejich přepočtu do nové měny.",
            "confirmLabel": "Změnit měnu",
            "cancelLabel": "Zpět"
          }
        },
        "sections": {
          "documentInfo": "Informace o dokladu",
          "supplier": "Dodavatel",
          "customer": "Odběratel",
          "description": "Popis dokumentu",
          "noDescription": "Žádný popis",
          "lineItems": "Položky faktury",
          "lineItems_receipt": "Položky účtenky",
          "vatMode": "Režim DPH",
          "invoiceInformation": "Informace o faktuře",
          "invoiceInformation_receipt": "Informace o účtence",
          "supplierDetails": "Údaje o Dodavateli",
          "dates": "Datumové údaje",
          "amounts": "Částky",
          "bankingDetails": "Bankovní spojení",
          "paymentSymbols": "Platební Symboly",
          "auditInformation": "Auditní Informace",
          "paymentDetails": "Platební údaje",
          "vatRecap": "Rekapitulace DPH",
          "invoiceTotals": "Souhrn k úhradě",
          "invoiceTotals_receipt": "Souhrn účtenky"
        },
        "lineItemsLabels": {
          "code": "KÓD",
          "name": "NÁZEV POLOŽKY",
          "quantity": "MNOŽSTVÍ",
          "unit": "MJ",
          "pricePerUnit": "CENA/KS s DPH",
          "pricePerUnitMJ": "CENA (MJ)",
          "pricePerUnitMJVatIncl": "CENA (MJ) S DPH",
          "pricePerUnitNoVat": "CENA/KS bez DPH",
          "totalAmountNoVat": "ZÁKLAD",
          "totalNoVat": "CELKEM BEZ DPH",
          "discount": "SLEVA",
          "discountPercent": "SLEVA V %",
          "vatRate": "DPH %",
          "vatAmount": "DPH",
          "totalWithVat": "CELKEM S DPH",
          "recyclingFee": "RECYKLAČNÍ POPLATEK",
          "noItems": "Faktura neobsahuje žádné položky",
          "placeholder": "—"
        },
        "validationSummary": {
          "affectedItems_one": "{{count}} položka",
          "affectedItems_few": "{{count}} položky",
          "affectedItems_other": "{{count}} položek",
          "errors_one": "{{count}} chyba",
          "errors_few": "{{count}} chyby",
          "errors_other": "{{count}} chyb",
          "warnings_one": "{{count}} varování",
          "warnings_few": "{{count}} varování",
          "warnings_other": "{{count}} varování"
        },
        "companyLabels": {
          "name": "Název/firma",
          "companyId": "IČO",
          "vatId": "DIČ pro DPH / VAT ID",
          "taxId": "DIČ / Tax ID",
          "address": "Adresa",
          "email": "Email",
          "phone": "Telefon",
          "notAvailable": "Neuvedeno",
          "mismatchSupplier": "Tato firma není označena jako dodavatel",
          "mismatchCustomer": "Tato firma není označena jako odběratel",
          "createPartnerSuccess": "Firma vytvořena a přiřazena k faktuře",
          "createPartnerError": "Firmu se nepodařilo vytvořit",
          "editPartner": "Upravit firmu",
          "editPartnerSuccess": "Firma byla upravena",
          "editPartnerError": "Firmu se nepodařilo upravit"
        },
        "fillFromRegistry": {
          "button": "Vyplnit z adresáře",
          "change": "Změnit z adresáře",
          "titleSupplier": "Vybrat dodavatele z adresáře",
          "titleCustomer": "Vybrat odběratele z adresáře",
          "selectPlaceholder": "Hledat firmu…",
          "apply": "Použít",
          "cancel": "Zrušit",
          "back": "Zpět",
          "overwrite": "Přepsat",
          "confirmTitle": "Přepsat stávající údaje?",
          "confirmMessage": "Výběrem „{{name}}“ se přepíšou aktuální údaje dodavatele/odběratele. Chcete pokračovat?",
          "linkedTo": "Přiřazená firma: {{name}}",
          "addNew": "Přidat jako novou firmu",
          "addNewSupplier": "Přidat nového dodavatele",
          "addNewCustomer": "Přidat nového odběratele",
          "disconnect": "Odpojit firmu od faktury",
          "createSuccess": "Firma vytvořena a přiřazena k faktuře",
          "createError": "Firmu se nepodařilo vytvořit",
          "linkError": "Firma vytvořena, ale nepodařilo se ji přiřadit k faktuře",
          "disconnectConfirmTitle": "Odpojit firmu od faktury?",
          "disconnectConfirmMessage": "Firma bude od faktury odpojena. Zadané údaje zůstanou zachovány.",
          "disconnectConfirm": "Odpojit"
        },
        "delivery": {
          "sameAsCustomer": "Doručovací údaje shodné s fakturačními",
          "address": "Doručovací adresa"
        },
        "paymentLabels": {
          "paymentMethod": "ZPŮSOB PLATBY",
          "paymentStatus": "STAV PLATBY",
          "paymentNote": "POZNÁMKA K PLATBĚ",
          "paidAmount": "PROPLACENÁ ČÁSTKA",
          "paidDate": "DATUM PROPLACENÍ",
          "postingStatus": "STAV ZAÚČTOVÁNÍ",
          "postedOn": "DATUM ZAÚČTOVÁNÍ",
          "accountNumber": "ČÍSLO ÚČTU",
          "bankName": "NÁZEV BANKY",
          "iban": "IBAN",
          "swift": "SWIFT / BIC",
          "bankCode": "KÓD BANKY",
          "varSymbol": "VARIABILNÍ SYMBOL",
          "constSymbol": "KONSTANTNÍ SYMBOL",
          "specSymbol": "SPECIFICKÝ SYMBOL"
        },
        "vatLabels": {
          "rate": "Sazba",
          "base": "Základ",
          "vat": "DPH",
          "withVat": "S DPH",
          "total": "Celkem",
          "totalWithoutVat": "Celkem bez DPH",
          "totalVat": "Celkem DPH",
          "rounding": "Zaokrouhlení",
          "totalToPay": "Celkem k úhradě",
          "notAvailable": "DPH rekapitulace není k dispozici",
          "rateMismatch": "Sazby {{rates}} neodpovídají povoleným sazbám pro danou zemi a DUZP.",
          "rateNotAllowed": "Tato sazba není pro danou zemi a DUZP platná"
        },
        "paymentMethod": {
          "bankTransfer": "Bankovní převod",
          "cash": "Hotovost",
          "card": "Karta"
        },
        "dateLabels": {
          "issueDate": "Datum vystavení",
          "dueDate": "Datum splatnosti",
          "taxDate": "DUZP",
          "receiptDate": "Datum přijetí"
        },
        "sidebar": {
          "relatedDocuments": "Vazby na doklady",
          "changeHistory": "Historie změn",
          "noRelatedDocuments": "Zatím žádné vazby",
          "noHistory": "Zatím žádná historie",
          "openRelatedDocument": "Otevřít vazbu: {{title}}",
          "previewAttachmentError": "Náhled se nepodařilo načíst",
          "validationNote": "Poznámka k validaci",
          "addRelatedDocument": "Přidat vazbu na doklad",
          "removeRelatedDocument": "Odebrat vazbu",
          "removeRelatedDocumentConfirm": "Odebrat vazbu",
          "removeSuccess": "Vazba odebrána",
          "removeError": "Nepodařilo se odebrat vazbu"
        },
        "emailPreview": {
          "title": "Zdrojový email",
          "from": "Od",
          "to": "Komu",
          "subject": "Předmět",
          "date": "Datum",
          "close": "Zavřít",
          "download": "Stáhnout"
        },
        "linkModal": {
          "title": "Vazba na jiný doklad",
          "description": "Vyhledejte fakturu, kterou chcete propojit. Typ vazby je určen automaticky.",
          "searchPlaceholder": "Hledat podle čísla, dodavatele, popisu…",
          "noResults": "Žádné faktury nenalezeny",
          "loadMore": "Načíst další ({{count}} zbývá)",
          "loading": "Načítám…",
          "selectInvoice": "Propojit fakturu {{number}}",
          "linkButton": "Propojit",
          "linking": "Propojuji…",
          "cancel": "Zrušit",
          "successToast": "Vazba byla úspěšně vytvořena",
          "errorToast": "Vytvoření vazby se nezdařilo. Zkuste to prosím znovu."
        },
        "relationTypes": {
          "CREDIT_NOTE_FOR_INVOICE": "Dobropis",
          "DEBIT_NOTE_FOR_INVOICE": "Vrubopis",
          "CREDIT_NOTE_FOR_ADVANCE": "Dobropis k záloze",
          "ADVANCE_FOR_FINAL": "Záloha",
          "PROFORMA_FOR_ADVANCE": "Zálohová proforma faktura",
          "STORNO": "Storno",
          "REPLACEMENT": "Náhrada",
          "RELATED": "Vztažený doklad"
        },
        "relationDescriptions": {
          "source": {
            "CREDIT_NOTE_FOR_INVOICE": "Oprava původní faktury",
            "DEBIT_NOTE_FOR_INVOICE": "Doúčtování k faktuře",
            "CREDIT_NOTE_FOR_ADVANCE": "Oprava zálohy",
            "ADVANCE_FOR_FINAL": "Záloha na tuto fakturu",
            "PROFORMA_FOR_ADVANCE": "Zálohová proforma faktura",
            "STORNO": "Stornuje původní doklad",
            "RELATED": "Propojený doklad",
            "default": "Zdrojový doklad"
          },
          "target": {
            "CREDIT_NOTE_FOR_INVOICE": "Opraveno dobropisem",
            "DEBIT_NOTE_FOR_INVOICE": "Doúčtováno vrubopisem",
            "CREDIT_NOTE_FOR_ADVANCE": "Opraveno dobropisem",
            "ADVANCE_FOR_FINAL": "Zaúčtovaná záloha",
            "PROFORMA_FOR_ADVANCE": "Záloha dle proformy",
            "STORNO": "Stornováno",
            "RELATED": "Propojený doklad",
            "default": "Cílový doklad"
          }
        },
        "historyLabels": {
          "created": "Vytvoření",
          "createdDescription": "Faktura vytvořena v systému.",
          "eventTypes": {
            "CREATED": "Vytvoření",
            "UPDATED": "Úprava",
            "LINE_ITEMS_UPDATED": "Úprava položek",
            "APPROVAL_STATUS_CHANGED": "Změna stavu",
            "VALIDATION_STATUS_CHANGED": "Změna validace",
            "PAYMENT_STATUS_CHANGED": "Změna stavu platby",
            "ARCHIVED": "Archivace",
            "UNARCHIVED": "Zrušení archivace",
            "ATTACHMENT_ADDED": "Přidání přílohy",
            "ATTACHMENT_REMOVED": "Odebrání přílohy",
            "AUTOFILL_DISCARDED": "Neprovedené doplnění",
            "MATCH_FINDING_ANSWERED": "Posouzení nálezu párování",
            "MATCH_AI_REVIEW": "Posouzení párování AI",
            "DELETED": "Smazání",
            "UNKNOWN": "Změna"
          },
          "fieldLabels": {
            "totalAmountInclVat": "Celková částka",
            "totalAmountNoVat": "Celkem bez DPH",
            "totalVatAmount": "DPH celkem",
            "status": "Stav dokladu",
            "validationStatus": "Stav validace",
            "paymentStatus": "Stav platby",
            "invoiceNumber": "Číslo faktury",
            "dueDate": "Datum splatnosti",
            "invoiceDate": "Datum vystavení",
            "description": "Popis",
            "userNote": "Poznámka",
            "currencyCode": "Měna",
            "quantity": "Množství",
            "unitPrice": "Jedn. cena",
            "unitPriceNoVat": "Jedn. cena (bez DPH)",
            "vatRate": "Sazba DPH",
            "vatAmount": "Částka DPH",
            "vatMode": "Režim DPH",
            "totalAmountLine": "Celkem",
            "ean": "EAN",
            "classification": "Klasifikace",
            "taxDate": "DUZP",
            "paidDate": "Datum platby",
            "paidAmount": "Proplaceno",
            "postingStatus": "Stav zaúčtování",
            "postedOn": "Datum zaúčtování",
            "internalNumber": "Interní číslo",
            "category": "Kategorie",
            "accountingAmount": "Účetní částka",
            "documentType": "Typ dokumentu",
            "invoicePurpose": "Účel faktury",
            "paymentMethod": "Způsob platby",
            "customerCompanyId": "IČO odběratele",
            "customerTaxId": "DIČ odběratele",
            "customerVatId": "DIČ pro DPH / VAT ID odběratele",
            "supplierCompanyId": "IČO dodavatele",
            "supplierTaxId": "DIČ dodavatele",
            "supplierVatId": "DIČ pro DPH / VAT ID dodavatele",
            "accountingExchangeRate": "Účetní kurz",
            "accountingTotalVatAmount": "Účetní DPH celkem",
            "accountingAmountNoVat": "Účetní částka (bez DPH)",
            "accountingCurrencyCode": "Účetní měna",
            "currency": "Měna",
            "isVatDocument": "Daňový doklad",
            "orderReference": "Číslo objednávky",
            "originalDocumentReference": "Reference původního dokladu",
            "roundingAmount": "Zaokrouhlení",
            "supplierName": "Název dodavatele",
            "supplierParty": "Firma dodavatele v adresáři",
            "supplierEmail": "E-mail dodavatele",
            "supplierPhone": "Telefon dodavatele",
            "supplierAddress": "Adresa dodavatele",
            "customerName": "Název odběratele",
            "customerParty": "Firma odběratele v adresáři",
            "customerEmail": "E-mail odběratele",
            "customerPhone": "Telefon odběratele",
            "customerAddress": "Adresa odběratele",
            "bankingDetails": "Bankovní údaje",
            "vatSummary": "Rekapitulace DPH",
            "contractId": "Smlouva",
            "contractLinkSource": "Přiřazení smlouvy"
          },
          "lineChanges": {
            "added": "+ {{count}} přidáno",
            "removed": "- {{count}} odebráno",
            "modified": "~ {{count}} upraveno",
            "lineNumber": "Položka {{number}}",
            "fieldChanged": "{{from}} → {{to}}",
            "fieldSet": "→ {{to}}",
            "fieldCleared": "odstraněno"
          },
          "vatChanges": {
            "added": "+ {{count}} přidáno",
            "removed": "- {{count}} odebráno",
            "modified": "~ {{count}} upraveno"
          },
          "modal": {
            "viewDetails": "Zobrazit změny položek",
            "viewVatDetails": "Zobrazit změny DPH",
            "viewMatchReview": "Zobrazit výsledky",
            "matchReview": {
              "title": "Výsledky posouzení párování",
              "line": "Položka",
              "finding": "Nález",
              "answer": "Výsledek",
              "outcome": "Stav zápisu",
              "confidence": "Jistota",
              "reasoning": "Zdůvodnění",
              "confidenceValue": "{{value}} %"
            },
            "lineChanges": "Změny položek",
            "addedLines": "Přidáno",
            "removedLines": "Odebráno",
            "modifiedLines": "Upraveno",
            "field": "Pole",
            "from": "Před",
            "to": "Po",
            "noDetails": "Žádné změny položek.",
            "close": "Zavřít"
          },
          "systemChange": "Systém",
          "valueChanged": "změněno",
          "loadError": "Nepodařilo se načíst historii",
          "cancelled": "Zrušeno",
          "approvers": "Schvalovatelé: {{value}}",
          "roleTarget": "Všichni s rolí {{role}}",
          "permissionTarget": "Všichni s oprávněním schvalovat",
          "approverDecision": "Rozhodnutí o schválení: {{value}}",
          "matchFindingAnswered": "Položka {{line}} · {{finding}}: {{resolution}}",
          "matchFindingAnsweredHeader": "{{finding}}: {{resolution}}",
          "approverDecisionValue": {
            "APPROVED": "Schváleno",
            "REJECTED": "Neschváleno"
          }
        },
        "qrPayment": {
          "title": "QR kód pro platbu",
          "subtitle": "Naskenujte QR kód v bankovní aplikaci pro rychlou platbu",
          "mobileSubtitle": "Sdílejte, zkopírujte nebo uložte QR kód.",
          "loading": "Načítání QR kódu...",
          "remainingAmount": "Zbývá uhradit",
          "variableSymbol": "VS",
          "constantSymbol": "KS",
          "specificSymbol": "SS",
          "message": "Zpráva pro příjemce",
          "account": "Účet",
          "iban": "IBAN",
          "qrCodeAlt": "QR kód pro platbu faktury",
          "unavailable": "QR kód není k dispozici. Na dokladu chybí platný bankovní účet, nebo už není co proplatit.",
          "shareButton": "Sdílet QR kód",
          "copyButton": "Kopírovat platební údaje",
          "downloadButton": "Stáhnout QR",
          "shareTitle": "QR kód pro platbu",
          "copied": "Platební údaje zkopírovány do schránky",
          "copyFailed": "Nepodařilo se zkopírovat platební údaje",
          "shareFailed": "Nepodařilo se sdílet QR kód"
        },
        "changeStatus": {
          "title": "Změnit stav faktury",
          "subtitle": "Vyberte nový stav pro fakturu {{invoiceNumber}}",
          "selectStatus": "Vyberte stav...",
          "cancel": "Zrušit",
          "change": "Změnit stav"
        },
        "exportModal": {
          "title": "Exportovat fakturu",
          "subtitle": "Vyberte formát pro export faktury {{invoiceNumber}}",
          "exporting": "Exportuji...",
          "cancel": "Zrušit",
          "formats": {
            "xml": {
              "title": "ISDOC",
              "description": "Samostatný soubor ISDOC — český standard elektronické fakturace"
            },
            "pdf": {
              "title": "PDF s ISDOC",
              "description": "PDF faktury s vloženým souborem ISDOC",
              "noPdf": "K této faktuře není připojen žádný PDF soubor"
            }
          },
          "error": {
            "validationTitle": "Fakturu nelze exportovat",
            "networkTitle": "Export se nezdařil",
            "moreIssues": "…a dalších {{count}} problém(ů)",
            "failed": "Export se nezdařil. Zkuste to prosím znovu.",
            "noData": "Server nevrátil žádná data",
            "notExportable": "Fakturu už nelze exportovat. Obnovte stránku a zkuste to znovu.",
            "sessionExpired": "Vaše relace vypršela. Přihlaste se prosím znovu.",
            "pdfUnreadable": "PDF soubor faktury nelze přečíst (může být zašifrovaný nebo poškozený), proto ji nelze exportovat do PDF. Exportujte ji jako ISDOC XML."
          },
          "issue": {
            "pdfMissing": "Faktura nemá připojený PDF soubor, proto ji nelze exportovat do PDF.",
            "notValidated": "Faktura neprošla validací ani nemá přijatá varování, proto ji nelze exportovat."
          }
        },
        "bankingDetailsModal": {
          "title": "Upravit bankovní spojení",
          "description": "Aktualizujte bankovní informace pro tuto fakturu",
          "cancel": "Zrušit",
          "save": "Uložit",
          "saving": "Ukládání...",
          "errors": {
            "atLeastOneField": "Vyplňte alespoň jedno pole",
            "invalidIban": "Neplatný formát IBAN",
            "saveError": "Nepodařilo se uložit bankovní spojení. Zkuste to prosím znovu."
          },
          "warnings": {
            "invalidDataTitle": "Varování: Neplatný formát údajů",
            "invalidDataBody": "Zkontrolujte zvýrazněná pole. Data lze uložit, ale mohou být nesprávná.",
            "invalidSwift": "Neplatný formát SWIFT/BIC (např. GIBACZPX nebo GIBACZPXXXX)",
            "invalidBankCode": "Kód banky by měl být 4-místné číslo (např. 0800)",
            "invalidIban": "Neplatný formát IBAN (např. CZ6508000000192000145399)"
          }
        },
        "vatSummaryModal": {
          "title": "Souhrn DPH",
          "description": "Editace sazeb DPH a celkových částek",
          "cancel": "Zrušit",
          "save": "Uložit změny",
          "saving": "Ukládání...",
          "errors": {
            "saveError": "Nepodařilo se uložit souhrn DPH. Zkuste to prosím znovu."
          },
          "vatRatesTitle": "Rekapitulace DPH podle sazeb",
          "noVatRates": "Pro tuto fakturu nejsou k dispozici sazby DPH",
          "totalsTitle": "Celkové částky",
          "totalWithoutVat": "Celkem bez DPH",
          "totalVatFromRecap": "Celkem DPH (z rekapitulace)",
          "totalToPay": "Celkem k úhradě",
          "vatRateLabel": "Sazba DPH",
          "baseLabel": "Základ ({{currency}})",
          "vatLabel": "DPH ({{currency}})",
          "totalInclVatLabel": "S DPH ({{currency}})",
          "warnings": {
            "totalMismatchTitle": "Varování: Nesoulad celkové částky",
            "totalMismatchBody": "Součet řádků DPH ({{rowsTotal}} {{currency}}) se neshoduje s celkovou částkou faktury ({{invoiceTotal}} {{currency}})",
            "vatCalcTitle": "Varování: Nesprávný výpočet DPH",
            "vatCalcBody": "Některé řádky DPH neodpovídají matematickému výpočtu (Základ × Sazba ≠ DPH). Zkontrolujte, zda částky odpovídají sazbám.",
            "linesMismatchTitle": "Varování: Nesoulad s položkami",
            "linesMismatchBody": "Celková částka ({{total}} {{currency}}) se liší od součtu položek ({{linesTotal}} {{currency}})",
            "expectedVat": "Očekáváno: {{expected}} {{currency}}",
            "expectedTotal": "Očekáváno: {{expected}} {{currency}}"
          }
        },
        "editLinesModal": {
          "title": "Editace položek faktury",
          "description": "Upravte zvýrazněná pole. Hodnoty se automaticky nepřepočítávají – zobrazí se varování, pokud částky nesedí.",
          "cancel": "Zrušit",
          "save": "Uložit změny",
          "saving": "Ukládání...",
          "noLines": "Žádné položky",
          "colName": "Název",
          "colQuantity": "Množství",
          "colPricePerUnit": "Cena/ks bez DPH",
          "colPricePerUnitInclVat": "Cena/ks s DPH",
          "colTotalAmountNoVat": "Základ",
          "colVatRate": "Sazba DPH",
          "colVatTotal": "DPH celkem",
          "colTotal": "Celkem",
          "colActions": "Akce",
          "noName": "Bez názvu",
          "addLine": "Přidat položku",
          "deleteLine": "Smazat položku",
          "tooltipExpected": "Očekávaná hodnota",
          "hintExpected": "Očekáváno:",
          "summaryBase": "Základ bez DPH",
          "summaryVat": "DPH celkem",
          "summaryTotal": "CELKEM",
          "itemCount_one": "{{count}} položka",
          "itemCount_few": "{{count}} položky",
          "itemCount_other": "{{count}} položek",
          "errors": {
            "saveError": "Nepodařilo se uložit položky faktury. Zkuste to prosím znovu."
          },
          "warnings": {
            "vatCalcTitle": "Varování: Nesprávný výpočet DPH",
            "vatCalcBody": "Některé položky mají nesprávně vypočítanou DPH. Zkontrolujte, zda částky odpovídají sazbám.",
            "expectedVat": "Očekáváno: {{expected}} {{currency}}",
            "expectedTotal": "Očekáváno: {{expected}} {{currency}}"
          }
        },
        "lineItems": {
          "title": "Položky Faktury",
          "columns": {
            "lineNumber": "#",
            "description": "Popis",
            "quantity": "Množství",
            "unitPrice": "Jednotková cena",
            "unit": "Jednotka",
            "totalAmount": "Celkem (s DPH)",
            "totalAmountNoVat": "Celkem (bez DPH)",
            "vatRate": "Sazba DPH (%)",
            "vatAmount": "Částka DPH"
          },
          "empty": "Žádné položky",
          "total": "Celkem (všechny položky)",
          "verification": {
            "match": "Odpovídá celkové částce faktury",
            "discrepancy": "Nesouhlasí s celkovou částkou faktury"
          },
          "actions": {
            "delete": "Smazat položku"
          },
          "add": "Přidat položku",
          "placeholder": {
            "description": "Popis položky",
            "unit": "ks"
          }
        },
        "fields": {
          "placeholder": "Není vyplněno",
          "selectSupplier": "Vyberte dodavatele...",
          "selectCustomer": "Vyberte odběratele...",
          "selectDocumentType": "Vyberte typ dokumentu...",
          "selectStatus": "Vyberte stav...",
          "invoiceNumber": "Číslo faktury",
          "internalNumber": "Interní číslo",
          "documentType": "Typ dokumentu",
          "invoicePurpose": "Účel faktury",
          "invoiceDirection": "Směr faktury",
          "paymentStatus": "Stav platby",
          "description": "Popis",
          "supplierName": "Název dodavatele",
          "supplierCode": "Kód dodavatele",
          "email": "Email",
          "phone": "Telefon",
          "companyId": "IČO",
          "taxId": "DIČ",
          "vatId": "DIČ pro DPH / VAT ID",
          "invoiceDate": "Datum faktury",
          "dueDate": "Datum splatnosti",
          "taxDate": "Datum zdanitelného plnění",
          "paidDate": "Datum proplacení",
          "deliveryDate": "Datum dodání",
          "paymentTerms": "Platební podmínky",
          "orderReference": "Číslo objednávky",
          "currency": "Měna",
          "totalAmountInclVat": "Celková částka (s DPH)",
          "totalAmountNoVat": "Celková částka (bez DPH)",
          "paidAmount": "Proplacená částka",
          "bankAccount": "Číslo účtu",
          "bankCode": "Kód banky",
          "bankName": "Název banky",
          "iban": "IBAN",
          "swift": "SWIFT/BIC",
          "varSymb": "Variabilní symbol",
          "constSymb": "KONSTANTNÍ SYMBOL",
          "specSymb": "SPECIFICKÝ SYMBOL",
          "createdAt": "Vytvořeno",
          "createdBy": "{{firstName}} {{lastName}} ({{email}})",
          "updatedAt": "Poslední úprava",
          "updatedBy": "{{firstName}} {{lastName}} ({{email}})",
          "name": "Název",
          "quantity": "Množství",
          "unit": "Jednotka",
          "unitPrice": "Jedn. cena",
          "totalPrice": "Celková cena",
          "vatRate": "Sazba DPH",
          "vatAmount": "Částka DPH",
          "streetName": "Ulice",
          "buildingNumber": "Číslo popisné",
          "city": "Město",
          "postalCode": "PSČ",
          "countryCode": "Kód země",
          "address": "Adresa",
          "confidence": "Spolehlivost",
          "ico": "IČO"
        },
        "deleteDialog": {
          "title": "Smazat fakturu?",
          "description": "Tato akce je nevratná. Faktura a všechny položky budou trvale smazány.",
          "confirm": "Smazat",
          "cancel": "Zrušit",
          "deleting": "Mazání...",
          "confirmMessage": "Opravdu chcete smazat fakturu<br /><strong>{{number}}</strong>?",
          "error": "Nepodařilo se smazat fakturu"
        },
        "acceptWarningsDialog": {
          "title": "Přijmout varování",
          "confirmMessage": "Doklad obsahuje <strong>{{count}}</strong> varování. Potvrzením se skryjí validační hlášky a doklad bude možné exportovat a schválit. Varování se znovu zobrazí, pokud provedete další změny.",
          "cancel": "Zrušit",
          "confirm": "Přijmout varování",
          "accepting": "Přijímání...",
          "notePlaceholder": "Volitelná poznámka — proč varování přijímáte?",
          "error": "Nepodařilo se přijmout varování. Zkuste to prosím znovu.",
          "acceptError": "Nepodařilo se přijmout upozornění. Zkuste to prosím znovu.",
          "approveError": "Upozornění byla přijata, ale schválení selhalo. Zkuste to prosím znovu."
        },
        "archiveDialog": {
          "title": "Přesunout fakturu do archivu?",
          "confirmMessage": "Opravdu chcete přesunout fakturu <strong>{{number}}</strong> do archivu?",
          "impactReadOnly": "Faktura se uzamkne a nepůjde dál upravovat.",
          "impactHidden": "Zmizí z aktivních přehledů a nebude se počítat do stavů.",
          "impactReversible": "Kdykoli ji můžete obnovit z archivu zpět do původního stavu.",
          "cancel": "Zrušit",
          "confirm": "Přesunout do archivu",
          "archiving": "Přesouvám do archivu…",
          "error": "Fakturu se nepodařilo přesunout do archivu. Zkuste to prosím znovu."
        },
        "unarchiveDialog": {
          "title": "Obnovit fakturu z archivu?",
          "confirmMessage": "Opravdu chcete obnovit fakturu <strong>{{number}}</strong> z archivu?",
          "impactRestored": "Faktura se vrátí do aktivních přehledů a do stavů.",
          "impactEditable": "Obnoví se její původní stav — bude ji možné upravovat nebo exportovat.",
          "cancel": "Zrušit",
          "confirm": "Obnovit z archivu",
          "unarchiving": "Obnovování...",
          "error": "Nepodařilo se obnovit fakturu z archivu. Zkuste to prosím znovu."
        },
        "completeDialog": {
          "title": "Ukončit fakturu?",
          "confirm": "Ukončit",
          "cancel": "Zrušit",
          "success": "Faktura je ukončená.",
          "error": "Fakturu se nepodařilo ukončit."
        },
        "returnToEditingDialog": {
          "title": "Vrátit doklad k editaci?",
          "confirmMessage": "Opravdu vrátit doklad <strong>{{number}}</strong> zpět k editaci?",
          "impactEditable": "Doklad se odemkne a půjde znovu upravovat.",
          "impactRemovedFromExport": "Probíhající schvalování se zruší a doklad se vrátí mezi rozpracované.",
          "cancel": "Zrušit",
          "confirm": "Vrátit k editaci",
          "reverting": "Vracení...",
          "error": "Nepodařilo se vrátit fakturu k editaci. Zkuste to prosím znovu."
        },
        "autoApprovedDialog": {
          "titleApproved": "Doklad byl automaticky schválen",
          "messageApproved": "Doklad <strong>{{number}}</strong> byl během úprav automaticky schválen a je uzamčen pro úpravy.",
          "expiredMessageApproved": "Doklad <strong>{{number}}</strong> byl automaticky schválen a je nyní uzamčen pro úpravy.",
          "hintApproved": "Návrat k editaci doklad znovu odemkne. Tlačítko OK schválení ponechá, otevřené editory se zavřou a neuložené změny se zahodí.",
          "titleSubmitted": "Doklad byl předán ke schválení",
          "messageSubmitted": "Doklad <strong>{{number}}</strong> byl po dokončení kontroly předán ke schválení a je uzamčen pro úpravy.",
          "expiredMessageSubmitted": "Doklad <strong>{{number}}</strong> byl předán ke schválení a je nyní uzamčen pro úpravy.",
          "hintSubmitted": "Návrat k editaci schvalování zruší a doklad znovu odemkne. Tlačítko OK doklad ve schvalování ponechá, otevřené editory se zavřou a neuložené změny se zahodí.",
          "ok": "OK",
          "okCountdown": "OK ({{seconds}} s)",
          "returnToEditing": "Vrátit k editaci",
          "reverting": "Vracení...",
          "error": "Nepodařilo se vrátit doklad k editaci. Zkuste to prosím znovu."
        },
        "validation": {
          "required": "{{field}} je povinné",
          "positive": "{{field}} musí být větší než 0",
          "nonNegative": "{{field}} musí být nezáporná",
          "saveError": "Nepodařilo se uložit změny",
          "deleteError": "Nepodařilo se smazat položku",
          "updateStatusError": "Nepodařilo se aktualizovat stav"
        },
        "toast": {
          "updateSuccess": "Změny uloženy",
          "updateError": "Nepodařilo se uložit změny",
          "fieldUpdated": "{{field}} aktualizováno",
          "fieldUpdateError": "Nepodařilo se aktualizovat {{field}}"
        },
        "validationBanner": {
          "title": "Faktura obsahuje problémy",
          "expand": "Rozbalit",
          "collapse": "Sbalit",
          "dismiss": "Skrýt toto varování",
          "scrollTo": "Přejít na pole",
          "stored": "uloženo",
          "calculated": "vypočteno",
          "severity": {
            "error": "Chyby",
            "warning": "Varování"
          },
          "fieldLabels": {
            "invoiceNumber": "Číslo faktury",
            "invoiceDate": "Datum vystavení",
            "dueDate": "Datum splatnosti",
            "taxDate": "Datum zdanitelného plnění",
            "currencyCode": "Měna",
            "paymentMethod": "Způsob platby",
            "documentType": "Typ dokladu",
            "description": "Popis",
            "totalAmountInclVat": "Celková částka",
            "totalAmountNoVat": "Celkem bez DPH",
            "vatAmount": "DPH",
            "vatSummary": "Rekapitulace DPH",
            "supplier": "Dodavatel",
            "supplierName": "Název dodavatele",
            "supplierAddress": {
              "streetName": "Ulice (dodavatel)",
              "buildingNumber": "Číslo popisné (dodavatel)",
              "city": "Město (dodavatel)",
              "postalCode": "PSČ (dodavatel)",
              "countryCode": "Kód země (dodavatel)"
            },
            "supplierAddressLabel": "Adresa dodavatele",
            "supplierCompanyId": "IČO dodavatele",
            "supplierVatId": "DIČ pro DPH / VAT ID dodavatele",
            "supplierTaxId": "DIČ dodavatele",
            "customer": "Odběratel",
            "customerName": "Název odběratele",
            "customerCompanyId": "IČO odběratele",
            "customerVatId": "DIČ pro DPH / VAT ID odběratele",
            "customerTaxId": "DIČ odběratele",
            "customerAddress": {
              "streetName": "Ulice (odběratel)",
              "buildingNumber": "Číslo popisné (odběratel)",
              "city": "Město (odběratel)",
              "postalCode": "PSČ (odběratel)",
              "countryCode": "Kód země (odběratel)"
            },
            "customerAddressLabel": "Adresa odběratele",
            "deliveryAddress": "Dodací adresa",
            "bankingDetails": {
              "iban": "IBAN",
              "swift": "BIC/SWIFT",
              "bankAccount": "Číslo účtu",
              "bankCode": "Kód banky",
              "varSymb": "Variabilní symbol"
            },
            "bankingDetailsLabel": "Bankovní spojení",
            "invoiceLines": "Položky",
            "relationships": "Navázané doklady",
            "contractId": "Smlouva",
            "originalDocumentReference": "Původní doklad",
            "vatMode": "Režim DPH",
            "accountingAmount": "Účetní částka",
            "accountingAmountNoVat": "Účetní částka bez DPH",
            "accountingExchangeRate": "Účetní kurz",
            "quantity": "Množství",
            "unitPrice": "Jednotková cena",
            "unitPriceNoVat": "Jednotková cena bez DPH",
            "vatRate": "Sazba DPH",
            "netAmount": "Základ daně",
            "totalAmountLine": "Celkem za položku",
            "description_line": "Popis"
          }
        },
        "preview": {
          "noDocument": "Zdrojový dokument není k dispozici"
        },
        "scanEditor": {
          "saved": "Pole uloženo",
          "saveFailed": "Nepodařilo se uložit pole",
          "unsupportedField": "Toto pole zatím nelze upravovat ze skenového editoru"
        },
        "documentEditor": {
          "resizeHandle": "Změnit velikost panelů",
          "confidenceTooltip": {
            "title": "Přesnost vytěžení",
            "low": "< {{medium}} %",
            "medium": "{{medium}}–{{high}} %",
            "high": "> {{high}} %"
          },
          "back": {
            "extractions": "Zpět na vytěžování",
            "invoice": "Zpět na doklad"
          },
          "emptyState": "Žádné pole neodpovídá aktuálním filtrům",
          "allOk": "Hotovo! Ani jedno pole nezlobí.",
          "saveChanges": "Uložit změny",
          "saving": "Ukládám…",
          "unsavedChanges": {
            "title": "Neuložené změny",
            "message": "Máte neuložené změny. Pokud odejdete, budou ztraceny.",
            "confirm": "Odejít bez uložení",
            "cancel": "Zůstat"
          },
          "filters": {
            "problemFields": "Zobrazit problémová pole",
            "showAll": "Zobrazit všechna pole"
          }
        }
      }
    },
    "receipts": {
      "detail": {
        "typeLabel": "Typ",
        "status": {
          "paid": "Proplaceno",
          "pending": "Čeká",
          "overdue": "Po splatnosti",
          "draft": "Koncept"
        },
        "additionalDetails": {
          "isVatDocument": "Daňový doklad",
          "vatMode": "Režim DPH",
          "currency": "Měna",
          "internalNumber": "Interní číslo",
          "orderReference": "Číslo objednávky",
          "taxDate": "Datum zdanitelného plnění",
          "dueDate": "Datum splatnosti",
          "description": "Popis",
          "userNote": "Poznámka"
        },
        "accountingConversion": {
          "title": "Účetní převod",
          "rate": "Kurz",
          "withoutVat": "Bez DPH",
          "vat": "DPH",
          "total": "Celkem"
        }
      }
    },
    "notificationEvents": {
      "expand": "Upravit podle druhu dokladu",
      "collapse": "Skrýt druhy dokladů",
      "kindSwitchLabel": "{{event}} – {{kind}}",
      "events": {
        "APPROVAL_REQUESTED": {
          "title": "Doklad čeká na schválení",
          "hint": "Schvalovatel obdrží e-mail, jakmile na něj doklad čeká."
        },
        "APPROVAL_REMINDER": {
          "title": "Souhrnná připomínka schvalovateli",
          "hint": "Schvalovatel obdrží souhrnný e-mail se všemi doklady, které na něj stále čekají."
        },
        "DOCUMENT_REJECTED": {
          "title": "Zamítnutí vlastního dokladu",
          "hint": "Vlastník dokladu obdrží e-mail, jakmile je doklad zamítnut."
        },
        "DOCUMENT_APPROVED": {
          "title": "Schválení vlastního dokladu",
          "hint": "Vlastník dokladu obdrží e-mail, jakmile je doklad schválen."
        }
      }
    },
    "profile": {
      "title": "Můj účet",
      "roles": {
        "title": "Role v organizaci",
        "description": "Co je v organizaci možné dělat, určují přidělené role. Mění je administrátor."
      },
      "loading": "Načítání profilu...",
      "retry": "Zkusit znovu",
      "error": {
        "title": "Nepodařilo se načíst profil",
        "updateFailed": "Nepodařilo se aktualizovat profil. Zkuste to prosím znovu.",
        "passwordChangeFailed": "Nepodařilo se změnit heslo. Zkontrolujte prosím své současné heslo.",
        "allFieldsRequired": "Všechna pole pro heslo jsou povinná.",
        "passwordMismatch": "Nové heslo a potvrzení se neshodují.",
        "passwordTooShort": "Heslo musí mít alespoň 8 znaků.",
        "passwordRequiresUppercase": "Heslo musí obsahovat alespoň jedno velké písmeno.",
        "passwordRequiresLowercase": "Heslo musí obsahovat alespoň jedno malé písmeno.",
        "passwordRequiresNumber": "Heslo musí obsahovat alespoň jednu číslici.",
        "passwordRequiresSpecial": "Heslo musí obsahovat alespoň jeden speciální znak.",
        "currentPasswordIncorrect": "Současné heslo je nesprávné.",
        "passwordTooWeak": "Heslo je příliš slabé. Musí obsahovat velké písmeno, malé písmeno, číslici a speciální znak.",
        "emailAlreadyInUse": "Tento e-mail je již používán jiným účtem.",
        "noPasswordSet": "Nemáte nastavené heslo. Použijte obnovení hesla pro jeho nastavení.",
        "passwordMustBeDifferent": "Nové heslo musí být odlišné od současného hesla."
      },
      "success": {
        "profileUpdated": "Profil byl úspěšně aktualizován.",
        "passwordChanged": "Heslo bylo úspěšně změněno.",
        "notificationSaved": "Nastavení upozornění uloženo."
      },
      "notFound": {
        "title": "Profil nenalezen",
        "message": "Nelze načíst informace o vašem profilu."
      },
      "fields": {
        "firstName": "Jméno",
        "lastName": "Příjmení",
        "fullName": "Celé jméno",
        "email": "E-mail",
        "emailVerifiedAt": "E-mail ověřen",
        "role": "Role",
        "status": "Stav",
        "memberSince": "Členem od",
        "verified": "Ověřeno",
        "notVerified": "Neověřeno",
        "yes": "Ano",
        "no": "Ne",
        "notAvailable": "N/A",
        "active": "Aktivní",
        "inactive": "Neaktivní",
        "personalInformation": "Osobní informace"
      },
      "userStats": {
        "approvedRequests": "Schválené požadavky",
        "processedDocs": "Zpracované dokumenty",
        "averageResponseTime": "Průměrný čas odpovědi",
        "aiUsage": "AI asistence využití"
      },
      "personalInfo": {
        "title": "Osobní informace",
        "description": "Spravujte své osobní údaje a kontaktní informace"
      },
      "notificationsInfo": {
        "title": "E-mailové notifikace",
        "description": "E-maily ke schvalování dokladů. Každou událost lze vypnout celou, nebo jen pro některé druhy dokladů.",
        "reminderInterval": {
          "label": "Jak často posílat připomínky",
          "every_one": "Každý",
          "every_few": "Každé",
          "every_many": "Každých",
          "every_other": "Každých",
          "days_one": "den",
          "days_few": "dny",
          "days_many": "dní",
          "days_other": "dní",
          "invalid": "Interval musí být celé číslo od 1 do 365."
        }
      },
      "tappeerEmails": {
        "title": "E-maily od Tappeeru",
        "creditUsage": {
          "title": "Upozornění na čerpání kreditů",
          "description": "Když organizace vyčerpá 80 % a 100 % kreditů."
        },
        "creditRenewal": {
          "title": "Obnovení kreditů",
          "description": "Na začátku každého období s novými kredity."
        },
        "marketing": {
          "title": "Tipy a novinky",
          "description": "Jak z Tappeeru vytáhnout víc, souhrn měsíce a novinky.",
          "success": {
            "granted": "Tipy a novinky ti budou chodit.",
            "withdrawn": "Tipy a novinky ti už chodit nebudou."
          }
        },
        "essential": {
          "title": "Přihlášení, pozvánky, schvalování a platby",
          "description": "Bez nich Tappeer používat nejde, proto je vypnout nejde."
        }
      },
      "securityInfo": {
        "title": "Zabezpečení účtu",
        "description": "Spravujte své heslo a bezpečnostní nastavení",
        "currentPassword": "Současné heslo",
        "currentPasswordPlaceholder": "Zadejte současné heslo",
        "newPassword": "Nové heslo",
        "newPasswordPlaceholder": "Zadejte nové heslo",
        "confirmPassword": "Potvrdit heslo",
        "confirmPasswordPlaceholder": "Potvrďte nové heslo",
        "changePasswordButton": "Změnit heslo",
        "changingPassword": "Měním..."
      },
      "account": {
        "title": "Informace o účtu",
        "fields": {
          "name": "Název organizace",
          "status": "Stav účtu",
          "createdAt": "Účet vytvořen",
          "accountId": "ID účtu"
        }
      },
      "billing": {
        "title": "Předplatné",
        "description": "Spravujte svůj tarif a platební metodu."
      }
    },
    "billing": {
      "success": {
        "title": "Platba proběhla úspěšně!",
        "description": "Váš nový tarif je aktivní. Nyní máte přístup ke všem funkcím.",
        "invoiceNotice": "Faktura ti přijde emailem během pár minut. Historii najdeš v záložce Faktury.",
        "viewSubscription": "Zobrazit předplatné",
        "processingTitle": "Potvrzujeme vaši platbu…",
        "processingDescription": "Obvykle to trvá jen chvilku.",
        "pendingTitle": "Platba se zpracovává",
        "pendingDescription": "Vaši platbu jsme přijali a tarif se aktivuje během pár okamžiků. Předplatné si můžete zkontrolovat už teď."
      },
      "cancel": {
        "title": "Platba zrušena",
        "description": "Platba byla zrušena. Váš tarif zůstal beze změny.",
        "tryAgain": "Zkusit znovu",
        "backToAccount": "Přejít na můj účet"
      }
    },
    "systemSettings": {
      "documentOutput": {
        "identitySource": "Identifikace firmy se bere z Profilu firmy.",
        "sections": {
          "PURCHASE_ORDER": {
            "title": "Objednávka",
            "description": "Texty a obchodní podmínky, které se tisknou na objednávky."
          }
        },
        "locales": {
          "cs": "Čeština",
          "en": "Angličtina"
        },
        "terms": {
          "label": "Obchodní podmínky",
          "hint": "Tiskne se za položkami objednávky; delší text pokračuje na další straně.",
          "placeholder": "Například: 1. Úvodní ustanovení. Tyto všeobecné nákupní podmínky upravují vztah mezi objednatelem a dodavatelem…"
        },
        "footerNote": {
          "label": "Poznámka v zápatí",
          "hint": "Tiskne se v zápatí každé stránky za identifikací firmy.",
          "placeholder": "Například: Doklad byl vystaven elektronicky. Informace o zpracování osobních údajů najdete na www.firma.cz/gdpr."
        },
        "printsOther": {
          "cs": "Na PDF se vytiskne česká verze",
          "en": "Na PDF se vytiskne anglická verze"
        },
        "tooLong": {
          "cs": "Český text je příliš dlouhý, může mít nejvýše {{max}} znaků.",
          "en": "Anglický text je příliš dlouhý, může mít nejvýše {{max}} znaků."
        },
        "save": "Uložit",
        "saving": "Ukládám…",
        "saveSuccess": "Nastavení uloženo.",
        "saveError": "Nastavení se nepodařilo uložit.",
        "loadError": "Nastavení výstupních dokladů se nepodařilo načíst."
      },
      "comingSoon": "Již brzy",
      "automation": {
        "lifecycle": {
          "description": "Doklad projde těmito kroky. Vyberte krok a nastavte jeho automatizaci.",
          "invoice": "Faktura",
          "requisition": "Žádanka",
          "purchaseOrder": "Objednávka",
          "enabled": "Zapnuto",
          "enabledWithoutAi": "Zapnuto (bez AI)",
          "aiAndUser": "AI + uživatel",
          "userOnly": "Schvaluje uživatel",
          "skipped": "Přeskočeno",
          "disabled": "Vypnuto",
          "manual": "Ručně",
          "alwaysOn": "Vždy zapnuto",
          "byIntegration": "Dle integrace",
          "integrationSettings": "Nastavení integrací",
          "backToOverview": "Zpět na přehled automatizací",
          "readOnly": "Nastavení automatizace si můžete prohlédnout. Měnit ho může jen ten, kdo spravuje pravidla.",
          "steps": {
            "invoiceInput": "Vstup dokumentu",
            "requisitionInput": "Vytvoření žádanky",
            "purchaseOrderInput": "Vytvoření objednávky",
            "purchaseOrder": {
              "validation": {
                "title": "Validace",
                "short": "Validace",
                "description": "Kontrola úplnosti a správnosti objednávky"
              },
              "approval": {
                "title": "Automatické schválení",
                "short": "Schválení",
                "description": "AI objednávku schválí, nebo předá schvalovateli"
              },
              "closure": {
                "title": "Ukončení",
                "short": "Ukončení",
                "description": "Kdy se objednávka ukončí automaticky"
              }
            },
            "requisition": {
              "validation": {
                "title": "Validace",
                "short": "Validace",
                "description": "Kontrola úplnosti a správnosti žádanky"
              },
              "approval": {
                "title": "Automatické schválení",
                "short": "Schválení",
                "description": "AI vyhodnotí žádanku dle schvalovací politiky"
              },
              "ordering": {
                "title": "Vytvoření objednávky",
                "short": "Objednávka",
                "description": "Ze schválené žádanky vznikne rozpracovaná objednávka"
              },
              "closure": {
                "title": "Ukončení",
                "short": "Ukončení",
                "description": "Kdy se žádanka ukončí automaticky"
              }
            },
            "extraction": {
              "title": "Extrakce",
              "short": "Extrakce",
              "description": "AI vytěžení dat z dokumentu"
            },
            "autofill": {
              "title": "Dopočet chybějících polí",
              "short": "Dopočet polí",
              "description": "Doplní pole dopočitatelná z ostatních údajů",
              "note": "Dopočet chybějících polí zatím nemá vlastní nastavení."
            },
            "matching": {
              "title": "Párování položek",
              "short": "Párování",
              "description": "Párování položek faktury s položkami objednávky"
            },
            "validation": {
              "title": "Validace",
              "short": "Validace",
              "description": "Kontrola úplnosti a správnosti dat"
            },
            "approval": {
              "title": "Automatické schválení",
              "short": "Schválení",
              "description": "AI vyhodnotí fakturu dle schvalovací politiky"
            },
            "export": {
              "title": "Export",
              "short": "Export",
              "description": "Předání do účetního systému",
              "note": "Export se řídí napojeným účetním systémem. Nastavte ho v Integracích."
            },
            "closure": {
              "title": "Ukončení",
              "short": "Ukončení",
              "description": "Kdy se faktura ukončí"
            }
          }
        },
        "validation": {
          "title": "Validace faktury",
          "description": "Validace se spouští automaticky po každé změně faktury a její výsledek určuje stav dokladu.",
          "loadError": "Nastavení validace se nepodařilo načíst.",
          "standard": {
            "title": "Běžné validace",
            "badge": "vždy aktivní",
            "description": "Úplnost a správnost údajů podle validačních pravidel — zákonné náležitosti, povinná pole, formát identifikátorů, výpočty částek, duplicity",
            "linkedSupplier": {
              "title": "Vyžadovat dodavatele z číselníku firem",
              "description": "Přijatou fakturu nepůjde odeslat ke schválení, dokud její dodavatel nebude propojen s firmou z číselníku."
            }
          },
          "paymentSecurity": {
            "title": "Kontrola bezpečnosti platby",
            "description": "Kontrola solventnosti a platebního spojení dodavatele",
            "unreliablePayer": {
              "title": "Označit nespolehlivého plátce",
              "description": "Vypíše varování, pokud je dodavatel nespolehlivým plátcem"
            },
            "bankAccount": {
              "title": "Kontrola bankovního účtu dodavatele",
              "label": "Způsob kontroly",
              "options": {
                "USED_OR_PUBLISHED": {
                  "label": "Účet byl použit, nebo je zveřejněný",
                  "description": "Vypíše varování, pokud účet není na žádné schválené faktuře dodavatele ani mezi zveřejněnými účty"
                },
                "PUBLISHED_ONLY": {
                  "label": "Účet musí být zveřejněný",
                  "description": "Vypíše varování, pokud účet není mezi zveřejněnými účty dodavatele"
                },
                "USED_ONLY": {
                  "label": "Účet je na schválené faktuře od dodavatele",
                  "description": "Vypíše varování, pokud účet není na žádné schválené faktuře dodavatele"
                },
                "VERIFIED_ONLY": {
                  "label": "Účet je ověřený dvěma podpisy",
                  "description": "Vypíše varování, pokud účet na faktuře není mezi účty dodavatele ověřenými dvěma podpisy"
                }
              },
              "foreignNotice": "Zveřejněné účty lze dohledat pouze u dodavatelů z ČR a SR. U ostatních dodavatelů se ověřuje pouze použití téhož účtu na některé z již schválených faktur."
            }
          },
          "ai": {
            "title": "AI validace",
            "description": "AI posoudí věcnou správnost faktury podle zadání níže a zjištěné nálezy doplní do výsledku validace. Zadání formulujte v přehledných bodech.",
            "prompt": {
              "label": "Zadání pro AI validaci"
            }
          },
          "save": "Uložit",
          "saving": "Ukládám…",
          "saveSuccess": "Zadání pro AI validaci bylo uloženo.",
          "saveError": "Nastavení se nepodařilo uložit.",
          "resetConfirm": {
            "title": "Obnovit výchozí zadání?",
            "message": "Současné zadání pro AI validaci bude přepsáno výchozím. Tuto akci nelze vzít zpět.",
            "confirm": "Obnovit výchozí zadání",
            "cancel": "Zrušit"
          },
          "reset": "Obnovit výchozí zadání",
          "resetting": "Obnovuji…",
          "resetSuccess": "Výchozí zadání bylo obnoveno.",
          "resetError": "Výchozí zadání se nepodařilo obnovit.",
          "preview": {
            "title": "Vyzkoušet na faktuře",
            "description": "Spusťte AI validaci nanečisto — uvidíte nálezy, které by přidala k výsledku validace. Faktura se nezmění.",
            "resultTitle": "Výsledek zkušebního běhu",
            "close": "Zavřít výsledek",
            "unsavedChanges": "Před vyzkoušením uložte změny nastavení.",
            "running": "Vyhodnocuji…",
            "error": "Vyhodnocení se nepodařilo dokončit. Zkuste to prosím znovu.",
            "noFindings": "Bez nálezů",
            "findingsCount": "Nálezy: {{count}}",
            "confidence": "Jistota: {{value}} %",
            "severityError": "Chyba",
            "severityWarning": "Varování"
          }
        },
        "extraction": {
          "title": "Extrakce dat z dokladu",
          "description": "První krok zpracování. AI přečte doklad a vytěží z něj údaje.",
          "loadError": "Nastavení extrakce se nepodařilo načíst.",
          "saveError": "Nastavení extrakce se nepodařilo uložit.",
          "autoExtract": {
            "label": "Automatické vytěžení",
            "description": "Zapnuto: každý příchozí doklad se vytěží hned po nahrání nebo doručení e-mailem. Ručně: doklad počká na detailu, dokud vytěžení nespustíte — do té doby nečerpá kredity.",
            "on": "Zapnuto",
            "off": "Ručně"
          }
        },
        "autofill": {
          "title": "Dopočet chybějících polí faktury",
          "description": "Proces se spouští po vytěžení dokumentu. Pole, která na skenu chybí, nebo nebyla vytěžena, a lze je s naprostou jistotou dopočítat z ostatních údajů, doplní automaticky.",
          "loadError": "Nastavení automatického doplňování se nepodařilo načíst.",
          "lineAmounts": {
            "label": "Ceny položek",
            "description": "Doplní chybějící celkové částky položky — Celkem bez DPH, Celkem s DPH a Částka DPH — pokud je lze dopočítat z ostatních hodnot položky (např. z množství a jednotkové ceny)."
          },
          "enabled": {
            "on": "Zapnuto",
            "off": "Vypnuto"
          },
          "accountingTotals": {
            "label": "Celkové částky v účetní měně",
            "description": "Dopočte celkové částky v účetní měně organizace dle zvoleného kurzu."
          },
          "rateSource": {
            "label": "Kurz pro přepočet",
            "options": {
              "INVOICE_ONLY": {
                "label": "Pouze kurz uvedený na faktuře",
                "description": "Přepočet proběhne jen tehdy, když je na faktuře uveden kurz. Bez kurzu se částky nedoplní."
              },
              "INVOICE_THEN_EXTERNAL": {
                "label": "Kurz z faktury, jinak ČNB/ECB",
                "description": "Přednost má kurz uvedený na faktuře. Pokud chybí, použije se oficiální kurz ČNB (pro CZK) nebo ECB k datu zdanitelného plnění, případně k datu vystavení."
              },
              "EXTERNAL_ALWAYS": {
                "label": "Vždy aktuální kurz ČNB/ECB",
                "description": "Vždy se použije oficiální kurz ČNB (pro CZK) nebo ECB k datu zdanitelného plnění, případně k datu vystavení. Kurz uvedený na faktuře bude při dopočtu přepsán."
              }
            }
          },
          "saveError": "Nastavení se nepodařilo uložit."
        },
        "invoiceClosure": {
          "title": "Ukončení faktury",
          "description": "Faktura je ukončena ve chvíli, kdy jsou splněny všechny aktivní podmínky. Pokud nejsou určeny žádné podmínky ukončení, lze fakturu ukončit pouze ručně.",
          "loadError": "Nastavení se nepodařilo načíst.",
          "saveError": "Nastavení se nepodařilo uložit.",
          "approval": {
            "label": "Faktura musí být schválena"
          },
          "payment": {
            "label": "Faktura musí být proplacena"
          },
          "posting": {
            "label": "Faktura musí být zaúčtována",
            "noAccountingSystem": "Pro získání informace o zaúčtování musí být připojen účetní systém."
          },
          "archiving": {
            "title": "Archivace po ukončení",
            "description": "Ukončená faktura se po zvoleném počtu dní archivuje. Archivovaná faktura už nemění svůj stav a nejde upravit. Archivaci lze ručně zrušit.",
            "days": {
              "label": "Počet dní od ukončení",
              "hint": "Při 0 se faktura archivuje hned při ukončení.",
              "invalid": "Počet dní musí být celé číslo od 0 do {{max}}.",
              "unit": "dní"
            }
          },
          "summary": {
            "approved": "Schváleno",
            "paid": "proplaceno",
            "paidOnly": "Proplaceno",
            "manual": "Jen ručně",
            "posted": "zaúčtováno",
            "postedOnly": "Zaúčtováno"
          }
        },
        "requisitionApproval": {
          "title": "Schvalování žádanek",
          "loadError": "Nastavení schvalování se nepodařilo načíst.",
          "enabled": {
            "on": "Zapnuto",
            "off": "Vypnuto"
          },
          "orgStructureWarning": {
            "title": "Organizační struktura není úplná",
            "message": "Pro správnou funkci schvalování je třeba mít nakonfigurovanou organizační strukturu. Bez zařazení uživatele na pozici org. struktury nelze určit jeho nadřízené.",
            "usersLabel": "Schvalovatelé bez přiřazené pozice:"
          },
          "prompt": {
            "label": "Schvalovací politika"
          },
          "save": "Uložit",
          "saving": "Ukládám…",
          "saveSuccess": "Schvalovací politika byla uložena.",
          "saveError": "Nastavení se nepodařilo uložit.",
          "resetConfirm": {
            "title": "Obnovit výchozí politiku?",
            "message": "Schvalovací politika a přepínač se vrátí na výchozí hodnoty. Postup hledání schvalovatele zůstane zachován.",
            "confirm": "Obnovit výchozí politiku",
            "cancel": "Zrušit"
          },
          "reset": "Obnovit výchozí politiku",
          "resetting": "Obnovuji…",
          "resetSuccess": "Výchozí politika byla obnovena.",
          "resetError": "Výchozí politiku se nepodařilo obnovit.",
          "preview": {
            "title": "Vyzkoušet na žádance",
            "description": "Zkušební vyhodnocení podle schvalovací politiky bez uplatnění hranice jistoty; stav žádanky se nezmění.",
            "resultTitle": "Výsledek zkušebního běhu",
            "close": "Zavřít výsledek",
            "unsavedChanges": "Před vyzkoušením uložte změny nastavení.",
            "running": "Vyhodnocuji…",
            "error": "Vyhodnocení se nepodařilo dokončit. Zkuste to prosím znovu.",
            "confidence": "Jistota rozhodnutí: {{value}} %",
            "wouldSet": "Automatický běh by žádanku převedl do stavu „{{status}}“.",
            "proposedApprover": "Navržený schvalovatel: {{name}}",
            "unknownApprover": "neznámý uživatel",
            "noSuitableCandidate": "Politika neurčila schvalovatele; rozhodne zvolený postup hledání schvalovatele."
          },
          "fallback": {
            "strategyLabel": "Postup",
            "userLabel": "Uživatel",
            "orgUnitLabel": "Pozice org. struktury",
            "roleLabel": "Role",
            "userPlaceholder": "Vyberte uživatele",
            "orgUnitPlaceholder": "Vyberte pozici org. struktury",
            "orgStructureLink": "Nastavení org. struktury",
            "rolePlaceholder": "Vyberte roli",
            "missingChoice": {
              "USER": "Zvolený postup vyžaduje výběr uživatele.",
              "ORG_UNIT": "Zvolený postup vyžaduje výběr pozice org. struktury.",
              "ROLE": "Zvolený postup vyžaduje výběr role."
            },
            "issue": {
              "USER_CANNOT_APPROVE": "Zvolený uživatel nemá oprávnění schvalovat doklady",
              "UNIT_HAS_NO_APPROVER": "Na zvolené pozici org. struktury není nikdo s oprávněním schvalovat doklady",
              "ROLE_HAS_NO_APPROVER": "Zvolenou roli nemá nikdo s oprávněním schvalovat doklady",
              "body": "Nastavení nelze uložit. Oprávnění ke schvalování se přiděluje rolí uživatele.",
              "usersLink": "Nastavení uživatelů"
            },
            "strategies": {
              "MANUAL_APPROVER_SELECTION": "Schvalovatel se neurčuje automaticky. Zvolí ho uživatel přímo na dokladu.",
              "ANYONE_WITH_PERMISSION": "Doklad je předán všem uživatelům s oprávněním ke schválení; ke schválení stačí jeden z nich.",
              "ORG_STRUCTURE_THEN_FALLBACK_USER_THEN_ANYONE_WITH_PERMISSION": "Schvalovatel se hledá mezi vedoucím pozice org. struktury žadatele a vedoucími nadřízených pozic.",
              "FALLBACK_USER_THEN_ANYONE_WITH_PERMISSION": "Doklad je předán zvolenému uživateli.",
              "ORG_UNIT_MANAGER_THEN_ANYONE_WITH_PERMISSION": "Schvalovatel se hledá mezi vedoucím zvolené pozice org. struktury a vedoucími nadřízených pozic.",
              "ORG_UNIT_MEMBER_THEN_ANYONE_WITH_PERMISSION": "Doklad je předán všem členům zvolené pozice org. struktury; ke schválení stačí jeden z nich.",
              "DOCUMENT_UNIT_MANAGER_THEN_ANYONE_WITH_PERMISSION": "Schvalovatel se hledá mezi vedoucím pozice org. struktury uvedené na dokladu a vedoucími nadřízených pozic. Není-li pozice org. struktury na dokladu vyplněna, tento krok se přeskočí.",
              "ROLE_MEMBER_THEN_ANYONE_WITH_PERMISSION": "Doklad je předán všem uživatelům se zvolenou rolí; ke schválení stačí jeden z nich.",
              "SUGGESTED_APPROVER_THEN_ANYONE_WITH_PERMISSION": "Doklad je předán schvalovateli, který je na něm navržen; pole „Navržený schvalovatel“ je při tomto postupu na dokladu povinné."
            }
          },
          "flow": {
            "master": "Schvalovat žádanky",
            "aiStep": "AI posoudí žádanku podle politiky",
            "branchNotMet": "nesplní → AI určí schvalovatele, pokud politika říká, komu žádanku předat; jinak pokračuje krok 2",
            "chainLeadAi": "Když AI žádanku neschválí ani nikomu nepředá, předá se",
            "chainLeadUser": "Žádanka se předá",
            "recipientNone": "žádanka bez schvalovatele",
            "end": "Schválená žádanka pokračuje k objednání",
            "selfApproval": {
              "label": "Kdo žádanku odeslal ke schválení, nemůže být jejím schvalovatelem",
              "hint": "Platí pro všechny kroky výše. Uživatel, který žádanku odeslal, se nestane jejím schvalovatelem, ani když ho určí AI, postup nebo je záložním uživatelem."
            }
          }
        },
        "purchaseOrderApproval": {
          "title": "Schvalování objednávek",
          "loadError": "Nastavení schvalování se nepodařilo načíst.",
          "enabled": {
            "on": "Zapnuto",
            "off": "Vypnuto"
          },
          "orgStructureWarning": {
            "title": "Organizační struktura není úplná",
            "message": "Pro správnou funkci schvalování je třeba mít nakonfigurovanou organizační strukturu. Bez zařazení uživatele na pozici org. struktury nelze určit jeho nadřízené.",
            "usersLabel": "Schvalovatelé bez přiřazené pozice:"
          },
          "prompt": {
            "label": "Schvalovací politika"
          },
          "save": "Uložit",
          "saving": "Ukládám…",
          "saveSuccess": "Schvalovací politika byla uložena.",
          "saveError": "Nastavení se nepodařilo uložit.",
          "resetConfirm": {
            "title": "Obnovit výchozí politiku?",
            "message": "Schvalovací politika a přepínač se vrátí na výchozí hodnoty. Postup hledání schvalovatele zůstane zachován.",
            "confirm": "Obnovit výchozí politiku",
            "cancel": "Zrušit"
          },
          "reset": "Obnovit výchozí politiku",
          "resetting": "Obnovuji…",
          "resetSuccess": "Výchozí politika byla obnovena.",
          "resetError": "Výchozí politiku se nepodařilo obnovit.",
          "preview": {
            "title": "Vyzkoušet na objednávce",
            "description": "Zkušební vyhodnocení podle schvalovací politiky bez uplatnění hranice jistoty; stav objednávky se nezmění.",
            "resultTitle": "Výsledek zkušebního běhu",
            "close": "Zavřít výsledek",
            "unsavedChanges": "Před vyzkoušením uložte změny nastavení.",
            "running": "Vyhodnocuji…",
            "error": "Vyhodnocení se nepodařilo dokončit. Zkuste to prosím znovu.",
            "confidence": "Jistota rozhodnutí: {{value}} %",
            "wouldSet": "Automatický běh by objednávku převedl do stavu „{{status}}“.",
            "proposedApprover": "Navržený schvalovatel: {{name}}",
            "unknownApprover": "neznámý uživatel",
            "noSuitableCandidate": "Politika neurčila schvalovatele; rozhodne zvolený postup hledání schvalovatele."
          },
          "fallback": {
            "strategyLabel": "Postup",
            "userLabel": "Uživatel",
            "orgUnitLabel": "Pozice org. struktury",
            "roleLabel": "Role",
            "userPlaceholder": "Vyberte uživatele",
            "orgUnitPlaceholder": "Vyberte pozici org. struktury",
            "orgStructureLink": "Nastavení org. struktury",
            "rolePlaceholder": "Vyberte roli",
            "missingChoice": {
              "USER": "Zvolený postup vyžaduje výběr uživatele.",
              "ORG_UNIT": "Zvolený postup vyžaduje výběr pozice org. struktury.",
              "ROLE": "Zvolený postup vyžaduje výběr role."
            },
            "issue": {
              "USER_CANNOT_APPROVE": "Zvolený uživatel nemá oprávnění schvalovat doklady",
              "UNIT_HAS_NO_APPROVER": "Na zvolené pozici org. struktury není nikdo s oprávněním schvalovat doklady",
              "ROLE_HAS_NO_APPROVER": "Zvolenou roli nemá nikdo s oprávněním schvalovat doklady",
              "body": "Nastavení nelze uložit. Oprávnění ke schvalování se přiděluje rolí uživatele.",
              "usersLink": "Nastavení uživatelů"
            },
            "strategies": {
              "MANUAL_APPROVER_SELECTION": "Schvalovatel se neurčuje automaticky. Zvolí ho uživatel přímo na dokladu.",
              "ANYONE_WITH_PERMISSION": "Doklad je předán všem uživatelům s oprávněním ke schválení; ke schválení stačí jeden z nich.",
              "ORG_STRUCTURE_THEN_FALLBACK_USER_THEN_ANYONE_WITH_PERMISSION": "Schvalovatel se hledá mezi vedoucím pozice org. struktury žadatele a vedoucími nadřízených pozic.",
              "FALLBACK_USER_THEN_ANYONE_WITH_PERMISSION": "Doklad je předán zvolenému uživateli.",
              "ORG_UNIT_MANAGER_THEN_ANYONE_WITH_PERMISSION": "Schvalovatel se hledá mezi vedoucím zvolené pozice org. struktury a vedoucími nadřízených pozic.",
              "ORG_UNIT_MEMBER_THEN_ANYONE_WITH_PERMISSION": "Doklad je předán všem členům zvolené pozice org. struktury; ke schválení stačí jeden z nich.",
              "DOCUMENT_UNIT_MANAGER_THEN_ANYONE_WITH_PERMISSION": "Schvalovatel se hledá mezi vedoucím pozice org. struktury uvedené na dokladu a vedoucími nadřízených pozic. Není-li pozice org. struktury na dokladu vyplněna, tento krok se přeskočí.",
              "ROLE_MEMBER_THEN_ANYONE_WITH_PERMISSION": "Doklad je předán všem uživatelům se zvolenou rolí; ke schválení stačí jeden z nich.",
              "SUGGESTED_APPROVER_THEN_ANYONE_WITH_PERMISSION": "Doklad je předán schvalovateli, který je na něm navržen; pole „Navržený schvalovatel“ je při tomto postupu na dokladu povinné."
            }
          },
          "flow": {
            "master": "Schvalovat objednávky",
            "aiStep": "AI posoudí objednávku podle politiky",
            "branchNotMet": "nesplní → AI určí schvalovatele, pokud politika říká, komu objednávku předat; jinak pokračuje krok 2",
            "chainLeadAi": "Když AI objednávku neschválí ani nikomu nepředá, předá se",
            "chainLeadUser": "Objednávka se předá",
            "recipientNone": "objednávka bez schvalovatele",
            "end": "Schválená objednávka pokračuje k dokončení",
            "selfApproval": {
              "label": "Kdo objednávku odeslal ke schválení, nemůže být jejím schvalovatelem",
              "hint": "Platí pro všechny kroky výše. Uživatel, který objednávku odeslal, se nestane jejím schvalovatelem, ani když ho určí AI, postup nebo je záložním uživatelem."
            }
          }
        },
        "purchaseOrderValidation": {
          "title": "Validace objednávky",
          "description": "Validace běží po každé změně objednávky. Ke schválení lze odeslat jen objednávku bez chyb; varování musí uživatel přijmout.",
          "standard": {
            "title": "Běžné validace",
            "badge": "vždy aktivní",
            "description": "Úplnost a správnost údajů podle validačních pravidel. Nemá vlastní nastavení."
          }
        },
        "purchaseOrderPicker": {
          "searchPlaceholder": "Hledat objednávku podle čísla, názvu nebo dodavatele…",
          "noResults": "Žádné objednávky nenalezeny."
        },
        "requisitionValidation": {
          "title": "Validace žádanky",
          "description": "Validace se spouští automaticky po každé změně žádanky. Odeslat ke schválení lze jen žádanku bez chyb a varování.",
          "standard": {
            "title": "Běžné validace",
            "badge": "vždy aktivní",
            "description": "Úplnost a správnost údajů podle validačních pravidel — číslo žádanky, alespoň jedna položka, popis a množství položek. Nemá vlastní nastavení."
          }
        },
        "requisitionPicker": {
          "searchPlaceholder": "Hledat žádanku podle čísla, názvu nebo dodavatele…",
          "noResults": "Žádné žádanky nenalezeny."
        },
        "purchaseOrderClosure": {
          "title": "Ukončení objednávky",
          "description": "Objednávka je ukončena ve chvíli, kdy jsou splněny všechny aktivní podmínky. Ukončení není samostatný stav — objednávka si ponechá svůj stav a navíc se označí jako ukončená. Ručně ukončenou objednávku automatika znovu neotevře.",
          "loadError": "Nastavení se nepodařilo načíst.",
          "saveError": "Nastavení se nepodařilo uložit.",
          "baseStatus": {
            "APPROVED": "Objednávka musí být schválena",
            "DISPATCHED": "Objednávka musí být odeslána dodavateli"
          },
          "delivery": {
            "label": "Objednávka musí být dodána",
            "description": "Všechny položky jsou dodané. Služby se nedodávají, za dodané se považují po vyfakturování."
          },
          "invoicing": {
            "label": "Objednávka musí být vyfakturována",
            "description": "Všechny položky jsou vyfakturované."
          },
          "archiving": {
            "title": "Archivace po ukončení",
            "description": "Ukončený doklad se po zvoleném počtu dní archivuje. Archivovaný doklad už nemění svůj stav a nejde upravit. Archivaci lze ručně zrušit.",
            "days": {
              "label": "Počet dní od ukončení",
              "hint": "Při 0 se doklad archivuje hned při ukončení.",
              "invalid": "Počet dní musí být celé číslo od 0 do {{max}}.",
              "unit": "dní"
            }
          },
          "summary": {
            "APPROVED": "Schváleno",
            "DISPATCHED": "Odesláno",
            "delivered": "dodáno",
            "invoiced": "vyfakturováno"
          }
        },
        "requisitionClosure": {
          "title": "Ukončení žádanky",
          "description": "Žádanka je ukončena ve chvíli, kdy jsou splněny všechny aktivní podmínky. Ukončení není samostatný stav — žádanka si ponechá svůj stav a navíc se označí jako ukončená. Ručně ukončenou žádanku automatika znovu neotevře.",
          "loadError": "Nastavení se nepodařilo načíst.",
          "saveError": "Nastavení se nepodařilo uložit.",
          "baseStatus": {
            "APPROVED": "Žádanka musí být schválena",
            "ORDERED": "Žádanka musí být objednána"
          },
          "delivery": {
            "label": "Žádanka musí být dodána",
            "description": "Všechny objednané položky jsou dodané. Služby se nedodávají, za dodané se považují po vyfakturování."
          },
          "invoicing": {
            "label": "Žádanka musí být vyfakturována",
            "description": "Všechny objednané položky jsou vyfakturované."
          },
          "archiving": {
            "title": "Archivace po ukončení",
            "description": "Ukončený doklad se po zvoleném počtu dní archivuje. Archivovaný doklad už nemění svůj stav a nejde upravit. Archivaci lze ručně zrušit.",
            "days": {
              "label": "Počet dní od ukončení",
              "hint": "Při 0 se doklad archivuje hned při ukončení.",
              "invalid": "Počet dní musí být celé číslo od 0 do {{max}}.",
              "unit": "dní"
            }
          },
          "summary": {
            "APPROVED": "Schváleno",
            "ORDERED": "Objednáno",
            "delivered": "dodáno",
            "invoiced": "vyfakturováno"
          }
        },
        "requisitionOrdering": {
          "title": "Vytvoření objednávky ze žádanky",
          "description": "Po schválení žádanky vznikne rozpracovaná objednávka. Dodavatel se převezme ze žádanky, pokud je navržený; jinak jej doplní nakupující na objednávce.",
          "loadError": "Nastavení se nepodařilo načíst.",
          "autoOrder": {
            "label": "Automaticky vytvářet objednávky ze schválené žádanky",
            "description": "Objednávka zůstane rozpracovaná; odesílá ji nakupující."
          },
          "saveError": "Nastavení se nepodařilo uložit."
        },
        "matching": {
          "title": "Párování položek",
          "description": "Položky faktury se automaticky párují s položkami objednávky podle kódu, EAN nebo popisu, a to při každém uložení faktury a po příjemce. Jednoznačné spárování se potvrdí samo, sporné čeká na rozhodnutí.",
          "ai": {
            "title": "AI párování",
            "description": "Dokončení párování pomocí AI"
          },
          "loadError": "Nastavení automatizace se nepodařilo načíst.",
          "enabled": {
            "on": "Zapnuto",
            "off": "Vypnuto"
          },
          "tools": {
            "title": "Co má AI k dispozici",
            "description": "AI si při posouzení sama obstará tato data:"
          },
          "saveError": "Nastavení se nepodařilo uložit."
        },
        "title": "Schvalování faktur",
        "loadError": "Nastavení automatizace se nepodařilo načíst.",
        "enabled": {
          "on": "Zapnuto",
          "off": "Vypnuto"
        },
        "prompt": {
          "label": "Schvalovací politika",
          "description": "Pravidla, podle kterých AI rozhoduje. Pište je jako srozumitelné odrážky — např. limity částek nebo požadavky na dodavatele."
        },
        "save": "Uložit",
        "saving": "Ukládám…",
        "saveSuccess": "Schvalovací politika byla uložena.",
        "saveError": "Nastavení se nepodařilo uložit.",
        "resetConfirm": {
          "title": "Obnovit výchozí nastavení?",
          "message": "Současná schvalovací politika a stav přepínače budou přepsány výchozím nastavením. Tuto akci nelze vzít zpět.",
          "confirm": "Obnovit výchozí nastavení",
          "cancel": "Zrušit"
        },
        "reset": "Obnovit výchozí politiku",
        "resetting": "Obnovuji…",
        "resetSuccess": "Výchozí nastavení bylo obnoveno.",
        "resetError": "Výchozí nastavení se nepodařilo obnovit.",
        "help": {
          "title": "Nápověda",
          "open": "Nápověda",
          "decisionTitle": "Jak automatizace rozhoduje",
          "toolsTitle": "Co má AI k dispozici ({{count}})",
          "toolsDescription": "AI si při vyhodnocení sama obstará tato data:",
          "writingRulesTitle": "Co má politika obsahovat",
          "writingInstructionsTitle": "Co má zadání obsahovat",
          "examplesTitle": "Příklady",
          "demonstrates": "Co ukazuje:",
          "loadError": "Nápovědu se nepodařilo načíst.",
          "close": "Zavřít"
        },
        "invoicePicker": {
          "searchPlaceholder": "Hledat fakturu podle čísla nebo dodavatele…",
          "noResults": "Žádné faktury nenalezeny."
        },
        "preview": {
          "title": "Vyzkoušet na faktuře",
          "description": "Spusťte vyhodnocení nanečisto — uvidíte, jak by AI rozhodla. Stav faktury se nezmění.",
          "resultTitle": "Výsledek zkušebního běhu",
          "close": "Zavřít výsledek",
          "unsavedChanges": "Před vyzkoušením uložte změny nastavení.",
          "running": "Vyhodnocuji…",
          "error": "Vyhodnocení se nepodařilo dokončit. Zkuste to prosím znovu.",
          "confidence": "Jistota rozhodnutí: {{value}} %",
          "wouldSet": "Automatický běh by fakturu převedl do stavu „{{status}}“.",
          "proposedApprover": "Schvalovatelem by byl zvolen {{name}}.",
          "unknownApprover": "neznámý uživatel",
          "anyApprover": "Schvalovateli by byli všichni uživatelé s oprávněním ke schválení.",
          "noSuitableCandidate": "Schvalovatele by určil postup nastavený níže."
        },
        "fallback": {
          "strategyLabel": "Postup",
          "userLabel": "Uživatel",
          "userPlaceholder": "Vyberte uživatele",
          "orgUnitLabel": "Pozice org. struktury",
          "orgUnitPlaceholder": "Vyberte pozici org. struktury",
          "orgStructureLink": "Nastavení org. struktury",
          "roleLabel": "Role",
          "rolePlaceholder": "Vyberte roli",
          "issue": {
            "USER_CANNOT_APPROVE": "Zvolený uživatel nemá oprávnění schvalovat doklady",
            "UNIT_HAS_NO_APPROVER": "Na zvolené pozici org. struktury není nikdo s oprávněním schvalovat doklady",
            "ROLE_HAS_NO_APPROVER": "Zvolenou roli nemá nikdo s oprávněním schvalovat doklady",
            "body": "Nastavení nelze uložit. Oprávnění ke schvalování se přiděluje rolí uživatele.",
            "usersLink": "Nastavení uživatelů"
          },
          "missingChoice": {
            "USER": "Zvolený postup vyžaduje výběr uživatele.",
            "ORG_UNIT": "Zvolený postup vyžaduje výběr pozice org. struktury.",
            "ROLE": "Zvolený postup vyžaduje výběr role."
          },
          "strategies": {
            "MANUAL_APPROVER_SELECTION": "Schvalovatel se neurčuje automaticky. Zvolí ho uživatel přímo na dokladu.",
            "ANYONE_WITH_PERMISSION": "Doklad je předán všem uživatelům s oprávněním ke schválení; ke schválení stačí jeden z nich.",
            "ORG_STRUCTURE_THEN_FALLBACK_USER_THEN_ANYONE_WITH_PERMISSION": "Schvalovatel se hledá mezi vedoucím pozice org. struktury žadatele a vedoucími nadřízených pozic.",
            "FALLBACK_USER_THEN_ANYONE_WITH_PERMISSION": "Doklad je předán zvolenému uživateli.",
            "ORG_UNIT_MANAGER_THEN_ANYONE_WITH_PERMISSION": "Schvalovatel se hledá mezi vedoucím zvolené pozice org. struktury a vedoucími nadřízených pozic.",
            "ORG_UNIT_MEMBER_THEN_ANYONE_WITH_PERMISSION": "Doklad je předán všem členům zvolené pozice org. struktury; ke schválení stačí jeden z nich.",
            "ROLE_MEMBER_THEN_ANYONE_WITH_PERMISSION": "Doklad je předán všem uživatelům se zvolenou rolí; ke schválení stačí jeden z nich."
          }
        },
        "flow": {
          "master": "Schvalovat faktury",
          "aiStep": "AI posoudí fakturu podle politiky",
          "branchNotMet": "nesplní → AI určí schvalovatele, pokud politika říká, komu fakturu předat; jinak pokračuje krok 2",
          "chainLeadAi": "Když AI fakturu neschválí ani nikomu nepředá, předá se",
          "chainLeadUser": "Faktura se předá",
          "recipientNone": "faktura bez schvalovatele",
          "end": "Schválená faktura pokračuje k exportu",
          "selfApproval": {
            "label": "Kdo fakturu odeslal ke schválení, nemůže být jejím schvalovatelem",
            "hint": "Platí pro všechny kroky výše. Uživatel, který fakturu odeslal, se nestane jejím schvalovatelem, ani když ho určí AI, postup nebo je záložním uživatelem."
          }
        },
        "approvalFlow": {
          "edit": "Upravit",
          "show": "Zobrazit",
          "candidatesLoadError": "Nepodařilo se načíst, kdo smí schvalovat. Postup schválení teď nelze měnit. Zkuste stránku načíst znovu.",
          "skipped": "Proces schvalování je přeskočen. Doklad se schválí ihned a pokračuje do následujícího <link>kroku</link>.",
          "branchMet": "splní politiku → <b>schváleno</b>",
          "fallbackLead": {
            "USER": "Když ani tam není schvalovatel nalezen, předá se",
            "OWNER_PICKS": "Když ani tam není schvalovatel nalezen,",
            "NONE": "Když ani tam není schvalovatel nalezen, zůstane"
          },
          "recipientChip": {
            "USER": "uživateli {{name}}",
            "OWNER_PICKS": "schvalovatele zvolí zakladatel"
          },
          "recipient": {
            "label": "Kdo doklad dostane",
            "userDescription": "Záložní uživatel",
            "OWNER_PICKS": "Schvalovatele zvolí zakladatel",
            "NONE": "Doklad bez schvalovatele",
            "fixedDescription": "Bez záložního uživatele"
          },
          "strategyChip": {
            "MANUAL_APPROVER_SELECTION": "schvalovateli, kterého zvolí zakladatel",
            "ANYONE_WITH_PERMISSION": "všem uživatelům s oprávněním schvalovat",
            "ORG_STRUCTURE_THEN_FALLBACK_USER_THEN_ANYONE_WITH_PERMISSION": "vedoucímu pozice žadatele",
            "ORG_STRUCTURE_THEN_FALLBACK_USER_THEN_ANYONE_WITH_PERMISSION_invoice": "vedoucímu pozice zakladatele",
            "DOCUMENT_UNIT_MANAGER_THEN_ANYONE_WITH_PERMISSION": "vedoucímu pozice uvedené na dokladu",
            "ORG_UNIT_MANAGER_THEN_ANYONE_WITH_PERMISSION": "vedoucímu pozice {{orgUnit}}",
            "ORG_UNIT_MEMBER_THEN_ANYONE_WITH_PERMISSION": "členům pozice {{orgUnit}}",
            "ROLE_MEMBER_THEN_ANYONE_WITH_PERMISSION": "uživatelům s rolí {{role}}",
            "FALLBACK_USER_THEN_ANYONE_WITH_PERMISSION": "uživateli {{user}}",
            "SUGGESTED_APPROVER_THEN_ANYONE_WITH_PERMISSION": "schvalovateli navrženému na dokladu"
          },
          "strategyChipUnpicked": {
            "ORG_UNIT_MANAGER_THEN_ANYONE_WITH_PERMISSION": "vedoucímu zvolené pozice",
            "ORG_UNIT_MEMBER_THEN_ANYONE_WITH_PERMISSION": "členům zvolené pozice",
            "ROLE_MEMBER_THEN_ANYONE_WITH_PERMISSION": "uživatelům se zvolenou rolí",
            "FALLBACK_USER_THEN_ANYONE_WITH_PERMISSION": "zvolenému uživateli"
          }
        }
      },
      "payments": {
        "hero": {
          "myPlan": "Můj plán",
          "myPlanLimit": "{{count}} dokumentů/měsíc",
          "myPlanCredits_one": "{{credits}} kredit/měsíc",
          "myPlanCredits_few": "{{credits}} kredity/měsíc",
          "myPlanCredits_many": "{{credits}} kreditu/měsíc",
          "myPlanCredits_other": "{{credits}} kreditů/měsíc",
          "billing": "Fakturace",
          "billingMonthly": "{{amount}} {{currency}} měsíčně",
          "billingFree": "Zdarma",
          "credits": "Vytěžené dokumenty",
          "creditsUsage": "{{used}} / {{limit}} dokumentů použito ({{pct}} %)",
          "creditsUnlimited": "Neomezeně",
          "overageProgress": "+ {{used}} / {{capacity}} navíc",
          "overageAriaLabel": "Využití překročení limitu",
          "overageCost": "Doplatek {{cost}} {{currency}}"
        },
        "quotaSection": "Vytěžené dokumenty",
        "quota": {
          "label": "Vytěžené dokumenty v tomto fakturačním cyklu",
          "resetsOn": "Obnovuje se {{date}}",
          "progressAriaLabel": "Využití kvóty: {{label}}",
          "excessCount": "Překročení limitu: {{count}} dokumentů",
          "currentPlan": "Aktuální plán: {{name}} ({{amount}} {{currency}} / měsíc)",
          "limitReached": "Měsíční limit vyčerpán",
          "overageNotification": {
            "title": "Překročen měsíční limit",
            "message": "Překročili jste měsíční limit. Tento měsíc vám bude fakturováno za {{count}} dokumentů navíc.",
            "messageWithRemaining": "Překročili jste měsíční limit. Fakturováno vám bude {{count}} dokumentů navíc. Ještě lze zpracovat {{remaining}} dokumentů do stropu."
          }
        },
        "allPlans": {
          "title": "Dostupné plány",
          "description": "Vyberte plán, který vyhovuje vašim potřebám.",
          "monthly": "Měsíčně",
          "yearly": "Ročně"
        },
        "planCard": {
          "currentPlan": "Aktuální plán",
          "documentsPerMonth": "dokumentů/měsíc",
          "creditsPerMonth_one": "kredit/měsíc",
          "creditsPerMonth_few": "kredity/měsíc",
          "creditsPerMonth_many": "kreditu/měsíc",
          "creditsPerMonth_other": "kreditů/měsíc",
          "overageAllowed": "Povoleno překročení limitu",
          "perMonth": "/měsíc",
          "perYear": "/rok",
          "selectPlan": "Vybrat plán",
          "upgrading": "Zpracovávám…",
          "noPriceForInterval": "Pro tento fakturační interval není dostupné",
          "cancelSubscription": "Zrušit předplatné",
          "upgrade": "Upgradnout",
          "scheduleDowngrade": "Naplánovat přechod",
          "cancelScheduledChange": "Zrušit naplánovanou změnu",
          "unavailable": "Nedostupné"
        },
        "cancelSubscription": {
          "heroButton": "Zrušit předplatné",
          "processing": "Zpracovávám…",
          "scheduled": {
            "title": "Předplatné bude zrušeno",
            "description": "Předplatné skončí {{date}}. Pak přejdeš na zdarma plán.",
            "resume": "Obnovit předplatné"
          },
          "modal": {
            "title": "Zrušit předplatné?",
            "bodyWithDate": "Předplatné skončí {{date}}. Do té doby máš všechno jako dnes. Po skončení přejdeš na zdarma plán ({{freeLimit}} dokumentů/měsíc).",
            "bodyWithoutDate": "Po skončení období přejdeš na zdarma plán ({{freeLimit}} dokumentů/měsíc).",
            "bodyWithDateCredits_one": "Předplatné skončí {{date}}. Do té doby máš všechno jako dnes. Po skončení přejdeš na zdarma plán ({{credits}} kredit/měsíc).",
            "bodyWithDateCredits_few": "Předplatné skončí {{date}}. Do té doby máš všechno jako dnes. Po skončení přejdeš na zdarma plán ({{credits}} kredity/měsíc).",
            "bodyWithDateCredits_many": "Předplatné skončí {{date}}. Do té doby máš všechno jako dnes. Po skončení přejdeš na zdarma plán ({{credits}} kreditu/měsíc).",
            "bodyWithDateCredits_other": "Předplatné skončí {{date}}. Do té doby máš všechno jako dnes. Po skončení přejdeš na zdarma plán ({{credits}} kreditů/měsíc).",
            "bodyWithoutDateCredits_one": "Po skončení období přejdeš na zdarma plán ({{credits}} kredit/měsíc).",
            "bodyWithoutDateCredits_few": "Po skončení období přejdeš na zdarma plán ({{credits}} kredity/měsíc).",
            "bodyWithoutDateCredits_many": "Po skončení období přejdeš na zdarma plán ({{credits}} kreditu/měsíc).",
            "bodyWithoutDateCredits_other": "Po skončení období přejdeš na zdarma plán ({{credits}} kreditů/měsíc).",
            "confirm": "Zrušit předplatné",
            "dismiss": "Ponechat předplatné"
          }
        },
        "changePlan": {
          "processing": "Zpracovávám…",
          "dismiss": "Zrušit",
          "upgrade": {
            "title": "Přejít na plán „{{plan}}\"?",
            "body": "Nové limity platí od teď. Rozdíl ceny ti naúčtujeme v příští faktuře.",
            "confirm": "Upgradnout"
          },
          "downgrade": {
            "title": "Přejít na plán „{{plan}}\"?",
            "bodyWithDate": "Plán „{{plan}}\" se aktivuje {{date}} (konec aktuálního období). Do té doby pokračuješ na současném plánu.",
            "bodyWithoutDate": "Plán „{{plan}}\" se aktivuje na konci aktuálního období. Do té doby pokračuješ na současném plánu.",
            "confirm": "Naplánovat přechod"
          }
        },
        "scheduledPlanChange": {
          "title": "Změna plánu naplánována na „{{plan}}\"",
          "description": "Nový plán se aktivuje {{date}}.",
          "cancel": "Zrušit změnu"
        },
        "portal": {
          "title": "Platební údaje",
          "description": "Změna karty, fakturační adresy nebo DIČ ve Stripe Customer Portalu.",
          "openButton": "Spravovat platební údaje",
          "opening": "Otevírám portál…",
          "error": "Nepodařilo se otevřít portál. Zkuste to prosím znovu.",
          "unavailable": "Správa předplatného je dočasně nedostupná. Zkuste to prosím později."
        },
        "managedByMasterAccount": {
          "title": "Fakturaci spravuje kancelář",
          "description": "Fakturaci a platby za tento účet spravuje účetní kancelář {{masterAccountName}}.",
          "quotaAvailable": "Doklady lze nahrávat k vytěžení.",
          "quotaExhausted": "Kancelář {{masterAccountName}} má vyčerpanou kvótu vytěžení — před nahráním dalších dokladů se jí prosím ozvěte.",
          "ownBooksQuotaExhausted": "Kancelář {{masterAccountName}} má vyčerpanou kvótu vytěžení. Navyšte tarif kanceláře na boardu v sekci Tarif a fakturace."
        },
        "pageDescription": "Spravuj svůj aktuální plán, sleduj využití vytěžování dokumentů a nastav chování při překročení limitu.",
        "pageDescriptionCredits": "Spravuj svůj aktuální plán, sleduj čerpání kreditů a dokup kredity, když dojdou."
      },
      "invoices": {
        "loadOlder": "Načíst starší",
        "loadOlderError": "Nepodařilo se načíst starší faktury. Zkuste to prosím znovu.",
        "loading": "Načítání…",
        "empty": {
          "title": "Zatím tu nic není",
          "description": "Jakmile bude faktura vystavena, objeví se zde i ve vašem emailu."
        },
        "table": {
          "number": "Číslo",
          "date": "Datum",
          "status": "Stav",
          "period": "Období",
          "plan": "Plán",
          "amount": "Částka",
          "pdf": "PDF",
          "download": "Stáhnout PDF"
        },
        "status": {
          "open": "Otevřená",
          "paid": "Zaplaceno",
          "void": "Stornováno",
          "uncollectible": "Nevymahatelná"
        }
      },
      "apiKeys": {
        "list": "Vaše API klíče",
        "fields": {
          "name": "Název",
          "description": "Popis",
          "prefix": "Prefix",
          "key": "Klíč",
          "createdAt": "Vytvořeno",
          "lastUsedAt": "Poslední použití",
          "expiresAt": "Vyprší",
          "rateLimit": "Limit",
          "status": "Stav",
          "actions": "Akce",
          "roles": "Role"
        },
        "placeholders": {
          "name": "Např. Produkční API",
          "description": "Volitelný popis účelu klíče",
          "rateLimitHint": "Požadavků za minutu (Výchozí: 1000)"
        },
        "table": {
          "loading": "Načítání API klíčů...",
          "error": "Chyba při načítání API klíčů",
          "empty": "Zatím jste nevytvořili žádné API klíče",
          "never": "Nikdy"
        },
        "actions": {
          "generateNewKey": "Vygenerovat nový klíč",
          "viewApiDocs": "Dokumentace API",
          "copyPrefix": "Kopírovat prefix",
          "revoke": "Zrušit klíč",
          "confirmRevoke": "Potvrdit zrušení",
          "cancel": "Zrušit",
          "editRoles": "Upravit role"
        },
        "status": {
          "active": "Aktivní",
          "revoked": "Zrušeno",
          "generating": "Generování..."
        },
        "errors": {
          "nameRequired": "Název je povinný",
          "rateLimitInvalid": "Limit musí být kladné číslo",
          "createError": "Chyba při vytváření API klíče",
          "revokeError": "Chyba při zrušení API klíče",
          "loadError": "Chyba při načítání API klíčů",
          "updateRolesError": "Chyba při ukládání rolí API klíče"
        },
        "success": {
          "generated": "API klíč vytvořen",
          "generateSuccess": "API klíč byl úspěšně vytvořen",
          "revokeSuccess": "API klíč byl úspěšně zrušen",
          "rolesUpdated": "Role API klíče byly uloženy"
        },
        "display": {
          "warningTitle": "Důležité",
          "warningMessage": "Tento klíč se zobrazí pouze jednou. Zkopírujte si jej nyní a bezpečně jej uložte. Pokud jej ztratíte, budete muset vytvořit nový.",
          "yourKey": "Váš klíč",
          "copyKey": "Kopírovat klíč",
          "copied": "Zkopírováno",
          "close": "Zavřít"
        },
        "editRoles": {
          "title": "Upravit role API klíče",
          "description": "Vyberte role klíče {{name}}. Role určují, co klíč smí dělat.",
          "save": "Uložit",
          "saving": "Ukládání...",
          "legacyRolesNote": "Uložením klíč přijde o role, které API klíčům nelze přidělit: {{roles}}."
        }
      },
      "webhooks": {
        "fields": {
          "url": "URL adresa",
          "authTitle": "Autentizační hlavička",
          "headerName": "Název hlavičky",
          "headerValue": "Hodnota hlavičky"
        },
        "placeholders": {
          "url": "https://example.com/webhook",
          "headerName": "např. X-Api-Key, Authorization",
          "headerValue": "Vložte hodnotu hlavičky"
        },
        "hints": {
          "url": "HTTPS endpoint, na který budou zasílány POST požadavky s JSON payloadem.",
          "authToken": "Autentizační hlavička je bezpečně uložena a po uložení formuláře je skryta.",
          "activationLocked": "Pro aktivaci webhooku nejprve uložte platnou URL adresu."
        },
        "status": {
          "label": "Stav webhooku",
          "active": "Webhook je zapnutý a systém na něj bude posílat notifikace",
          "inactive": "Webhook je vypnutý a systém na něj nebude posílat notifikace"
        },
        "statusBadge": {
          "active": "Aktivní",
          "inactive": "Neaktivní"
        },
        "actions": {
          "save": "Uložit nastavení",
          "saving": "Ukládání...",
          "activate": "Aktivovat",
          "activating": "Aktivování...",
          "togglingActive": "Změna stavu...",
          "deactivate": "Deaktivovat",
          "deactivating": "Deaktivování...",
          "delete": "Smazat",
          "deleting": "Mazání...",
          "deleteHeader": "Smazat autentizační hlavičku",
          "clearUrl": "Vymazat URL",
          "testConnection": "Otestovat připojení"
        },
        "modal": {
          "deleteConfirm": "Jste si jisti, že chcete smazat konfiguraci webhooku?",
          "deleteWarning": "Tuto akci nelze vrátit zpět.",
          "activateTitle": "Aktivovat webhook",
          "activateDescription": "Webhook bude aktivován a začne odesílat notifikace o událostech na nakonfigurovaný endpoint.",
          "deactivateTitle": "Deaktivovat webhook",
          "deactivateDescription": "Webhook bude deaktivován a přestane odesílat notifikace o událostech.",
          "confirm": "Potvrdit",
          "cancel": "Zrušit"
        },
        "errors": {
          "urlRequired": "URL adresa je povinná",
          "urlRequiredForActivation": "Pro aktivaci webhooku zadejte platnou URL adresu",
          "urlInvalid": "Zadejte platnou URL adresu",
          "urlInvalidFormat": "Neplatný formát URL",
          "urlMissingProtocol": "URL musí obsahovat protokol http:// nebo https://",
          "urlMissingHostname": "URL musí obsahovat platné jméno hostitele",
          "urlNotAllowed": "Tato URL odkazuje na privátní nebo interní adresu a nelze ji použít",
          "urlCredentials": "URL nesmí obsahovat uživatelské jméno ani heslo. Přihlašovací údaje zadejte v části „Autentizační hlavička“",
          "headerValueTooLong": "Hodnota hlavičky smí mít nejvýš 500 znaků",
          "headerValueInvalid": "Hodnota hlavičky smí obsahovat jen písmena bez diakritiky, číslice, mezery a běžné znaky, bez zalomení řádku",
          "saveError": "Nepodařilo se uložit konfiguraci webhooku",
          "deleteError": "Nepodařilo se smazat konfiguraci webhooku",
          "loadError": "Nepodařilo se načíst konfiguraci webhooku"
        },
        "success": {
          "saveSuccess": "Konfigurace webhooku byla úspěšně uložena",
          "deleteSuccess": "Konfigurace webhooku byla úspěšně smazána"
        }
      },
      "users": {
        "fields": {
          "email": "Email",
          "firstName": "Jméno",
          "lastName": "Příjmení",
          "displayName": "Celé jméno",
          "role": "Role",
          "status": "Stav",
          "createdAt": "Vytvořeno",
          "invitedAt": "Pozváno",
          "invitedBy": "Pozval",
          "expiresAt": "Vyprší",
          "actions": "Akce"
        },
        "placeholders": {
          "email": "Např. novak@firma.cz",
          "firstName": "Např. Jan",
          "lastName": "Např. Novák",
          "selectRole": "Vyberte roli"
        },
        "filter": {
          "searchPlaceholder": "Hledat podle jména nebo e-mailu...",
          "allRoles": "Všechny role",
          "allStatuses": "Všechny stavy",
          "roleLabel": "Role",
          "statusLabel": "Stav"
        },
        "table": {
          "loading": "Načítání uživatelů...",
          "error": "Chyba při načítání uživatelů",
          "empty": "Zatím nebyli přidáni žádní uživatelé",
          "you": "(vy)",
          "systemUser": "System"
        },
        "orgUnit": {
          "label": "Pozice v org. struktuře (nepovinné)",
          "choose": "Vybrat pozici",
          "change": "Změnit",
          "remove": "Odebrat",
          "pickerTitle": "Pozice v org. struktuře",
          "confirm": "Vybrat",
          "asManager": "Nastavit jako vedoucího pozice",
          "replacesHead": "Nahradí současného vedoucího {{name}}, až pozvánku přijme.",
          "asManagerTag": "jako vedoucí"
        },
        "actions": {
          "inviteUser": "Pozvat uživatele",
          "edit": "Upravit",
          "deactivate": "Deaktivovat",
          "reactivate": "Reaktivovat",
          "delete": "Smazat",
          "resendInvitation": "Znovu odeslat",
          "cancelInvitation": "Zrušit pozvánku",
          "cancel": "Zrušit",
          "save": "Uložit"
        },
        "status": {
          "inviting": "Odesílání...",
          "updating": "Ukládání...",
          "deleting": "Mazání...",
          "pending": "Čeká na pozvání"
        },
        "modals": {
          "invite": {
            "title": "Pozvat uživatele",
            "description": "Zadejte email a roli nového uživatele. Bude mu odeslána pozvánka."
          },
          "edit": {
            "title": "Upravit uživatele",
            "description": "Změňte jméno, příjmení nebo roli uživatele.",
            "sharedIdentityNotice": "Jméno a předvolby si tento uživatel mění sám ve svém profilu, protože je členem i dalšího účtu nebo účetní kanceláře."
          },
          "confirmDeactivate": {
            "title": "Deaktivovat uživatele?",
            "message": "Opravdu chcete deaktivovat uživatele {{name}}? Nebude se moci přihlásit, dokud ho znovu neaktivujete.",
            "confirm": "Deaktivovat"
          },
          "confirmReactivate": {
            "title": "Reaktivovat uživatele?",
            "message": "Opravdu chcete reaktivovat uživatele {{name}}? Bude se moci opět přihlásit.",
            "confirm": "Reaktivovat"
          },
          "confirmDelete": {
            "title": "Smazat uživatele?",
            "message": "Opravdu chcete trvale smazat uživatele {{name}}? Tuto akci nelze vrátit zpět.",
            "confirm": "Smazat"
          },
          "confirmCancelInvitation": {
            "title": "Zrušit pozvánku?",
            "message": "Opravdu chcete zrušit pozvánku pro {{email}}?",
            "confirm": "Zrušit pozvánku"
          }
        },
        "errors": {
          "loadError": "Nepodařilo se načíst uživatele",
          "emailRequired": "Email je povinný",
          "emailInvalid": "Neplatný formát emailu",
          "roleRequired": "Role je povinná",
          "firstNameRequired": "Jméno je povinné",
          "lastNameRequired": "Příjmení je povinné",
          "inviteError": "Chyba při odesílání pozvánky",
          "updateError": "Chyba při aktualizaci uživatele",
          "deactivateError": "Chyba při deaktivaci uživatele",
          "reactivateError": "Chyba při reaktivaci uživatele",
          "deleteError": "Chyba při mazání uživatele",
          "resendError": "Chyba při opětovném odeslání pozvánky",
          "cancelError": "Chyba při rušení pozvánky",
          "cannotModifySelf": "Nemůžete měnit vlastní roli nebo se smazat",
          "lastAdmin": "V organizaci musí zůstat alespoň jeden aktivní správce."
        },
        "success": {
          "inviteSuccess": "Pozvánka byla úspěšně odeslána",
          "updateSuccess": "Uživatel byl úspěšně aktualizován",
          "deactivateSuccess": "Uživatel byl úspěšně deaktivován",
          "reactivateSuccess": "Uživatel byl úspěšně reaktivován",
          "deleteSuccess": "Uživatel byl úspěšně smazán",
          "resendSuccess": "Pozvánka byla znovu odeslána",
          "cancelSuccess": "Pozvánka byla zrušena"
        },
        "orgPositions": {
          "title": "Pozice v organizační struktuře",
          "empty": "Uživatel není v žádné pozici."
        }
      },
      "organization": {
        "loading": "Načítání organizace...",
        "error": "Nepodařilo se načíst data organizace",
        "accountSection": {
          "title": "Správa účtu",
          "description": "Spravujte detaily organizačního účtu a přiřazené společnosti"
        },
        "partySection": {
          "title": "Přiřazená společnost",
          "description": "Záznam společnosti 1:1 přiřazený k tomuto účtu"
        },
        "localizationSection": {
          "title": "Lokalizace"
        },
        "fields": {
          "name": "Název organizace",
          "partyName": "Název společnosti",
          "companyId": "IČO",
          "taxId": "DIČ",
          "vatId": "DIČ pro DPH / VAT ID",
          "vatIdHint": "Číslo, pod kterým je subjekt registrován k DPH. U většiny českých firem shodné s DIČ.",
          "registryEntry": "Zápis v obchodním rejstříku",
          "registryEntryHint": "Tiskne se na vystavované doklady. Například: Společnost zapsaná v obchodním rejstříku vedeném Městským soudem v Praze, oddíl C, vložka 123456",
          "phone": "Telefon",
          "email": "E-mail",
          "street": "Ulice",
          "buildingNumber": "č.p.",
          "city": "Město",
          "postalCode": "PSČ",
          "accountingCurrencyCode": "Účetní měna",
          "accountingCurrencyCodeHint": "Měna, do které se přepočítávají faktury (např. CZK)",
          "reportingCurrencyCode": "Reportní měna",
          "reportingCurrencyCodeHint": "Měna pro reporty a exporty. Když ji nevyplníte, použije se účetní měna.",
          "country": "Kód země",
          "language": "Jazyk",
          "timezone": "Časové pásmo",
          "noParty": "Žádná společnost není přiřazena"
        },
        "localeOptions": {
          "CS": "Čeština",
          "EN": "English"
        },
        "actions": {
          "save": "Uložit změny",
          "saving": "Ukládání...",
          "delete": "Smazat účet",
          "cancel": "Zrušit"
        },
        "feedback": {
          "saveSuccess": "Změny byly úspěšně uloženy",
          "saveError": "Nepodařilo se uložit změny",
          "deleteNotSupported": "Smazání účtu zatím není podporováno. Kontaktujte prosím podporu.",
          "noPartyToUpdate": "K tomuto účtu není přiřazena žádná společnost, proto nejde upravit její údaje. Kontaktujte podporu."
        },
        "errors": {
          "nameRequired": "Název organizace je povinný",
          "nameTooLong": "Název může mít nejvýše {{max}} znaků",
          "partyNameTooLong": "Název společnosti může mít nejvýše {{max}} znaků",
          "icoTooLong": "IČO může mít nejvýše {{max}} znaků",
          "dicTooLong": "DIČ může mít nejvýše {{max}} znaků",
          "localeTooLong": "Kód měny může mít nejvýše {{max}} znaky",
          "registryEntryTooLong": "Zápis v obchodním rejstříku může mít nejvýše {{max}} znaků",
          "accountNameTaken": "Tento název organizace je již obsazen",
          "accountingCurrencyRequired": "Účetní měna je povinná"
        },
        "deleteAccount": {
          "title": "Smazat tento účet",
          "hint": "Účet a všechna data budou po 30denní ochranné lhůtě nenávratně smazána.",
          "button": "Smazat účet",
          "confirmTitle": "Smazat účet?",
          "confirmMessage": "Účet bude naplánován ke smazání a všichni budou odhlášeni.",
          "confirmWarning": "Po 30 dnech se účet a všechna jeho data nenávratně smažou. Během této doby jej můžete obnovit opětovným přihlášením.",
          "confirmButton": "Smazat účet",
          "cancelButton": "Zrušit",
          "requestError": "Účet se nepodařilo naplánovat ke smazání. Zkuste to prosím znovu později.",
          "needsDirectAdmin": "Tuto organizaci může ke smazání navrhnout jen její vlastní administrátor."
        },
        "masterAccountSection": {
          "title": "Účetní kancelář",
          "description": "Jako účetní kancelář budete moci spravovat doklady svých klientů z jednoho účtu.",
          "declareError": "Prohlášení účtu za účetní kancelář se nepodařilo",
          "action": "Prohlásit za účetní kancelář",
          "declareDialog": {
            "title": "Prohlásit organizaci za účetní kancelář?",
            "intro": "Co se stane:",
            "ownBooks": "Tato organizace se stane vaší organizací „Moje kancelář“. Zůstanou jí všechny doklady, e-mailová adresa i integrace.",
            "masterAccountBoard": "Vznikne nový board kanceláře, na kterém budete spravovat klienty. Budete na něm správcem kanceláře.",
            "subscription": "Předplatné se přesune na board kanceláře.",
            "peopleTitle": "Kdo bude pracovat v kanceláři?",
            "peopleHint": "U každého uživatele vyberte, kam patří. Zaměstnanec firmy zůstane jen v „Moje kancelář“. Člen kanceláře přejde na board kanceláře jako účetní.",
            "classificationLabel": "Zařazení: {{name}}",
            "masterAccountMemberWarningTitle": "Členové kanceláře přijdou o své dosavadní role",
            "masterAccountMemberWarningBody": "V „Moje kancelář“ budou mít jen roli účetního a ztratí ostatní role, například schvalovatele. Schvalování, která na ně čekají, bude možná potřeba přeřadit.",
            "peopleLoading": "Načítám lidi z organizace…",
            "peopleError": "Seznam lidí z organizace se nepodařilo načíst. Zavřete okno a zkuste to znovu.",
            "confirm": "Prohlásit za kancelář",
            "cancel": "Zrušit"
          }
        },
        "leaveMasterAccount": {
          "title": "Účetní kancelář",
          "description": "Tento účet spravuje účetní kancelář {{masterAccountName}}.",
          "button": "Odejít od kanceláře",
          "confirmTitle": "Odejít od kanceláře?",
          "confirmMessage": "Účet přestane spravovat kancelář {{masterAccountName}}. Přidělí se mu výchozí tarif a od teď si bude platit sám. Doklady zůstávají zachovány.",
          "confirmWarning": "Tuto akci nelze vzít zpět.",
          "confirmButton": "Odejít od kanceláře",
          "cancelButton": "Zrušit",
          "success": "Účet již nespravuje účetní kancelář",
          "error": "Odchod od kanceláře se nepodařil",
          "errorDetachNameTaken": "Od kanceláře nelze odejít: stejný název už používá jiná organizace. Nejdřív svou organizaci přejmenujte v nastavení."
        },
        "hints": {
          "registryInfo": {
            "CZ": "Zadejte IČO a název firmy, adresu sídla i DIČ načteme z registru ARES.",
            "SK": "Zadejte IČO a název firmy i adresu sídla načteme z registru RPO. Registr nezveřejňuje daňová čísla, DIČ a DIČ pro DPH / VAT ID proto doplňte sami."
          }
        },
        "registry": {
          "CZ": {
            "label": "Načíst údaje podle IČO nebo DIČ",
            "placeholder": "Zadejte IČO nebo DIČ"
          },
          "SK": {
            "label": "Načíst údaje podle IČO",
            "placeholder": "Zadejte IČO"
          }
        },
        "masterAccountErrors": {
          "classificationInvalid": "Mezitím se změnili lidé v organizaci. Zkontrolujte jejich zařazení a potvrďte znovu.",
          "alreadyAMasterAccount": "Tato organizace už je účetní kanceláří.",
          "masterAccountDoesNotNest": "Organizace, kterou spravuje účetní kancelář, se sama kanceláří stát nemůže.",
          "declareConflict": "Mezitím se změnili lidé v organizaci. Zkontrolujte jejich zařazení a zkuste to znovu.",
          "forbidden": "Organizaci může prohlásit za kancelář jen její aktivní správce, a to pod vlastním přihlášením.",
          "ownBooksIdentityReadOnly": "Údaje kanceláře se upravují na boardu kanceláře."
        },
        "ownBooksIdentityNote": "Údaje kanceláře se upravují na boardu kanceláře.",
        "logo": {
          "label": "Logo",
          "hint": "PNG nebo JPG, nejvýše {{max}} MB. Tiskne se na objednávky.",
          "alt": "Logo organizace",
          "none": "Logo není nahrané.",
          "upload": "Nahrát logo",
          "replace": "Nahradit",
          "remove": "Odebrat",
          "cancel": "Zrušit",
          "removeTitle": "Odebrat logo?",
          "removeMessage": "Objednávky se budou tisknout bez loga.",
          "uploaded": "Logo je nahrané.",
          "removed": "Logo je odebrané.",
          "errors": {
            "wrongType": "Logo musí být obrázek PNG nebo JPG.",
            "refused": "Logo musí být obrázek PNG nebo JPG, nejvýše {{px}} × {{px}} px.",
            "tooLarge": "Logo může mít nejvýše {{max}} MB.",
            "limitReached": "Organizace už logo má. Pokud ho chcete změnit, zvolte „Nahradit“.",
            "busy": "Logo teď nejde nahrát. Zkuste to prosím za chvíli znovu.",
            "tooSlow": "Připojení je na nahrání loga příliš pomalé. Zkuste to prosím znovu.",
            "uploadFailed": "Logo se nepodařilo nahrát. Zkuste to prosím znovu.",
            "removeFailed": "Logo se nepodařilo odebrat. Zkuste to prosím znovu."
          }
        }
      },
      "accountRelations": {
        "origin": {
          "CREATED": "Založen kanceláří",
          "TRANSFERRED": "Přesunut ke kanceláři",
          "CONVERTED": "Převeden při zřízení kanceláře"
        },
        "createModal": {
          "title": "Nový klient",
          "subtitle": "Založí nový, prázdný účet klienta pod vaší kanceláří.",
          "icoLabel": "Načíst údaje podle IČO",
          "icoPlaceholder": "Zadejte IČO",
          "nameLabel": "Název klienta",
          "namePlaceholder": "Zadejte název klienta",
          "cancel": "Zrušit",
          "submit": "Vytvořit klienta",
          "creating": "Vytvářím…",
          "success": "Klient byl vytvořen",
          "error": {
            "generic": "Vytvoření klienta se nezdařilo",
            "limitReached": "Kancelář dosáhla limitu klientů pro svůj tarif. Pro navýšení limitu kontaktujte podporu.",
            "notActive": "Kancelář musí být aktivní, aby mohla spravovat klienty.",
            "nameTaken": "Klient s tímto názvem už v kanceláři existuje.",
            "rateLimit": "Příliš mnoho pokusů o založení klienta v krátké době. Zkuste to prosím za chvíli znovu.",
            "notAMasterAccountAccountant": "Klient nebyl založen: některá z vybraných účetních už není aktivní účetní kanceláře. Seznam účetních je aktualizovaný, zkontrolujte výběr a zkuste to znovu."
          },
          "registryNotFound": "Firma s tímto IČO nebyla v registru nalezena.",
          "registryUnavailable": "Vyhledání v registru se nezdařilo. Zkuste to prosím znovu.",
          "accountants": {
            "label": "Účetní",
            "placeholder": "Vyberte účetní (nepovinné)",
            "hint": "Vybrané účetní získají přístup ke klientovi hned po jeho založení.",
            "noAccountants": "Kancelář zatím nemá žádné účetní. Přiřadit je můžete později.",
            "loadError": "Seznam účetních se nepodařilo načíst. Přiřadit je můžete později."
          }
        },
        "disconnectModal": {
          "title": "Odpojit klienta?",
          "message": "Klient {{name}} bude odpojen od kanceláře a přestane být spravován tímto účtem.",
          "confirm": "Odpojit klienta",
          "cancel": "Zrušit",
          "success": "Klient byl odpojen",
          "error": {
            "generic": "Odpojení klienta se nezdařilo",
            "detachNameTaken": "Organizaci nelze odpojit: stejný název už používá jiná organizace. Nejdřív ji přejmenujte.",
            "noOwnUsers": "Klienta nelze odpojit, protože nemá žádného vlastního aktivního uživatele. Klienta, kterého kancelář založila, můžete smazat; v ostatních případech se obraťte na podporu."
          }
        },
        "deleteModal": {
          "title": "Smazat klienta?",
          "message": "Klient {{name}} nemá žádného vlastního uživatele, proto ho nelze odpojit. Bude naplánován ke smazání a po 30denní ochranné lhůtě bude i se všemi svými daty nenávratně smazán. Kancelář k němu ihned ztratí přístup; do konce lhůty ho může obnovit jen podpora.",
          "confirm": "Smazat klienta",
          "cancel": "Zrušit",
          "success": "Klient je naplánován ke smazání",
          "error": {
            "generic": "Smazání klienta se nezdařilo",
            "hasOwnUsers": "Klient mezitím získal vlastního uživatele. Místo smazání ho prosím odpojte.",
            "needsSupport": "Tohoto klienta kancelář nezaložila, proto ho nemůže smazat. Obraťte se prosím na podporu."
          }
        }
      },
      "mailbox": {
        "loading": "Načítání nastavení schránky…",
        "error": "Nastavení schránky se nepodařilo načíst",
        "preview": "Náhled:",
        "sections": {
          "currentMailbox": "Aktuální schránka",
          "createMailbox": "Vytvořit schránku"
        },
        "fields": {
          "status": "Stav",
          "emailAddress": "E-mailová adresa",
          "prefix": "Prefix adresy",
          "prefixHint": "Malá písmena, čísla a pomlčky. Minimálně 3 znaky. K adrese se doplní náhodný suffix, aby ji nešlo uhodnout.",
          "entityType": "Adresa pro příjem faktur"
        },
        "placeholders": {
          "prefix": "např. faktury-firma"
        },
        "status": {
          "active": "Aktivní",
          "inactive": "Neaktivní"
        },
        "actions": {
          "create": "Vytvořit schránku",
          "creating": "Vytvářím…",
          "activate": "Aktivovat",
          "deactivate": "Deaktivovat",
          "delete": "Smazat schránku",
          "copy": "Kopírovat adresu do schránky"
        },
        "deleteConfirm": {
          "message": "Opravdu chcete smazat schránku? Tuto akci nelze vrátit.",
          "confirm": "Ano, smazat",
          "cancel": "Zrušit"
        },
        "validation": {
          "required": "Prefix je povinný",
          "tooShort": "Prefix musí mít alespoň 3 znaky",
          "tooLong": "Prefix může mít nejvýše 119 znaků",
          "invalidFormat": "Povolena jsou pouze malá písmena, čísla a pomlčky. Nesmí začínat ani končit pomlčkou.",
          "blacklisted": "Tento prefix není povolen. Zvolte prosím jiný.",
          "alreadyConfigured": "Váš účet již má nastavenou schránku."
        },
        "feedback": {
          "createSuccess": "Schránka byla úspěšně vytvořena",
          "createError": "Vytvoření schránky se nezdařilo",
          "enableSuccess": "Schránka aktivována",
          "disableSuccess": "Schránka deaktivována",
          "toggleError": "Změna stavu schránky se nezdařila",
          "deleteSuccess": "Schránka smazána",
          "deleteError": "Smazání schránky se nezdařilo",
          "copied": "E-mailová adresa zkopírována do schránky"
        },
        "hints": {
          "usage": "Přeposílejte faktury od dodavatelů na tuto adresu. Přiložené PDF, ISDOC nebo Word soubory budou automaticky extrahovány a převedeny na dokumenty.",
          "createInfo": "Vytvořte si dedikovanou e-mailovou adresu pro příjem faktur. Dodavatelé mohou faktury posílat přímo na tuto adresu a budou automaticky zpracovány."
        },
        "quarantine": {
          "title": "Zadržené e-maily",
          "description": "Tyto e-maily se tváří jako od domény, která odesílatele nepotvrdila. Nic z nich se nezpracovalo ani nespotřebovalo kredit na extrakci. Uvolněte jen ty, které poznáváte.",
          "loading": "Načítání zadržených e-mailů…",
          "error": "Zadržené e-maily se nepodařilo načíst",
          "noSubject": "(bez předmětu)",
          "fields": {
            "sender": "Odesílatel",
            "subject": "Předmět",
            "receivedAt": "Přijato",
            "attachments": "Přílohy",
            "actions": "Akce"
          },
          "actions": {
            "release": "Uvolnit",
            "discard": "Zahodit",
            "loadMore": "Načíst další"
          },
          "feedback": {
            "releaseSuccess": "E-mail byl uvolněn ke zpracování",
            "releaseError": "Uvolnění e-mailu se nezdařilo",
            "discardSuccess": "E-mail byl zahozen",
            "discardError": "Zahození e-mailu se nezdařilo"
          }
        },
        "allowlist": {
          "title": "Důvěryhodní odesílatelé",
          "description": "E-maily od těchto odesílatelů se nikdy nezadrží, i když jejich doména odesílatele nepotvrdí. Zadejte celou adresu nebo jen doménu.",
          "loading": "Načítání seznamu…",
          "empty": "Zatím nemáte žádného důvěryhodného odesílatele.",
          "error": "Seznam odesílatelů se nepodařilo načíst",
          "fields": {
            "value": "Adresa nebo doména",
            "valueHint": "Např. faktury@dodavatel.cz nebo dodavatel.cz",
            "addedAt": "Přidáno",
            "actions": "Akce"
          },
          "placeholders": {
            "value": "dodavatel.cz"
          },
          "actions": {
            "add": "Přidat",
            "remove": "Odebrat",
            "loadMore": "Načíst další"
          },
          "validation": {
            "required": "Zadejte adresu nebo doménu",
            "invalidFormat": "Zadejte platnou e-mailovou adresu nebo doménu",
            "duplicate": "Tento odesílatel už na seznamu je"
          },
          "feedback": {
            "addSuccess": "Odesílatel byl přidán",
            "addError": "Přidání odesílatele se nezdařilo",
            "removeSuccess": "Odesílatel byl odebrán",
            "removeError": "Odebrání odesílatele se nezdařilo"
          },
          "forwardingHint": "Přeposíláte-li poštu (např. pravidlem v Exchange nebo M365), přidejte dodavatele nebo doménu, ze které se pošta přeposílá — shoda se hledá v hlavičce From, ne ve vaší ingest adrese."
        }
      },
      "numberSeries": {
        "fields": {
          "documentType": "Agenda",
          "prefix": "Prefix",
          "pattern": "Vzor",
          "padding": "Počet číslic",
          "preview": "Náhled",
          "actions": "Akce"
        },
        "table": {
          "loading": "Načítání číselných řad...",
          "error": "Číselné řady se nepodařilo načíst",
          "empty": "Zatím zde nejsou žádné číselné řady"
        },
        "actions": {
          "edit": "Upravit číselnou řadu",
          "save": "Uložit",
          "cancel": "Zrušit"
        },
        "modal": {
          "title": "Číselná řada – {{documentType}}",
          "description": "Náhled ukazuje číslo, které by řada přidělila jako další."
        },
        "placeholders": {
          "title": "Dostupné zástupné symboly",
          "insert": "Vložit do vzoru",
          "prefix": "Prefix řady, například OBJ",
          "year": "Čtyřmístný rok, například 2026",
          "yy": "Dvojmístný rok, například 26",
          "month": "Dvojmístný měsíc vystavení, například 09",
          "seq": "Pořadové číslo dokladu doplněné nulami na zvolený počet číslic"
        },
        "issues": {
          "EMPTY": "Vzor nesmí být prázdný.",
          "TOO_LONG": "Vzor je příliš dlouhý, maximum je {{max}} znaků.",
          "UNKNOWN_PLACEHOLDER": "Neznámý zástupný symbol {{placeholder}}. Zkontrolujte překlep.",
          "UNBALANCED_BRACE": "Vzor obsahuje osamocenou složenou závorku.",
          "MISSING_SEQUENCE": "Vzor neobsahuje {seq}, takže by všechny doklady dostaly stejné číslo.",
          "PREFIX_EMPTY": "Prefix nesmí být prázdný.",
          "PREFIX_TOO_LONG": "Prefix je příliš dlouhý, maximum je {{prefixMax}} znaků.",
          "PADDING_OUT_OF_RANGE": "Počet číslic musí být celé číslo od {{paddingMin}} do {{paddingMax}}.",
          "RENDERED_TOO_LONG": "Vygenerované číslo by bylo delší než {{numberMax}} znaků a doklady by nešlo založit. Zkraťte prefix nebo vzor."
        },
        "success": {
          "saved": "Číselná řada byla uložena"
        },
        "errors": {
          "saveError": "Číselnou řadu se nepodařilo uložit"
        }
      },
      "bankAccounts": {
        "systemCheck": {
          "title": "Systémová kontrola účtů",
          "label": "Systém smí dát první podpis",
          "description": "Systém může dát první podpis, když účet dřív nahlásilo ERP nebo ho zveřejňuje registr plátců DPH. Druhý podpis dává vždy uživatel.",
          "noPermission": "Měnit to může jen ten, kdo spravuje nastavení účtu.",
          "saved": "Uloženo.",
          "saveError": "Nastavení se nepodařilo uložit.",
          "loadError": "Nastavení se nepodařilo načíst."
        },
        "ownAccounts": {
          "title": "Účty naší firmy",
          "noCompany": "Nejdřív vyplň údaje firmy v záložce Organizace."
        }
      }
    },
    "shared": {
      "companyRegistry": {
        "action": "Načíst údaje",
        "loading": "Načítání…",
        "applied": "Údaje byly načteny z registru a uloženy.",
        "errors": {
          "invalidFormat": "Zadejte IČO jako 8 číslic (funguje i české DIČ, např. CZ12345678).",
          "notFound": "Firma s tímto IČO nebyla v registru nalezena.",
          "unavailable": "Registr je momentálně nedostupný. Zkuste to prosím později."
        }
      },
      "lifecycle": {
        "status": {
          "ACTIVE": "Aktivní",
          "DEACTIVATED": "Deaktivováno",
          "OUT_OF_VALIDITY": "Mimo platnost"
        },
        "outOfValidity": {
          "from": "Mimo platnost (platí od {{date}})",
          "to": "Mimo platnost (platilo do {{date}})"
        },
        "filter": {
          "ALL": "Všechny stavy",
          "INACTIVE": "Neaktivní",
          "label": "Stav"
        },
        "fields": {
          "validFrom": "Platnost od",
          "validTo": "Platnost do"
        },
        "errors": {
          "invertedWindow": "Datum „Platnost do“ nesmí být dřívější než datum „Platnost od“."
        },
        "window": {
          "both": "Platnost od {{from}} do {{to}}",
          "from": "Platnost od {{from}}",
          "to": "Platnost do {{to}}"
        }
      },
      "syncProvenance": {
        "badge": {
          "info": "Smazáno ve zdroji ({{system}})",
          "deactivate": "Deaktivováno — smazáno ve zdroji ({{system}})",
          "delete": "Odstraněno — smazáno ve zdroji ({{system}})"
        },
        "detectedAt": "Zjištěno {{date}}",
        "more": "+{{count}}",
        "filter": "Chybí v účetním systému",
        "filterHint": "Jen záznamy, které účetní systém smazal nebo je přestal posílat."
      },
      "accountRelation": {
        "ownBooks": "Moje kancelář"
      },
      "rolesGuide": {
        "toggle": "Co která role umožňuje",
        "help": "Více v nápovědě",
        "helpOpensInNewTab": "Více v nápovědě (otevře se v nové záložce)"
      }
    },
    "partyValidation": {
      "title": "Kontrola duplicity",
      "acknowledge": "Přesto uložit",
      "saving": "Ukládání...",
      "close": "Zavřít",
      "cancel": "Zrušit",
      "fieldLabels": {
        "companyId": "IČO",
        "vatId": "DIČ pro DPH / VAT ID",
        "taxId": "DIČ"
      }
    },
    "partners": {
      "addButton": "Přidat firmu",
      "loading": "Načítám...",
      "empty": "Zatím žádné firmy. Přidejte první.",
      "noResults": "Žádné firmy neodpovídají hledání.",
      "toast": {
        "createSuccess": "Firma vytvořena",
        "updateSuccess": "Firma aktualizována",
        "saveError": "Uložení se nezdařilo",
        "deactivateSuccess": "Firma deaktivována",
        "deactivateError": "Deaktivace se nezdařila",
        "reactivateSuccess": "Firma aktivována",
        "reactivateError": "Aktivace se nezdařila",
        "deleteSuccess": "Firma smazána",
        "deleteError": "Smazání firmy se nezdařilo",
        "batchDeactivateSuccess_one": "Deaktivována {{count}} firma",
        "batchDeactivateSuccess_few": "Deaktivovány {{count}} firmy",
        "batchDeactivateSuccess_other": "Deaktivováno {{count}} firem",
        "batchDeactivatePartial": "Deaktivováno {{count}}, přeskočeno {{skipped}}. {{reason}}",
        "batchDeactivateError": "Deaktivace vybraných firem se nezdařila",
        "batchReactivateSuccess_one": "Aktivována {{count}} firma",
        "batchReactivateSuccess_few": "Aktivovány {{count}} firmy",
        "batchReactivateSuccess_other": "Aktivováno {{count}} firem",
        "batchReactivatePartial": "Aktivováno {{count}}, přeskočeno {{skipped}}. {{reason}}",
        "batchReactivateError": "Aktivace vybraných firem se nezdařila",
        "batchDeleteSuccess_one": "Smazána {{count}} firma",
        "batchDeleteSuccess_few": "Smazány {{count}} firmy",
        "batchDeleteSuccess_other": "Smazáno {{count}} firem",
        "batchDeletePartial": "Smazáno {{count}}, přeskočeno {{skipped}} — jsou stále používané. {{reason}}",
        "batchDeleteError": "Smazání vybraných firem se nezdařilo"
      },
      "search": {
        "placeholder": "Hledat…"
      },
      "filters": {
        "role": {
          "all": "Všechny role",
          "supplier": "Dodavatelé",
          "customer": "Odběratelé"
        }
      },
      "columns": {
        "name": "Název",
        "companyId": "IČO",
        "role": "Role",
        "status": "Stav",
        "actions": "Akce",
        "taxId": "DIČ",
        "vatId": "VAT ID"
      },
      "role": {
        "supplier": "Dodavatel",
        "customer": "Odběratel"
      },
      "actions": {
        "edit": "Upravit",
        "deactivate": "Deaktivovat",
        "reactivate": "Aktivovat",
        "delete": "Smazat"
      },
      "deactivateModal": {
        "title": "Deaktivovat firmu",
        "message": "Chcete deaktivovat \"{{name}}\"?",
        "confirm": "Deaktivovat",
        "cancel": "Zrušit"
      },
      "reactivateModal": {
        "title": "Aktivovat firmu",
        "message": "Chcete znovu aktivovat \"{{name}}\"?",
        "confirm": "Aktivovat",
        "cancel": "Zrušit"
      },
      "selection": {
        "selectAll": "Vybrat vše",
        "selectRow": "Vybrat {{name}}",
        "selectedCount_one": "Vybrána {{count}}",
        "selectedCount_few": "Vybrány {{count}}",
        "selectedCount_other": "Vybráno {{count}}"
      },
      "detail": {
        "title": "Firma",
        "createTitle": "Nová firma",
        "back": "Zpět na firmy",
        "actionsLabel": "Akce firmy",
        "loadError": "Firmu se nepodařilo načíst.",
        "save": "Uložit",
        "create": "Vytvořit",
        "saving": "Ukládám...",
        "cancel": "Zrušit",
        "postalAddress": "Poštovní adresa",
        "deliveryAddress": "Dodací adresa",
        "sameAsRegisteredOffice": "Stejná jako sídlo",
        "contactPersons": {
          "title": "Kontaktní osoby",
          "erpNotice": "Odebrání osoby se do ERP nepropíše.",
          "add": "Přidat osobu",
          "empty": "Zatím žádné kontaktní osoby.",
          "personN": "Osoba {{n}}",
          "main": "Hlavní",
          "openWebsite": "Otevřít web",
          "fields": {
            "firstName": "Jméno",
            "lastName": "Příjmení",
            "role": "Funkce",
            "email": "E-mail",
            "phone": "Telefon",
            "mobile": "Mobil",
            "website": "Web"
          },
          "errors": {
            "emailInvalid": "Neplatný formát e-mailu",
            "websiteInvalid": "Zadejte webovou adresu http(s), např. www.firma.cz"
          }
        },
        "bankAccounts": {
          "title": "Bankovní účty",
          "erpNotice": "Odebrání účtu se do ERP nepropíše.",
          "add": "Přidat účet",
          "empty": "Zatím žádné bankovní účty.",
          "accountN": "Účet {{n}}",
          "main": "Hlavní",
          "warnings": {
            "invalidSwift": "Neplatný formát SWIFT/BIC (např. GIBACZPX nebo GIBACZPXXXX)",
            "invalidBankCode": "Kód banky by měl být čtyřmístné číslo (např. 0800)",
            "invalidIban": "Neplatný formát IBAN (např. CZ6508000000192000145399)"
          }
        },
        "contactPersonsInvalid": "Opravte zvýrazněná pole u kontaktních osob."
      },
      "deleteModal": {
        "title": "Smazat firmu",
        "message": "Opravdu trvale smazat „{{name}}“? Smazat lze jen firmu, na kterou nic neodkazuje.",
        "confirm": "Smazat",
        "cancel": "Zrušit"
      },
      "batchDeactivateModal": {
        "title": "Deaktivovat firmy",
        "message_one": "Deaktivovat {{count}} vybranou firmu?",
        "message_few": "Deaktivovat {{count}} vybrané firmy?",
        "message_other": "Deaktivovat {{count}} vybraných firem?",
        "confirm": "Deaktivovat",
        "cancel": "Zrušit"
      },
      "batchReactivateModal": {
        "title": "Aktivovat firmy",
        "message_one": "Aktivovat {{count}} vybranou firmu?",
        "message_few": "Aktivovat {{count}} vybrané firmy?",
        "message_other": "Aktivovat {{count}} vybraných firem?",
        "confirm": "Aktivovat",
        "cancel": "Zrušit"
      },
      "batchDeleteModal": {
        "title": "Smazat firmy",
        "message_one": "Trvale smazat {{count}} vybranou firmu? Firmy, které jsou stále používané, se přeskočí.",
        "message_few": "Trvale smazat {{count}} vybrané firmy? Firmy, které jsou stále používané, se přeskočí.",
        "message_other": "Trvale smazat {{count}} vybraných firem? Firmy, které jsou stále používané, se přeskočí.",
        "confirm": "Smazat",
        "cancel": "Zrušit",
        "confirmationPhrase": "SMAZAT",
        "confirmationLabel": "Pro smazání {{count}} firem napište {{phrase}}"
      },
      "countLabel_one": "{{count}} firma",
      "countLabel_few": "{{count}} firmy",
      "countLabel_other": "{{count}} firem",
      "countLoadedLabel_one": "{{loaded}}/{{count}} firma",
      "countLoadedLabel_few": "{{loaded}}/{{count}} firmy",
      "countLoadedLabel_other": "{{loaded}}/{{count}} firem"
    },
    "codeLists": {
      "accountingCodes": {
        "managedInErp": "Číselník se spravuje v účetním systému a do Tappeeru se načítá integrací.",
        "searchPlaceholder": "Hledat podle kódu nebo popisu...",
        "loadMore": "Načíst další",
        "loadedCount": "Zobrazeno {{loaded}} z {{count}}",
        "loadMoreError": "Další kódy se nepodařilo načíst. Zkuste to znovu.",
        "debit": "MD {{account}}",
        "credit": "D {{account}}"
      },
      "glPostings": {
        "error": "Předkontace se nepodařilo načíst. Zkuste stránku obnovit.",
        "empty": {
          "title": "Zatím tu nejsou žádné předkontace",
          "description": "Předkontace se spravují v účetním systému a do Tappeeru je načte integrace. Objeví se tu po první synchronizaci."
        },
        "noResults": "Hledání neodpovídá žádná předkontace",
        "vatPosting": "Zaúčtování DPH {{code}}"
      },
      "vatCodes": {
        "error": "Členění DPH se nepodařilo načíst. Zkuste stránku obnovit.",
        "empty": {
          "title": "Zatím tu není žádné členění DPH",
          "description": "Členění DPH se spravuje v účetním systému a do Tappeeru ho načte integrace. Objeví se tu po první synchronizaci."
        },
        "noResults": "Hledání neodpovídá žádné členění DPH",
        "directionBoth": "Přijaté i vydané doklady"
      },
      "vatPostings": {
        "error": "Zaúčtování DPH se nepodařilo načíst. Zkuste stránku obnovit.",
        "empty": {
          "title": "Zatím tu není žádné zaúčtování DPH",
          "description": "Zaúčtování DPH se spravuje v účetním systému a do Tappeeru ho načte integrace. Objeví se tu po první synchronizaci."
        },
        "noResults": "Hledání neodpovídá žádné zaúčtování DPH",
        "directionBoth": "Příjem i výdej",
        "standardRate": "Základní sazba",
        "reducedRate": "Snížená sazba"
      },
      "orgStructure": {
        "error": "Chyba při načítání organizační struktury",
        "empty": {
          "title": "Žádné pozice org. struktury",
          "description": "Organizační strukturu můžete založit ručně, nebo ji zapíše integrační platforma ze zákaznických systémů."
        },
        "searchPlaceholder": "Hledat pozici nebo uživatele...",
        "noSearchResults": "Žádné pozice neodpovídají hledání",
        "create": "Nová pozice",
        "backToTree": "Zpět na strukturu",
        "tree": {
          "expand": "Rozbalit",
          "collapse": "Sbalit",
          "noManager": "Pozice nemá vedoucího"
        },
        "detail": {
          "selectPrompt": "Vyberte pozici ve stromu",
          "managerRole": "vedoucí pozice",
          "noManagerTitle": "Pozice nemá vedoucího",
          "noManagerHint": "Schvalování tuto pozici tiše přeskočí a dokument doputuje k nadřízené pozici.",
          "costCenter": "Středisko",
          "parent": "Nadřízená pozice",
          "rootUnit": "Kořenová pozice",
          "memberCount": "Členů",
          "children": "Podřízené",
          "members": "Členové",
          "membersLoading": "Načítání členů...",
          "noMembers": "Pozice nemá žádné členy",
          "none": "—",
          "edit": "Upravit",
          "addChild": "Přidat podřízený"
        },
        "form": {
          "createTitle": "Nová pozice",
          "editTitle": "Úprava pozice",
          "create": "Založit",
          "save": "Uložit",
          "cancel": "Zrušit",
          "noParent": "Bez nadřízené (kořenová pozice)",
          "noManager": "Bez vedoucího",
          "addMember": "Přidat člena…",
          "removeMember": "Odebrat {{name}} z pozice",
          "noMembers": "Pozice zatím nemá žádné členy.",
          "membersLoading": "Načítání členů…",
          "membersLoadFailed": "Členy pozice se nepodařilo načíst.",
          "noCostCenter": "Bez střediska",
          "fields": {
            "code": "Kód",
            "name": "Název",
            "parent": "Nadřízená pozice",
            "manager": "Vedoucí",
            "members": "Členové",
            "costCenter": "Středisko",
            "description": "Popis",
            "status": "Stav"
          },
          "hints": {
            "code": "Velká písmena, číslice a pomlčky, například OU-NAKUP.",
            "codeLocked": "Kód po založení nelze změnit.",
            "members": "Uživatel může být členem více pozic; přidáním sem ho z jiné pozice neodeberete."
          },
          "success": {
            "created": "Pozice byla založena",
            "updated": "Pozice byla uložena"
          },
          "errors": {
            "codeTaken": "Pozice s tímto kódem už existuje.",
            "saveFailed": "Pozici se nepodařilo uložit.",
            "managerFailed": "Pozice je uložena, vedoucího se ale nepodařilo nastavit.",
            "membersFailed": "Pozice je uložena, některé změny členů se ale nepodařilo uložit."
          }
        },
        "headTag": "Vedoucí"
      },
      "costCenters": {
        "error": "Chyba při načítání nákladových středisek",
        "empty": {
          "title": "Žádná nákladová střediska",
          "description": "Nákladová střediska lze založit ručně, nebo je zapíše integrační platforma ze zákaznických systémů."
        },
        "create": "Nové středisko",
        "searchPlaceholder": "Hledat podle kódu nebo názvu...",
        "noResults": "Žádná střediska neodpovídají hledání",
        "form": {
          "createTitle": "Nové středisko",
          "editTitle": "Úprava střediska",
          "create": "Založit",
          "save": "Uložit",
          "cancel": "Zrušit",
          "fields": {
            "code": "Kód",
            "name": "Název",
            "description": "Popis",
            "status": "Stav"
          },
          "hints": {
            "code": "Velká písmena, číslice a pomlčky, například CC-MARKETING.",
            "codeLocked": "Kód po založení nelze změnit."
          },
          "success": {
            "created": "Středisko bylo založeno",
            "updated": "Středisko bylo uloženo"
          },
          "errors": {
            "codeTaken": "Středisko s tímto kódem už existuje.",
            "saveFailed": "Středisko se nepodařilo uložit."
          }
        }
      },
      "jobs": {
        "error": "Chyba při načítání zakázek",
        "empty": {
          "title": "Žádné zakázky",
          "description": "Zakázky lze založit ručně, nebo je zapíše integrační platforma ze zákaznických systémů."
        },
        "create": "Nová zakázka",
        "searchPlaceholder": "Hledat podle kódu nebo názvu...",
        "noResults": "Žádné zakázky neodpovídají hledání",
        "form": {
          "createTitle": "Nová zakázka",
          "editTitle": "Úprava zakázky",
          "create": "Založit",
          "save": "Uložit",
          "cancel": "Zrušit",
          "fields": {
            "code": "Kód",
            "name": "Název",
            "type": "Typ",
            "status": "Stav",
            "description": "Popis"
          },
          "hints": {
            "code": "Například ZAK-2026-01.",
            "status": "Na doklady lze zakázku přiřadit jen ve stavu Aktivní.",
            "closing": "Uzavřenou zakázku už nelze znovu otevřít."
          },
          "success": {
            "created": "Zakázka byla založena",
            "updated": "Zakázka byla uložena"
          },
          "errors": {
            "codeTaken": "Zakázka s tímto kódem už existuje.",
            "saveFailed": "Zakázku se nepodařilo uložit."
          }
        }
      },
      "filters": {
        "status": {
          "all": "Všechny stavy",
          "label": "Stav"
        },
        "sort": {
          "nameAsc": "Název (A-Z)",
          "nameDesc": "Název (Z-A)",
          "idAsc": "ID (vzestupně)",
          "idDesc": "ID (sestupně)"
        }
      }
    },
    "onboarding": {
      "title": "Ahoj! Jsem Tappeer",
      "subtitle": "Ukážu ti, co umím",
      "description": "Připravil jsem ti ukázkovou fakturu, ať vidíš, jak vytahuji všechny důležité údaje – číslo faktury, částku, dodavatele, splatnost... Zkus to!",
      "trySample": "Nakrm mě ukázkovou fakturou",
      "skipLabel": "Tappeera znám, přeskočit",
      "organization": {
        "header": "Něco o tvé firmě",
        "subtitle": "Řekni mi, kde je tvá firma registrovaná, ať čtu faktury tak, jak to tvá země očekává.",
        "countryLabel": "Země registrace",
        "countryPlaceholder": "Vyberte zemi",
        "locationHint": "Všechno můžete později změnit v Nastavení systému → Organizace.",
        "continue": "Pokračovat",
        "skipLookup": "Pokračovat bez načtení",
        "errors": {
          "countryRequired": "Vyberte zemi, ve které je firma registrovaná.",
          "countrySaveFailed": "Zemi se nepodařilo uložit. Zkuste to prosím znovu."
        },
        "registry": {
          "CZ": {
            "label": "IČO firmy",
            "placeholder": "Zadejte IČO nebo DIČ",
            "hint": "Název firmy, adresu sídla i DIČ načtu z registru ARES."
          },
          "SK": {
            "label": "IČO firmy",
            "placeholder": "Zadejte IČO",
            "hint": "Název firmy a adresu sídla načtu z registru RPO. Daňová čísla nezveřejňuje, DIČ proto doplňte později."
          }
        }
      },
      "accountType": {
        "header": "Čí doklady budeme zpracovávat?",
        "subtitle": "Řekni mi, jestli jde o doklady tvé firmy, nebo o doklady tvých klientů.",
        "company": {
          "title": "Jsme firma",
          "description": "Zpracováváme vlastní doklady."
        },
        "firm": {
          "title": "Jsme účetní kancelář",
          "description": "Spravujeme doklady svých klientů."
        },
        "firmHint": "Když zvolíš účetní kancelář, stane se z této organizace „Moje kancelář“, vznikne board kanceláře pro správu klientů a předplatné se přesune na něj. Za účetní kancelář se můžeš prohlásit i později v Nastavení systému → Správa účtu.",
        "confirm": {
          "intro": "Co se stane, když organizaci prohlásíš za účetní kancelář:",
          "ownBooks": "Tato organizace se stane tvou organizací „Moje kancelář“. Zůstanou jí všechny doklady, e-mailová adresa i integrace.",
          "masterAccountBoard": "Vznikne board kanceláře, na kterém budeš spravovat klienty. Budeš na něm správcem kanceláře.",
          "subscription": "Předplatné se přesune na board kanceláře.",
          "back": "Zpět",
          "submit": "Ano, jsme účetní kancelář"
        },
        "refused": "V organizaci teď jsou i další lidé, proto ji tady za účetní kancelář prohlásit nejde. Udělat to můžeš v Nastavení systému → Správa účtu, kde určíš, kdo z nich bude pracovat v kanceláři."
      },
      "preview": {
        "header": "Ukázková faktura",
        "subtitle": "Mám tu pro tebe tuhle ukázkovou fakturu",
        "proceed": "Vytěžit tuhle fakturu"
      },
      "processing": {
        "title": "Čmuchám data...",
        "subtitle": "Právě prohledávám tvůj doklad a hledám důležité údaje",
        "hint": "Obvykle to zvládnu za 1–2 minuty"
      },
      "complete": {
        "title": "Mám hotovo!",
        "subtitle": "Načítám výsledek...",
        "dataSafety": "Neboj se, tvoje data jsou v bezpečí. Více info v ToS nebo v FAQu na webu."
      },
      "steps": {
        "welcome": "Tappeer",
        "extraction": "Čmuchám...",
        "done": "Hotovo"
      },
      "tooltips": {
        "export": {
          "title": "Exportuj doklad",
          "text": "Pošli ho do účetnictví — ISDOC nebo PDF."
        },
        "qrPayment": {
          "title": "Zaplať QR kódem",
          "text": "Naskenuj QR nebo otevři v bankovní aplikaci."
        },
        "nextDocument": {
          "title": "Vytěžit další doklad",
          "text": "Vrať se zpět a vytěž další doklad ze schránky."
        }
      }
    },
    "quotaExceeded": {
      "titleExceeded": "Ups! – Limit vyčerpán",
      "titleOk": "Nastavení plánu",
      "headline": "Ups! Vyčerpal/a jsi limit vytěžování dokumentů.",
      "headlineOk": "Vše v pořádku!",
      "save": "Uložit",
      "admin": {
        "description": "Měsíční limit tvého plánu byl dosažen. Povol překročení limitu, nebo upgraduj plán.",
        "descriptionOverage": "Limit je dosažen a máš {{count}} vytěžení navíc v tomto cyklu.",
        "descriptionHardCap": "Dosáhl/a jsi absolutního limitu tohoto plánu ({{hardCap}} dokumentů celkem). Pro pokračování je nutný upgrade plánu nebo počkej na reset fakturačního cyklu.",
        "descriptionOk": "Zbývá ti {{count}} dokumentů v tomto fakturačním cyklu. Pokud potřebuješ více, můžeš přejít na vyšší plán níže.",
        "descriptionUnlimited": "Tvůj plán nemá limit dokumentů.",
        "stayOnPlan": "Povolit překročení limitu",
        "overagesEnabled": "Zapnuto – každý další dokument bude zpoplatněn sazbou {{amount}} {{currency}}.",
        "overagesEnabledNoPrice": "Zapnuto – dokumenty nad limit budou zpoplatněny.",
        "overagesDisabled": "Vypnuto – vytěžování bude po dosažení limitu zablokováno.",
        "upgradePlan": "Upgradovat plán",
        "upgradePlanDynamic": "Upgradovat na {{name}}",
        "upgradePlanHint": "Přejdi na vyšší plán s větším limitem.",
        "upgradePlanHintDynamic": "{{amount}} {{currency}} / měsíc – {{docs}} dokumentů měsíčně."
      },
      "member": {
        "description": "Měsíční limit vytěžování dokumentů tvé organizace byl vyčerpán. Kontaktuj prosím administrátora."
      },
      "close": "Zavřít"
    },
    "procurement": {
      "title": "Nákup",
      "overview": {
        "placeholder": "Sem přijde váš přehled — co po vás něco chce a co se vám právě děje.",
        "nothingYet": "Zatím nemáte v nákupním procesu nic svého.",
        "error": "Přehled se nepodařilo načíst.",
        "retry": "Zkusit znovu",
        "stalled": "Zaseklé",
        "stalledHint": "Od {{time}} se tu nic nezměnilo.",
        "invoiceForOrder": "k objednávce {{number}}",
        "showingSome": "Zobrazeno {{shown}} z {{total}}",
        "create": {
          "label": "Nový doklad",
          "requisition": "Žádanka",
          "purchaseOrder": "Objednávka",
          "contract": "Smlouva"
        },
        "lists": "Všechny doklady",
        "bands": {
          "waitingOnMe": {
            "title": "Ke schválení",
            "hint": "Někdo čeká na vaše rozhodnutí.",
            "empty": "Nikdo na vás nečeká."
          },
          "cameBackToMe": {
            "title": "Vráceno k opravě",
            "hint": "Schvalovatel doklad neschválil. Opravte ho a odešlete znovu.",
            "empty": "Nemáte nic k opravě."
          },
          "inProgress": {
            "title": "Rozpracované",
            "hint": "Koncepty, které jste zatím neodeslali. Dokončete je a odešlete ke schválení.",
            "empty": "Nemáte žádné neodeslané koncepty."
          },
          "waitingOnOthers": {
            "title": "Čeká na ostatní",
            "hint": "Odeslali jste je. U každého vidíte, kdo je na tahu a jak dlouho to trvá.",
            "empty": "Nic vašeho není v procesu."
          },
          "recentlyFinished": {
            "title": "Nedávno ukončené",
            "empty": "V posledních dnech jste nic neukončili."
          }
        },
        "subtitle": "Tady vidíte, co je potřeba udělat a kde se co zaseklo.",
        "history": "Historie",
        "kindCount": "{{kind}} ({{count}})",
        "allClear": {
          "title": "Teď po vás nikdo nic nepotřebuje",
          "hint": "Nemáte nic ke schválení ani k opravě.",
          "hintWithDrafts_one": "Nemáte nic ke schválení ani k opravě. Máte ale <strong>{{count}} rozpracovaný doklad</strong>, který jste zatím neodeslali.",
          "hintWithDrafts_few": "Nemáte nic ke schválení ani k opravě. Máte ale <strong>{{count}} rozpracované doklady</strong>, které jste zatím neodeslali.",
          "hintWithDrafts_many": "Nemáte nic ke schválení ani k opravě. Máte ale <strong>{{count}} rozpracovaného dokladu</strong>, který jste zatím neodeslali.",
          "hintWithDrafts_other": "Nemáte nic ke schválení ani k opravě. Máte ale <strong>{{count}} rozpracovaných dokladů</strong>, které jste zatím neodeslali.",
          "finishDrafts": "Dokončit rozpracované"
        },
        "forMe": {
          "title": "Čeká na vás",
          "hint": "Bez vás se tyhle doklady nepohnou."
        },
        "kinds": {
          "REQUISITION": "Žádanka",
          "PURCHASE_ORDER": "Objednávka",
          "GOODS_RECEIPT": "Dodací list",
          "INVOICE": "Faktura",
          "CONTRACT": "Smlouva"
        },
        "kindLists": {
          "REQUISITION": "Žádanky",
          "PURCHASE_ORDER": "Objednávky",
          "GOODS_RECEIPT": "Dodací listy",
          "INVOICE": "Faktury",
          "CONTRACT": "Smlouvy"
        },
        "row": {
          "noSupplier": "dodavatel nevybrán",
          "edited": "upraveno {{time}}",
          "waiting": {
            "minute_one": "čeká {{count}} minutu",
            "minute_few": "čeká {{count}} minuty",
            "minute_many": "čeká {{count}} minuty",
            "minute_other": "čeká {{count}} minut",
            "hour_one": "čeká {{count}} hodinu",
            "hour_few": "čeká {{count}} hodiny",
            "hour_many": "čeká {{count}} hodiny",
            "hour_other": "čeká {{count}} hodin",
            "day_one": "čeká {{count}} den",
            "day_few": "čeká {{count}} dny",
            "day_many": "čeká {{count}} dne",
            "day_other": "čeká {{count}} dní"
          },
          "continue": "Pokračovat",
          "decide": "Rozhodnout",
          "fix": "Opravit",
          "changedAt": "Naposledy změněno {{time}}"
        },
        "progress": {
          "label": "Krok {{step}} z {{total}}: {{name}}",
          "steps": {
            "REQUISITION": "Žádanka",
            "ORDER": "Objednávka",
            "DELIVERY": "Dodání",
            "INVOICE": "Faktura",
            "COMPLETION": "Dokončení"
          }
        },
        "waitingOn": {
          "label": "na tahu: {{who}}",
          "andOthers": "{{name}} a další ({{count}})",
          "named": {
            "AUTOMATION": "{{names}}",
            "APPROVERS": "{{names}}",
            "BUYER": "nákupčí {{names}}",
            "SUPPLIER": "dodavatel {{names}}",
            "VIEWER": "vy"
          },
          "unnamed": {
            "AUTOMATION": "automatické schvalování",
            "APPROVERS": "nikdo, chybí schvalovatel",
            "BUYER": "nákupčí",
            "SUPPLIER": "dodavatel",
            "VIEWER": "vy"
          }
        },
        "howItWorks": {
          "title": "Jak nákup probíhá",
          "steps": {
            "requisition": {
              "title": "Žádanka",
              "hint": "Napíšete, co potřebujete, a pošlete ji ke schválení."
            },
            "order": {
              "title": "Objednávka",
              "hint": "Ze schválené žádanky vznikne objednávka u dodavatele."
            },
            "delivery": {
              "title": "Dodání a faktura",
              "hint": "Potvrdíte převzetí, dodavatel pošle fakturu."
            },
            "paid": {
              "title": "Zaplaceno",
              "hint": "Účtárna fakturu uhradí a nákup se uzavře."
            }
          }
        }
      },
      "requisition": {
        "justification": "Zdůvodnění",
        "internalNote": "Interní poznámka",
        "neededBy": "Termín dodání",
        "estimatedTotal": "Odhad bez DPH",
        "currency": "Měna",
        "costCenter": "Středisko",
        "orgUnit": "Pozice org. struktury",
        "job": "Zakázka",
        "suggestedSupplier": "Preferovaný dodavatel",
        "submittedAt": "Odesláno",
        "approvedAt": "Schváleno",
        "lines": "Požadované položky",
        "title": "Název",
        "suggestedApprover": "Navržený schvalovatel",
        "documentType": "Žádanka"
      },
      "purchaseOrder": {
        "number": "Číslo objednávky",
        "numberRequired": "Číslo objednávky je povinné.",
        "note": "Poznámka pro dodavatele",
        "internalNote": "Interní poznámka",
        "supplier": "Dodavatel",
        "expectedDelivery": "Termín dodání",
        "totalNoVat": "Celkem bez DPH",
        "totalInclVat": "Celkem s DPH",
        "currency": "Měna",
        "costCenter": "Středisko",
        "orgUnit": "Pozice org. struktury",
        "job": "Zakázka",
        "paymentTerms": "Splatnost",
        "paymentTermsDays": "{{days}} dní od faktury",
        "paymentTermsUnit": "dní",
        "paymentTermsInvalid": "Zadejte počet dní od 0 do {{max}}.",
        "paymentDue_one": "{{count}} den (do {{date}})",
        "paymentDue_few": "{{count}} dny (do {{date}})",
        "paymentDue_other": "{{count}} dní (do {{date}})",
        "incoterms": "Incoterms",
        "incotermsPlace": "Místo dle Incoterms",
        "deliveryAddress": "Adresa dodání",
        "dispatchedAt": "Odesláno dodavateli",
        "dispatchedOn": "Odesláno {{date}}",
        "notDispatched": "Neodesláno",
        "lines": "Objednané položky",
        "withVat": "S DPH",
        "title": "Název",
        "documentType": "Objednávka",
        "suggestedApprover": "Navržený schvalovatel",
        "moreDetails": "Další údaje"
      },
      "customer": {
        "title": "Odběratel"
      },
      "party": {
        "registryParty": "Firma z adresáře",
        "notLinked": "Nepřiřazeno",
        "name": "Název",
        "companyId": "IČO",
        "vatId": "DIČ pro DPH",
        "email": "E-mail",
        "phone": "Telefon",
        "address": "Adresa",
        "editParty": "Upravit firmu",
        "editSuccess": "Firma byla upravena",
        "editError": "Firmu se nepodařilo upravit",
        "addSupplier": "Přidat nového dodavatele",
        "addCustomer": "Přidat nového odběratele",
        "createSuccess": "Firma byla vytvořena a přiřazena k dokladu",
        "createdNotLinked": "Firma byla vytvořena, ale k dokladu se ji nepodařilo přiřadit",
        "createError": "Firmu se nepodařilo vytvořit",
        "disconnect": "Odpojit firmu od dokladu",
        "disconnectConfirmTitle": "Odpojit firmu od dokladu?",
        "disconnectConfirmMessage": "Firma bude od dokladu odpojena. Zadané údaje zůstanou zachovány.",
        "disconnectConfirm": "Odpojit",
        "cancel": "Zrušit"
      },
      "lines": {
        "number": "Č.",
        "description": "Popis",
        "productType": "Typ",
        "quantity": "Množství",
        "estimatedUnitPrice": "Odhad za MJ",
        "estimatedTotal": "Odhad celkem",
        "unitPrice": "Cena za MJ",
        "totalNoVat": "Celkem bez DPH",
        "totalInclVat": "Celkem s DPH",
        "empty": "Zatím žádné položky.",
        "code": "Kód položky",
        "codeValue": "Kód položky: {{code}}",
        "coverage": {
          "header": "Objednáno",
          "none": "Neobjednáno",
          "partial": "{{ordered}} z {{requested}}",
          "full": "Objednáno celé"
        },
        "delivery": {
          "header": "Dodáno",
          "none": "Nedodáno",
          "partial": "{{received}} z {{ordered}}",
          "full": "Dodáno celé"
        },
        "invoiced": {
          "header": "Fakturováno",
          "unconfirmed": "Zahrnuje napárování, která zatím nikdo nepotvrdil"
        },
        "unit": "MJ",
        "units": {
          "piece": "ks",
          "hour": "hod",
          "day": "den",
          "kilometre": "km",
          "litre": "l",
          "kilogram": "kg",
          "tonne": "t",
          "metre": "m",
          "squareMetre": "m²",
          "cubicMetre": "m³",
          "package": "bal"
        },
        "vatRate": "Sazba DPH"
      },
      "goodsReceipt": {
        "title": "Dodací list",
        "lines": "Dodané položky",
        "supplier": "Dodavatel",
        "order": "K objednávce",
        "unsolicited": "Dodávka bez objednávky",
        "deliveryNoteNumber": "Číslo dodacího listu dodavatele",
        "carrier": "Přepravce",
        "receivedAt": "Přijato dne",
        "notes": "Poznámka",
        "ordered": "Objednáno",
        "alreadyReceived": "Dodáno dříve",
        "receivingNow": "Tato dodávka",
        "remainingAfter": "Zbývá po této dodávce",
        "context": "Objednáno {{ordered}} {{unit}} · {{received}} dodáno dříve",
        "receiveAll": "Vše ({{quantity}})",
        "overReceipt": "Více než objednáno",
        "overReceiptSummary": "Některé řádky evidují více, než bylo objednáno. To je v pořádku — rozdíl vyřeší párování.",
        "notANumber": "Zadejte číslo.",
        "negative": "Množství nemůže být záporné.",
        "saveReceiving": "Uložit dodávku",
        "outstandingPanel": "Zbývá k dodání",
        "orderStrip": "{{number}} · zbývá {{quantity}}",
        "orderStripDelivered": "{{number}} · kompletně doručeno",
        "orderOutstanding": "Objednávka: zbývá {{quantity}}",
        "withoutDeliveryNote": "Bez dodacího listu",
        "withoutDeliveryNoteHint": "Bez dodacího listu – dodání bylo potvrzeno na objednávce."
      },
      "approverSummary": {
        "label": "Schvaluje:",
        "andOthers": "{{names}} a další ({{count}})",
        "awaitingAutomation": "Schvalovatele vybírá automatika",
        "unassigned": "Schvalovatel zatím není určený",
        "ariaLabel": "{{summary}} – zobrazit schvalovatele",
        "loading": "Načítám schvalovatele…",
        "loadFailed": "Schvalovatele se nepodařilo načíst."
      },
      "approval": {
        "title": "Schvalování",
        "none": "Doklad nečeká na schválení.",
        "counter": "Schválení {{approved}}/{{required}}",
        "hasApproved": "Schválil",
        "targets": "Přiděleno",
        "unit": "Pozice org. struktury",
        "roleTarget": "Všichni s rolí {{role}}",
        "permissionTarget": "Všichni s oprávněním schvalovat",
        "members": "Zobrazit, kdo může rozhodnout",
        "noMembers": "Žádný z členů nemá oprávnění schvalovat.",
        "ownerCannotDecide": "Zakladatel dokladu",
        "ownerCannotDecideTooltip": "Zakladateli dokladu není umožněno rozhodnout o jeho schválení.",
        "history": "Předchozí kola",
        "status": {
          "APPROVED": "Schváleno",
          "REJECTED": "Neschváleno",
          "CANCELLED": "Zrušeno"
        },
        "action": {
          "APPROVED": "schválil",
          "REJECTED": "neschválil"
        },
        "rejectTitle": "Neschválit doklad",
        "rejectDescription": "Doklad {{number}} se vrátí k úpravám. Důvod se zobrazí u záznamu o neschválení.",
        "rejectNote": "Důvod",
        "rejectNotePlaceholder": "Proč doklad neschvalujete",
        "unreachableTitle": "Schválení nemůže proběhnout",
        "unreachable": "Přidělení nevede k žádnému schvalovateli. Změňte schvalovatele, aby doklad mohl být schválen.",
        "awaitingAutomation": "Hledáme, kdo doklad schválí.",
        "manualSelectionTitle": "Vyžadován výběr schvalovatele",
        "edit": "Změnit",
        "choose": "Zvolit",
        "editTitle": "Schvalovatelé",
        "editDescription": "Vyberte uživatele nebo pozice org. struktury, které mají doklad {{number}} schválit. U pozice rozhodují její aktuální členové.",
        "users": "Uživatelé",
        "orgUnits": "Pozice org. struktury",
        "orgUnitsHint": "Člen pozice bez role, která smí schvalovat, se mezi schvalovatele nezařadí.",
        "formerMember": "Bývalý člen",
        "roles": "Role",
        "anyApprover": "Kdokoli, kdo smí schvalovat",
        "anyApproverHint": "Rozhodnout může {{roles}}.",
        "save": "Uložit",
        "targetsRequired": "Vyberte alespoň jednoho schvalovatele.",
        "saveError": "Schvalovatele se nepodařilo změnit.",
        "decideError": "Rozhodnutí se nepodařilo zaznamenat.",
        "aiDecision": "Zobrazit zdůvodnění automatického rozhodnutí",
        "aiApprovedTitle": "Schváleno automaticky",
        "withdrawnTitle": "Schválení odvoláno",
        "withdrawn": "Doklad byl vrácen k úpravám. Před dalším zpracováním musí znovu projít schválením.",
        "aiDecisionTitle": "Automatické rozhodnutí: {{decision}}",
        "aiConfidence": "jistota {{value}} %",
        "aiDecisionNone": "Automatické schvalování u tohoto dokladu zatím neproběhlo.",
        "aiUnresolvedApprover": "Schvalovatele se dle současného nastavení nepodařilo určit. Zvažte úpravu schvalovací politiky.",
        "aiSettingsLink": "Nastavení automatizace schvalování",
        "unassignableTitle": "Schvalovatele nebylo možné přidělit",
        "unassignable": "Podle současného nastavení schvalování nebylo možné určit nikoho, kdo by doklad schválil, proto byl automaticky neschválen. Správce by měl nastavení schvalování zkontrolovat."
      },
      "people": {
        "title": "Lidé",
        "you": "Vy",
        "requester": "Pro koho",
        "createdBy": "Zadal",
        "suggestedApprover": "Navržený schvalovatel",
        "buyer": "Nákupčí",
        "receivedBy": "Přijal"
      },
      "coveringOrders": {
        "title": "Objednávky",
        "empty": "Zatím z ní nevznikla žádná objednávka.",
        "open": "Otevřít objednávku {{number}}"
      },
      "answeredRequisitions": {
        "title": "Žádanky",
        "empty": "Objednávka nevychází ze žádanky.",
        "open": "Otevřít žádanku {{number}}"
      },
      "history": {
        "title": "Historie změn",
        "empty": "Zatím žádné změny.",
        "system": "Systém",
        "approvers": "Schvalovatelé: {{value}}",
        "viewLineChanges": "Zobrazit změny položek",
        "linkedDocument": "{{kind}} {{number}}",
        "linesAdded": "+ {{count}} přidáno",
        "linesRemoved": "- {{count}} odebráno",
        "linesModified": "~ {{count}} upraveno",
        "valueChanged": "změněno",
        "valueCleared": "vymazáno",
        "allLinesOrdered": "Všechny položky objednány",
        "linesNoLongerOrdered": "Některé položky už nejsou objednány",
        "yes": "Ano",
        "no": "Ne"
      },
      "createOrder": {
        "title": "Vytvořit objednávku",
        "description": "Ze žádanky {{number}}. Položky, rozúčtování a kódování se zkopírují.",
        "supplier": "Dodavatel",
        "supplierPlaceholder": "Zatím bez dodavatele",
        "expectedDelivery": "Termín dodání",
        "deliveryAddress": "Adresa dodání",
        "deliveryAddressHint": "Není-li vyplněna, použije se adresa organizace.",
        "lines": "Položky k objednání",
        "linesRequired": "Vyberte alespoň jednu položku.",
        "lineRemaining": "zbývá {{remaining}} z {{requested}} {{unit}}",
        "nothingLeft": "Všechny položky této žádanky jsou už objednané.",
        "submit": "Vytvořit objednávku",
        "error": "Objednávku se nepodařilo vytvořit.",
        "suggestedSupplierNotEffective": "Navržený dodavatel {{name}} dnes není platný, vyberte prosím jiného."
      },
      "actions": {
        "moreActions": "Další akce",
        "cancel": "Zrušit",
        "submitForApproval": "Odeslat ke schválení",
        "submitSuccess": "Odesláno ke schválení.",
        "submitError": "Doklad se nepodařilo odeslat ke schválení.",
        "submitBlockedByErrors": "Doklad obsahuje validační chyby. Odeslání ke schválení je možné až po jejich odstranění.",
        "submitBlockedByValidation": "Probíhá kontrola dokladu. Odeslání ke schválení bude možné po jejím dokončení.",
        "approve": "Schválit",
        "approveSuccess": "Schváleno.",
        "reject": "Neschválit",
        "rejectSuccess": "Neschváleno.",
        "dispatch": "Odeslat dodavateli",
        "createOrder": "Vytvořit objednávku",
        "transitionError": "Stav se nepodařilo změnit.",
        "saveError": "Změnu se nepodařilo uložit.",
        "returnToDraft": "Vrátit k úpravám",
        "returnToDraftSuccess": "Vráceno k úpravám.",
        "closeDocument": "Ukončit",
        "closeDocumentSuccess": "Ukončeno.",
        "cancelDocument": "Zrušit doklad",
        "cancelDocumentSuccess": "Doklad byl zrušen.",
        "copyDocument": "Kopírovat",
        "copySuccess": "Vytvořena kopie dokladu {{number}}.",
        "copyError": "Doklad se nepodařilo zkopírovat.",
        "delete": "Smazat",
        "deleteSuccess": "Smazáno.",
        "deleteError": "Doklad se nepodařilo smazat.",
        "recordDelivery": "Zaevidovat dodávku",
        "recordDeliveryFor": "Zaevidovat dodávku k {{number}}",
        "recordNextDelivery": "Zaevidovat další dodávku",
        "recordDeliveryError": "Dodávku se nepodařilo založit.",
        "deliveryOptions": "Další možnosti dodávky",
        "cancelOptions": "Další možnosti rušení",
        "confirmDeliveryWithoutReceipt": "Potvrdit dodání bez dodacího listu",
        "confirmDeliveryWithoutReceiptSuccess": "Dodání potvrzeno.",
        "confirmDeliveryWithoutReceiptError": "Dodání se nepodařilo potvrdit.",
        "allLinesDelivered": "Všechny položky jsou již plně dodány.",
        "downloadPdf": "Stáhnout PDF",
        "downloadPdfError": "PDF objednávky se nepodařilo stáhnout.",
        "downloadPdfTooLarge": "Objednávka je pro PDF příliš rozsáhlá.",
        "downloadPdfBusy": "PDF nyní nelze vytvořit. Stažení lze zopakovat za několik okamžiků.",
        "confirmDelivery": "Potvrdit dodávku",
        "confirmDeliverySuccess": "Dodávka zaevidována.",
        "orderRaised": "Schváleno. Byla založena objednávka {{number}} — najdete ji v seznamu vázaných dokladů níže.",
        "archive": "Přesunout do archivu",
        "archiveSuccess": "Přesunuto do archivu.",
        "archiveError": "Doklad se nepodařilo přesunout do archivu.",
        "unarchive": "Obnovit z archivu",
        "unarchiveSuccess": "Obnoveno z archivu.",
        "unarchiveError": "Doklad se nepodařilo obnovit z archivu.",
        "closeDocumentHint": "Označí doklad jako vyřízený. Zůstane v přehledech, dokud se nepřesune do archivu.",
        "archiveHint": "Skryje doklad z běžných přehledů. Zůstane jen pro čtení a kdykoli ho obnovíte."
      },
      "flow": {
        "lineStripLabel": "Průběh nákupu položky {{number}}",
        "open": "Otevřít {{number}}",
        "of": "{{quantity}} z {{total}}",
        "matched": "Spárováno {{quantity}}",
        "unconfirmed": "Navržené spárování, dosud nepotvrzené",
        "headerLinked": "Odkazuje na objednávku jako celek; žádná položka zatím není spárována",
        "unbacked": "{{quantity}} bez dodávky",
        "lineCount_one": "{{count}} položka",
        "lineCount_few": "{{count}} položky",
        "lineCount_other": "{{count}} položek"
      },
      "linked": {
        "orders": "Objednávky",
        "requisitions": "Žádanky",
        "receipts": "Dodací listy",
        "invoices": "Faktury",
        "siblingReceipts": "Další dodávky",
        "order": "Objednávka",
        "outstanding": "Zbývá k dodání",
        "contract": "Smlouva",
        "empty": "Zatím nic navázaného.",
        "open": "Otevřít {{number}}"
      },
      "fieldLabels": {
        "lineNumber": "Řádek {{number}}",
        "number": "Číslo dokladu",
        "lines": "Položky",
        "title": "Název",
        "orgUnitId": "Pozice org. struktury",
        "suggestedApproverUserId": "Navržený schvalovatel",
        "supplierPartyId": "Dodavatel",
        "supplierName": "Název dodavatele",
        "supplierVatId": "DIČ pro DPH dodavatele",
        "supplierCompanyId": "IČO dodavatele",
        "supplierContact": "Kontakt na dodavatele",
        "description": "Popis",
        "quantity": "Množství",
        "unitPriceNoVat": "Jednotková cena",
        "status": "Stav",
        "internalNote": "Interní poznámka",
        "costCenterId": "Nákladové středisko",
        "jobId": "Zakázka",
        "currencyCode": "Měna",
        "accountingCurrencyCode": "Účetní měna",
        "justification": "Odůvodnění",
        "requesterId": "Žadatel",
        "neededBy": "Termín dodání",
        "accountingEstimatedAmountNoVat": "Odhad v účetní měně",
        "suggestedSupplierPartyId": "Navržený dodavatel",
        "suggestedSupplierName": "Název navrženého dodavatele",
        "suggestedSupplierVatId": "DIČ pro DPH navrženého dodavatele",
        "suggestedSupplierCompanyId": "IČO navrženého dodavatele",
        "suggestedSupplierAddress": "Adresa navrženého dodavatele",
        "note": "Poznámka pro dodavatele",
        "buyerUserId": "Nákupčí",
        "requesterUserId": "Žadatel",
        "expectedDeliveryDate": "Termín dodání",
        "paymentTermsDays": "Splatnost (dní)",
        "incoterms": "Dodací podmínky",
        "incotermsPlace": "Místo dle Incoterms",
        "withVat": "S DPH",
        "deliveryAddress": "Adresa dodání",
        "notes": "Poznámka",
        "purchaseOrderId": "Objednávka",
        "receivedAt": "Datum přijetí",
        "deliveryNoteNumber": "Číslo dodacího listu dodavatele",
        "carrier": "Přepravce",
        "receivedByUserId": "Přijal",
        "supplierAddress": "Adresa dodavatele",
        "customerPartyId": "Odběratel",
        "customerName": "Název odběratele",
        "customerVatId": "DIČ pro DPH odběratele",
        "customerCompanyId": "IČO odběratele",
        "customerAddress": "Adresa odběratele",
        "supplierEmail": "E-mail dodavatele",
        "supplierPhone": "Telefon dodavatele",
        "customerEmail": "E-mail odběratele",
        "customerPhone": "Telefon odběratele",
        "suggestedSupplierEmail": "E-mail navrženého dodavatele",
        "suggestedSupplierPhone": "Telefon navrženého dodavatele",
        "contractId": "Smlouva"
      },
      "fields": {
        "unset": "Nevyplněno",
        "useTyped": "Použít zadanou hodnotu"
      },
      "linesEditor": {
        "addLine": "Přidat položku",
        "removeLine": "Odebrat položku {{number}}",
        "copyLine": "Kopírovat položku {{number}}",
        "empty": "Zatím žádné položky. Přidejte první.",
        "requiredMissing": "Vyplňte popis a množství u každé položky.",
        "submit": "Uložit položky",
        "error": "Položky se nepodařilo uložit.",
        "discard": "Zahodit změny"
      },
      "lineDetails": {
        "toggle": "Podrobnosti položky {{number}}"
      },
      "lineCoding": {
        "saveItemsFirst": "Nejdřív uložte nebo zahoďte změny položek.",
        "createCostCenter": "Nové středisko",
        "createJob": "Nová zakázka"
      },
      "list": {
        "untitled": "Bez názvu",
        "error": "Seznam se nepodařilo načíst.",
        "retry": "Zkusit znovu",
        "invoice": {
          "title": "Faktury a účtenky"
        },
        "requisition": {
          "title": "Žádanky",
          "searchPlaceholder": "Číslo, název, zdůvodnění nebo dodavatel",
          "empty": "Žádné žádanky neodpovídají filtru.",
          "estimatedTotal": "Odhad bez DPH",
          "tabs": {
            "FOR_EDIT": "K editaci",
            "FOR_APPROVAL": "Ke schválení",
            "TO_ORDER": "K objednání",
            "AWAITING_DELIVERY": "Čeká na dodání",
            "AWAITING_INVOICE": "Čeká na fakturu",
            "REJECTED": "Zamítnuto",
            "CANCELLED": "Zrušeno",
            "COMPLETED": "Ukončeno",
            "ARCHIVED": "Archivováno"
          }
        },
        "purchaseOrder": {
          "title": "Objednávky",
          "searchPlaceholder": "Číslo, název nebo dodavatel",
          "empty": "Žádné objednávky neodpovídají filtru.",
          "totalNoVat": "Celkem bez DPH",
          "tabs": {
            "FOR_EDIT": "K editaci",
            "FOR_APPROVAL": "Ke schválení",
            "TO_SEND": "K odeslání",
            "AWAITING_DELIVERY": "Čeká na dodání",
            "AWAITING_INVOICE": "Čeká na fakturu",
            "REJECTED": "Zamítnuto",
            "CANCELLED": "Zrušeno",
            "COMPLETED": "Ukončeno",
            "ARCHIVED": "Archivováno"
          }
        },
        "goodsReceipt": {
          "title": "Dodací listy",
          "searchPlaceholder": "Číslo, dodací list dodavatele, dodavatel nebo dopravce",
          "empty": "Žádné dodací listy neodpovídají filtru.",
          "receivedAt": "Přijato",
          "unsolicited": "Bez objednávky",
          "tabs": {
            "DRAFT": "K editaci",
            "RECEIVED": "Přijato",
            "CANCELLED": "Zrušeno",
            "ARCHIVED": "Archivováno"
          }
        },
        "contract": {
          "title": "Smlouvy"
        },
        "sort": {
          "createdAt": "Vytvořeno",
          "updatedAt": "Změněno",
          "number": "Číslo",
          "title": "Název",
          "neededBy": "Termín dodání",
          "expectedDelivery": "Termín dodání",
          "receivedAt": "Přijato",
          "amount": "Částka"
        },
        "dates": {
          "createdAt": "Vytvořeno",
          "approvedAt": "Schváleno",
          "sentAt": "Odesláno",
          "confirmedAt": "Potvrzeno",
          "delivery": "Dodáno"
        }
      },
      "completion": {
        "completed": "Ukončeno",
        "delivery": "Dodání",
        "invoicing": "Fakturace",
        "infoManualBy": "Ukončeno {{date}} · ručně: {{name}}",
        "infoManual": "Ukončeno {{date}} · ručně",
        "infoAutomatic": "Ukončeno {{date}} · automaticky",
        "settingsLink": "Nastavení ukončení"
      },
      "archive": {
        "archived": "Archivováno",
        "info": "Archivováno {{date}}",
        "explanation": "Archivovaný doklad je jen pro čtení. V přehledech je pod záložkou Archivováno."
      },
      "cancellation": {
        "cancelled": "Zrušeno",
        "info": "Zrušeno {{date}}",
        "infoBy": "Zrušeno {{date}} · {{name}}",
        "reason": "Důvod: {{reason}}"
      },
      "confirm": {
        "archive": {
          "title": "Přesunout doklad do archivu?",
          "message": "Opravdu chcete přesunout {{number}} do archivu?",
          "warning": "Doklad zmizí z běžných přehledů a zůstane jen pro čtení. Najdete ho pod záložkou Archivováno a kdykoli ho obnovíte.",
          "confirm": "Přesunout do archivu"
        },
        "close": {
          "title": "Ukončit doklad?",
          "message": "Opravdu ukončit {{number}}?",
          "confirm": "Ukončit"
        },
        "cancel": {
          "title": "Zrušit doklad?",
          "message": "Opravdu chcete zrušit {{number}}?",
          "warning": "Se zrušeným dokladem už nelze dále pracovat.",
          "reason": "Důvod (nepovinný)",
          "reasonPlaceholder": "Proč doklad rušíte?",
          "reasonTooLong": "Důvod může mít nejvýše {{max}} znaků.",
          "confirm": "Zrušit doklad",
          "keep": "Zpět"
        },
        "delete": {
          "title": "Smazat doklad?",
          "message": "Opravdu chcete smazat {{number}}?",
          "warning": "Doklad zmizí ze seznamů a v aplikaci ho už neotevřete.",
          "confirm": "Smazat"
        },
        "deliveryWithoutReceipt": {
          "title": "Potvrdit dodání bez dodacího listu",
          "lead": "Zaškrtněte dodané položky a upravte množství.",
          "columns": {
            "line": "Položka",
            "unit": "MJ",
            "remaining": "Zbývá",
            "quantity": "Dodáno"
          },
          "overMax": "Nejvýše {{max}}",
          "positive": "Zadejte množství větší než 0.",
          "confirm": "Potvrdit dodání"
        },
        "lineCoding": {
          "costCenter": {
            "title": "Změnit středisko u všech položek?",
            "message_one": "{{count}} položka má vlastní středisko nebo žádné. Změnou ho přepíšete.",
            "message_few": "{{count}} položky mají vlastní středisko nebo žádné. Změnou ho přepíšete.",
            "message_many": "{{count}} položky má vlastní středisko nebo žádné. Změnou ho přepíšete.",
            "message_other": "{{count}} položek má vlastní středisko nebo žádné. Změnou ho přepíšete.",
            "confirm": "Změnit středisko"
          },
          "job": {
            "title": "Změnit zakázku u všech položek?",
            "message_one": "{{count}} položka má vlastní zakázku nebo žádnou. Změnou ji přepíšete.",
            "message_few": "{{count}} položky mají vlastní zakázku nebo žádnou. Změnou ji přepíšete.",
            "message_many": "{{count}} položky má vlastní zakázku nebo žádnou. Změnou ji přepíšete.",
            "message_other": "{{count}} položek má vlastní zakázku nebo žádnou. Změnou ji přepíšete.",
            "confirm": "Změnit zakázku"
          }
        }
      },
      "completionConditions": {
        "lead": "Doklad nesplňuje tyto podmínky ukončení:",
        "settingsInfo": "Podmínky ukončení nastavíte v automatizaci.",
        "orderNotDispatched": "Objednávka není označena jako odeslaná",
        "orderNotApproved": "Objednávka není schválena",
        "requisitionNotOrdered": "Žádanka není objednána",
        "requisitionNotApproved": "Žádanka není schválena",
        "deliveryIncomplete": "Neúplné dodání",
        "invoicingIncomplete": "Neúplná fakturace",
        "invoiceNotApproved": "Faktura není schválena",
        "invoiceNotPaid": "Faktura není proplacena",
        "invoiceNotPosted": "Faktura není zaúčtována",
        "question": "Opravdu chcete doklad ukončit ručně?"
      },
      "acceptWarnings": {
        "title": "Přijmout varování",
        "message_one": "Doklad obsahuje {{count}} varování. Potvrzením se varování přijme a doklad se odešle ke schválení. Další úprava dokladu přijetí zruší.",
        "message_few": "Doklad obsahuje {{count}} varování. Potvrzením se varování přijmou a doklad se odešle ke schválení. Další úprava dokladu přijetí zruší.",
        "message_other": "Doklad obsahuje {{count}} varování. Potvrzením se varování přijmou a doklad se odešle ke schválení. Další úprava dokladu přijetí zruší.",
        "notePlaceholder": "Poznámka k přijetí varování (nepovinné)",
        "confirm": "Přijmout a odeslat",
        "acceptError": "Varování se nepodařilo přijmout."
      },
      "dispatch": {
        "title": "Odeslání objednávky dodavateli",
        "description": "Objednávka {{number}} se odešle e-mailem s PDF v příloze, nebo se pouze označí jako odeslaná.",
        "emailUnavailable": "Odesílání e-mailů není k dispozici. Objednávku lze pouze označit jako odeslanou.",
        "buyerMissing": "Objednávka nemá nákupčího s e-mailovou adresou pro odpovědi dodavatele. Před odesláním e-mailem je nutné nákupčího doplnit; jinak lze objednávku pouze označit jako odeslanou.",
        "replyTo": "Odpovědi dodavatele směřují na: {{addresses}}",
        "recipients": "Příjemci",
        "recipientsHint": "Více adres se odděluje čárkou nebo středníkem. E-mail obdrží první adresa, ostatní kopii.",
        "recipientsInvalid": "Adresy nejsou platné nebo je jich více než {{max}}.",
        "subject": "Předmět",
        "body": "Text e-mailu",
        "saveAsTemplate": "Uložit jako šablonu",
        "saveAsTemplateDescription": "Předmět a text budou k dispozici pro další objednávky. Číslo objednávky, dodavatel, firma a odesílatel se doplňují podle konkrétní objednávky.",
        "templateName": "Název šablony",
        "templateNameReplaces": "Šablona s tímto názvem bude přepsána.",
        "template": "Šablona",
        "defaultTemplate": "Výchozí",
        "manageTemplates": "Spravovat šablony",
        "deleteTemplate": "Smazat šablonu {{name}}",
        "deleteTemplateError": "Šablonu se nepodařilo smazat.",
        "cancel": "Zrušit",
        "markAsSent": "Označit jako odeslanou bez e-mailu",
        "sendEmail": "Odeslat e-mail",
        "emailSuccess": "Objednávka je odeslána dodavateli.",
        "markedSuccess": "Objednávka je označena jako odeslaná.",
        "emailError": "E-mail se nepodařilo odeslat. Objednávka zůstává ve stavu Schváleno.",
        "sentStatusNotUpdated": "E-mail byl dodavateli odeslán, stav objednávky se však nepodařilo změnit. Opětovné odeslání není nutné; objednávku stačí označit jako odeslanou.",
        "sendInProgress": "Objednávka se právě odesílá. Opakované odeslání není možné.",
        "confirmDeleteTitle": "Smazání šablony",
        "confirmDeleteMessage": "Šablona {{name}} bude odstraněna pro celou organizaci.",
        "confirmDelete": "Smazat",
        "draftError": "Návrh e-mailu se nepodařilo načíst. Objednávku lze označit jako odeslanou."
      },
      "contract": {
        "label": "Smlouva",
        "currencyConfirm": {
          "title": "Navázat smlouvu v jiné měně?",
          "message": "Měna dokladu se změní na {{currency}} podle smlouvy. Ceny položek zůstanou, jak jsou zadané, takže je zkontrolujte.",
          "confirm": "Navázat smlouvu",
          "cancel": "Zrušit"
        }
      }
    },
    "contracts": {
      "picker": {
        "label": "Smlouva",
        "placeholder": "Hledat smlouvu",
        "clear": "Bez smlouvy"
      },
      "list": {
        "title": "Smlouvy",
        "searchPlaceholder": "Hledat číslo nebo název",
        "empty": "Žádné smlouvy neodpovídají filtru.",
        "create": "Nová smlouva",
        "untitled": "Bez názvu",
        "term": "{{from}} – {{to}}",
        "termOpenEnded": "Od {{from}} na dobu neurčitou",
        "validFromLabel": "Platí od",
        "validToLabel": "Platí do",
        "openEnded": "neurčito",
        "endsLabel": "Končí",
        "limitNoVat": "Limit bez DPH",
        "used": "Vyčerpáno {{percent}} %",
        "costCenter": "Středisko",
        "job": "Zakázka",
        "tabs": {
          "DRAFT": "Koncepty",
          "NOT_YET_IN_FORCE": "Zatím neplatí",
          "IN_FORCE": "Platné",
          "TERMINATING": "Ve výpovědi",
          "ENDED": "Skončené"
        }
      },
      "create": {
        "title": "Nová smlouva",
        "submit": "Vytvořit smlouvu",
        "cancel": "Zrušit",
        "fields": {
          "direction": "Druh smlouvy",
          "contractType": "Typ smlouvy",
          "noContractType": "Bez typu",
          "supplier": "Dodavatel",
          "customer": "Odběratel",
          "partyPlaceholder": "Vyberte firmu",
          "title": "Název",
          "counterpartyNumber": "Číslo smlouvy u protistrany",
          "currency": "Měna",
          "validityFrom": "Platnost od",
          "validityTo": "Platnost do",
          "validFrom": "Účinnost od",
          "validTo": "Účinnost do",
          "openEnded": "Na dobu neurčitou",
          "limitAmount": "Limit bez DPH",
          "noticePeriodDays": "Výpovědní lhůta (dny)",
          "owner": "Odpovědná osoba",
          "costCenter": "Středisko",
          "job": "Zakázka",
          "noCostCenter": "Bez střediska",
          "noJob": "Bez zakázky",
          "note": "Poznámka"
        },
        "hints": {
          "counterpartyNumber": "Číslo, které protistrana píše na faktury.",
          "currency": "V této měně je limit i navázané doklady.",
          "limitAmount": "Nepovinné. Platí pro celou smlouvu."
        },
        "errors": {
          "partyRequired": "Vyberte firmu.",
          "currencyRequired": "Vyberte měnu.",
          "validityToBeforeFrom": "Platnost nemůže končit dřív, než začne.",
          "validFromRequired": "Vyplňte, od kdy je smlouva účinná.",
          "validFromTooEarly": "Smlouva nemůže začínat víc než {{years}} let zpátky.",
          "validToRequired": "Vyplňte, do kdy je smlouva účinná, nebo zvolte dobu neurčitou.",
          "validToBeforeFrom": "Konec nemůže být dřív než začátek.",
          "noticeRange": "Zadejte celý počet dnů od 0 do {{maxDays}}.",
          "limitInvalid": "Limit nemůže být záporný.",
          "createFailed": "Smlouvu se nepodařilo vytvořit. Zkuste to prosím znovu."
        }
      },
      "party": {
        "title": "Smlouvy",
        "create": "Nová smlouva",
        "showAll": "Zobrazit vše ({{total}})",
        "empty": "S touto firmou zatím žádnou smlouvu nemáte.",
        "loadFailed": "Smlouvy se nepodařilo načíst.",
        "retry": "Zkusit znovu"
      },
      "detail": {
        "documentType": "Smlouva",
        "deleteConfirm": "Opravdu chcete smazat smlouvu {{number}}?",
        "actions": {
          "activate": "Aktivovat",
          "activateSuccess": "Smlouva je aktivní.",
          "activateError": "Smlouvu se nepodařilo aktivovat.",
          "copy": "Kopírovat",
          "copySuccess": "Vytvořena kopie smlouvy {{number}}.",
          "copyError": "Smlouvu se nepodařilo zkopírovat.",
          "delete": "Smazat",
          "deleteSuccess": "Smlouva je smazaná.",
          "deleteError": "Smlouvu se nepodařilo smazat.",
          "saveError": "Změnu se nepodařilo uložit.",
          "moreActions": "Další akce"
        },
        "fields": {
          "title": "Název",
          "note": "Poznámka",
          "direction": "Druh smlouvy",
          "contractType": "Typ smlouvy",
          "noContractType": "Bez typu",
          "supplier": "Dodavatel",
          "customer": "Odběratel",
          "counterpartyNumber": "Číslo smlouvy u protistrany",
          "validityFrom": "Platnost od",
          "validityTo": "Platnost do",
          "signedOn": "Datum podpisu",
          "validityOrder": "Platnost nemůže začínat později, než končí.",
          "owner": "Odpovědná osoba",
          "noOwner": "Bez odpovědné osoby",
          "costCenter": "Středisko",
          "job": "Zakázka",
          "noCostCenter": "Bez střediska",
          "noJob": "Bez zakázky",
          "currency": "Měna",
          "noticePeriod": "Výpovědní lhůta",
          "limitAmount": "Limit bez DPH",
          "noLimit": "Bez limitu",
          "limitInvalid": "Limit nemůže být záporný.",
          "days_one": "{{count}} den",
          "days_few": "{{count}} dny",
          "days_many": "{{count}} dne",
          "days_other": "{{count}} dní",
          "wholeNumber": "Zadejte celé číslo od {{min}} do {{max}}."
        },
        "facts": {
          "effectiveEnd": "Účinnost do",
          "indefinite": "Na dobu neurčitou",
          "cancellationDeadline": "Vypovědět nejpozději",
          "deadlinePassed": "{{date}} (lhůta uplynula)",
          "terminated": "Vypovězeno",
          "created": "Vytvořeno"
        },
        "terms": {
          "current": "Aktuální období",
          "range": "{{from}} – {{to}}",
          "openEnded": "od {{from}} na dobu neurčitou",
          "terminatedEnd": "(ukončeno výpovědí, původně do {{date}})",
          "terminatedEndOpenEnded": "(ukončeno výpovědí, původně na dobu neurčitou)",
          "terminatedBeforeStart": "(vypovězeno před začátkem)"
        },
        "linked": {
          "more_one": "+{{count}} další",
          "more_few": "+{{count}} další",
          "more_many": "+{{count}} dalších",
          "more_other": "+{{count}} dalších",
          "notCountedOtherCurrency": "Nezapočteno – jiná měna",
          "amountNoVat": "{{amount}} bez DPH",
          "loadError": "Navázané doklady se nepodařilo načíst.",
          "retry": "Zkusit znovu"
        },
        "references": {
          "title": "Odkazy",
          "registryNumber": "Číslo v registru smluv",
          "archiveNumber": "Číslo fyzické archivace"
        },
        "deleteDialog": {
          "title": "Smazat smlouvu?",
          "warning": "Smlouva zmizí ze seznamů a v aplikaci ji už neotevřete."
        },
        "directionChange": {
          "title": "Změnit druh smlouvy",
          "lead": "Současná protistrana se k tomuto druhu smlouvy nehodí. Vyberte novou.",
          "submit": "Změnit druh",
          "cancel": "Zrušit",
          "error": "Druh smlouvy se nepodařilo změnit. Zkontrolujte protistranu a zkuste to znovu."
        }
      },
      "history": {
        "fieldLabels": {
          "number": "Číslo",
          "title": "Název",
          "note": "Poznámka",
          "direction": "Druh smlouvy",
          "contractType": "Typ smlouvy",
          "partyId": "Protistrana",
          "counterpartyNumber": "Číslo smlouvy u protistrany",
          "validityFrom": "Platnost od",
          "validityTo": "Platnost do",
          "signedOn": "Datum podpisu",
          "registryNumber": "Číslo v registru smluv",
          "archiveNumber": "Číslo fyzické archivace",
          "ownerUserId": "Odpovědná osoba",
          "noticePeriodDays": "Výpovědní lhůta",
          "autoRenew": "Automatické prodloužení",
          "renewalTermMonths": "Délka prodloužení",
          "currencyCode": "Měna",
          "costCenterId": "Středisko",
          "jobId": "Zakázka",
          "status": "Stav",
          "endsOn": "Konec smlouvy",
          "validFrom": "Účinnost od",
          "validTo": "Účinnost do",
          "limitAmount": "Limit bez DPH"
        },
        "valueChanged": "změněno",
        "valueCleared": "vymazáno",
        "yes": "Ano",
        "no": "Ne",
        "days_one": "{{count}} den",
        "days_few": "{{count}} dny",
        "days_many": "{{count}} dne",
        "days_other": "{{count}} dní",
        "months_one": "{{count}} měsíc",
        "months_few": "{{count}} měsíce",
        "months_many": "{{count}} měsíce",
        "months_other": "{{count}} měsíců",
        "termRange": "{{from}} – {{to}}",
        "termOpenEnded": "od {{from}} na dobu neurčitou",
        "termLimit": "limit {{amount}} bez DPH",
        "noLimit": "bez limitu",
        "indefinite": "na dobu neurčitou",
        "termModified": "Období od {{from}}: {{changes}}"
      },
      "usage": {
        "title": "Čerpání",
        "ariaLabel": "Čerpání limitu",
        "used": "Vyčerpáno {{percent}} %",
        "overLimit": "Limit je překročený",
        "committed": "Objednáno",
        "spent": "Vyfakturováno",
        "remaining": "Zbývá",
        "noVat": "Částky jsou bez DPH.",
        "uncounted_one": "{{count}} faktura v jiné měně se nezapočítává.",
        "uncounted_few": "{{count}} faktury v jiné měně se nezapočítávají.",
        "uncounted_many": "{{count}} faktury v jiné měně se nezapočítává.",
        "uncounted_other": "{{count}} faktur v jiné měně se nezapočítává."
      },
      "terms": {
        "allTerms": "Všechna období",
        "edit": "Upravit období",
        "delete": "Smazat období",
        "editModal": {
          "title": "Upravit období",
          "submit": "Uložit",
          "cancel": "Zrušit",
          "validFrom": "Účinnost od",
          "validTo": "Účinnost do",
          "openEnded": "Na dobu neurčitou",
          "hints": {
            "validFromFixed": "Začátek období aktivní smlouvy se už nemění.",
            "validToFixed": "Konec může změnit jen poslední období, jinak by mezi obdobími vznikla mezera."
          },
          "errors": {
            "validFromRequired": "Vyplňte, od kdy je období účinné.",
            "validToRequired": "Vyplňte, do kdy je období účinné, nebo zvolte dobu neurčitou.",
            "validToBeforeFrom": "Konec nemůže být dřív než začátek.",
            "currentEndsBeforeToday": "Aktuální období nemůže skončit dřív než dnes.",
            "failed": "Období se nepodařilo uložit. Zkuste to prosím znovu."
          },
          "saved": "Období je uložené."
        },
        "deleteConfirm": {
          "title": "Smazat období?",
          "message": "Opravdu chcete smazat období {{range}}?",
          "confirm": "Smazat",
          "cancel": "Zpět"
        },
        "deleted": "Období je smazané.",
        "deleteFailed": "Období se nepodařilo smazat."
      },
      "renew": {
        "action": "Prodloužit",
        "title": "Prodloužit smlouvu",
        "startsOn": "Nové období začne {{date}}, den po konci toho posledního.",
        "length": "Délka období",
        "lengthOptions": {
          "SAME_AS_LAST": "Stejně dlouho jako poslední období",
          "UNTIL": "Do zvoleného dne",
          "INDEFINITE": "Na dobu neurčitou"
        },
        "sameLengthUntil_one": "Do {{date}} ({{count}} měsíc).",
        "sameLengthUntil_few": "Do {{date}} ({{count}} měsíce).",
        "sameLengthUntil_many": "Do {{date}} ({{count}} měsíce).",
        "sameLengthUntil_other": "Do {{date}} ({{count}} měsíců).",
        "validTo": "Účinnost do",
        "submit": "Prodloužit",
        "cancel": "Zrušit",
        "errors": {
          "validToRequired": "Vyplňte, do kdy je nové období účinné.",
          "validToBeforeStart": "Konec nemůže být dřív než začátek nového období.",
          "failed": "Smlouvu se nepodařilo prodloužit. Zkuste to prosím znovu."
        },
        "success": "Smlouva je prodloužená."
      },
      "terminate": {
        "action": "Vypovědět",
        "endedTooltip": "Smlouva už skončila, není co vypovídat.",
        "title": "Vypovědět smlouvu",
        "end": "Konec smlouvy",
        "modes": {
          "END_OF_TERM": "Na konci aktuálního období",
          "ON_DATE": "K vybranému dni"
        },
        "endOfTerm": "Smlouva skončí {{date}} a už se neprodlouží.",
        "openEnded": "Aktuální období je na dobu neurčitou, vyberte den, kdy smlouva skončí.",
        "endsOn": "Poslední den účinnosti",
        "laterTerms": "Pozdější období, proti kterým se zatím nic nezapočítalo, se smažou.",
        "submit": "Vypovědět",
        "cancel": "Zpět",
        "errors": {
          "endsOnRequired": "Vyberte den, kdy smlouva skončí.",
          "endsOnInPast": "Smlouva nemůže skončit v minulosti.",
          "failed": "Smlouvu se nepodařilo vypovědět. Zkuste to prosím znovu.",
          "endsOnAfterTermEnd": "Smlouva může skončit nejpozději {{date}}, s koncem aktuálního období."
        },
        "success": "Smlouva je vypovězená."
      }
    },
    "credits": {
      "banner": {
        "payerTitle": "AI je pozastavená, došly kredity",
        "payerAction": "Doplnit kredity",
        "askAdmin": "Požádejte správce o doplnění kreditů.",
        "clientTitle": "AI je pozastavená – kontaktujte {{master}}"
      },
      "status": {
        "panelDescription": "Doklad je uložený. Tappeer ho vytěží, jakmile budou kredity k dispozici."
      },
      "billing": {
        "title": "Kredity",
        "usage": "{{used}} / {{allotment}} kreditů",
        "usedPercent": "{{percent}} %",
        "available_one": "{{credits}} kredit k dispozici",
        "available_few": "{{credits}} kredity k dispozici",
        "available_many": "{{credits}} kreditu k dispozici",
        "available_other": "{{credits}} kreditů k dispozici",
        "extra": "+{{credits}} navíc",
        "renewsOn": "Kredity se obnoví {{date}}",
        "endsOn": "Končí {{date}}",
        "noPeriod": "Žádné běžící období",
        "progressAriaLabel": "Čerpání kreditů: {{label}}",
        "transactionsLink": "Výpis kreditů",
        "low": "Kredity docházejí",
        "exhausted": "Kredity došly, AI je pozastavená",
        "buyPack": "Koupit balíček",
        "upgrade": "Navýšit tarif",
        "openPortal": "Upravit platbu",
        "upgradePaidFirst": "Navýšený tarif začne platit, až zaplatíte fakturu za navýšení.",
        "pendingUpgrade": {
          "title": "Navýšení tarifu na {{planName}} čeká na zaplacení faktury",
          "payInvoice": "Zaplatit fakturu"
        }
      },
      "packs": {
        "title": "Koupit balíček kreditů",
        "description": "Kredity z balíčku se připíšou k vašim kreditům, jakmile platbu dokončíte.",
        "credits_one": "{{credits}} kredit",
        "credits_few": "{{credits}} kredity",
        "credits_many": "{{credits}} kreditu",
        "credits_other": "{{credits}} kreditů",
        "price": "{{price}} bez DPH",
        "buy": "Koupit",
        "loadMore": "Načíst další",
        "empty": "Teď pro vás nemáme žádný balíček.",
        "loadError": "Balíčky se nepodařilo načíst. Zkuste to prosím za chvíli.",
        "refusal": {
          "MANAGED_CLIENT": "Kredity za vás platí vaše účetní kancelář, balíček proto může koupit jen ona.",
          "FREE_PLAN": "Balíčky kreditů jsou v placených tarifech. Pro další kredity přejděte na vyšší tarif.",
          "MANUAL_PLAN": "Váš tarif nastavuje Tappeer. Pro další kredity se nám ozvěte.",
          "NOT_CREDITS_PLAN": "Váš tarif se neúčtuje v kreditech, balíček k němu koupit nejde.",
          "SUBSCRIPTION_NOT_ACTIVE": "Předplatné není aktivní. Upravte platbu a balíčky budou zase k dispozici.",
          "CHANGE_SCHEDULED": "Máte naplánovanou změnu nebo zrušení tarifu. Balíček půjde koupit, až ji zrušíte nebo až proběhne.",
          "PENDING_DELETION": "Účet je naplánovaný ke smazání, balíček teď koupit nejde."
        },
        "error": {
          "notOffered": "Tento balíček už v nabídce není. Vyberte si prosím jiný.",
          "generic": "Platbu se teď nepodařilo otevřít. Zkuste to prosím za chvíli."
        }
      },
      "transactions": {
        "title": "Výpis kreditů",
        "backToBilling": "Zpět na tarif",
        "columns": {
          "date": "Datum",
          "type": "Typ",
          "operation": "Operace",
          "bucket": "Zdroj",
          "amount": "Změna",
          "balanceAfter": "Zůstatek",
          "user": "Uživatel",
          "client": "Klient"
        },
        "entryType": {
          "CHARGE": "Čerpání",
          "GRANT": "Přidělení",
          "EXPIRY": "Propadnutí",
          "ADJUSTMENT": "Úprava"
        },
        "bucket": {
          "PLAN_PERIOD": "Příděl tarifu",
          "PACK": "Balíček",
          "MANUAL": "Ruční příděl"
        },
        "operator": "Tappeer",
        "formerClient": "Bývalý nebo nedostupný klient",
        "empty": "Zatím tu nejsou žádné pohyby kreditů.",
        "loadMore": "Načíst další",
        "loadError": "Výpis se nepodařilo načíst. Zkuste to prosím za chvíli.",
        "noAccess": {
          "title": "Výpis kreditů vidí jen správce fakturace",
          "description": "Pokud ho potřebujete, požádejte správce."
        }
      },
      "purchase": {
        "success": "Kredity se připíšou do minuty",
        "cancel": "Nákup byl zrušen"
      }
    },
    "documentHandler": {
      "banner": "Doklad řeší {{name}}"
    },
    "masterAccountIntegrationTemplates": {
      "list": {
        "intro": "Šablona je hotové nastavení instalace a konektorů, které pak nasadíte svým klientům. Co má každý klient jiné, vyplníte až u něj.",
        "new": "Nová šablona",
        "filter": {
          "label": "Systém",
          "all": "Všechny systémy"
        },
        "columns": {
          "name": "Název",
          "system": "Systém",
          "connectors": "Konektory",
          "updatedAt": "Upraveno",
          "actions": "Akce"
        },
        "connectors_one": "{{count}} konektor",
        "connectors_few": "{{count}} konektory",
        "connectors_many": "{{count}} konektoru",
        "connectors_other": "{{count}} konektorů",
        "noConnectors": "Bez konektorů",
        "needsReview": "Vyžaduje kontrolu",
        "delete": "Smazat šablonu {{name}}",
        "loadError": "Šablony se nepodařilo načíst. Zkuste stránku načíst znovu.",
        "empty": {
          "title": "Zatím tu žádná šablona není.",
          "description": "Nastavte instalaci jednou a pak ji nasaďte všem klientům, kteří ji potřebují.",
          "filtered": "Pro tento systém tu žádná šablona není."
        },
        "shown": "Zobrazeno {{shown}} z {{total}}",
        "loadMore": "Načíst další",
        "deleteConfirm": {
          "title": "Smazat šablonu?",
          "message": "Šablona „{{name}}“ zmizí. Klientům, kteří už z ní mají nastavenou integraci, se nic nezmění.",
          "confirm": "Smazat šablonu",
          "cancel": "Zrušit",
          "done": "Šablona je smazaná.",
          "failed": "Šablonu se nepodařilo smazat. Zkuste to prosím znovu."
        },
        "apply": "Nasadit šablonu {{name}} klientům",
        "applyShort": "Nasadit"
      },
      "editor": {
        "newTitle": "Nová šablona integrace",
        "back": "Šablony integrací",
        "loadError": "Šablonu se nepodařilo načíst. Zkuste stránku načíst znovu.",
        "pluginUnavailable": "Systém {{externalApp}} teď v katalogu není, takže šablonu nejde upravit.",
        "basics": {
          "title": "Systém a název",
          "plugin": "Systém",
          "pluginPlaceholder": "Vyberte systém",
          "pluginHint": "Po uložení šablony už systém změnit nejde.",
          "pluginLocked": "Systém uložené šablony změnit nejde. Pro jiný systém založte novou šablonu.",
          "noPlugins": "Žádný systém z katalogu se do šablony uložit nedá.",
          "pickFirst": "Vyberte systém a ukáže se, co šablona nastaví.",
          "name": "Název šablony",
          "nameHint": "Pod tímto názvem šablonu v kanceláři najdete."
        },
        "installation": {
          "title": "Instalace",
          "description": "Tohle nastavení instalace systému {{externalApp}} dostane každý klient. Co má každý klient jiné, označte „Vyplní se u klienta“: šablona si to neuloží a vyplníte to až při nasazení.",
          "nameLabel": "Název instalace u klienta",
          "nameHint": "Tak se bude instalace jmenovat u každého klienta."
        },
        "perClient": {
          "toggle": "Vyplní se u klienta",
          "forcedAgenda": "Agendu má každý klient vlastní, proto ji vyplníte vždy u klienta.",
          "forcedSecret": "Přístupové údaje patří každému klientovi zvlášť, proto je vyplníte vždy u klienta.",
          "toggleFor": "Vyplní se u klienta: {{setting}}"
        },
        "connectors": {
          "title": "Konektory",
          "intro": "Tyto konektory dostane každý klient. Založí se vypnuté, zapnete je až u klienta.",
          "none": "Systém {{externalApp}} nenabízí nic, co by šlo synchronizovat.",
          "include": "Zahrnout do šablony",
          "defaultName": "{{externalApp}} – {{entity}}",
          "name": "Název konektoru",
          "directions": "Směr synchronizace",
          "schedule": "Kdy se spouští",
          "settings": "Nastavení konektoru",
          "settingsEmpty": "Konektor nemá žádná vlastní nastavení."
        },
        "rules": {
          "title": "Pravidla",
          "defaults": "Výchozí pravidla pluginu",
          "imported": "Importovaná pravidla",
          "custom": "Vlastní pravidla",
          "hint": "Pravidla se v šabloně neupravují. Importujte soubor exportovaný z konektoru, nebo nechte výchozí pravidla pluginu.",
          "import": "Importovat pravidla",
          "useDefaults": "Použít výchozí pravidla pluginu",
          "confirm": {
            "file": "Pravidla a tok polí tohoto konektoru budou nahrazeny těmi ze souboru {{name}}. Nic se neuloží, dokud šablonu neuložíte.",
            "pasted": "Pravidla a tok polí tohoto konektoru budou nahrazeny těmi z vloženého textu. Nic se neuloží, dokud šablonu neuložíte."
          },
          "replaced": "Pravidla jsou nahrazená. Uložte šablonu, ať se zachovají."
        },
        "needsReview": {
          "title": "Šablonu je potřeba zkontrolovat",
          "body": "Systém {{externalApp}} změnil svá nastavení. Projděte šablonu a uložte ji znovu, než ji nasadíte klientům."
        },
        "save": {
          "label": "Uložení šablony",
          "unsaved": "Máte neuložené změny.",
          "new": "Nová šablona zatím není uložená.",
          "review": "Šablonu je potřeba znovu uložit.",
          "discard": "Zahodit změny",
          "cancel": "Zrušit",
          "save": "Uložit šablonu",
          "saving": "Ukládám…",
          "created": "Šablona je uložená.",
          "saved": "Změny šablony jsou uložené.",
          "fixErrors": "Něco ve formuláři nesedí. Opravte zvýrazněná pole."
        },
        "errors": {
          "nameRequired": "Vyplňte název šablony.",
          "installationNameRequired": "Vyplňte název instalace.",
          "connectorNameRequired": "Vyplňte název konektoru.",
          "directionsRequired": "Vyberte aspoň jeden směr.",
          "nameConflict": "Šablona s tímto názvem už v kanceláři je. Zvolte jiný název.",
          "perClientKeySet": "Tento údaj má každý klient vlastní. Zapněte „Vyplní se u klienta“, nebo pole vyprázdněte.",
          "perClientKeySetUnplaced": "Některý údaj, který má každý klient vlastní, je v šabloně vyplněný. Vyprázdněte ho a uložte šablonu znovu.",
          "pluginUnsupported": {
            "title": "Tento systém do šablony uložit nejde",
            "body": "Systém {{externalApp}} nemá společné nastavení instalace, nebo drží přístupové údaje na konektoru."
          },
          "featureDisabled": {
            "title": "Šablony integrací tu teď nejsou k dispozici",
            "body": "Pro vaši kancelář teď nejsou zapnuté. Nic se neuložilo."
          },
          "configInvalid": "Šablona nesedí k nastavení systému. Nic se neuložilo.",
          "needsReview": "Šablonu je potřeba nejdřív zkontrolovat a znovu uložit.",
          "other": "Šablonu se nepodařilo uložit. Zkuste to prosím znovu."
        },
        "fromConnection": {
          "creating": "Ukládáme šablonu z instalace klienta…",
          "created": "Šablona je uložená. Zkontrolujte ji.",
          "failed": "Šablonu se z instalace klienta nepodařilo uložit."
        }
      },
      "perClientKeys": {
        "title": "Co vyplníte u každého klienta",
        "intro": "Zaškrtnuté údaje se nezkopírují, vyplníte je u každého klienta zvlášť.",
        "none": "Instalace nemá žádné společné nastavení."
      },
      "saveAsTemplate": {
        "action": "Uložit jako šablonu kanceláře",
        "copy": "Zkopírovat dalším klientům",
        "title": "Uložit jako šablonu kanceláře",
        "intro": "Šablona se uloží v kanceláři a pak ji nasadíte dalším klientům. Instalace tohoto klienta zůstane, jak je.",
        "name": "Název šablony",
        "nameRequired": "Vyplňte název šablony.",
        "defaultName": "{{externalApp}} – {{installation}}",
        "secretsWarning": "Přihlašovací údaje instalace se zkopírují do šablony kanceláře.",
        "rulesWarning": "Pravidla konektorů mohou obsahovat údaje tohoto klienta.",
        "confirm": "Uložit do kanceláře",
        "cancel": "Zrušit",
        "secretsWarningOwnBridge": "Do šablony kanceláře se zkopírují vlastní přihlašovací údaje tohoto klienta (jeho Bridge)."
      },
      "actionErrors": {
        "needsReview": "Šablonu je potřeba nejdřív zkontrolovat a znovu uložit.",
        "inProgress": "V kanceláři se právě nasazuje jiná šablona. Až doběhne, zkuste to znovu.",
        "configInvalid": "Nastavení nesedí k systému.",
        "featureDisabled": "Šablony integrací teď pro vaši kancelář nejsou zapnuté.",
        "notFound": "Šablonu, instalaci nebo Bridge se nepodařilo najít. Možná je mezitím někdo smazal.",
        "clientNotAvailable": "U tohoto klienta teď integrace spravovat nemůžete.",
        "nameConflict": "Šablona s tímto názvem už v kanceláři je. Uložte ji pod jiným názvem.",
        "pluginUnsupported": "Tento systém do šablony uložit nejde.",
        "other": "Něco se nepovedlo. Zkuste to prosím znovu.",
        "retry": "Zkusit znovu"
      },
      "refusals": {
        "CLIENT_NOT_AVAILABLE": "U tohoto klienta teď integrace spravovat nemůžete.",
        "BRIDGE_AGENDA_TAKEN": "Tuto agendu už na tomto Bridge používá jiný klient.",
        "BRIDGE_AGENDA_INCOMPLETE": "Agenda není vyplněná celá. Doplňte všechny její údaje.",
        "INTEGRATIONS_SUSPENDED": "Klient má integrace pozastavené.",
        "INTEGRATION_TEMPLATE_CLIENT_ALREADY_CONFIGURED": "Klient už konektor tohoto systému má. Nic se u něj nezměnilo.",
        "INTEGRATION_TEMPLATE_NAME_CONFLICT": "Klient už instalaci s tímto názvem má. Zvolte jiný název.",
        "INTEGRATION_TEMPLATE_CONFIG_INVALID": "Nastavení u klienta nesedí.",
        "other": "Klienta se nepodařilo nastavit."
      },
      "apply": {
        "title": "Nasadit šablonu „{{name}}“",
        "titleLoading": "Nasadit šablonu",
        "back": "Šablony integrací",
        "loadError": "Šablonu se nepodařilo načíst. Zkuste stránku načíst znovu.",
        "pluginUnavailable": "Systém {{externalApp}} teď v katalogu není, takže šablonu nejde nasadit.",
        "copyTitle": "Zkopírovat instalaci dalším klientům",
        "copySource": "Kopíruje se z „{{client}} · {{installation}}“. Šablona se neuloží.",
        "copyUnknownClient": "Klient",
        "saveAsTemplate": "Uložit jako šablonu kanceláře",
        "needsReview": {
          "title": "Šablonu je potřeba zkontrolovat",
          "body": "Systém {{externalApp}} změnil nastavení. Projděte šablonu a znovu ji uložte, pak ji půjde nasadit.",
          "open": "Otevřít šablonu"
        },
        "steps": {
          "bridge": "Bridge",
          "clients": "Klienti",
          "values": "Údaje klientů",
          "summary": "Souhrn"
        },
        "next": "Pokračovat",
        "previous": "Zpět",
        "bridge": {
          "intro": "Vyberte Bridge kanceláře, přes který se klienti připojí k systému {{externalApp}}.",
          "label": "Bridge kanceláře",
          "empty": "Systém {{externalApp}} teď neobsluhuje žádný Bridge kanceláře.",
          "emptyHint": "Spusťte Bridge na počítači se systémem {{externalApp}} a počkejte, až se ohlásí.",
          "openBridges": "Otevřít Bridge kanceláře",
          "required": "Vyberte Bridge.",
          "loadError": "Bridge kanceláře se nepodařilo načíst. Zkuste stránku načíst znovu."
        },
        "clients": {
          "intro": "Vyberte klienty, kterým integraci nastavíte.",
          "loadError": "Klienty se nepodařilo načíst. Zkuste stránku načíst znovu.",
          "incomplete": "Některé klienty se nepodařilo načíst, seznam není celý.",
          "empty": "Kancelář zatím nemá žádné další klienty.",
          "search": "Hledat klienta",
          "selected": "Vybráno {{selected}} z max. {{max}}",
          "limit": "Najednou jde nasadit nejvýš {{max}} klientům. Další nasadíte v dalším kole.",
          "noMatch": "Žádný klient tomu neodpovídá.",
          "columns": {
            "choose": "Vybrat",
            "name": "Klient"
          },
          "choose": "Vybrat klienta {{name}}",
          "required": "Vyberte aspoň jednoho klienta."
        },
        "values": {
          "intro": "Vyplňte, co má každý klient vlastní.",
          "introNone": "Šablona od klientů nic dalšího nepotřebuje. Zkontrolujte jen názvy instalací.",
          "client": "Klient",
          "installationName": "Název instalace",
          "installationNameRequired": "Vyplňte název instalace.",
          "fieldFor": "{{setting}} – {{client}}"
        },
        "summary": {
          "running": "Nastavujeme klienty. Může to chvíli trvat.",
          "created_one": "U každého klienta vznikne instalace a {{count}} vypnutý konektor.",
          "created_few": "U každého klienta vznikne instalace a {{count}} vypnuté konektory.",
          "created_many": "U každého klienta vznikne instalace a {{count}} vypnutého konektoru.",
          "created_other": "U každého klienta vznikne instalace a {{count}} vypnutých konektorů.",
          "createdCopy": "U každého klienta vznikne instalace a stejné konektory jako u zdroje, všechny vypnuté.",
          "bridge": "Bridge",
          "clients": "Klienti",
          "enableLater": "Zapnutí a první synchronizaci provedete u každého klienta zvlášť.",
          "secretsWarning": "Přihlašovací údaje zdrojové instalace se zkopírují do instalací vybraných klientů.",
          "rulesWarning": "Pravidla konektorů mohou obsahovat údaje zdrojového klienta.",
          "apply": "Nasadit klientům",
          "confirm": {
            "title": "Nasadit klientům?",
            "message": "Vybraní klienti: {{clients}}. U každého vznikne instalace a vypnuté konektory, nic dalšího se u nich nezmění.",
            "cancel": "Zrušit"
          },
          "secretsWarningOwnBridge": "Do instalací vybraných klientů se zkopírují vlastní přihlašovací údaje zdrojového klienta (jeho Bridge)."
        },
        "results": {
          "title": "Výsledek",
          "appliedCount": "Nastaveno: {{applied}} z {{total}}",
          "refusedCount": "Nenastaveno: {{refused}}",
          "enableHint": "Konektory jsou vypnuté. Zapnete je a spustíte první synchronizaci u každého klienta.",
          "columns": {
            "client": "Klient",
            "status": "Stav",
            "detail": "Detail"
          },
          "unknownClient": "Nedostupný klient",
          "applied": "Nastaveno",
          "refused": "Nenastaveno",
          "open": "Otevřít u klienta",
          "openFor": "Otevřít instalaci u klienta {{client}}",
          "fieldError": "{{field}}: {{message}}",
          "backToList": "Zpět na šablony",
          "again": "Nasadit dalším klientům"
        },
        "errors": {
          "title": "Klientům se nic nenasadilo.",
          "partialTitle": "Nasazení se nedokončilo.",
          "partialBody": "Část klientů už může být nastavená. Zkuste to znovu — nastavené klienty server přeskočí."
        }
      }
    },
    "partyBankAccounts": {
      "title": "Bankovní účty k platbám",
      "description": "Platit se dá jen na ověřený účet. Ověřený je, když ho podepíšou dva různí lidé.",
      "add": "Přidat účet",
      "showAll": "Zobrazit i neaktivní, zamítnuté a zrušené",
      "empty": "Zatím tu není žádný bankovní účet.",
      "loadError": "Bankovní účty se nepodařilo načíst.",
      "loadMore": "Načíst další",
      "row": {
        "anyCurrency": "Libovolná měna",
        "default": "Výchozí",
        "inactive": "Neaktivní",
        "iban": "IBAN {{iban}}",
        "bic": "BIC {{bic}}",
        "actions": "Další akce s účtem"
      },
      "actions": {
        "sign": "Podepsat",
        "edit": "Upravit",
        "history": "Historie",
        "reject": "Zamítnout",
        "revoke": "Zrušit ověření",
        "deactivate": "Deaktivovat"
      },
      "form": {
        "addTitle": "Přidat bankovní účet",
        "addDescription": "Nový účet je neověřený, dokud ho nepodepíšou dva lidé.",
        "editTitle": "Upravit bankovní účet",
        "submitAdd": "Přidat účet",
        "submitEdit": "Uložit",
        "cancel": "Zrušit",
        "required": "Vyplň toto pole.",
        "anyCurrency": "Libovolná měna",
        "fields": {
          "scheme": "Typ účtu",
          "iban": "IBAN",
          "accountNumber": "Číslo účtu",
          "bankIdentifier": {
            "CZ": "Kód banky",
            "SK": "Kód banky",
            "GB_SORT_CODE": "Sort code",
            "US_ABA": "Routing number (ABA)",
            "OTHER": "Kód banky"
          },
          "countryCode": "Země",
          "bic": "BIC (SWIFT), nepovinné",
          "label": "Popis, nepovinné",
          "currencyCode": "Měna",
          "isDefault": "Výchozí účet pro tuto měnu"
        },
        "hints": {
          "domesticAccountNumber": "I s předčíslím, např. 19-2000145399."
        }
      },
      "errors": {
        "invalid": "Tohle číslo účtu nesedí. Zkontroluj ho.",
        "duplicate": "Tenhle účet už tu je.",
        "inactive": "Účet je mezitím deaktivovaný.",
        "stateConflict": "Ve stavu, ve kterém účet je, to nejde.",
        "signerIsCreator": "Účet jsi přidal ty, takže druhý podpis musí dát někdo jiný.",
        "signerIsFirstSigner": "První podpis jsi dal ty, takže druhý musí dát někdo jiný.",
        "signerIsLastEditor": "Účet jsi naposledy upravoval ty, takže druhý podpis musí dát někdo jiný.",
        "signerIsStatementUploader": "Výpis, o který se opírá podpis systému, jsi nahrával ty, takže druhý podpis musí dát někdo jiný.",
        "stateChanged": "Účet se mezitím změnil. Načetli jsme jeho aktuální stav.",
        "evidenceStale": "Podklad, o který se opíral podpis systému, už neplatí, takže druhý podpis dát nejde. Účet zamítni a přidej ho znovu, ať projde novou kontrolou.",
        "personRequired": "Tohle musí udělat konkrétní uživatel, ne API klíč.",
        "notPrinted": "Na faktuře není jeden platný účet, který by šel přidat.",
        "supplierNotLinked": "Faktura nemá přiřazeného dodavatele. Nejdřív ho vyber.",
        "other": "Nepovedlo se to. Zkus to prosím znovu."
      },
      "bankingErrors": {
        "required": "Vyplň toto pole.",
        "invalidFormat": "Tohle číslo účtu nesedí. Zkontroluj ho.",
        "unknownBankCode": "Takový kód banky neznáme.",
        "prefixMod11Failed": "Předčíslí účtu nesedí. Zkontroluj ho.",
        "accountMod11Failed": "Číslo účtu nesedí. Zkontroluj ho.",
        "ibanRequired": "Vyplň IBAN.",
        "ibanTooShort": "IBAN je moc krátký.",
        "ibanInvalidCountryCode": "IBAN začíná kódem země, který neznáme.",
        "ibanInvalid": "Tenhle IBAN nesedí. Zkontroluj ho.",
        "bicRequired": "Vyplň BIC.",
        "bicInvalidLength": "BIC má 8 nebo 11 znaků.",
        "bicInvalid": "Tenhle BIC nesedí (např. GIBACZPX).",
        "schemeUnknown": "Tenhle typ účtu neznáme.",
        "countryCodeInvalid": "Vyber zemi.",
        "countryMismatch": "Země k tomuhle typu účtu nepatří.",
        "schemeRequiredForCountry": "Tahle země má vlastní typ účtu, zvol ho (např. IBAN).",
        "bankIdentifierRequired": "Vyplň kód banky.",
        "bankIdentifierInvalid": "Tenhle kód banky nesedí.",
        "accountNumberRequired": "Vyplň číslo účtu.",
        "accountNumberInvalid": "Tohle číslo účtu nesedí.",
        "routingChecksumFailed": "Routing number nesedí. Zkontroluj ho."
      },
      "sign": {
        "firstTitle": "Podepsat bankovní účet",
        "firstMessage": "Dáváš první podpis. Ověřený bude, až ho podepíše ještě někdo další.",
        "secondTitle": "Druhý podpis",
        "secondMessage": "Tvým podpisem bude účet ověřený a půjde na něj platit.",
        "confirm": "Podepsat",
        "cancel": "Zpět",
        "firstSignature": "První podpis",
        "firstSignedBy": "{{name}}, {{date}}",
        "firstSignerGone": "Někdo, kdo už ve firmě nemá přístup, {{date}}",
        "systemSigned": "Systém po nezávislé kontrole, {{date}}",
        "evidenceLoadError": "Podklady kontroly se nepodařilo načíst.",
        "evidenceRetry": "Zkusit znovu",
        "evidenceMissing": "Podklady kontroly chybí, takže druhý podpis teď dát nejde."
      },
      "evidence": {
        "e1": "ERP nahlásilo tenhle účet přes konektor dřív, než ho Tappeer kdy odeslal.",
        "e1Named": "ERP nahlásilo tenhle účet přes konektor {{connector}} dřív, než ho Tappeer kdy odeslal.",
        "e2": "Dřívější platbu tomuto partnerovi na tenhle účet potvrdil bankovní výpis.",
        "e3": "Účet zveřejňuje registr plátců DPH.",
        "register": "Registr",
        "vatId": "DIČ",
        "companyId": "IČO",
        "registerCompanyId": "IČO podle registru",
        "registerName": "Název v registru",
        "checkedOn": "Ověřeno",
        "registers": {
          "ADIS": "Registr plátců DPH (Finanční správa ČR)",
          "ODFS": "Registr plátců DPH (Finančná správa SR)"
        },
        "notGiven": "neuvedeno",
        "nameMismatch": "Registr uvádí jiný název, než má partner ({{partyName}}). Než podepíšeš, ověř, že jde o stejnou firmu."
      },
      "terminal": {
        "rejectTitle": "Zamítnout bankovní účet",
        "rejectMessage": "Zamítnutý účet už nepůjde použít. Kdyby byl potřeba znovu, přidá se jako nový účet.",
        "revokeTitle": "Zrušit ověření účtu",
        "revokeMessage": "Zrušený účet už nepůjde použít. Kdyby byl potřeba znovu, přidá se jako nový účet.",
        "reason": "Důvod, nepovinné",
        "confirmReject": "Zamítnout",
        "confirmRevoke": "Zrušit ověření",
        "cancel": "Zpět"
      },
      "deactivate": {
        "title": "Deaktivovat bankovní účet",
        "message": "Účet zůstane v historii, ale platit se na něj už nebude.",
        "confirm": "Deaktivovat",
        "cancel": "Zpět"
      },
      "history": {
        "title": "Historie účtu",
        "empty": "Zatím tu nic není.",
        "loadError": "Historii se nepodařilo načíst.",
        "system": "Systém",
        "unknownActor": "Bez uvedené osoby",
        "reason": "Důvod: {{reason}}",
        "close": "Zavřít",
        "loadMore": "Načíst další"
      },
      "toast": {
        "created": "Účet je přidaný. Teď čeká na podpisy.",
        "updated": "Uloženo.",
        "signedFirst": "Podepsáno. Teď je na řadě druhý podpis.",
        "verified": "Hotovo, účet je ověřený.",
        "rejected": "Účet je zamítnutý.",
        "revoked": "Ověření účtu je zrušené.",
        "deactivated": "Účet je deaktivovaný."
      },
      "invoice": {
        "accept": "Přijmout jako nový účet",
        "accepting": "Přidávám…",
        "accepted": "Účet je přidaný k partnerovi jako neověřený.",
        "alreadyThere": "Partner už tenhle účet má, čeká na podpisy.",
        "openPartner": "Bankovní účty partnera"
      }
    },
    "bankMovements": {
      "title": "Bankovní pohyby",
      "searchPlaceholder": "Protistrana, reference nebo zpráva",
      "totalCount": "Celkem: {{count}}",
      "loadMore": "Načíst další",
      "loadError": "Bankovní pohyby se nepodařilo načíst.",
      "retry": "Zkusit znovu",
      "noResults": "Filtrům neodpovídá žádný bankovní pohyb.",
      "empty": {
        "title": "Zatím tu nejsou žádné bankovní pohyby.",
        "description": "Přibývají z bankovních výpisů a z ERP."
      },
      "sort": {
        "bookingDate": "Datum",
        "amount": "Částka"
      },
      "filters": {
        "title": "Filtry",
        "apply": "Zobrazit",
        "clear": "Zrušit filtry",
        "source": "Zdroj",
        "channel": "Kanál",
        "direction": "Směr",
        "resolution": "Párování",
        "ownBankAccount": "Náš účet",
        "any": "Vše",
        "anyAccount": "Všechny účty",
        "bookingDate": "Datum zaúčtování",
        "from": "Od",
        "to": "Do",
        "includeInactive": "Zobrazit i doklady, které už nejsou v ERP"
      },
      "table": {
        "bookingDate": "Datum",
        "amount": "Částka",
        "counterparty": "Protistrana",
        "reference": "Reference",
        "origin": "Zdroj",
        "resolution": "Párování",
        "ownBankAccount": "Náš účet",
        "open": "Otevřít bankovní pohyb z {{date}}",
        "inactive": "Už není v ERP"
      },
      "detail": {
        "title": "Bankovní pohyb",
        "bookingDate": "Datum zaúčtování",
        "valueDate": "Datum valuty",
        "counterparty": "Protistrana",
        "counterpartyAccount": "Účet protistrany",
        "ownBankAccount": "Náš účet",
        "source": "Zdroj",
        "channel": "Kanál",
        "creditorReference": "Reference pro příjemce",
        "remittanceInfo": "Zpráva pro příjemce",
        "endToEndId": "End-to-end ID",
        "bankReference": "Reference banky",
        "returnCode": "Důvod vrácení",
        "createdAt": "Načteno do Tappeeru",
        "updatedAt": "Naposledy změněno",
        "inactive": "Tento doklad už v ERP není. Zůstává tu jen pro přehled.",
        "close": "Zavřít",
        "erp": {
          "title": "Doklad v ERP",
          "documentNumber": "Číslo dokladu",
          "fiscalYear": "Účetní rok"
        },
        "statement": {
          "title": "Bankovní výpis",
          "number": "Číslo výpisu",
          "period": "Období",
          "format": "Formát"
        },
        "pairings": {
          "title": "Spárované faktury",
          "empty": "ERP tento doklad nespárovalo se žádnou fakturou.",
          "invoiceGone": "Faktura už není dostupná",
          "invoiceWithoutNumber": "Faktura bez čísla"
        }
      },
      "documentKind": {
        "BANK": "Bankovní doklad",
        "CASH": "Pokladní doklad",
        "INTERNAL": "Interní doklad"
      },
      "invoicePanel": {
        "title": "Úhrady z banky a pokladny",
        "document": "{{kind}} {{number}}",
        "total": "z celkových {{amount}}"
      },
      "tabs": {
        "movements": "Pohyby",
        "statements": "Výpisy",
        "queue": "K párování"
      },
      "upload": {
        "action": "Nahrát výpis",
        "title": "Nahrát bankovní výpis",
        "description": "Pohyby z výpisu načteme a zkusíme je spárovat s platbami.",
        "file": "Soubor s výpisem",
        "dropTitle": "Vyber soubor s výpisem",
        "dropDescription": "CAMT.053, MT940 nebo ABO (GPC)",
        "remove": "Odebrat soubor",
        "format": "Formát",
        "formatAuto": "Rozpoznat automaticky",
        "formatHint": "Formát poznáme sami. Vyber ho, jen když ho chceš určit.",
        "submit": "Nahrát výpis",
        "cancel": "Zrušit",
        "close": "Zavřít",
        "success": "Výpis je nahraný. Hned ho načteme.",
        "existing": {
          "title": "Tenhle soubor už je nahraný.",
          "state": "Nahráno {{date}} · {{status}}",
          "open": "Zobrazit ve výpisech"
        },
        "refusal": {
          "FILE_MISSING": "Vyber soubor s výpisem.",
          "FILE_NAME_INVALID": "Název souboru obsahuje nepovolené znaky nebo je moc dlouhý. Přejmenuj ho a zkus to znovu.",
          "FORMAT_INVALID": "Tenhle formát neznáme. Vyber CAMT.053, MT940 nebo ABO (GPC), nebo nech formát rozpoznat.",
          "UPLOADER_INVALID": "Výpis nahraje jen uživatel ve vlastním přihlášení, ne v zastoupení.",
          "SUBSCRIPTION_LOCKED": "Předplatné kanceláře je pozastavené, výpis teď nahrát nejde.",
          "FORBIDDEN": "Na nahrávání výpisů nemáš oprávnění.",
          "TOO_SLOW": "Soubor nedorazil včas. Zkontroluj připojení a zkus to znovu.",
          "TOO_LARGE": "Soubor je moc velký. Výpis může mít nejvýš 10 MB.",
          "BUSY": "Teď se nahrává moc souborů najednou. Zkus to za chvíli znovu.",
          "FAILED": "Výpis se nepodařilo nahrát. Zkus to znovu."
        },
        "dropDescriptionWithoutGpc": "CAMT.053 nebo MT940"
      },
      "imports": {
        "table": {
          "file": "Soubor",
          "uploadedBy": "Nahrál/a",
          "status": "Stav",
          "content": "Obsah"
        },
        "statementCount_one": "{{count}} výpis",
        "statementCount_few": "{{count}} výpisy",
        "statementCount_many": "{{count}} výpisu",
        "statementCount_other": "{{count}} výpisů",
        "lineCount_one": "{{count}} pohyb",
        "lineCount_few": "{{count}} pohyby",
        "lineCount_many": "{{count}} pohybu",
        "lineCount_other": "{{count}} pohybů",
        "content": "{{statements}} · {{lines}}",
        "skipped": "Už nahrané dřív: {{statements}} · {{lines}}",
        "continuityGap": "Výpis nenavazuje na předchozí – zůstatky nesedí. Možná nějaký výpis chybí.",
        "position": {
          "statement": "Výpis {{number}}",
          "line": "řádek {{line}}",
          "lineColumn": "řádek {{line}}, sloupec {{column}}",
          "path": "místo {{path}}"
        },
        "failure": {
          "FILE_EMPTY": "Soubor je prázdný.",
          "FILE_TOO_LARGE": "Soubor je moc velký. Výpis může mít nejvýš 10 MB.",
          "FORMAT_UNKNOWN": "Tohle nevypadá jako výpis, který umíme načíst. Nahraj výpis ve formátu CAMT.053 nebo MT940.",
          "FORMAT_UNKNOWN_GPC": "Je to výpis ve formátu ABO (GPC). Ten zatím načítat nemáme zapnutý. Stáhni si z banky výpis ve formátu CAMT.053 nebo MT940.",
          "FORMAT_MISMATCH": "Soubor je v jiném formátu, než jsi vybral/a. Nahraj ho znovu a nech formát rozpoznat.",
          "FORMAT_VERSION_UNSUPPORTED": "Tuhle verzi formátu zatím načíst neumíme. Zkus si z banky stáhnout výpis v jiné verzi.",
          "ENCODING_UNSUPPORTED": "Soubor je v kódování, které neumíme přečíst.",
          "ENCODING_INVALID": "Soubor obsahuje znaky, které v jeho kódování nedávají smysl. Možná je poškozený.",
          "XML_FORBIDDEN": "Soubor obsahuje části XML, které z bezpečnostních důvodů nečteme.",
          "XML_MALFORMED": "Soubor není platné XML. Možná je poškozený nebo neúplný.",
          "RECORD_INVALID": "Ve výpisu je záznam, kterému nerozumíme.",
          "FIELD_MISSING": "Ve výpisu chybí povinný údaj.",
          "FIELD_INVALID": "Některý údaj ve výpisu nejde přečíst.",
          "LIMIT_EXCEEDED": "Výpis je na nás moc velký – má moc pohybů nebo moc dlouhé údaje.",
          "CURRENCY_MISMATCH": "Měna výpisu nesedí – nesouhlasí s měnou našeho účtu, nebo se ve výpisu míchají měny.",
          "BALANCE_MISMATCH": "Zůstatky a pohyby ve výpisu spolu nesedí.",
          "NO_STATEMENTS": "V souboru není žádný výpis.",
          "OWN_ACCOUNT_NOT_REGISTERED": "Výpis je z účtu, který mezi našimi účty nemáme. Přidej ho v Nastavení → Bankovní účty a nahraj výpis znovu.",
          "OWN_ACCOUNT_AMBIGUOUS": "Účtu z výpisu odpovídá víc našich účtů. Uprav je v Nastavení → Bankovní účty a nahraj výpis znovu.",
          "STATEMENT_OVERLAP": "Za stejné období už máme výpis tohoto účtu v jiném formátu. Výpisy jednoho účtu nahrávej v jednom formátu.",
          "PARSE_TIME_BUDGET_EXCEEDED": "Čtení souboru trvalo moc dlouho. Zkus nahrát menší výpis.",
          "INTERNAL": "Něco se pokazilo na naší straně. Zkus soubor nahrát znovu."
        },
        "loadError": "Výpisy se nepodařilo načíst.",
        "empty": {
          "title": "Zatím tu není žádný nahraný výpis.",
          "description": "Výpis z banky nahraješ ve formátu CAMT.053 nebo MT940."
        }
      },
      "queue": {
        "filters": {
          "show": "Zobrazit",
          "showWaiting": "Čeká na párování",
          "showDismissed": "Vyřazené",
          "returns": "Vratky",
          "returnsAll": "Všechny pohyby",
          "returnsOnly": "Jen vratky",
          "returnsNone": "Bez vratek"
        },
        "return": "Vratka",
        "returnCode": "Kód vrácení {{code}}",
        "statement": "Výpis {{number}}",
        "noProposal": "K tomuhle pohybu jsme žádnou platbu nenašli.",
        "history": "Dřívější návrhy ({{number}})",
        "dismissed": "Vyřazeno: {{reason}}",
        "payment": {
          "gone": "Platba už není dostupná.",
          "noPayee": "Neznámý příjemce",
          "invoices": "Faktury: {{numbers}}",
          "invoiceWithoutNumber": "bez čísla",
          "run": "Dávka {{number}}",
          "runExecution": "Dávka {{number}} · k provedení {{date}}"
        },
        "sum": {
          "total": "Celkem"
        },
        "duplicate": {
          "title": "Možná dvojí stržení",
          "body": "Tuhle platbu už potvrdil jiný pohyb, takže peníze mohly odejít dvakrát. Návrh jde jen zamítnout, nebo pohyb vyřadit z párování.",
          "titleOtherAccount": "Možná dvojí stržení na jiný účet",
          "bodyOtherAccount": "Tuhle platbu už potvrdil jiný pohyb a tyhle peníze navíc šly na jiný účet, než má platba. Prověř to v bance. Návrh jde jen zamítnout, nebo pohyb vyřadit z párování."
        },
        "actions": {
          "accept": "Přijmout",
          "reject": "Zamítnout",
          "dismiss": "Není naše",
          "reopen": "Vrátit do párování",
          "acceptSum": "Přijmout všechny",
          "rejectSum": "Zamítnout všechny",
          "matchByHand": "Spárovat ručně",
          "createPayment": "Vytvořit platbu"
        },
        "accept": {
          "title": "Přijmout návrh",
          "titleSum": "Přijmout součet plateb",
          "summary": "Z výpisu {{line}} · platba {{payment}}",
          "summarySum": "Z výpisu {{line}} · platby celkem {{total}}",
          "returnWarning": "Platba se označí jako vrácená bankou a její faktury půjde zase proplatit.",
          "difference": "Rozdíl",
          "differenceAmount": "Částka rozdílu",
          "differenceHint": "Částka z výpisu minus částka platby, v měně platby.",
          "note": "Poznámka",
          "noteReturnHint": "Vratka je nižší než platba. Napiš proč, třeba poplatek banky.",
          "submit": "Přijmout",
          "submitSum": "Přijmout všechny",
          "cancel": "Zrušit",
          "success": "Hotovo. Pohyb je spárovaný.",
          "differenceMissing": "Zadej částku rozdílu.",
          "differenceInvalid": "Rozdíl nesmí být nula a může mít nejvýš čtyři desetinná místa.",
          "noteRequired": "Napiš, proč je vratka nižší.",
          "noteTooLong": "Poznámka může mít nejvýš {{max}} znaků.",
          "noteReturnUnstatedHint": "Vratka není v měně platby. Napiš, kolik z platby se vrátilo.",
          "differenceNamedHint": "Výpis neuvádí částku v měně platby. Napiš rozdíl v měně platby: částka z výpisu minus částka platby, se znaménkem minus, když přišlo méně.",
          "sumInfo": "Pohyb potvrdí všechny tyhle platby najednou, bez rozdílu.",
          "partialInfo": "Z výpisu je o {{shortfall}} méně, než kolik je v platbě. Pohyb přijmeš jako částečnou platbu: zaplaceno bude {{paid}}, zbytek se zruší a jeho faktury půjde znovu zaplatit.",
          "shortfall": "Nedoplatek nese",
          "shortfallByDueDate": "Faktury podle splatnosti",
          "shortfallByDueDateHint": "Nejdřív se zaplatí faktury s nejbližší splatností, nedoplatek ponesou ty poslední. Faktury potvrzené z ERP a zápočty dobropisů zůstanou zaplacené.",
          "shortfallChosenHint": "Celý nedoplatek ponese tahle faktura, ostatní zůstanou zaplacené.",
          "shortfallOption": "V platbě {{amount}}",
          "discountLost": "Faktura {{number}} bude zaplacená jen zčásti, takže přijde o slevu {{amount}}.",
          "belowConfirmed": "Faktury potvrzené z ERP spolu se zápočty dobropisů zůstanou zaplacené, a to je {{stayingPaid}}. Pohyb platí méně, takže ho jako částečnou platbu přijmout nejde.",
          "partialWithoutRun": "Z výpisu je méně, než kolik je v platbě. Platba ale není z platební dávky, takže ji jako částečnou rozdělit nejde. Návrh zamítni, nebo pohyb vyřaď z párování.",
          "split": {
            "label": "Co pohyb zaplatí a co půjde znovu k úhradě",
            "invoice": "Faktura",
            "due": "Splatnost",
            "inPayment": "V platbě",
            "paid": "Zaplaceno",
            "payableAgain": "Znovu k úhradě",
            "creditNote": "Zápočet dobropisu",
            "erpConfirmed": "Potvrzeno z ERP"
          }
        },
        "reject": {
          "title": "Zamítnout návrh",
          "description": "Tuhle platbu už k pohybu nenavrhneme.",
          "descriptionSum": "Zamítneš všechny platby součtu najednou. Žádnou z nich už k pohybu nenavrhneme.",
          "note": "Proč to není tahle platba?",
          "noteSum": "Proč to nejsou tyhle platby?",
          "submit": "Zamítnout",
          "cancel": "Zrušit",
          "success": "Návrh je zamítnutý.",
          "noteTooLong": "Poznámka může mít nejvýš {{max}} znaků."
        },
        "dismiss": {
          "title": "Není naše",
          "description": "Pohyb nepatří k žádné naší platbě, třeba mzda nebo převod mezi účty. Otevřené návrhy zmizí.",
          "reason": "Důvod",
          "submit": "Vyřadit z párování",
          "cancel": "Zrušit",
          "success": "Pohyb je vyřazený z párování.",
          "reasonTooLong": "Důvod může mít nejvýš {{max}} znaků."
        },
        "reopen": {
          "title": "Vrátit pohyb do párování?",
          "message": "Zkusíme ho spárovat znovu. Zamítnuté návrhy zůstanou zamítnuté.",
          "submit": "Vrátit do párování",
          "cancel": "Zrušit",
          "success": "Pohyb je zpátky v párování."
        },
        "match": {
          "title": "Spárovat ručně",
          "description": "Z výpisu {{line}}. Vyber otevřenou platbu, ke které pohyb patří.",
          "noCounterparty": "Pohyb neuvádí účet protistrany, takže nabízíme jen platby na stejnou částku. Rozdíl u nich uvést nejde.",
          "candidates": "Otevřené platby",
          "empty": "K tomuhle pohybu se nehodí žádná otevřená platba. Nabízíme jen odeslané platby ze stejného účtu a ve stejné měně, které ještě nepotvrdil žádný výpis.",
          "loadError": "Otevřené platby se nepodařilo načíst.",
          "submit": "Spárovat",
          "cancel": "Zrušit",
          "success": "Hotovo. Pohyb je spárovaný."
        },
        "createPayment": {
          "title": "Vytvořit platbu",
          "description": "Z výpisu {{line}}. Vyber dodavatele a faktury, které pohyb zaplatil.",
          "party": "Dodavatel",
          "partyPlaceholder": "Vyber dodavatele",
          "creditedAccount": "Připsáno na účet",
          "unverified": {
            "title": "Peníze šly na neověřený účet",
            "noCounterparty": "Pohyb neuvádí účet protistrany, takže platba nebude připsaná na žádný ověřený účet dodavatele.",
            "notVerified": "Účet z pohybu není mezi ověřenými účty dodavatele. Platba se uloží bez připsaného účtu."
          },
          "invoices": "Faktury dodavatele",
          "invoice": "Faktura",
          "due": "Splatnost",
          "outstanding": "Zbývá uhradit",
          "amount": "Platí se",
          "amountFor": "Částka k faktuře {{number}}",
          "invoiceWithoutNumber": "bez čísla",
          "amountInvalid": "Zadej částku vyšší než nula, nejvýš se čtyřmi desetinnými místy.",
          "amountExceedsOutstanding": "Je to víc, než kolik na faktuře zbývá uhradit.",
          "loaded": "Načteno {{loaded}} z {{total}}",
          "empty": "Tenhle dodavatel nemá žádnou fakturu, kterou by šlo pohybem zaplatit. Hodí se jen předané faktury v měně pohybu, na kterých ještě něco zbývá a které nedrží uvolněná dávka.",
          "loadError": "Faktury dodavatele se nepodařilo načíst.",
          "sum": "Celkem {{total}} · pohyb {{line}}",
          "sumMatches": "Součet sedí s pohybem.",
          "sumShort": "Zbývá rozdělit {{amount}}.",
          "sumOver": "To je o {{amount}} víc, než je na pohybu.",
          "tooMany": "Jedna platba může zaplatit nejvýš {{max}} faktur.",
          "submit": "Vytvořit platbu",
          "cancel": "Zrušit",
          "success": "Hotovo. Platba je vytvořená a pohyb spárovaný.",
          "accountsLoadError": "Ověřené účty dodavatele se nepodařilo načíst, takže nevíme, na který účet platba půjde."
        },
        "refusal": {
          "personRequired": "Rozhodnout může jen uživatel ve vlastním přihlášení, ne API klíč ani zastoupení.",
          "runAuthor": "Platbu jsi připravil/a nebo upravil/a v dávce. Rozhodnout o ní musí někdo jiný.",
          "statementUploader": "Výpis jsi nahrál/a ty, nebo nevíme kdo. Rozhodne jen někdo, o kom víme, že ho nenahrál.",
          "blockedRunAuthor": "Připravil/a nebo upravil/a jsi dávku, jejíž export nejde vzít zpět kvůli dřívějšímu spárování tohoto pohybu. O spárování, které by to uvolnilo, musí rozhodnout někdo jiný.",
          "counterpartyDiffers": "Peníze šly na jiný účet, než má platba. Takový návrh jde jen zamítnout.",
          "proposalStale": "O návrhu už je rozhodnuto.",
          "duplicate": "Tuhle platbu už potvrdil jiný pohyb, takže tady může jít o dvojí stržení. Takový návrh jde jen zamítnout.",
          "lineDuplicate": "U pohybu čeká návrh na možné dvojí stržení. Nejdřív ho zamítni, nebo pohyb vyřaď z párování.",
          "createPaymentRunAuthor": "Připravil/a nebo upravil/a jsi dávku platby, kterou k pohybu navrhujeme. Platbu z pohybu musí vytvořit někdo jiný."
        },
        "errors": {
          "proposalStale": "Návrh už neplatí – mezitím se změnil. Podívej se na pohyb znovu.",
          "noteRequired": "Napiš poznámku. U zamítnutí a u vratky nižší než platba je povinná.",
          "differenceRequired": "Částka se liší. Uveď, jestli jde o bankovní poplatek, nebo kurzový rozdíl, a kolik dělá.",
          "differenceInvalid": "Rozdíl musí být přesně částka z výpisu minus částka platby. Poplatek je vždy kladný a kurzový rozdíl jen u platby v jiné měně.",
          "returnExceedsPayment": "Vratka je vyšší než platba. Tenhle návrh přijmout nejde.",
          "notDismissable": "Tenhle pohyb už v párování není. Podívej se na něj znovu.",
          "notReopenable": "Tenhle pohyb není vyřazený, není co vracet.",
          "dismissReasonRequired": "Napiš, proč pohyb není náš.",
          "paymentNotConfirmable": "Tuhle platbu teď pohybem potvrdit nejde – mezitím se změnila.",
          "partialConverted": "Částečnou úhradu jde uvést jen u pohybu v měně platby, který nebyl přepočtený.",
          "shortfallAllocationInvalid": "Nedoplatek může nést jen faktura platby, kterou ERP nepotvrdilo jako zaplacenou, a jen u částečné úhrady.",
          "shortfallExceedsAllocation": "Vybraná faktura platí méně, než je nedoplatek. Vyber jinou.",
          "partialBelowConfirmed": "Pohyb platí méně, než kolik ERP už u faktur potvrdilo jako zaplacené.",
          "sumDifferenceInvalid": "Součet více plateb se přijímá bez rozdílu – bez poplatku, kurzového rozdílu i částečné úhrady.",
          "sumAmountDiffers": "Platby v tomhle součtu už dohromady nedávají částku pohybu. Podívej se na něj znovu.",
          "notMatchable": "Tenhle pohyb už nečeká na spárování, takže ho ručně spárovat nejde. Podívej se na něj znovu.",
          "matchNotCandidate": "S touhle platbou pohyb spárovat nejde. Vyber odeslanou platbu ze stejného účtu a ve stejné měně, kterou ještě nepotvrdil žádný výpis.",
          "matchCounterpartyDiffers": "Peníze šly na jiný účet, než má platba. S touhle platbou pohyb spárovat nejde.",
          "matchNamesAnotherPayment": "Pohyb nese identifikaci jiné platby (end-to-end ID nebo symboly). Spárovat ho jde jen s ní.",
          "matchDifferenceNeedsCounterparty": "Pohyb neuvádí účet protistrany, takže ho ručně spárovat jde jen s platbou na stejnou částku, bez rozdílu.",
          "queuePaymentLineInvalid": "Tenhle pohyb už nečeká na spárování, takže z něj platbu vytvořit nejde. Podívej se na něj znovu.",
          "queuePaymentNamesPayment": "Pohyb nese identifikaci jedné z našich plateb (end-to-end ID nebo symboly). Spáruj ho s ní.",
          "queuePaymentRestOtherPayee": "Pohyb je nedoplatek jedné z našich plateb. Zaplatit ho jde jen jejímu příjemci.",
          "queuePaymentAllocationsInvalid": "Vyber aspoň jednu fakturu, každou jen jednou, s částkou vyšší než nula.",
          "queuePaymentSumDiffers": "Částky u faktur musí dát dohromady přesně částku pohybu.",
          "queuePaymentInvoiceOtherParty": "Jedna z faktur je od jiného dodavatele, než kterému se platí.",
          "queuePaymentInvoiceCurrencyDiffers": "Jedna z faktur je v jiné měně než pohyb.",
          "queuePaymentInvoiceArchived": "Jedna z faktur je archivovaná, takže ji pohybem zaplatit nejde.",
          "queuePaymentInvoiceReserved": "Jedna z faktur je v uvolněné dávce, která ji platí.",
          "queuePaymentInvoiceNotRecordable": "Na jednu z faktur platbu zapsat nejde.",
          "queuePaymentInvoiceNotSubmitted": "Jedna z faktur je rozpracovaná nebo zamítnutá. Nejdřív ji předej ke schválení.",
          "queuePaymentExceedsOutstanding": "Částka u jedné z faktur je vyšší, než kolik na ní zbývá k úhradě.",
          "acceptFailed": "Návrh se nepodařilo přijmout.",
          "rejectFailed": "Návrh se nepodařilo zamítnout.",
          "dismissFailed": "Pohyb se nepodařilo vyřadit.",
          "reopenFailed": "Pohyb se nepodařilo vrátit do párování.",
          "matchFailed": "Pohyb se nepodařilo spárovat.",
          "createPaymentFailed": "Platbu se nepodařilo vytvořit."
        },
        "loadError": "Pohyby k párování se nepodařilo načíst.",
        "noResults": "Filtrům neodpovídá žádný pohyb.",
        "emptyDismissed": "Žádný pohyb tu není vyřazený.",
        "empty": {
          "title": "Teď tu není nic k párování.",
          "description": "Sem přijdou pohyby z výpisů, které jsme nespárovali sami."
        }
      }
    },
    "payments": {
      "blocked": "Blokovaná",
      "invoicePanel": {
        "title": "Platby",
        "paidOf": "Uhrazeno {{paid}} z {{total}}",
        "outstanding": "Zbývá {{amount}}",
        "source": {
          "LEDGER": "Podle plateb v Tappeeru",
          "ERP": "Podle ERP"
        },
        "erpReports": "ERP hlásí: {{state}}",
        "mismatch": {
          "title": "Tappeer a ERP se neshodují",
          "body": "Podle plateb v Tappeeru: {{ledgerStatus}}. ERP hlásí: {{erpStatus}}. Nic jsme nepřepsali. Podívej se na to v ERP, nebo zaznamenej chybějící platbu."
        },
        "origin": {
          "RUN": "Platba z platební dávky",
          "RECORDED": "Zaznamenaná platba",
          "MIGRATION": "Převzatá platba",
          "QUEUE": "Platba z bankovního pohybu"
        },
        "payee": "Komu: {{name}}",
        "discount": "Sleva {{amount}}",
        "withholding": "Srážka {{amount}}",
        "migrated": "Převzato z dřívějšího stavu faktury",
        "openMovement": "Otevřít {{document}}",
        "openStatementLine": "{{source}} – otevřít pohyb z výpisu",
        "revoked": "Odvoláno",
        "erpWithdrawn": "ERP doklad platbu už nepotvrzuje",
        "awaitingConfirmation": "Čeká na potvrzení.",
        "revoke": "Odvolat",
        "confirm": "Potvrdit proplacení"
      },
      "record": {
        "action": "Zaznamenat platbu",
        "title": "Zaznamenat platbu",
        "description": "Zapiš platbu, kterou jsi poslal/a mimo Tappeer — v bankovnictví, kartou nebo hotově. Uloží se jako tvoje potvrzení.",
        "amount": "Částka",
        "paidOn": "Datum platby",
        "dateRequired": "Vyber datum platby.",
        "method": "Způsob platby",
        "methodRequired": "Vyber způsob platby.",
        "payee": "Komu",
        "payeeSupplier": "Dodavateli",
        "payeeColleague": "Kolegovi, který to zaplatil",
        "colleague": "Kdo",
        "colleaguePlaceholder": "Vyber kolegu",
        "colleagueRequired": "Vyber, kdo to zaplatil.",
        "creditAccount": "Na účet dodavatele",
        "creditAccountHint": "Nepovinné. Nabízíme jen ověřené účty.",
        "noCreditAccount": "Neuvádět",
        "submit": "Zaznamenat platbu",
        "cancel": "Zrušit",
        "success": "Platba je zapsaná."
      },
      "confirm": {
        "title": "Potvrdit proplacení",
        "description": "Zapíše se to jako tvoje potvrzení. Až přijde výpis z banky nebo doklad z ERP, přidá se vedle něj.",
        "paidOn": "Datum platby",
        "submit": "Potvrdit proplacení",
        "cancel": "Zrušit",
        "success": "Platba je potvrzená."
      },
      "revoke": {
        "title": "Odvolat ruční potvrzení",
        "description": "Platba přestane být potvrzená, pokud ji nepotvrdil výpis nebo ERP.",
        "statementTitle": "Odvolat potvrzení z výpisu",
        "statementDescription": "Pohyb se vrátí mezi pohyby ke spárování a faktura přestane být zaplacená, pokud ji nepotvrdilo ERP nebo uživatel ručně. Platba zapsaná ručně nebo vytvořená z pohybu se zruší a faktura se znovu otevře k platbě.",
        "statementAction": "Odvolat potvrzení",
        "reason": "Důvod",
        "reasonTooLong": "Důvod může mít nejvýš {{max}} znaků.",
        "submit": "Odvolat",
        "cancel": "Zrušit",
        "success": "Potvrzení je odvolané."
      },
      "refusal": {
        "personRequired": "Platbu může zapsat, potvrdit nebo odvolat jen uživatel ve vlastním přihlášení, ne API klíč ani zastoupení.",
        "runAuthor": "Dávku jsi připravil/a nebo upravil/a. Platbu v ní musí potvrdit někdo jiný.",
        "alreadyConfirmed": "Platbu už někdo potvrdil ručně.",
        "notConfirmable": "Tuhle platbu teď ručně potvrdit nejde.",
        "notRevocable": "Tohle potvrzení už odvolat nejde.",
        "partialSplit": "Potvrzení částečné platby odvolat nejde. Platba se při něm rozdělila na zaplacenou část a nedoplatek.",
        "returnPaidAgain": "Vratku teď odvolat nejde: fakturu mezitím platí jiná platba.",
        "bankLineEvidenceUsed": "Tohle potvrzení odvolat nejde. Díky němu se už vzal zpět export dávky, kterou tenhle pohyb potvrdil dřív. Pokud je potvrzení chybné, obrať se na správce účtu.",
        "invoiceNotRecordable": "Na tenhle doklad platbu zapsat nejde.",
        "nothingOutstanding": "Na dokladu už nezbývá nic k úhradě.",
        "personRequiredRun": "Tohle může udělat jen uživatel ve vlastním přihlášení, ne API klíč ani zastoupení.",
        "personRequiredApproval": "Schválit a uvolnit dávku může jen uživatel ve vlastním přihlášení, ne API klíč ani zastoupení.",
        "approveAuthor": "Dávku jsi připravil/a nebo upravil/a. Schválit ji musí někdo jiný.",
        "releaseAuthor": "Dávku jsi připravil/a nebo upravil/a. Uvolnit ji musí někdo jiný.",
        "releaseApprover": "Dávku jsi schválil/a, nebo jsi v ní po schválení odblokoval/a platbu. Uvolnit ji musí někdo třetí.",
        "unblockAuthor": "Dávku jsi připravil/a nebo upravil/a. Platbu v ní musí odblokovat někdo jiný.",
        "unblockReleaser": "Dávku jsi uvolnil/a. Platbu v ní musí odblokovat někdo jiný.",
        "noPayment": "V dávce není žádná platba k odeslání.",
        "exportNothingToSend": "Do souboru teď nejde žádná platba: každá je blokovaná, potvrzená nebo zrušená. Blokovanou platbu odblokuj, nebo dávku zruš.",
        "confirmationStands": "Některou platbu už potvrdil výpis, ERP nebo uživatel. Peníze odešly, export už zpět vzít nejde.",
        "bankLineEvidence": "Pohyb z výpisu ukázal, že peníze z dávky odešly. Jeho potvrzení je odvolané, ale dokud ten pohyb nepotvrdí jinou platbu z některé dávky, export zpět vzít nejde.",
        "paymentConfirmationStands": "Platbu už potvrdil výpis nebo uživatel. Peníze odešly, zrušit ji nejde."
      },
      "qrRefusal": {
        "notApproved": "Doklad ještě není schválený.",
        "inPaymentRun": "Doklad už je v platební dávce.",
        "erpReportsPaid": "ERP hlásí doklad jako proplacený.",
        "nothingOutstanding": "Na dokladu už nezbývá nic k proplacení.",
        "noBankAccount": "Na dokladu chybí platný bankovní účet.",
        "qrUnavailable": "QR platbu pro tento doklad nejde vytvořit."
      },
      "errors": {
        "recordFailed": "Platbu se nepodařilo zapsat.",
        "invoiceNotApproved": "Platbu jde zapsat jen u schváleného dokladu.",
        "confirmFailed": "Platbu se nepodařilo potvrdit.",
        "revokeFailed": "Potvrzení se nepodařilo odvolat.",
        "dateInFuture": "Platba nemůže být v budoucnu.",
        "exceedsOutstanding": "Víc, než zbývá proplatit, zapsat nejde.",
        "amountInvalid": "Zadej částku větší než nula, nejvýš na čtyři desetinná místa.",
        "payeeInvalid": "Tomuhle příjemci platbu zapsat nejde. Vyber dodavatele dokladu, nebo kolegu z tohoto účtu.",
        "creditAccountNotVerified": "Tenhle účet dodavatele už není ověřený. Vyber jiný, nebo účet neuváděj.",
        "reasonRequired": "Napiš, proč potvrzení odvoláváš.",
        "discountNotFullSettlement": "Slevu lze vzít jen při úhradě celé faktury.",
        "allocationExceedsOutstanding": "Dohromady to nesmí přesáhnout částku k úhradě.",
        "debitAccountInvalid": "Z tohoto účtu teď platit nejde. Musí být náš, aktivní a ověřený.",
        "runNotHomogeneous": "Dávka musí být v měně účtu, ze kterého se platí. ABO (KPC) jde jen v korunách.",
        "nothingToPay": "Podle tohoto výběru teď není co platit.",
        "runNotEditable": "Dávka se mezitím posunula dál a tohle už v ní změnit nejde.",
        "transferNotPositive": "Platba musí zůstat vyšší než nula. Zbytek dobropisu počká na další dávku.",
        "creditNoteNotNettable": "Tenhle dobropis teď započíst nejde, nebo na něm tolik nezbývá.",
        "releaserNotThird": "Dávku jsi připravil/a, upravil/a nebo schválil/a. Uvolnit ji musí někdo třetí.",
        "notBlockable": "Tuhle platbu teď blokovat ani odblokovat nejde.",
        "blockReasonRequired": "Napiš, proč platbu blokuješ.",
        "runHasConfirmations": "Některou platbu dávky už potvrdil výpis, ERP nebo uživatel. Dávku teď zrušit nejde.",
        "withdrawalReasonRequired": "Napiš, proč export bereš zpět.",
        "notCancellable": "Tuhle platbu zrušit nejde: je v souboru pro banku, nebo už skončila.",
        "splitCreditNote": "Platbu teď zrušit nejde: dobropis započtený v ní by potvrzenou část snížil na nulu.",
        "buildFailed": "Dávku se nepodařilo připravit.",
        "submitFailed": "Dávku se nepodařilo předat ke schválení.",
        "approveFailed": "Dávku se nepodařilo schválit.",
        "releaseFailed": "Dávku se nepodařilo uvolnit.",
        "exportFailed": "Soubor se nepodařilo vytvořit.",
        "withdrawFailed": "Export se nepodařilo vzít zpět.",
        "cancelFailed": "Dávku se nepodařilo zrušit.",
        "blockFailed": "Platbu se nepodařilo zablokovat.",
        "unblockFailed": "Platbu se nepodařilo odblokovat.",
        "cancelLeftOutFailed": "Platbu se nepodařilo zrušit.",
        "removeAllocationFailed": "Fakturu se nepodařilo z dávky vyřadit.",
        "updateAllocationFailed": "Platbu se nepodařilo upravit.",
        "netCreditNoteFailed": "Dobropis se nepodařilo započíst."
      },
      "title": "Platby",
      "tabs": {
        "payables": "K úhradě",
        "runs": "Platební dávky"
      },
      "notPayable": "Nelze proplatit – {{clause}}",
      "moreClauses": "+{{n}}",
      "clauseFix": {
        "openInvoice": "Otevřít fakturu",
        "openRun": "Otevřít dávku",
        "verifyAccount": "Ověřit účet",
        "chooseAccount": "Vybrat účet"
      },
      "prepareRun": "Připravit dávku",
      "loadMore": "Načíst další",
      "retry": "Zkusit znovu",
      "totalCount": "Celkem: {{count}}",
      "filters": {
        "title": "Filtry",
        "apply": "Zobrazit",
        "clear": "Zrušit filtry"
      },
      "payables": {
        "title": "Faktury k úhradě",
        "searchPlaceholder": "Faktura, dodavatel nebo VS",
        "loadError": "Faktury k úhradě se nepodařilo načíst.",
        "empty": {
          "title": "Teď není co platit.",
          "description": "Přijaté faktury se tu objeví, dokud nebudou proplacené."
        },
        "noResults": "Filtrům neodpovídá žádná faktura.",
        "sort": {
          "due": "Splatnost"
        },
        "filters": {
          "payability": "Proplatit",
          "anyPayability": "Vše",
          "payable": "Lze proplatit",
          "notPayable": "Nelze proplatit",
          "clause": "Důvod",
          "anyClause": "Všechny důvody",
          "dueTo": "Splatné do",
          "currency": "Měna",
          "anyCurrency": "Všechny měny",
          "supplier": "Dodavatel",
          "anySupplier": "Všichni dodavatelé"
        },
        "table": {
          "invoice": "Faktura",
          "due": "Splatnost",
          "toPay": "K úhradě",
          "supplierAccount": "Účet dodavatele",
          "state": "Stav",
          "pastDue": "po splatnosti",
          "ofTotal": "z {{total}}",
          "reserved": "{{amount}} v dávce {{number}}",
          "open": "Otevřít fakturu {{number}}"
        },
        "state": {
          "payable": "Lze proplatit",
          "inRun": "V dávce {{number}}",
          "inProposal": "V návrhu {{number}}",
          "withdrawnFile": "Soubor dávky {{number}} byl vzatý zpět. Mohl už dorazit do banky."
        }
      },
      "build": {
        "title": "Připravit platební dávku",
        "debitAccount": "Platit z účtu",
        "debitAccountPlaceholder": "Vyber účet",
        "debitAccountRequired": "Vyber účet, ze kterého se bude platit.",
        "anyCurrency": "libovolná měna",
        "runCurrency": "Měna dávky: {{currency}}",
        "currency": "Měna dávky",
        "currencyPlaceholder": "Vyber měnu",
        "currencyRequired": "Vyber měnu dávky.",
        "dueTo": "Splatné do",
        "dueToHint": "Do dávky půjdou schválené faktury v měně účtu splatné nejpozději tento den.",
        "dueToRequired": "Vyber den splatnosti.",
        "margin": "Rezerva pro banku",
        "marginUnit": "dní",
        "marginHint": "Přidá i faktury splatné o tolik dní později, aby je banka stihla proplatit včas.",
        "marginInvalid": "Zadej celý počet dní od 0 do {{max}}.",
        "format": "Formát souboru",
        "preview_one": "Do dávky teď půjde {{count}} faktura.",
        "preview_few": "Do dávky teď půjdou {{count}} faktury.",
        "preview_many": "Do dávky teď půjde {{count}} faktury.",
        "preview_other": "Do dávky teď půjde {{count}} faktur.",
        "previewNone": "Podle tohoto výběru teď není co platit.",
        "noAccount": "Nemáme žádný ověřený vlastní účet, ze kterého by šlo platit.",
        "bankAccountsLink": "Bankovní účty",
        "submit": "Připravit dávku",
        "cancel": "Zrušit",
        "success": "Dávka je připravená."
      },
      "runs": {
        "title": "Platební dávky",
        "searchPlaceholder": "Číslo dávky",
        "loadError": "Platební dávky se nepodařilo načíst.",
        "empty": {
          "title": "Zatím tu není žádná platební dávka.",
          "description": "Připravíš ji z faktur k úhradě."
        },
        "noResults": "Filtrům neodpovídá žádná dávka.",
        "sort": {
          "created": "Vytvoření",
          "amount": "Částka"
        },
        "filters": {
          "status": "Stav",
          "open": "Otevřené",
          "all": "Všechny",
          "debitAccount": "Platit z účtu",
          "anyAccount": "Všechny účty"
        },
        "table": {
          "number": "Číslo",
          "state": "Stav",
          "debitAccount": "Platit z účtu",
          "dueTo": "Splatné do",
          "payments": "Platby",
          "amount": "Částka",
          "preparedBy": "Připravil/a",
          "blocked_one": "{{count}} blokovaná",
          "blocked_few": "{{count}} blokované",
          "blocked_many": "{{count}} blokované",
          "blocked_other": "{{count}} blokovaných",
          "open": "Otevřít dávku {{number}}"
        }
      },
      "paymentCount_one": "{{count}} platba",
      "paymentCount_few": "{{count}} platby",
      "paymentCount_many": "{{count}} platby",
      "paymentCount_other": "{{count}} plateb",
      "run": {
        "title": "Platební dávka {{number}}",
        "loadError": "Platební dávku se nepodařilo načíst.",
        "summary": "{{payments}} · {{amount}} · z účtu {{account}}",
        "blockedSummary": "Blokované: {{payments}} · {{amount}} — do souboru nepůjdou.",
        "withdrawnWarning": {
          "title": "Dřívější soubor této dávky byl vzatý zpět",
          "body": "Mohl už dorazit do banky. Než pošleš do banky nový soubor, ověř v bankovnictví, že platby z toho prvního neodešly."
        },
        "steps": {
          "prepared": "Připravená",
          "approved": "Schválená",
          "released": "Uvolněná",
          "exported": "Exportovaná",
          "confirmed": "Potvrzená"
        },
        "actions": {
          "submit": "Předat ke schválení",
          "approve": "Schválit",
          "release": "Uvolnit",
          "export": "Vytvořit soubor pro banku",
          "download": "Stáhnout soubor",
          "withdraw": "Vzít export zpět",
          "cancel": "Zrušit dávku",
          "more": "Další akce"
        },
        "selection": {
          "title": "Výběr faktur",
          "sentence": "Do dávky šly schválené faktury v {{currency}} splatné do {{date}}, které v tu chvíli šlo proplatit.",
          "sentenceWithMargin": "Do dávky šly schválené faktury v {{currency}} splatné do {{date}} (s rezervou {{margin}}), které v tu chvíli šlo proplatit.",
          "marginDays_one": "{{count}} den",
          "marginDays_few": "{{count}} dny",
          "marginDays_many": "{{count}} dne",
          "marginDays_other": "{{count}} dní",
          "dueTo": "Splatné do",
          "margin": "Rezerva pro banku",
          "debitAccount": "Platit z účtu",
          "currency": "Měna",
          "format": "Formát souboru",
          "builtBy": "Sestavil/a",
          "notPayableLink": "Co teď proplatit nejde",
          "notPayableCaption": "Podle dnešního stavu, ne podle stavu při sestavení."
        },
        "payments": {
          "title": "Platby",
          "payee": "Příjemce",
          "account": "Účet příjemce",
          "reference": "Reference",
          "invoices": "Faktury",
          "amount": "Částka",
          "state": "Stav",
          "actions": "Akce s platbou",
          "expand": "Zobrazit faktury platby {{payee}}",
          "collapse": "Skrýt faktury platby {{payee}}",
          "totalToSend": "Celkem k odeslání {{amount}}",
          "totalBlocked": "Blokováno {{amount}}",
          "empty": {
            "title": "V dávce nezůstala žádná platba.",
            "description": "Zruš ji, nebo připrav novou."
          },
          "notPayableNow_one": "{{count}} faktura teď nejde proplatit",
          "notPayableNow_few": "{{count}} faktury teď nejdou proplatit",
          "notPayableNow_many": "{{count}} faktury teď nejde proplatit",
          "notPayableNow_other": "{{count}} faktur teď nejde proplatit",
          "dropsAtExport": "Při vytvoření souboru se z dávky vyřadí.",
          "block": "Blokovat platbu",
          "unblock": "Odblokovat",
          "net": "Započíst dobropis",
          "confirm": "Potvrdit proplacení",
          "cancelLeftOut": "Zrušit platbu",
          "revoke": "Odvolat"
        },
        "allocation": {
          "invoice": "Faktura",
          "due": "Splatnost",
          "toPay": "K úhradě",
          "paid": "Platí se",
          "discount": "Sleva",
          "withholding": "Srážka",
          "actions": "Akce s fakturou",
          "creditNote": "Dobropis",
          "edit": "Upravit částku",
          "remove": "Vyřadit z dávky"
        },
        "cancellation": {
          "BLOCKED_AT_RELEASE": "Vyřazena při uvolnění, protože byla blokovaná",
          "BLOCKED_AT_EXPORT": "Vyřazena při vytvoření souboru",
          "INVOICE_NOT_PAYABLE": "Vyřazena při vytvoření souboru: {{invoice}} už nešla proplatit",
          "AMOUNT_EXCEEDS_OUTSTANDING": "Vyřazena při vytvoření souboru: {{invoice}} už dluží méně, než platba posílala",
          "LEFT_OUT_CANCELLED": "Zrušena, protože nešla do souboru pro banku",
          "splitOff": "Zrušená část platby, kterou ERP nepotvrdilo",
          "RUN_CANCELLED": "Zrušena spolu s dávkou",
          "CONFIRMATION_REVOKED": "Zrušena po odvolání posledního potvrzení",
          "PARTIAL_SHORTFALL": "Zrušena jako nedoplatek částečně zaplacené platby"
        },
        "exports": {
          "title": "Soubory pro banku",
          "file": "Soubor",
          "messageId": "ID zprávy",
          "sha256": "SHA-256",
          "createdBy": "Vytvořil/a",
          "state": "Stav",
          "valid": "Platný",
          "withdrawn": "Vzato zpět",
          "download": "Stáhnout",
          "copySha": "Zkopírovat SHA-256 souboru {{file}}",
          "copied": "SHA-256 je zkopírovaný."
        },
        "people": {
          "title": "Kdo s dávkou pracoval",
          "preparedBy": "Připravil/a",
          "editors": "Upravili",
          "approvedBy": "Schválil/a",
          "releasedBy": "Uvolnil/a",
          "exportedBy": "Vytvořil/a soubor",
          "confirmedBy": "Potvrdil/a ručně",
          "cancelledBy": "Zrušil/a",
          "you": "Ty"
        }
      },
      "submit": {
        "success": "Dávka čeká na schválení."
      },
      "approve": {
        "title": "Schválit dávku {{number}}?",
        "body": "{{payments}} za {{amount}} z účtu {{account}}. Blokované platby do schválené částky nepatří.",
        "confirm": "Schválit",
        "cancel": "Zrušit",
        "success": "Schváleno."
      },
      "release": {
        "title": "Uvolnit dávku?",
        "info": "Před uvolněním znovu zkontrolujeme každou fakturu a každý účet. Uvolněné faktury pak nepůjde proplatit jinou dávkou.",
        "blockedInfo": "Blokované platby se nerezervují.",
        "confirm": "Uvolnit",
        "cancel": "Zrušit",
        "close": "Zavřít",
        "success": "Dávka je uvolněná.",
        "failed": {
          "title": "Dávku teď nejde uvolnit.",
          "heldByAnotherRun": "Některou fakturu teď drží jiná uvolněná dávka.",
          "hint": "Platbu zablokuj, nebo fakturu z dávky vyřaď.",
          "code": {
            "INVOICE_NOT_PAYABLE": "Nelze proplatit – {{clause}}",
            "EXCEEDS_OUTSTANDING": "Dávka platí víc, než faktura teď dluží",
            "DISCOUNT_NOT_FULL_SETTLEMENT": "Slevu lze vzít jen při úhradě celé faktury",
            "CREDIT_NOTE_EXCEEDS_REMAINING": "Dávka započítává víc, než na dobropisu zbývá",
            "PAYEE_NOT_SUPPLIER": "Dodavatel faktury už není příjemce platby",
            "CURRENCY_MISMATCH": "Faktura už není v měně dávky",
            "CREDIT_ACCOUNT_INVALID": "Účet příjemce už není ověřený"
          },
          "invoiceNotPayable": "Faktura teď nejde proplatit"
        }
      },
      "export": {
        "confirmTitle": "Vytvořit soubor pro banku?",
        "blockedBody_one": "{{count}} blokovaná platba se z dávky vyřadí: do souboru nepůjde a její faktury se vrátí mezi faktury k úhradě.",
        "blockedBody_few": "{{count}} blokované platby se z dávky vyřadí: do souboru nepůjdou a jejich faktury se vrátí mezi faktury k úhradě.",
        "blockedBody_many": "{{count}} blokované platby se z dávky vyřadí: do souboru nepůjdou a jejich faktury se vrátí mezi faktury k úhradě.",
        "blockedBody_other": "{{count}} blokovaných plateb se z dávky vyřadí: do souboru nepůjdou a jejich faktury se vrátí mezi faktury k úhradě.",
        "plainBody": "Do souboru půjdou všechny platby, které čekají na odeslání.",
        "confirm": "Vytvořit soubor",
        "cancel": "Zrušit",
        "success": "Soubor je připravený ke stažení.",
        "closedOut": "Všechny platby už jsou potvrzené. Dávka je uzavřená a soubor nebyl potřeba.",
        "cancelledOut_one": "{{count}} platba se při vytvoření souboru z dávky vyřadila. Důvod najdeš u ní.",
        "cancelledOut_few": "{{count}} platby se při vytvoření souboru z dávky vyřadily. Důvod najdeš u nich.",
        "cancelledOut_many": "{{count}} platby se při vytvoření souboru z dávky vyřadily. Důvod najdeš u nich.",
        "cancelledOut_other": "{{count}} plateb se při vytvoření souboru z dávky vyřadilo. Důvod najdeš u nich.",
        "failed": {
          "title": "Soubor teď nejde vytvořit.",
          "hint": "Platbu zablokuj, nebo dávku zruš. Účet příjemce oprav u dodavatele.",
          "close": "Zavřít",
          "wholeRun": "Celá dávka",
          "code": {
            "CREDIT_ACCOUNT_INVALID": "Účet příjemce už není ověřený",
            "CREDIT_ACCOUNT_CHANGED": "Účet příjemce se od uvolnění změnil",
            "CREDIT_ACCOUNT_NOT_DOMESTIC": "ABO (KPC) platí jen na české účty",
            "DEBIT_ACCOUNT_NOT_DOMESTIC": "ABO (KPC) jde poslat jen z českého účtu",
            "CURRENCY_NOT_SUPPORTED": "ABO (KPC) platí jen v korunách",
            "BANK_FILE_REFUSED": "Soubor by banka nepřijala"
          }
        }
      },
      "withdraw": {
        "title": "Vzít export zpět",
        "reason": "Důvod",
        "warning": "Soubor zůstane uložený. Dávka se vrátí ke schválení a faktury mezi faktury k úhradě. Pokud už soubor máš v bance, platby tím nezastavíš — zruš je tam.",
        "submit": "Vzít export zpět",
        "cancel": "Zrušit",
        "success": "Export je vzatý zpět."
      },
      "reasonTooLong": "Důvod může mít nejvýš {{max}} znaků.",
      "cancelRun": {
        "title": "Zrušit dávku {{number}}?",
        "body": "Faktury se vrátí mezi faktury k úhradě.",
        "releasedBody": "Faktury se vrátí mezi faktury k úhradě. Jejich rezervace se uvolní.",
        "confirm": "Zrušit dávku",
        "cancel": "Zpět",
        "success": "Dávka je zrušená."
      },
      "block": {
        "title": "Blokovat platbu",
        "reason": "Důvod",
        "info": "Platba zůstane v dávce, ale do schválené částky se nepočítá. Pokud bude blokovaná i při vytvoření souboru, z dávky se vyřadí a její faktury se vrátí mezi faktury k úhradě.",
        "submit": "Blokovat platbu",
        "cancel": "Zrušit",
        "success": "Platba je blokovaná."
      },
      "unblock": {
        "title": "Odblokovat platbu?",
        "body": "Platba se vrátí do dávky.",
        "approvedBody": "Platba se vrátí do schválené částky dávky.",
        "confirm": "Odblokovat",
        "cancel": "Zrušit",
        "success": "Platba je zpět v dávce.",
        "failed": {
          "title": "Platbu teď nejde odblokovat.",
          "hint": "Platba zůstane blokovaná, dokud se to nevyřeší."
        }
      },
      "cancelLeftOut": {
        "title": "Zrušit platbu?",
        "body": "Platba nešla do souboru pro banku, takže ji žádná banka nemá. Její faktury se vrátí mezi faktury k úhradě.",
        "splitBody": "Část, kterou už potvrdilo ERP, zůstane proplacená. Zruší se jen zbytek a jeho faktury se vrátí mezi faktury k úhradě.",
        "confirm": "Zrušit platbu",
        "cancel": "Zpět",
        "success": "Platba je zrušená."
      },
      "removeAllocation": {
        "title": "Vyřadit fakturu {{number}} z dávky?",
        "body": "Faktura se vrátí mezi faktury k úhradě.",
        "confirm": "Vyřadit z dávky",
        "cancel": "Zrušit",
        "success": "Faktura je z dávky vyřazená.",
        "creditNoteTitle": "Vyřadit dobropis {{number}} z platby?",
        "creditNoteBody": "Dobropis se z platby vyřadí a platba se o jeho částku zvýší."
      },
      "editAllocation": {
        "title": "Upravit platbu faktury {{number}}",
        "outstanding": "K úhradě {{amount}}",
        "applied": "Proplatit",
        "discount": "Sleva za včasnou platbu",
        "withholding": "Srážka",
        "withholdingHint": "Část, kterou dodavateli nevyplácíš, například srážková daň.",
        "settlesInFull": "Faktura se tím vyrovná celá.",
        "remains": "Zůstane k úhradě {{amount}}.",
        "appliedInvalid": "Zadej částku větší než nula.",
        "partInvalid": "Zadej nulu nebo kladnou částku.",
        "submit": "Uložit",
        "cancel": "Zrušit",
        "success": "Platba je upravená."
      },
      "netCreditNote": {
        "title": "Započíst dobropis",
        "description": "Platba {{payee}} · {{amount}}",
        "creditNote": "Dobropis",
        "date": "Datum",
        "remaining": "Zbývá",
        "pick": "Vybrat dobropis {{number}}",
        "amount": "Započíst",
        "amountInvalid": "Zadej částku větší než nula.",
        "exceedsRemaining": "Víc, než na dobropisu zbývá, započíst nejde.",
        "transferNotPositive": "Platba musí zůstat vyšší než nula. Zbytek dobropisu počká na další dávku.",
        "none": "Dodavatel nemá žádný dobropis k započtení.",
        "loadError": "Dobropisy se nepodařilo načíst.",
        "submit": "Započíst",
        "cancel": "Zrušit",
        "success": "Dobropis je započtený."
      },
      "approvedWarning": "Dávka je schválená. Po úpravě se vrátí ke schválení a schválit ji musí někdo, kdo ji nepřipravoval ani neupravoval."
    },
    "settingsShell": {
      "title": "Nastavení systému",
      "searchPlaceholder": "Hledat v nastavení",
      "noResults": "Nic jsme nenašli. Zkus jiné slovo.",
      "sectionDenied": "K požadované sekci nemáte dostatečné oprávnění.",
      "tabs": {
        "settings": "Nastavení systému",
        "codeLists": "Číselníky",
        "automation": "Automatizace"
      },
      "groups": {
        "company": "Firma",
        "people": "Lidé a přístup",
        "documents": "Doklady",
        "codeLists": "Číselníky",
        "connections": "Integrace a API",
        "subscription": "Předplatné"
      },
      "sections": {
        "overview": {
          "label": "Přehled",
          "description": "Jak je Tappeer nastavený.",
          "keywords": "úvod stav souhrn"
        },
        "organization": {
          "label": "Profil firmy",
          "description": "Jak se firma jmenuje, kde sídlí a v jaké měně účtuje.",
          "keywords": "organizace ičo dič dph vat adresa sídlo název jazyk měna časové pásmo ares obchodní rejstřík telefon"
        },
        "bankAccounts": {
          "label": "Bankovní účty",
          "description": "Účty, ze kterých platíš a na které ti chodí peníze.",
          "keywords": "iban banka účet číslo účtu swift bic ověření platby"
        },
        "users": {
          "label": "Uživatelé",
          "description": "Kdo v Tappeeru pracuje a co smí.",
          "keywords": "pozvat pozvánka role admin schvalovatel tým lidé přístup oprávnění"
        },
        "mailbox": {
          "label": "Příjem dokladů",
          "description": "Kam posílat faktury, aby je Tappeer vyčuchal.",
          "keywords": "e-mail email mail schránka přeposílání inbox adresa"
        },
        "automation": {
          "label": "Automatizace"
        },
        "numberSeries": {
          "label": "Číselné řady",
          "description": "Jak se číslují doklady, které vystavuješ.",
          "keywords": "číslování prefix řada formát objednávky"
        },
        "documentOutput": {
          "label": "Výstupní doklady",
          "description": "Jak vypadají doklady, které z Tappeeru odcházejí.",
          "keywords": "pdf patička podmínky tisk objednávka vzhled"
        },
        "partners": {
          "label": "Firmy",
          "description": "Dodavatelé a odběratelé, se kterými obchoduješ.",
          "keywords": "dodavatel dodavatelé odběratel odběratelé zákazník zákazníci firma firmy partner partneři ičo dič kontakty adresář číselník"
        },
        "orgStructure": {
          "label": "Organizační struktura",
          "description": "Pozice ve firmě a jejich vedoucí, podle kterých jde schvalování.",
          "keywords": "pozice útvar oddělení vedoucí manažer struktura hierarchie organizace schvalování číselník"
        },
        "costCenters": {
          "label": "Nákladová střediska",
          "description": "Střediska, na která rozděluješ náklady.",
          "keywords": "středisko náklady nákladové rozpočet číselník"
        },
        "jobs": {
          "label": "Zakázky",
          "description": "Zakázky a projekty, ke kterým přiřazuješ doklady.",
          "keywords": "zakázka projekt číselník"
        },
        "glPostings": {
          "label": "Předkontace",
          "description": "Předkontace z účetního systému pro zaúčtování dokladů.",
          "keywords": "předkontace účtování zaúčtování účet účetnictví číselník"
        },
        "vatCodes": {
          "label": "Členění DPH",
          "description": "Členění DPH z účetního systému.",
          "keywords": "dph vat členění sazba daň číselník"
        },
        "vatPostings": {
          "label": "Zaúčtování DPH",
          "description": "Jak účetní systém účtuje DPH.",
          "keywords": "dph vat zaúčtování účtování daň číselník"
        },
        "integrations": {
          "label": "Integrace",
          "description": "Synchronizace dat s tvým účetnictvím nebo ERP.",
          "keywords": "integrace erp účetnictví pohoda money s3 abra flexi konektor konektory synchronizace sync import export plugin",
          "children": {
            "connections": {
              "label": "Instalace",
              "description": "Odsud čtou data tvoje konektory. Konektory nad jednou instalací sdílejí její nastavení, takže adresu nebo heslo zadáš jen jednou.",
              "keywords": "instalace cílový systém cílové systémy připojení adresa heslo přihlášení server databáze účetní jednotka"
            },
            "bridges": {
              "label": "Bridge",
              "description": "Počítače ve tvé síti, přes které Tappeer dosáhne na systémy, kam z internetu nevidí.",
              "keywords": "bridge bridgy agent počítač windows síť tunel párování párovací kód lokální server"
            },
            "monitor": {
              "label": "Monitor",
              "description": "Běhy a problémy všech konektorů tohoto účtu.",
              "keywords": "monitor monitoring běh běhy synchronizace chyby chyba problémy historie log stav"
            }
          }
        },
        "webhooks": {
          "label": "Webhooky",
          "description": "Dej svému systému vědět, když se v Tappeeru něco stane.",
          "keywords": "webhook url události notifikace vývojář"
        },
        "apiKeys": {
          "label": "API klíče",
          "description": "Klíče pro přístup k Tappeeru z jiných aplikací.",
          "keywords": "token api vývojář klíč přístup"
        },
        "subscription": {
          "label": "Tarif",
          "description": "Co máš předplacené a kolik z toho zbývá.",
          "keywords": "předplatné plán tarif kredity platba karta"
        },
        "billingInvoices": {
          "label": "Faktury za Tappeer",
          "description": "Faktury, které ti posílá Tappeer.",
          "keywords": "faktury vyúčtování platby stažení pdf billing"
        },
        "accountManagement": {
          "label": "Správa účtu",
          "description": "Akce s celým účtem: účetní kancelář a smazání účtu.",
          "keywords": "smazat smazání zrušit zrušení kancelář účetní prohlásit odejít odpojit účet"
        }
      },
      "overview": {
        "attention": {
          "title": "Potřebuje pozornost"
        },
        "status": {
          "organization": {
            "withCompanyId": "{{name}}, IČO {{companyId}}",
            "nameOnly": "{{name}}"
          },
          "bankAccounts": {
            "count_one": "{{value}} účet",
            "count_few": "{{value}} účty",
            "count_other": "{{value}} účtů",
            "none": "Zatím žádný účet"
          },
          "mailbox": {
            "active": "Faktury posílej na {{address}}",
            "disabled": "Příjem e-mailem je vypnutý",
            "none": "Zatím nemáš adresu pro doklady"
          },
          "webhooks": {
            "none": "Zatím žádný webhook",
            "off": "Webhook je vypnutý",
            "failing": "Poslední doručení se nepovedlo",
            "on": "Webhook je zapnutý"
          },
          "subscription": {
            "balance_one": "Zbývá {{value}} kredit",
            "balance_few": "Zbývají {{value}} kredity",
            "balance_other": "Zbývá {{value}} kreditů",
            "paidBy": "Kredity platí {{name}}"
          }
        }
      },
      "bankAccountsPending": {
        "count_one": "{{value}} účet čeká na ověření",
        "count_few": "{{value}} účty čekají na ověření",
        "count_other": "{{value}} účtů čeká na ověření"
      },
      "integrationHealth": {
        "bridgeOffline": "Bridge je offline",
        "syncStale": "Synchronizace stojí"
      }
    },
    "listFilters": {
      "search": "Hledat",
      "addFilter": "Přidat filtr",
      "filterBy": "Filtrovat podle",
      "clearAll": "Zrušit filtry",
      "apply": "Použít",
      "back": "Zpět",
      "remove": "Odebrat filtr {{name}}",
      "sheetTitle": "Filtry",
      "noOptions": "Nic jsme nenašli",
      "from": "Od",
      "to": "Do",
      "status": {
        "label": "Stav",
        "all": "Vše",
        "panelTitle": "Filtrovat podle stavu",
        "panelHint": "Kliknutím na vybraný stav výběr zrušíš a zobrazí se vše."
      },
      "datePresets": {
        "thisMonth": "Tento měsíc",
        "lastMonth": "Minulý měsíc",
        "last30Days": "Posledních 30 dní",
        "custom": "Vlastní"
      },
      "range": {
        "between": "{{from}} – {{to}}",
        "from": "od {{value}}",
        "to": "do {{value}}"
      },
      "amount": {
        "inclVat": "s DPH",
        "exclVat": "bez DPH",
        "accountingCurrency": "Účetní měna",
        "hint": "Bez zvolené měny se porovnává částka přepočtená do účetní měny.",
        "estimateHint": "Bez zvolené měny se porovnává odhad v účetní měně."
      },
      "flag": {
        "show": "Zobrazit"
      },
      "orgUnit": {
        "includeDescendants": "Včetně podřízených",
        "withDescendants": "{{value}} a podřízené"
      },
      "endsWithin": {
        "days": "{{days}} dnů"
      },
      "payment": {
        "overdue": "Po splatnosti"
      },
      "check": {
        "error": "S chybou",
        "warning": "S upozorněním",
        "success": "Bez problémů"
      },
      "params": {
        "relationship": "Vztah ke mně",
        "supplier": "Dodavatel",
        "suggestedSupplier": "Navržený dodavatel",
        "party": "Smluvní strana",
        "direction": "Směr",
        "amount": "Částka",
        "issued": "Datum vystavení",
        "due": "Splatnost",
        "delivery": "Termín dodání",
        "received": "Přijato",
        "created": "Vytvořeno",
        "documentType": "Typ dokladu",
        "payment": "Platba",
        "posting": "Zaúčtování",
        "check": "Kontrola",
        "costCenter": "Středisko",
        "job": "Zakázka",
        "orgUnit": "Organizační struktura",
        "contract": "Smlouva",
        "endsWithin": "Končí do",
        "cancelled": "Zrušené"
      },
      "saved": {
        "title": "Uložené filtry",
        "empty": "Zatím tu nemáš žádný uložený filtr.",
        "loadFailed": "Uložené filtry se nepodařilo načíst.",
        "saveCurrent": "Uložit aktuální filtry…",
        "createTitle": "Uložit filtry",
        "save": "Uložit",
        "name": "Název",
        "includeStatus": "Včetně stavu",
        "includeStatusHint": "Filtr pak přepne i stav na „{{status}}“.",
        "cancel": "Zrušit",
        "actions": "Akce filtru {{name}}",
        "rename": "Přejmenovat",
        "renameTitle": "Přejmenovat filtr",
        "overwrite": "Uložit aktuální filtry sem",
        "delete": "Smazat",
        "deleteTitle": "Smazat filtr?",
        "deleteMessage": "Filtr „{{name}}“ zmizí z tvých uložených filtrů.",
        "created": "Filtr „{{name}}“ je uložený.",
        "overwritten": "Filtr „{{name}}“ teď ukládá aktuální filtry.",
        "deleted": "Filtr „{{name}}“ je smazaný.",
        "errors": {
          "nameTaken": "Filtr s tímto názvem už máš.",
          "nameRequired": "Zadej název filtru.",
          "nameTooLong": "Název může mít nejvýš 80 znaků.",
          "limitReached": "Uložit můžeš nejvýš 50 filtrů pro tento seznam. Nějaký smaž a zkus to znovu.",
          "queryTooLong": "Tolik filtrů se uložit nedá. Zkus jich nastavit méně.",
          "failed": "Změnu se nepodařilo uložit. Zkus to znovu."
        }
      }
    }
  },
  "modules": {
    "menu": {
      "myAccount": "Profil",
      "logout": "Odhlásit se",
      "profile": "Můj profil",
      "systemSettings": "Nastavení systému",
      "apiKeyClose": "Zavřít"
    }
  },
  "impersonation": {
    "callback": {
      "loading": "Navazuji relaci…",
      "invalidToken": "Platnost odkazu vypršela nebo je neplatný."
    },
    "banner": {
      "message": "Provádíš akce jako {{name}}",
      "stopButton": "Ukončit impersonaci",
      "stopping": "Ukončování…",
      "stopError": "Nepodařilo se ukončit impersonaci. Zkus to prosím znovu."
    }
  }
}
